import React, { useState, useMemo, useEffect } from 'react';
import { initReactI18next, useTranslation, I18nextProvider } from 'react-i18next';
import axios from 'axios';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import numbro from 'numbro';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$3 = ".styles-module_header-wrap__faom4 {\n  height: 60px;\n  background: #232325;\n  display: flex;\n  justify-content: space-between;\n  color: #010313;\n  padding: 0 30px;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr {\n  display: flex;\n  align-items: center;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic {\n  margin-left: 150px;\n  display: flex;\n  align-items: center;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT {\n  display: inline-block;\n  padding: 5px 10px;\n  margin-right: 20px;\n  white-space: nowrap;\n  font-size: 14px;\n  cursor: pointer;\n  color: #b3b4c8;\n  background: none;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT::after {\n  content: \"\";\n  position: absolute;\n  height: 10px;\n  bottom: -10px;\n  left: 0;\n  width: 100%;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT svg {\n  margin-left: -4px;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT.styles-module_active__lo-Rt {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  color: #fff;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  color: #fff;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT .styles-module_about-bx-wrap__rgrO1 {\n  display: flex;\n  position: absolute;\n  width: 130px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  top: 35px;\n  left: 0;\n  color: #010313;\n  box-sizing: border-box;\n  flex-direction: column;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT .styles-module_about-bx-wrap__rgrO1 .styles-module_item__nSiEc {\n  width: 100%;\n  text-align: left;\n  box-sizing: border-box;\n  height: 40px;\n  padding-left: 10px;\n  line-height: 40px;\n  cursor: pointer;\n  background: none;\n  border-radius: 12px;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT .styles-module_about-bx-wrap__rgrO1 .styles-module_item__nSiEc:hover {\n  background: rgba(32, 26, 85, 0.05);\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT .styles-module_convert-trade-menu-wrap__VYvx0 {\n  display: flex;\n  position: absolute;\n  width: 130px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  top: 35px;\n  left: 0;\n  color: #010313;\n  box-sizing: border-box;\n  flex-direction: column;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT .styles-module_convert-trade-menu-wrap__VYvx0 .styles-module_item__nSiEc {\n  width: 100%;\n  text-align: left;\n  box-sizing: border-box;\n  height: 40px;\n  padding-left: 10px;\n  line-height: 40px;\n  cursor: pointer;\n  background: none;\n  border-radius: 12px;\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT .styles-module_convert-trade-menu-wrap__VYvx0 .styles-module_item__nSiEc:hover {\n  background: rgba(32, 26, 85, 0.05);\n}\n.styles-module_header-wrap__faom4 .styles-module_left__1CvEr .styles-module_menus__eK-ic .styles-module_menu-item__7ugYT .styles-module_convert-trade-menu-wrap__VYvx0 .styles-module_item__nSiEc.styles-module_active__lo-Rt {\n  background: rgba(32, 26, 85, 0.05);\n}\n.styles-module_header-wrap__faom4 .styles-module_right__GTLWo {\n  display: flex;\n  align-items: center;\n}\n.styles-module_header-wrap__faom4 .styles-module_right__GTLWo .styles-module_btn__qDJby {\n  width: 74px;\n  line-height: 27px;\n  color: #b3b4c8;\n  border: 1px solid #7b7c8f;\n  text-align: center;\n  font-size: 12px;\n  border-radius: 30px;\n  cursor: pointer;\n  margin-right: 30px;\n}\n.styles-module_header-wrap__faom4 .styles-module_right__GTLWo .styles-module_btn__qDJby:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n.styles-module_header-wrap__faom4 .styles-module_right__GTLWo .styles-module_user-info-wrap__q6Efh {\n  display: flex;\n  align-items: center;\n  margin-right: 30px;\n  position: relative;\n}\n.styles-module_header-wrap__faom4 .styles-module_right__GTLWo .styles-module_user-info-wrap__q6Efh::after {\n  position: absolute;\n  width: 100%;\n  height: 17px;\n  background-color: transparent;\n  bottom: -13px;\n  left: 0;\n  content: \"\";\n}\n.styles-module_header-wrap__faom4 .styles-module_right__GTLWo .styles-module_user-info-wrap__q6Efh:hover {\n  cursor: pointer;\n}\n.styles-module_header-wrap__faom4 .styles-module_right__GTLWo .styles-module_user-info-wrap__q6Efh:hover .styles-module_user-icon__DCBh7 {\n  color: #fff;\n}\n.styles-module_header-wrap__faom4 .styles-module_right__GTLWo .styles-module_user-info-wrap__q6Efh .styles-module_user-icon__DCBh7 {\n  color: #B3B4C8;\n}\n.styles-module_header-wrap__faom4 .styles-module_mobile-wrap__I19rC {\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  background: #232325;\n  align-items: center;\n  height: calc(100vh - 60px);\n  position: absolute;\n  top: 60px;\n  left: 0;\n  padding-top: 57px;\n  z-index: 9999;\n}\n.styles-module_header-wrap__faom4 .styles-module_mobile-wrap__I19rC .styles-module_menu-wrap__pfVIw .styles-module_personal__U-4gj {\n  border: 1px solid rgba(139, 138, 153, 0.3);\n  border-radius: 12px;\n  padding: 10px 20px;\n  margin-bottom: 47px;\n  display: flex;\n  justify-content: flex-start;\n  color: #fff;\n  font-size: 14px;\n}\n.styles-module_header-wrap__faom4 .styles-module_mobile-wrap__I19rC .styles-module_menu-wrap__pfVIw .styles-module_personal__U-4gj svg {\n  width: 20px;\n  margin-right: 5px;\n}\n.styles-module_header-wrap__faom4 .styles-module_mobile-wrap__I19rC .styles-module_menu-wrap__pfVIw .styles-module_mobile-menu-item__fM2RB {\n  color: #b3b4c8;\n  font-size: 14px;\n  margin-bottom: 46px;\n  display: flex;\n  justify-content: flex-start;\n}\n.styles-module_header-wrap__faom4 .styles-module_mobile-wrap__I19rC .styles-module_menu-wrap__pfVIw .styles-module_mobile-menu-item__fM2RB svg {\n  width: 18px;\n  margin-left: 5px;\n}\n.styles-module_header-wrap__faom4 .styles-module_mobile-wrap__I19rC .styles-module_contact-wrap__6PmsC {\n  display: flex;\n  position: absolute;\n  bottom: 100px;\n}\n.styles-module_header-wrap__faom4 .styles-module_mobile-wrap__I19rC .styles-module_contact-wrap__6PmsC img {\n  display: inline-block;\n  width: 25px;\n  height: 25px;\n  margin-left: 20px;\n}\n\n.styles-module_pi-tip-modal-mask__ab3Ac {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  z-index: 3;\n}\n.styles-module_pi-tip-modal-mask__ab3Ac .styles-module_pi-tip-modal__O66G6 {\n  padding: 50px 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 370px;\n  background: #FFFFFF;\n  box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);\n  border-radius: 20px;\n  margin: 0 auto;\n}\n.styles-module_pi-tip-modal-mask__ab3Ac .styles-module_pi-tip-modal__O66G6 .styles-module_company-tip-text__HN5Oq {\n  color: #000;\n  font-size: 16px;\n}\n.styles-module_pi-tip-modal-mask__ab3Ac .styles-module_pi-tip-modal__O66G6 .styles-module_company-tip-text__HN5Oq b {\n  color: #333BF5;\n  font-weight: normal;\n}\n.styles-module_pi-tip-modal-mask__ab3Ac .styles-module_pi-tip-modal__O66G6 .styles-module_title__E3Cnq {\n  color: #000;\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 10px;\n}\n.styles-module_pi-tip-modal-mask__ab3Ac .styles-module_pi-tip-modal__O66G6 .styles-module_content__U9BVs {\n  margin-top: 20px;\n  color: #010313;\n  font-size: 14px;\n  font-weight: 400;\n}\n.styles-module_pi-tip-modal-mask__ab3Ac .styles-module_pi-tip-modal__O66G6 .styles-module_footer__Div4E {\n  display: flex;\n  margin-top: 20px;\n  justify-content: space-around;\n  cursor: pointer;\n  width: 100%;\n}\n.styles-module_pi-tip-modal-mask__ab3Ac .styles-module_pi-tip-modal__O66G6 .styles-module_footer__Div4E .styles-module_cancel-button__-wHlW {\n  width: 100px;\n  height: 44px;\n  padding: 0px 20px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 30px;\n  display: flex;\n  background: rgba(32, 26, 85, 0.05);\n}\n.styles-module_pi-tip-modal-mask__ab3Ac .styles-module_pi-tip-modal__O66G6 .styles-module_footer__Div4E .styles-module_ok-button__f-33P {\n  margin-left: 10px;\n  display: flex;\n  width: 200px;\n  height: 44px;\n  padding: 0px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  background-color: #333BF5;\n  border-radius: 30px;\n  color: #fff;\n  cursor: pointer;\n}";
var styles$2 = {"header-wrap":"styles-module_header-wrap__faom4","left":"styles-module_left__1CvEr","menus":"styles-module_menus__eK-ic","menu-item":"styles-module_menu-item__7ugYT","active":"styles-module_active__lo-Rt","about-bx-wrap":"styles-module_about-bx-wrap__rgrO1","item":"styles-module_item__nSiEc","convert-trade-menu-wrap":"styles-module_convert-trade-menu-wrap__VYvx0","right":"styles-module_right__GTLWo","btn":"styles-module_btn__qDJby","user-info-wrap":"styles-module_user-info-wrap__q6Efh","user-icon":"styles-module_user-icon__DCBh7","mobile-wrap":"styles-module_mobile-wrap__I19rC","menu-wrap":"styles-module_menu-wrap__pfVIw","personal":"styles-module_personal__U-4gj","mobile-menu-item":"styles-module_mobile-menu-item__fM2RB","contact-wrap":"styles-module_contact-wrap__6PmsC","pi-tip-modal-mask":"styles-module_pi-tip-modal-mask__ab3Ac","pi-tip-modal":"styles-module_pi-tip-modal__O66G6","company-tip-text":"styles-module_company-tip-text__HN5Oq","title":"styles-module_title__E3Cnq","content":"styles-module_content__U9BVs","footer":"styles-module_footer__Div4E","cancel-button":"styles-module_cancel-button__-wHlW","ok-button":"styles-module_ok-button__f-33P"};
styleInject(css_248z$3);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var API_WALLET_SERVER = 'https://testgateway.bixin.com';

var pHHNdTPNyDzQgIvYd$2 = {
	message: "你好"
};
var cWSaveaKAPErStEYy$2 = {
	message: "首页"
};
var sSIcbzainkLvqqhxh$2 = {
	message: "钱包"
};
var aLZzpUtzvgrrPWvcQGbT$2 = {
	message: "币币交易"
};
var IizWxRwTfRDgQnVPXcb$2 = {
	message: "历史账单"
};
var jeYCQaSvbBRtAklYZ$2 = {
	message: "关于我们"
};
var kfASiYACukCdCVcFmcsq$2 = {
	message: "欢迎%s%"
};
var YpcGXAgMexsVEmQnseE$2 = {
	message: "为正常使用账户功能，请尽快完成身份验证。主要步骤包括："
};
var OivHVusJobtDPuGMSbDN$2 = {
	message: "手机号验证"
};
var HNryhyKcRNPaLZpBHK$2 = {
	message: "身份证明"
};
var IDPsMPUXhtCczMWcA$2 = {
	message: "自拍"
};
var MnGzdARgdxwWnBQGqasa$2 = {
	message: "住址证明（如需）"
};
var dSypETsKWXyxFowLHe$2 = {
	message: "开始"
};
var CRjZdhorIpDDNDAPls$2 = {
	message: "稍后再试"
};
var KEEUdFUfkYDFEeiUhk$2 = {
	message: "您的手机号"
};
var BQbWzLQtSHQVHdIDAgJ$2 = {
	message: "发送验证码"
};
var fxHeYqwgtTcKAdCKPyVe$2 = {
	message: "重新发送"
};
var OXrwZMwkWAjoSDDALzow$2 = {
	message: "验证码"
};
var tOaRBVUJHpnSgDBrGON$2 = {
	message: "下一步"
};
var WbPTckCFMKtPHgAlL$2 = {
	message: "返回"
};
var nHxEoVJEcaAOmKgBbYO$2 = {
	message: "您当前所选择的证件发行国家为"
};
var MZjVFSmKoCrehUMcH$2 = {
	message: "修改"
};
var puvbUtnTezlmHPfbVAqn$2 = {
	message: "护照"
};
var HOpNrycyzpeOCvcWPwAM$2 = {
	message: "身份证"
};
var QaixZWMxqfefkNPgkdy$2 = {
	message: "驾驶证"
};
var RPMjhEtAWhHwQeAjSV$2 = {
	message: "上传护照"
};
var mBnIkwyDNdwNDoWcq$2 = {
	message: "上传身份证"
};
var ApuVYLcjyFSzxzZB$2 = {
	message: "上传驾驶证"
};
var YoNUkubiEWSyPsgRUR$2 = {
	message: "请确保信息清晰、无涂改，请上传PDF或者JPG格式，不超过5MB"
};
var msvgVjHCdtHxFKkrS$2 = {
	message: "姓"
};
var SUObcbdMwQrjwarfaMi$2 = {
	message: "名"
};
var ElMEzQxYcCuZMmCmB$2 = {
	message: "中间名"
};
var idqLvJqjeiEmQbpa$2 = {
	message: "必填"
};
var FhkGAkzeRaGMUGCREr$2 = {
	message: "选填"
};
var lXmoRtYVpvHfxffpUp$2 = {
	message: "出生日期"
};
var fIZJfHadJjLYozRPMC$2 = {
	message: "国籍"
};
var fVuoUoQRKfJuwltrQWcF$2 = {
	message: "您输入的基本信息与证件信息保持一致"
};
var tMHuCmLcCyWTKXTkJpl$2 = {
	message: "请打开摄像头，开始人脸验证"
};
var yXhUtplPqxAjDtkzW$2 = {
	message: "遇到困难？请选择上传手持证件自拍"
};
var EGBtpzynCWcQsWcMz$2 = {
	message: "请手持证件并自拍"
};
var nFxxFVzdRTilHiouzuY$2 = {
	message: "上传"
};
var gYpQegnebgwwccEuM$2 = {
	message: "常居地"
};
var HQSjnUOWYQPuvvTpu$2 = {
	message: "常居地址"
};
var PufPEQRHcFlNqsAG$2 = {
	message: "邮寄地址"
};
var lvvtaxnLzNOtFCZllw$2 = {
	message: "与常居地址保持一致"
};
var NoqAHzFdypmIlmXmyM$2 = {
	message: "上传住址证明"
};
var dLTuZclgDrLDUToEe$2 = {
	message: "有效的住址证明包括3个月内的银行账单、水电费账单等，请上传PDF或JPG格式，不超过5MB"
};
var YChcfaxDaLscdSPiRQz$2 = {
	message: "提交"
};
var qtCIhbuRgppyZzltf$2 = {
	message: "账单"
};
var wvzbJUEmNoCiDQLTaWzH$2 = {
	message: "账户管理"
};
var POdaGgvMxQRsisLbVcll$2 = {
	message: "账号与安全"
};
var qRoYPOkmAoqOZnZawkD$2 = {
	message: "个人信息"
};
var SgWXitfFwQHiWicT$2 = {
	message: "设置"
};
var txfROteTwdaWdTnlkif$2 = {
	message: "登录密码"
};
var qEmYfNcGOwxFPeXxWz$2 = {
	message: "通过设置登录密码，您将可以使用账号和登录密码直接登录"
};
var sjqwCBQBKOIAKZymEnSd$2 = {
	message: "支付密码"
};
var wAFriagWUVTteXOh$2 = {
	message: "用于提现、交易时的安全验证"
};
var ffqVyVPsxEFhGDWwjo$2 = {
	message: "手机号"
};
var ZFmapCdeoYAGjnNG$2 = {
	message: "用于登录、提现、修改密码、安全设置时收取验证短信"
};
var JTHQBsfkCFvanpmGhYL$2 = {
	message: "谷歌验证器"
};
var tLufHBCFhvZchanHd$2 = {
	message: "用于登录、提现、修改安全设置时输入谷歌验证码"
};
var VUMActZjvXkEaSCs$2 = {
	message: "实名认证"
};
var dqGnSTBmWfxxuxSAR$2 = {
	message: "用于登录、提现、修改安全设置时进行身份验证"
};
var NrifpOBOTpbiyPCqT$2 = {
	message: "认证"
};
var ogjLTTEZpYaUhUJAk$2 = {
	message: "个人信息"
};
var TGFdcFVaVnCAXfpC$2 = {
	message: "昵称"
};
var cFKHegtmXlwojKtJw$2 = {
	message: "保存"
};
var pNHFlymBnWuShBmbewj$2 = {
	message: "出生日期"
};
var AsLSeryFUtTwDklOIhVE$2 = {
	message: "性别"
};
var lNGEpmcaWzCMRfZFypa$2 = {
	message: "计价方式"
};
var CKVRBnYMLalEUVhYrqI$2 = {
	message: "返回首页"
};
var JAKswaiCfseLlQNZ$2 = {
	message: "联系我们"
};
var bZduiedsIokAAxBsM$2 = {
	message: "登录/注册"
};
var rtVWmSuAATyCaNgkRNx$2 = {
	message: "登录"
};
var TVTktEvtpSXRbnxIB$2 = {
	message: "邮箱"
};
var leXQdnNvhrYWetVTXjE$2 = {
	message: "邮箱地址"
};
var MzbyaTzwTlbRpWdHmwt$2 = {
	message: "没有账号？立即注册"
};
var phfuULxmHCuLNyotJ$2 = {
	message: "验证码已发送至您的邮箱，请查看邮箱"
};
var qdvGrtpVJQsGGgiLvje$2 = {
	message: "我已阅读并同意《BIXIN用户条款》与《隐私政策》"
};
var PIxkcsUxBzUPVVFfu$2 = {
	message: "错误的邮箱格式"
};
var OBIAENcRtoPgMWcJNZ$2 = {
	message: "验证码错误"
};
var iDYPzXzvGbnKWCRr$2 = {
	message: "忘记密码？"
};
var FmpkJYVtUXpBCGEVp$2 = {
	message: "密码错误"
};
var mzWsFtJNWfexuuUgYctv$2 = {
	message: "抱歉！您所选的国家/地区暂不提供支持"
};
var wjeaGDSVTuLLjJGehN$2 = {
	message: "注册"
};
var KbSjSRobgQmXjHChGKJ$2 = {
	message: "至少8位，包含至少1位数字、1位大写字母和一位小写字母"
};
var TAFoyaQLwVzluFioqh$2 = {
	message: "确认登录密码"
};
var eChfcikkuQFNcZULZuP$2 = {
	message: "请重复密码"
};
var VnLNiYiOJxZraQxL$2 = {
	message: "已有账户？立即登录"
};
var bqNjZcEbCrAzOJJpJDn$2 = {
	message: "总资产折合（BTC）"
};
var gTYMvovCwafJTrjdlKg$2 = {
	message: "充值"
};
var PczYwMSUlifZlPdkNj$2 = {
	message: "提现"
};
var DDrTONBZdHTEWHNFNgtV$2 = {
	message: "一键交易"
};
var OkpDnVcVIcDyntNTMI$2 = {
	message: "代币名称"
};
var EfVkywGLHyLgyrRjzg$2 = {
	message: "代币价格"
};
var NOIPqSfkgPcsNJnyAFA$2 = {
	message: "代币数量"
};
var WauyOiSpVDMamrXbLP$2 = {
	message: "折合法币"
};
var eXVsxwaBOXkkntIEGtC$2 = {
	message: "下滑查看更多"
};
var EOmmDCycYoHFOZOV$2 = {
	message: "币信号"
};
var ysjFKMhSQlIqXgPlz$2 = {
	message: "已认证"
};
var TNkXPjSKdzQcBLZPsWj$2 = {
	message: "未认证"
};
var FMUUecQmwAheUKwpq$2 = {
	message: "可用额度"
};
var KSxzKkrfZaaHIOptelk$2 = {
	message: "交易总额"
};
var IurrXFgATIlGAlejcf$2 = {
	message: "增加额度"
};
var mUgsNHlLzyKVnxhVjRT$2 = {
	message: "个人信息"
};
var LcqaZGQKcdkxNrnIcK$2 = {
	message: "帮助中心"
};
var zQsiOHqCsFIqBzNsf$2 = {
	message: "设置"
};
var erLerUcELvDAcoUWi$2 = {
	message: "退出登录"
};
var TGYvVRioXBfDBtmCBpH$2 = {
	message: "额度申请"
};
var cQKfBbUkEhBhPtPCx$2 = {
	message: "请您提供尽可能多的收入/资产证明材料，以便我们为您批核更高的持仓限额。"
};
var SHjOXbqLUjZRUKsWMzD$2 = {
	message: "选择证明类型"
};
var mUuMBlRDyzHtFgLsivV$2 = {
	message: "选择范围"
};
var ISJVpXHVtpoxunGygBGu$2 = {
	message: "上传证明文件"
};
var VGmDUnWBzMKfFbMKXyl$2 = {
	message: "选择类型"
};
var ZAhuzRDlLUTXhKrhhx$2 = {
	message: "请上传PDF或JPG格式，不超过5MB"
};
var BggwtUciWOTxbdTdDg$2 = {
	message: "添加"
};
var QFbYEdxUgXzRwcPFQDis$2 = {
	message: "提交"
};
var UNForxvjDLCZdGrmWkX$2 = {
	message: "取消"
};
var OCamqUckeIZshGlCbF$2 = {
	message: "历史账单"
};
var YMfvOKmAFnfMwTXPfI$2 = {
	message: "个人中心"
};
var nvfgxTKtdXdTEhFZf$2 = {
	message: "多语言"
};
var HrHtlLjcEICrEnWiRA$2 = {
	message: "由合资格金融机构开具的资产证明"
};
var HIFNIcNDmIhRZEsgzSq$2 = {
	message: "合资格金融机构"
};
var KSyKpOAjkLSpCGns$2 = {
	message: "其他"
};
var eUvzxeVvXrffrpEOrFrP$2 = {
	message: "删除"
};
var NqgOQEXQaHsramCnbX$2 = {
	message: "上传"
};
var YqzlhmIgzcgLnWmZhMsa$2 = {
	message: "充值"
};
var FrzWGSiDSDzTfNgZH$2 = {
	message: "返回"
};
var WYhIabGPkCnbVBIPcwW$2 = {
	message: "选择您需要充入的币种"
};
var LFipKWcCwIamrrato$2 = {
	message: "选择币种"
};
var RFoMDsIwGyJlPkuuxrON$2 = {
	message: "选择充币网络"
};
var bpvYuERgedcoMzzLNl$2 = {
	message: "选择网络"
};
var NsvJYqLAVHAaWNUXAvz$2 = {
	message: "请确保您已选择与提币平台一致的网络进行充币，否则将造成资产损失。"
};
var UbeafDPBCDfpRnQyWUjq$2 = {
	message: "币种/网络"
};
var LbGVMqLVHqyddGmXzULS$2 = {
	message: "重新编辑"
};
var qdnqxPdrpfdxhejrkCj$2 = {
	message: "对低于0.05 BTC的链上充值，收取0.0001BTC的小额度处理费用。"
};
var XYHinpRQuEPFjXMzLP$2 = {
	message: "查看原因"
};
var LQNXJVNXqgqLimcQn$2 = {
	message: "该地址仅用做%S%收款，转入其他币种将无法找回"
};
var nzLBdKgvNCXQTgYI$2 = {
	message: "Memo标签"
};
var iYpfkywMVpuafYnqXxGI$2 = {
	message: "提现"
};
var DVjsSAdKoyNHoIqhumQ$2 = {
	message: "选择您需要提取的币种"
};
var cxKcumOzANqjtQqREyas$2 = {
	message: "选择提现方式"
};
var BQkFfUTgzkweftGIpOLt$2 = {
	message: "链上提现"
};
var FNNzRxnZqrKRYwIte$2 = {
	message: "%S%-链上提现"
};
var SultIciVtbYeZaII$2 = {
	message: "链上地址"
};
var dGRvusBQRnbHUIYQRit$2 = {
	message: "网络"
};
var bJwUxepDjVzlNzKuI$2 = {
	message: "选择网络"
};
var HlrghIZaaySLZjESwU$2 = {
	message: "数量"
};
var TCuuXTtXBYeAldQkZp$2 = {
	message: "最小提币额：%S%"
};
var HYTGqldMNoESWJswz$2 = {
	message: "可用"
};
var dkdmEAWTXMORUhlQaX$2 = {
	message: "服务费"
};
var XwYKiJGJKAZZZpNp$2 = {
	message: "支付详情"
};
var swejTyFcYnjuUgsfQW$2 = {
	message: "付款币种"
};
var mWoxaQwwzwCFvWjRmK$2 = {
	message: "付款方"
};
var tFaBUAWNRhJqtjIha$2 = {
	message: "订单信息"
};
var FEySNpPzdMqiOsZXI$2 = {
	message: "链上提现"
};
var AIwKneHGNfSJmdLnG$2 = {
	message: "订单金额"
};
var wMGJlEJaupHayuzRwi$2 = {
	message: "立即付款"
};
var iRiLJudagJVXZozmnz$2 = {
	message: "当前金额低于最小限制"
};
var laRzOEpYMTvnZYRBZMnj$2 = {
	message: "当前金额高于最大限制"
};
var MDhXYatnZcwvrjVeRh$2 = {
	message: "您选择的地址与币种不匹配，请重新选择币种。"
};
var hDPPfPClruPeWrSoayR$2 = {
	message: "内部转账"
};
var NTsLbMXwQdPYbmOwP$2 = {
	message: "选择您需要转账的币种"
};
var POqloYgxpcTCqdnchGE$2 = {
	message: "币信账户"
};
var KxeaINzIsNNJmsIncnV$2 = {
	message: "手机号/邮箱/UID"
};
var sfsygIDbANBoFslbcsw$2 = {
	message: "转账数量"
};
var YgpFeXbXojsYnphM$2 = {
	message: "最小提币额：%S%"
};
var MutPBZAXykjaIurt$2 = {
	message: "确认转账"
};
var GvnMmZJtuApdXwWhsFd$2 = {
	message: "您当前暂未绑定GA无法进行此次转账"
};
var IcahwJmNfgdvVpPz$2 = {
	message: "去设置"
};
var bxtlucAfnIxfwBYAY$2 = {
	message: "本次支付需要完成以下验证"
};
var KKbVbDLheqewlSvBE$2 = {
	message: "请输入支付密码"
};
var RLztZboedHACRMkjdD$2 = {
	message: "请输入 GoogleAuthenticator 验证码"
};
var QEaaELvQUvbfoIpje$2 = {
	message: "如有问题，请联系客服"
};
var czSsfuZGitGjFRwLTF$2 = {
	message: "币信安全保护中"
};
var xrYEaiWUOcaNRQMIf$2 = {
	message: "交易成功"
};
var QDuPlYKAxjAjIgyoAqM$2 = {
	message: "立即兑换"
};
var ZkDBgJuvDUVQPOxBY$2 = {
	message: "当月剩余可交易额度：%S%"
};
var rJAhIVPUqedRmsfmj$2 = {
	message: "买入"
};
var GpGpOkSHUzYBQNFc$2 = {
	message: "付款方"
};
var aMdrNUxkhioFGrNGFIO$2 = {
	message: "支出金额"
};
var siLEsPwfoiqGBiXjB$2 = {
	message: "服务费"
};
var DYgqvlfmNbyLNOrWwc$2 = {
	message: "%S%s后自动刷新"
};
var rifKyRmlGZOwlJkDyZG$2 = {
	message: "支出"
};
var aNVsLyHapaJbRxWnHsv$2 = {
	message: "获得"
};
var cQiCyvfOMMDJEIXyc$2 = {
	message: "账单"
};
var SywvArMjCuuGzTEtlJ$2 = {
	message: "全部"
};
var vRyVKhBOPCmWYPPacY$2 = {
	message: "外部转账-收款"
};
var GMOQAxsTvfWIEBANuS$2 = {
	message: "外部转账-付款"
};
var xqLddTkVnCrEvxgKGso$2 = {
	message: "内部转账-收款"
};
var sHqYaogVbbeWItJGb$2 = {
	message: "内部转账-付款"
};
var xgIKqcGuTlutCTLLG$2 = {
	message: "币币交易-收款"
};
var zsLweYcWjOwUgfyub$2 = {
	message: "币币交易-付款"
};
var xUNmcszdZBWMTcxnI$2 = {
	message: "含服务费"
};
var moirunBAysHLMEDtBxUt$2 = {
	message: "转账详情"
};
var YrkgVnAQcYRhGGRex$2 = {
	message: "查看"
};
var iuOLeRpygvfPFDnf$2 = {
	message: "类型"
};
var iuswsIRQwNAIuOzoFX$2 = {
	message: "创建时间"
};
var sBFILAqpJhAnTLlpQ$2 = {
	message: "交易哈希"
};
var eSLIwfCNWkIwJpqCHSVC$2 = {
	message: "账单详情"
};
var RtWpXpLfhjeWPtKhcENN$2 = {
	message: "身份认证"
};
var KveBVvOTiGXRKmAUQZz$2 = {
	message: "充值详情"
};
var XwmOjTtjNklQiLDgnjIB$2 = {
	message: "系统判定该笔资金存在风险，拒绝支付！如有疑问请联系客服！"
};
var GLIndpTHvNVRVWQuT$2 = {
	message: "发送给"
};
var WzcUSFqDMdwkVtGoj$2 = {
	message: "完成"
};
var kuTgfRDYzVZvEHrFtQ$2 = {
	message: "邮箱验证"
};
var gXbirwakdsaUKBglwK$2 = {
	message: "复制成功"
};
var cTlSqXgGENkCAQQJCHx$2 = {
	message: "6位数字"
};
var JsmDOHlXAmjSPqaxg$2 = {
	message: "发送"
};
var yCCsuXAjuRzOLNxo$2 = {
	message: "验证码格式错误"
};
var iizCYlpFHwQBzRyqLM$2 = {
	message: "没有账号？"
};
var FbztGftxEQrszJntb$2 = {
	message: "立即注册"
};
var rteqizIYZXJwMWMenVz$2 = {
	message: "这个邮箱还没注册，点击去注册"
};
var sydmFvhfSgzJVhtAud$2 = {
	message: "这个邮箱已经注册过了，请更换邮箱"
};
var aYdhyaHCqMJLweGFD$2 = {
	message: "请阅读并同意"
};
var SMEPVJNtMGWMrEceo$2 = {
	message: "密码格式不正确"
};
var jgXHbpNLgJMKuuZER$2 = {
	message: "两次密码输入不一致，请重新输入"
};
var JWDRcPebwmpIhvJhVrJe$2 = {
	message: "我已阅读并同意"
};
var UtQJNokaxJhxqqTQDiO$2 = {
	message: "《用户协议》"
};
var TFAtjCZbFqacobpGxct$2 = {
	message: "与"
};
var EokACCilfAZfuGcXD$2 = {
	message: "《隐私条款》"
};
var UXURgENTpgxogbFAD$2 = {
	message: "已有账户？"
};
var ElbSFPkaecjnmBToovei$2 = {
	message: "立即登录"
};
var LuigfaXzmPRCftdFOV$2 = {
	message: "请输入验证码"
};
var BNXHKONNlrkDGKwkXt$2 = {
	message: "设置支付密码"
};
var ltXrglJnxfNqZDSStFq$2 = {
	message: "验证码"
};
var FClYxqPqiIjfTGZZthn$2 = {
	message: "请设置6位数字支付密码"
};
var cNmmUqRZfZDUxgWTQeXm$2 = {
	message: "格式不正确，请重新设置"
};
var lKLpdmEuElAKKvltT$2 = {
	message: "确认支付密码"
};
var coPPHMNHpJdMYeKPskDY$2 = {
	message: "请重复支付密码"
};
var NovuNXyQGDRrjfyMs$2 = {
	message: "注册成功"
};
var bOSFxWykzVFerKLOiV$2 = {
	message: "添加Google Authy"
};
var HfjMmDJQuBZXqFJUw$2 = {
	message: "第一步：保存你的GA私钥"
};
var SVTrmHtEOHifBpgPNCY$2 = {
	message: "请妥善保管私钥。私钥是恢复GA认证的唯一方式，请不要向任何人泄露你的私钥。"
};
var LmRHxJOIEHRnUwFSxEm$2 = {
	message: "如何恢复？"
};
var gbkxEEkMTXuhYuUCZTJ$2 = {
	message: "第二步：打开 Google Authenticator/Authy添加账号"
};
var rQgPydQgDVYqtWJXCky$2 = {
	message: "绑定成功！"
};
var nFSJqWAXBnxTngDNyoj$2 = {
	message: "重设密码"
};
var MThZOMtyoBvwpuodWEa$2 = {
	message: "修改成功！"
};
var hiEgXdIbTRKrnaYJnNY$2 = {
	message: "重设登录密码"
};
var PqkPSNBQJWOqaAsafW$2 = {
	message: "Google Authy验证"
};
var vHRZRztWvqyjjHCxW$2 = {
	message: "验证码已发送至您尾号%S%的手机号，请查看"
};
var QZchoinPLbiohHfdnLU$2 = {
	message: "金融机构名称"
};
var gnOvqPVwTsPuWvBTXzI$2 = {
	message: "文件类型"
};
var bDmdcJmdRsIZfYYBDeZ$2 = {
	message: "申请成功，等待人工审批"
};
var YEPMktdEzwhrMMYKefX$2 = {
	message: "月"
};
var wGSnhUtsHuueniKdYTwM$2 = {
	message: "请填写机构名称"
};
var krMQcSEJDOnglqhrHgu$2 = {
	message: "请填写文件类型"
};
var erZFCFRNsVfSKVMRLN$2 = {
	message: "男"
};
var dmeNSGPySLKtEpPGwG$2 = {
	message: "女"
};
var czWbrtWmnCEbUCzVWzQQ$2 = {
	message: "绑定"
};
var YATiezBAjBifZRNRVk$2 = {
	message: "已绑定"
};
var sTMySyQXFMSuchwUXiJ$2 = {
	message: "重设支付密码"
};
var FxLhtNEexnBoJElMC$2 = {
	message: "修改手机号"
};
var hYBHkTzZmueqvwJb$2 = {
	message: "中国香港"
};
var GBvqxVjZVWwZtAPZgH$2 = {
	message: "输入手机号"
};
var KVLFziUaVDlFbnJzh$2 = {
	message: "请输入手机号"
};
var OQGpXlfSrBKFcwjAv$2 = {
	message: "住址证明"
};
var AsfYVtpYWMjfUopLa$2 = {
	message: "您当前所选的证件发行国家为："
};
var wZZutIhpaOoppafvh$2 = {
	message: "请选择"
};
var OUdBKfTzsTrdfcZmbCAI$2 = {
	message: "遇到困难？请选择"
};
var IwzxXaGfVvDNSxQpmeO$2 = {
	message: "手持证件自拍"
};
var XzCcbOKjdfmcCnQLEwNj$2 = {
	message: "审核被拒绝，请重新提交"
};
var IkToKVrxLaVfCKfNGvl$2 = {
	message: "请填写姓"
};
var mRtlyGWfQVnoeqMeTs$2 = {
	message: "请填写名"
};
var ldgxhAKPgZpGiyMyJw$2 = {
	message: "审核中，请等待"
};
var mxKAuwcjmevMUSvDQE$2 = {
	message: "审核通过"
};
var pSTKNwtZdcuFuoyTsPhb$2 = {
	message: "请选择出生日期"
};
var EkbLQeqmPtcNzItJWQO$2 = {
	message: "请填写常居地址"
};
var KzFzOytWXScqDRKFwg$2 = {
	message: "审核中"
};
var MvJmrHwTdesvsHWH$2 = {
	message: "验证码已发送至您的手机，请查看"
};
var bksAzarViFUYGzwAOk$2 = {
	message: "人工审核中"
};
var EOLVYvzyNXSKoGmX$2 = {
	message: "由于当前支付风险偏高，已进入人工审核，预计30分钟内完成审核，如有疑问请联系客服"
};
var EvOtSTBQrIYspwjQ$2 = {
	message: "请填写邮寄地址"
};
var eQHAVxHydpVhNAygOp$2 = {
	message: "认证地区"
};
var LWInyMcYkagvzvaBfUHZ$2 = {
	message: "该币种外部充值必须同时指定【地址】和【Memo】标签, 否则无法入账。"
};
var OKOogywrWeAjtQWF$2 = {
	message: "手续费不足"
};
var MOtoFwFvpTtTEDVUD$2 = {
	message: "余额不足"
};
var ZdMOAZGAMXotVGVlKJ$2 = {
	message: "币种/提现方式"
};
var rEpbPaWEEsiOSTjOiSGL$2 = {
	message: "输入地址"
};
var SWVaRdViGfCBJhJNg$2 = {
	message: "输入Pubkey"
};
var lrCgiXeJcIwkuDsyc$2 = {
	message: "链号"
};
var vyxYMhwwOspfcdpj$2 = {
	message: "请输入邮箱"
};
var MqMVsYdMMtqujWPKHW$2 = {
	message: "请输入uid"
};
var siEUrpaJmBIICzsaBnr$2 = {
	message: "收款方"
};
var XGLKbSKPnzgwwZwEHu$2 = {
	message: "请输入邮箱验证码"
};
var DPFrIOWnjfRpVQHkhKJ$2 = {
	message: "发送邮件"
};
var dTLgwTGGXjpsnLhrpr$2 = {
	message: "交易类型"
};
var gZgeimlXmokhLdRziw$2 = {
	message: "备注"
};
var xqhbTjIzOYuCUiHEUmd$2 = {
	message: "交易ID"
};
var bbQJHoMWXkEHQuVRSsO$2 = {
	message: "系统检测到您的账户行为存在风险，请联系客服进行人工审核"
};
var HHdEPKdocehppzeI$2 = {
	message: "请输入"
};
var tICtqmzJVNeVfZQM$2 = {
	message: "单笔限额"
};
var HOQBmfsmIsFBlsaJaSa$2 = {
	message: "可用余额最多可交易"
};
var XsOliEIHDkjKcghOik$2 = {
	message: "卖出"
};
var ADXLpfHxGLEEMBBLjSL$2 = {
	message: "获得金额"
};
var kHAIwKLXztAgQxLOxj$2 = {
	message: "价格"
};
var pqNxLtehgpuJIUBdg$2 = {
	message: "确认交易"
};
var nodIQIicrpcVpCqYey$2 = {
	message: "提交成功"
};
var gMjyScxabRhqehsX$2 = {
	message: "为继续使用服务，请确认您已阅读并同意最新的"
};
var AQrCocFqoKoYieUnT$2 = {
	message: "确认"
};
var COydGeEPULYaNAmN$2 = {
	message: "站外转账"
};
var pFhbWEovZnvIiVEEJnme$2 = {
	message: "站内转账"
};
var omUetmzxCLiTloCSalU$2 = {
	message: "暂无数据"
};
var pqzdTKxlixAoAQwGy$2 = {
	message: "币信：易用又安全的比特币、以太币等虚拟资产交易平台"
};
var VihBsZgCPMgMJnwUeMLt$2 = {
	message: "英文名（必填）"
};
var ohIqnNpSPiMOrWPSWk$2 = {
	message: "英文姓（必填）"
};
var TGIiRSnHGjASSfzjMA$2 = {
	message: "关于我们"
};
var jjFQYQyxRWGgKdjbaeB$2 = {
	message: "NewBX Limited设立于香港，是币信集团的全资子公司。 Bixin.com平台前身为HaoBTC，成立于2014年，旨在为用户提供“易用且安全”的虚拟资产服务。九年来，Bixin.com服务用户逾百万，年交易量超过300万笔，每年为用户节省交易手续费185万美元。\nBixin.com构建了完善的风控体系，实时监控异常数据，保障各业务环节的安全。平台通过冷热钱包隔离、多重签名、军工级硬件加密机制，为用户虚拟资产提供工业级保护，安全运营九年多，零安全事故"
};
var VsuTZcfrgRHVvsOOY$2 = {
	message: "关于币信"
};
var PLhQWivTKyTYZvsNwMxj$2 = {
	message: "立即体验"
};
var ZLJlKTdDgntyZXzg$2 = {
	message: "易用又安全的\n虚拟资产交易平台"
};
var pPqFjpMzSnmyNWXdT$2 = {
	message: "始于2014年，一对一专属客户经理全程专业服务"
};
var aJpdCHYrgIukuVpHluT$2 = {
	message: "稳定运行十年"
};
var olWnlFpnBjRnPCLuu$2 = {
	message: "币信拥有业内顶尖的安全团队，搭建了完善的风险控制架构，实时监控异常数据，确保币信账户安全、交易安全。冷热钱包分离、多重签名、军工级硬件加密机制等技术，更是为数字资产提供银行级保障。"
};
var ApYUyYTgQDVozNVGdoWy$2 = {
	message: "强大易用的交易平台"
};
var MEuzpQOAySrMUyXj$2 = {
	message: "我们为区块链资产提供强大且灵活易用的工具，致力于让每个人都能平等地持有、使用和管理自己的数字货币。产品逻辑易懂，操作体验流畅。无需繁琐的教程，用户完成身份验证后即可开始使用。"
};
var NkjUESwzghXjElHM$2 = {
	message: "虚拟资产交易一站搞定"
};
var GnugFlecXZohsDMgfjv$2 = {
	message: "由转账到交易，币信可以满足你全方位的需求，并帮助你实现一站式操作。币信在不断巩固现有功能的基础上，也在开发更多高效、实用、有趣的功能。"
};
var nwsbWCYbSYugmHDgHTAB$2 = {
	message: "多种方式 一站交易"
};
var gphdXFLzIrPxMQrAp$2 = {
	message: "全球通用 全民适用 全方位服务"
};
var toUaeInrwbWVqvGGGX$2 = {
	message: "风控严格"
};
var gVAFPuXrrstpWxRF$2 = {
	message: "多种风控手段\n保证您的资金安全"
};
var AowuwjwDLrAJJKuVzCA$2 = {
	message: "便捷易用"
};
var TfmLyYqIoASEGHkuRa$2 = {
	message: "身份认证"
};
var tjuWuhQfpwDJLMscdbI$2 = {
	message: "KYC认证 活体人脸识别"
};
var KewXLZFbuyWsCSbvXi$2 = {
	message: "立即兑换"
};
var vQphyNqvokPAiFdfRR$2 = {
	message: "NewBX Limited设立于香港，是币信集团的全资子公司。 Bixin.com平台前身为HaoBTC，成立于2014年，旨在为用户提供“易用且安全”的虚拟资产服务。九年来，Bixin.com服务用户逾百万，年交易量超过300万笔，每年为用户节省交易手续费185万美元。\nBixin.com构建了完善的风控体系，实时监控异常数据，保障各业务环节的安全。平台通过冷热钱包隔离、多重签名、军工级硬件加密机制，为用户虚拟资产提供工业级保护，安全运营九年多，零安全事故。"
};
var ZbQsLkbfHUtbznnzU$2 = {
	message: "用户协议"
};
var TsnjCIOPEKKCCfrIF$2 = {
	message: "隐私条款"
};
var qyKlEsEkyTXybgIHcI$2 = {
	message: "帮助中心"
};
var VZexjbUhosOUoUTI$2 = {
	message: "币信集团"
};
var jDRHFidXonxhhPKaTl$2 = {
	message: "易用又安全的"
};
var CInUOzoFKTOMvMbix$2 = {
	message: "虚拟资产交易平台"
};
var fTbsMnhpZYjiOkAdex$2 = {
	message: "多种风控手段"
};
var yOZzgRmKudbwNjuurBHz$2 = {
	message: "保证您的资产安全"
};
var lelamaRhejmRBJOD$2 = {
	message: "Bixin.com构建了完善的风控体系，实时监控异常数据，保障各业务环节的安全。平台通过冷热钱包隔离、多重签名、军工级硬件加密机制，为用户虚拟资产提供工业级保护，安全运营九年多，零安全事故。"
};
var pZxEeOQMfyGXKTBxtyJ$2 = {
	message: "全球通用"
};
var ZGyanZavgObBeqhP$2 = {
	message: "全民适用"
};
var oeMZNyLdkPQdxrobojO$2 = {
	message: "全方位服务"
};
var MYuuWNTVQwjCeRRGl$2 = {
	message: "NewBX Limited设立于香港，是币信集团的全资子公司。 Bixin.com平台前身为HaoBTC，成立于2014年，旨在为用户提供“易用且安全”的虚拟资产服务。九年来，Bixin.com服务用户逾百万，年交易量超过300万笔，每年为用户节省交易手续费185万美元。"
};
var yrlrMPLgOtiEzbmPW$2 = {
	message: "正如币信一贯倡导的"
};
var EzMbHhWUJOaBMLDRJxZ$2 = {
	message: "余额"
};
var hQRkbssUXUGGLhtxc$2 = {
	message: "资产"
};
var eDwDkAgbfaPsnwOb$2 = {
	message: "交易"
};
var AVWJwkijUTbNMShmp$2 = {
	message: "账单"
};
var wEEzjRnoOftKrGIPbix$2 = {
	message: "完成身份认证，以正常使用所有产品功能"
};
var NqoduOnqIqJtrjajas$2 = {
	message: "资金账户资产折合（BTC）"
};
var vLUFWGhkoIBWnOMA$2 = {
	message: "交易账户资产折合（BTC）"
};
var tjsCbqUvgNvcdRqdDp$2 = {
	message: "划转"
};
var zBceLwpDLhGkPRkvbU$2 = {
	message: "交易"
};
var udmfKDblDABqFbQPK$2 = {
	message: "资金账户"
};
var AysRHzzIQTbjLUdgdaq$2 = {
	message: "交易账户"
};
var KZPDAndezwXohlXxO$2 = {
	message: "可用"
};
var hdPRTcCCnKbkxbRwgv$2 = {
	message: "确认"
};
var pfVyzGgyXmkqtJpGH$2 = {
	message: "交易模式主题"
};
var KRzStRHbmbrDbAUMnU$2 = {
	message: "日间模式"
};
var lfLIpxDvOAXOplowzN$2 = {
	message: "夜间模式"
};
var BiqzWayxveHNZGxaBa$2 = {
	message: "涨跌颜色"
};
var CvvaFnujrEUnFHnWNb$2 = {
	message: "绿涨红跌"
};
var CNmFZyGboWXdpYPQDvxV$2 = {
	message: "红涨绿跌"
};
var OmOTUgBCsVHUoKutAD$2 = {
	message: "可用余额不足"
};
var DCXoQKoDcwNYuYivD$2 = {
	message: "数量不能为空"
};
var ApeuvISiLLWNGQPrFrP$2 = {
	message: "冻结"
};
var sCfZtZRTGxweYVxtEuoY$2 = {
	message: "代币总数量"
};
var VpbDUCnJRDAsPzfIkn$2 = {
	message: "未完成订单中的代币数量"
};
var WfvaFuidVgEGCwnBEkl$2 = {
	message: "所选币种在该账户中没有可供划转的资产"
};
var UheALJaSjOHgmVnoCrI$2 = {
	message: "请输入金额"
};
var fNFAnFLpEoAIoPfbh$2 = {
	message: "划转成功"
};
var uUrUZzojXlsqxsuOJZTc$2 = {
	message: "系统错误"
};
var CqNbVYlZNfwGfGTGRtE$2 = {
	message: "支付单不存在"
};
var QgEerZTcSTdjtiTnKRT$2 = {
	message: "支付单已过期"
};
var GnbMsiqoZbfmcDerQ$2 = {
	message: "您无法向自己转账"
};
var nEgrtiBYldBKXkpKCocL$2 = {
	message: "抱歉！支付请求拒绝"
};
var AJSlWSWYVQZSygnFKRsI$2 = {
	message: "划转失败"
};
var KzgGszjJLuRsOKsdkH$2 = {
	message: "充值失败"
};
var YmIZCYMTuGNvbocpiJOP$2 = {
	message: "现货交易"
};
var YixzEmijtHztNgwIE$2 = {
	message: "价格"
};
var geVHcZlrpiEaagZcypgy$2 = {
	message: "数量"
};
var SAruOCDnkHugkPOIFSc$2 = {
	message: "金额"
};
var yteHSDpgaHMYFeMBfpWk$2 = {
	message: "买入 BTC"
};
var slVffWcKrAhjpgaMEuY$2 = {
	message: "高级认证"
};
var ghYLDApWJBxFOzhqAlN$2 = {
	message: "开始认证"
};
var GCxKMtkKAZPoOHsZIDh$2 = {
	message: "专业投资者"
};
var uRLAPBsurxBqxfvgaSH$2 = {
	message: "您确认要开始专业投资者认证？"
};
var FaQaEHvLdVELQbCZrFN$2 = {
	message: "根据香港证监会规定，个人专业投资者（Professional Investor) 是指持有港币800万以上的投资组合的高净值人士"
};
var RZgUzTVRaXNflgjshVf$2 = {
	message: "为了正常使用账户功能，请尽快完成身份认证"
};
var nXPQNJCVxPkQKidfjnn$2 = {
	message: "个人"
};
var swSisSeZXWyUyMvIu$2 = {
	message: "零售用户"
};
var HryFxrLzCqTGOVNrpI$2 = {
	message: "法团/机构"
};
var QqwNZKCLuiPIswItY$2 = {
	message: "请先填写预选表格，我们的开户专员会尽快与您联系"
};
var gqfClfSZIJlpPGmuBjum$2 = {
	message: "选择"
};
var HMclPwyZgRMKnvBRCr$2 = {
	message: "公司信息"
};
var iZKMHnInbVLuJJcbpbR$2 = {
	message: "公司名称"
};
var VYJdtiuPscmItOfIyux$2 = {
	message: "所在地"
};
var sbzqRZRFyPyYqnsMtNy$2 = {
	message: "网站"
};
var SwDoMzvfeChtJIrEA$2 = {
	message: "产品与服务"
};
var pPViUnFnexhWKoFMx$2 = {
	message: "是否金融机构？"
};
var NltNaOnxuMeUAbBeZ$2 = {
	message: "是"
};
var HmXYHUAhkQnrZSfKu$2 = {
	message: "否"
};
var KgKURwhHRUNpPmFtXTAv$2 = {
	message: "联络人"
};
var thvmUblDYmiyVPacUB$2 = {
	message: "姓名"
};
var ViAVfshtzuMNFpCqJl$2 = {
	message: "职位"
};
var sSrzMRNSGNzrJsidBnYz$2 = {
	message: "提交成功"
};
var wVSQKNQtitzmkbjDOac$2 = {
	message: "我们的开户专员会尽快与您联系"
};
var rvLRPuoiEpNqnbxwWj$2 = {
	message: "个人认证"
};
var CRMoLKUrfyLkDWFEuSu$2 = {
	message: "基本信息"
};
var GJOdwcCnvAbhzEkImJ$2 = {
	message: "地址证明"
};
var pnGXcYRvktMyOUBwX$2 = {
	message: "财务资料与资产证明（适用于专业投资者）"
};
var fQOFawXqhywMOGSe$2 = {
	message: "测评"
};
var KIIMnxhTdJBhZfaEMP$2 = {
	message: "投资风险取向问卷"
};
var hAacNWPacMHaAAaOw$2 = {
	message: "虚拟资产知识测验"
};
var aCtajuQWKCQNkeKgtwLb$2 = {
	message: "专业投资者测评与声明（适用于专业投资者）"
};
var XjTUjttgmruHnxFXgVf$2 = {
	message: "验证"
};
var ovsIpOdHmKskDqaansBG$2 = {
	message: "持牌人/注册人验证"
};
var RawXxpklaPpnKkAjXLL$2 = {
	message: "银行转账验证（即将上线）"
};
var dpnyHVmjzJjiqtQIfpD$2 = {
	message: "认证"
};
var CtiOEevtmgSCxLlIqb$2 = {
	message: "该国家/地区的服务暂不提供，请确认您后续身份认证的区域不在此国家/地区"
};
var HmoCuzIHcMwWJJxszus$2 = {
	message: "曾用名"
};
var xoPXukoFZulOsawPoPe$2 = {
	message: "国籍"
};
var FlbUChtSXKPaYQGW$2 = {
	message: "如有疑问，请联系<b>support@bixin.com</b>。</br>\n或者，您可以在右下方客服机器人输入“<b>人工认证</b>”手动提交包括身份证明、长期签证、入境许可等材料。\n"
};
var XUWTeclWoXtMrQkJzuuq$2 = {
	message: "选用电子结单和通知书"
};
var YCHRDIIKsDzJFQJw$2 = {
	message: "强烈推荐您选用环保且即时的电子结单和通知书。</br>\n如您确认选用纸质版本，须支付100港元/年的额外费用，请联系客服处理：<b>support@bixin.com</b>"
};
var hfBBkSOAXqfEsLVFs$2 = {
	message: "审核中"
};
var aETDJvQumPoQnxdEPkQR$2 = {
	message: "了解更多关于<b>专业投资者认证</b>"
};
var zZXyblLWbONMNIjPmBN$2 = {
	message: "审核通过"
};
var gyneoIYPeiHgfaCY$2 = {
	message: "审核失败"
};
var ihVcXhmbhwIbsPsTbF$2 = {
	message: "CRS自我证明表格"
};
var ctaxFEnYnZIrAtOaYc$2 = {
	message: "下载"
};
var tMlPwcyXKotAImFCGfQ$2 = {
	message: "请填妥并签署后以PDF上传（不可超过15MB）"
};
var SRUOTyGYueLSOwlA$2 = {
	message: "由合资格金融机构开具的资产证明（12个月内）"
};
var rpFnFNTJlMZaopFU$2 = {
	message: "由合资格人士核证的资产证明（16个月内）"
};
var sMMYOeSUIvHuRdqiC$2 = {
	message: "合资格人士包括公正机构、律师、注册会计师等"
};
var fYiJCYMSTpHPjREdFLyB$2 = {
	message: "投资组合证明"
};
var XzXwpEBzHGPNkUqaw$2 = {
	message: "例如在主经纪商（Prime Brokerage）的资产证明、持仓和交易记录等"
};
var YyrFTDoECNUvGnXVt$2 = {
	message: "您的风险取向类型为<b>$s</b>，代表您不适合虚拟资产投资"
};
var leIEPguvvNFtRsXGFI$2 = {
	message: "重试"
};
var yEMtEIJyJomPsTPTv$2 = {
	message: "您的风险取向类型为<b> $s </b>，请您继续完成《虚拟资产知识测验》"
};
var EHBFEqMJtpPqVznA$2 = {
	message: "您的测评未通过，请重试"
};
var IHceeEHwOOHjpdHosyOe$2 = {
	message: "评分"
};
var kINzgREzBDTsegQCvHQ$2 = {
	message: "恭喜，您的测评已通过！"
};
var ObVBBALqXaIzgsSPVQO$2 = {
	message: "专业投资者测评与声明表格"
};
var ckNnmPAbtNOsWqlpAKy$2 = {
	message: "根据香港证监会规定，身分证明文件的见证，应由其他持牌人或注册人、持牌人或注册人的联系人士、太平绅士或专业人士例如银行分行经理、执业会计师、律师、公证人或特许秘书加以验证。"
};
var nmOEDJmAsIcTkCgZMv$2 = {
	message: "请在完成验证后上传证明副本"
};
var jMXTehFeNbljMLGb$2 = {
	message: "或者，您可以联系<b>onboarding@bixin.com</b>安排面对面见证开户（仅限香港用户）"
};
var ZbUUOchcpSOpwpIk$2 = {
	message: "电子结单"
};
var lzbnQluepXRurDUf$2 = {
	message: "月结单"
};
var xDfYpxodvMVDQJKav$2 = {
	message: "日结单"
};
var XBrHgyrvVacGhRNJco$2 = {
	message: "您可在此查询最近12个月的月结单，如需更多查询，请联系<b>support@bixin.com</b>"
};
var cXhPoUARLvRqvesHQqeu$2 = {
	message: "选择日期"
};
var tBDAaKFwVBeiyQnnTDIA$2 = {
	message: "查询"
};
var PuqWAcBQEKXlfTuxDuD$2 = {
	message: "您可在此查询最近30天的日结单，如需更多查询，请联系<b>support@bixin.com</b>"
};
var yzrKsfyEambKetSgWv$2 = {
	message: "财务资料与资产证明"
};
var NSkMpVyoVWGymUTOzL$2 = {
	message: "专业投资者测评与声明"
};
var JkoaUyCjjTHSNUEy$2 = {
	message: "保守型 (低度风险)"
};
var LtnRgezlrxMzWvZBxRJ$2 = {
	message: "中度型 (低至中度风险)"
};
var jXvqhJJMhyxRdxCxv$2 = {
	message: "平衡型 (中度风险)"
};
var YZKOONeeIQMFqysxrZ$2 = {
	message: "增长型 (中至高度风险)"
};
var nmicLlJCgyNNjjzKJUt$2 = {
	message: "进取型 (高度风险)"
};
var BCZEHAhJNfTPwNSqVZl$2 = {
	message: "其他（选填）"
};
var zIFzaxTFaAhTdPpeh$2 = {
	message: "请至少选择一项资产证明或投资组合证明"
};
var tdxbonOdGqBYgBaOjc$2 = {
	message: "上传证明副本"
};
var XondKWeJxfchfIoGLe$2 = {
	message: "限额"
};
var ndyNHmtKJFFsefAzdv$2 = {
	message: "限额为0"
};
var FeBXkTWnPLzGZEnXEpg$2 = {
	message: "请确认您输入的信息真实有效，且与证件信息保持一致"
};
var QZCxVURndUpletXFScR$2 = {
	message: "请输入必填项"
};
var UXOpXybkQBmLEHTAgw$2 = {
	message: "账户类型"
};
var BslmwdHcTinuPaihULw$2 = {
	message: "本风险取向问卷分为三个部分："
};
var jvnfqZRQbFEGTCMGbvT$2 = {
	message: "<b>背景</b>: 第1 - 2题"
};
var NsZKEKPRgLQfWeSixA$2 = {
	message: "<b>风险状况评估问卷</b>: 第3 - 11题"
};
var icMsBwEbBUQztvmOv$2 = {
	message: "<b>投资知识与经验</b>："
};
var dXXdlICxETXaAzDyY$2 = {
	message: "非复杂产品: 第12 - 16题"
};
var zhFTdPuxrgMfcNWoA$2 = {
	message: "复杂产品（虚拟资产）: 第17 - 22题"
};
var pjPGNrHukGWKUheCaX$2 = {
	message: "在做出任何投资决定之前，请考虑咨询您的独立投资顾问。"
};
var uglsZRLSLmmcqItl$2 = {
	message: "对于联名帐户，本风险取向问卷应由所有帐户持有人填写，联名帐户持有人的集体回答将反映您商定的财务目标、情况以及财务指示方面的知识和经验。"
};
var nPqFzGTyChvJyTQw$2 = {
	message: "除非另有说明，本风险取向问卷将采用以下定义："
};
var mEPBGXtDbaIrisefS$2 = {
	message: "<b>投资</b>是指价值可能波动的投资产品，包括股票、单位信托、外币、商品、结构性投资产品、认股权证、涡轮、期货、投资连结保险计划或虚拟资产或其相关产品。"
};
var dBZfEFBQmkatfptbV$2 = {
	message: "<b>风险偏好</b>是指选择投资组合的整体方法，可能包括风险等级高于或低于您期望持有的产品。"
};
var jYUScsXfUCTPNPqSAR$2 = {
	message: "投资价值可能增加或减少，甚至可能变得毫无价值。过去的业绩数据并不代表未来的业绩。应阅读相关产品提供文件以了解更多详细资讯。"
};
var OJjDmIeMWmMfkDihQu$2 = {
	message: "本问卷中收集的个人资料将被保密。这些资讯可在保密义务下用于设计和/或推广虚拟资产产品或服务。"
};
var JoPUjgxywPfIQlnDrzx$2 = {
	message: "<b>重要提示和免责声明</b>"
};
var ZVRKVLGoMmmrOxLzg$2 = {
	message: "在完成此风险取向问卷时，您可以提出问题并听取独立建议。在您确认风险状况后，本公司将记录相应的风险偏好，并可能用于产生投资建议和评估产品对您的适合性。本免责声明作为一项无罪声明，免除本公司因本风险取向问卷中包含的任何重大遗漏、错误或虚假陈述而可能对我们提起的任何及所有债务、责任或索赔。我们在此建议所有参与者进行尽职调查，并对问卷的内容进行全面审阅。由此产生的后果，本公司不承担任何法律责任。"
};
var HYklWTwhtonjbiQRYCz$2 = {
	message: "本月未生成月结单"
};
var RsjGGXbMJbrislSlWM$2 = {
	message: "您选择的日期内未生成日结单"
};
var wEarLFdfZMShsSfacNU$2 = {
	message: "白名单管理"
};
var eEcajuQQvABwGKndqss$2 = {
	message: "管理充值、提现时的白名单列表"
};
var EfIjGkMogFrJyNKuWar$2 = {
	message: "管理"
};
var JaPjOXJRPJqsTDLdU$2 = {
	message: "请确保您的充值来自<b>白名单地址</b>，否则您的充值资产将会被冻结"
};
var cuKtQbYgXOwLPEbN$2 = {
	message: "您只能提现到白名单地址，请先<b>设置您的白名单</b>"
};
var BVmyvtMVCbAJXhwSpT$2 = {
	message: "暂无地址"
};
var NRUPVKxKVtYaCDVPq$2 = {
	message: "您确认要删除该地址吗？"
};
var szgmmxxDYVvTLNzPkk$2 = {
	message: "新增地址"
};
var mJjedBCPidtXUCYHus$2 = {
	message: "非托管钱包"
};
var IIbmROzHEYCycsCyk$2 = {
	message: "交易所"
};
var knoGdfgXpoVeAMqHCXu$2 = {
	message: "已验证"
};
var SBLHeXGlsYVIdiBNRe$2 = {
	message: "验证失败"
};
var AocjyYzlYgRsGzlavU$2 = {
	message: "地址"
};
var wQEsyNYfqlFrkqUvaDx$2 = {
	message: "状态"
};
var rbefbFgPVyawmaktVYF$2 = {
	message: "操作"
};
var MjEyxNUcFsFMIjsOIDpg$2 = {
	message: "自定义名称"
};
var ygnbLzvTAMIylzNxj$2 = {
	message: "选择网络"
};
var peIDsRhrNLVzQmAQWg$2 = {
	message: "输入地址"
};
var BbqJaDHRCDmiNwNVcGB$2 = {
	message: "验证地址"
};
var LESgEuOUJYjZQYLUlO$2 = {
	message: "签名验证"
};
var hsgIRJDqXwkPnsmgktga$2 = {
	message: "小额转账验证"
};
var mDlqsQlmoApWZXHKLq$2 = {
	message: "交易所名称"
};
var DjgcgdUJtoNmqshNSb$2 = {
	message: "请向以上地址转入<b>$s $s </b>以验证该钱包归您所有"
};
var FxlLNwkBHAbChJrnM$2 = {
	message: "我明白我需要完成小额转账以验证钱包所有权"
};
var NuZslGbiHniUKgycjhmv$2 = {
	message: "连接钱包"
};
var AdLFmhSQGMGYrTgXdUH$2 = {
	message: "已连接"
};
var rQiWsAGGRmEQCtfaIK$2 = {
	message: "签名"
};
var HjfxCIPqXHVRBXeofOe$2 = {
	message: "等待签名中……"
};
var CwyRzEeuIMzGRVzVdSVg$2 = {
	message: "签名验证中……"
};
var MgdMcyuZEloUdpqcv$2 = {
	message: "签名成功"
};
var yKqxJEvOxokRNAPXYDZC$2 = {
	message: "签名失败，请重试"
};
var FIvibwVWwddLxzofT$2 = {
	message: "重试"
};
var HQLJuhRwbVdfCwEp$2 = {
	message: "安全验证"
};
var irXsKkZagNKDlvCyhKYK$2 = {
	message: "支付密码验证"
};
var RQJGnpiCuJKbplbuWeaj$2 = {
	message: "验证通过"
};
var ULhbQlNBpFJzLTlp$2 = {
	message: "密码错误，请重试"
};
var DmecbpJQgGJiVjTqP$2 = {
	message: "请输入支付密码"
};
var qltXLGplQJNtHWdY$2 = {
	message: "成交单据"
};
var vamuznzHAJqilfEEP$2 = {
	message: "关闭成交单据提醒的风险确认"
};
var oGNuorHWcxXehehzCno$2 = {
	message: "请注意：关闭成交单据的提醒，您可能会面临更多风险，例如：您的账户将有可能在被黑客入侵或被执行未授权交易时，未能即时发现并采取必要措施而导致资产损失，或对影响您投资的市场变化的认识有限。</br>\n\n<br>请定期检查您的账户并寻找其他渠道以随时了解情况。如有疑问，请联络我们的支援团队support@bixin.com。</br>"
};
var pFjSwsuOrRtiguvbEc$2 = {
	message: "本人确认并同意不收取有关成交的通知，并自行承担一切因此变更引发的风险或损失。"
};
var VZMtxSlhbTKcmTYeEsW$2 = {
	message: "待审核或未能验证来源的资产。如有疑问，请联络客服 support@bixin.com"
};
var ivAXIbjvUUQpQqpmXz$2 = {
	message: "消息通知"
};
var thJZdZfDKDEFyETsPyzj$2 = {
	message: "未安装"
};
var mrdEVkqkBIuEBVzzL$2 = {
	message: "地址名称"
};
var JWctZqDXJyyraLbOe$2 = {
	message: "如果您选择签名验证，请在PC端登录www.bixin.com > 点击账户头像 > 账号与安全 > 白名单管理 > 新增地址"
};
var rXWcwotndeKQsLjAdyrw$2 = {
	message: "输入英文姓"
};
var ZuxEmUvBYSsOHORKrFrd$2 = {
	message: "输入英文名"
};
var TfIbvRVtJxzInjuIwq$2 = {
	message: "英文"
};
var YBvzRbRVqKkwTDkNDfoc$2 = {
	message: "联络我们"
};
var pJTXUuIjycHTetIC$2 = {
	message: "您填写的姓名应与您的账户姓名保持一致"
};
var razdiXXHIkQKbPQTZn$2 = {
	message: "绑定手机号"
};
var WCGnQDmVyXVqLZPQyqYs$2 = {
	message: "验证码已发送至您尾号$s的手机号，请查看"
};
var NgUCFdNkwlZfzWkAiv$2 = {
	message: "为确保您的账户安全，请使用手机号验证登录。"
};
var sdgZycbHzMUKHwVH$2 = {
	message: "请先绑定您的手机号："
};
var xQtzLCbkmmYpqCXOwRT$2 = {
	message: "请验证手机号码"
};
var rKSrOqgimgcTrDutYUA$2 = {
	message: "用途"
};
var nFlxQWOJCGHgwwHQhP$2 = {
	message: "请确保与您交易所账户的姓名一致"
};
var sMvNZNODlnAIiuzFMR$2 = {
	message: "1. 请提供截图显示包括交易所名称和logo、您的账户名称和联系方式等关键信息"
};
var RrEKjSeFQrtvLrZIO$2 = {
	message: "请以PNG、JPG或PDF格式上传"
};
var QnjpooahLXRwxGqJIVt$2 = {
	message: "2. 请提供截图显示您在交易所相应币种的充值地址"
};
var qZljkUmjmSBKpnUsYfp$2 = {
	message: "我确认我是以上交易所账户的所有人，且提供的资料真实有效。如存在伪造、欺瞒等不实情况，一切后果均由本人承担。"
};
var kjqqAmIhgKSjlBVQx$2 = {
	message: "公司法定全名"
};
var WfJRbDGlqfLFvNVzyWu$2 = {
	message: "请确保与您交易所的账户名称一致"
};
var wgbBNytjmVvMvqRkRL$2 = {
	message: "待验证地址"
};
var pXHPsbEpWSnCyJGH$2 = {
	message: "充值失败，已冻结"
};
var CRbVirgSccJqKzSUSEau$2 = {
	message: "如有疑问，请联系客服<b>support@bixin.com</b>"
};
var FgrxZUNDleeDGneKmwd$2 = {
	message: "更新时间"
};
var uJpZAZRdzpyAaUkEqwSx$2 = {
	message: "如果充值来自非托管钱包，请确保该钱包在充值<b>白名单地址</b>；如果充值来自交易所账户，您需要在充值后<span>验证地址</span>。否则，您的充值资产将会被冻结。"
};
var elXgEtyDNXczWYbDHV$2 = {
	message: "交易哈希"
};
var LiwpXDoMAXANnTRZ$2 = {
	message: "2. 请提供截图显示您在交易所完成该笔充值转账的交易明细"
};
var wfRBtzUHBPZjVDxUc$2 = {
	message: "该手机号已被占用"
};
var xrfefvhsEfCoJokIdeW$2 = {
	message: "您至少需要选择一种用途"
};
var gapTtWntRtJcQzRtBz$2 = {
	message: "上传交易所账户所有权证明"
};
var NhBzijnKrdihICUwgi$2 = {
	message: "法团/机构开户表格"
};
var PdxWoNDxKAJmNcpe$2 = {
	message: "请填妥并签署后以PDF上传"
};
var AHMRWIOaHFIWiIPqUx$2 = {
	message: "恭喜，您的审核已通过！"
};
var LDNvolWeNGwNyvpTMnL$2 = {
	message: "您的审核未通过"
};
var uYLqhJrdDgRVWcNvDpr$2 = {
	message: "如有疑问，请联系开户专员<b>onboarding@bixin.com</b>"
};
var ZnbyJyzHTxzgLRDFBmEm$2 = {
	message: "个人资料"
};
var FTVpPZybylBmTnwhMhtx$2 = {
	message: "请确认您已备妥开户所需填写的资料。可参考<b>个人客户注册表</b>"
};
var THMxZAxLcuuIfPErpGb$2 = {
	message: "名"
};
var bTWntlsiiBougPgd$2 = {
	message: "姓"
};
var zIgntQSydRspYJCaQ$2 = {
	message: "曾用名"
};
var vPVjNqmPYGCrexspl$2 = {
	message: "选填"
};
var oMgGPGaGAlElFewgOv$2 = {
	message: "性别"
};
var iqCHKgJKHatuZHiXEFm$2 = {
	message: "男"
};
var dHIzNCfEthjGsjpMsfJN$2 = {
	message: "女"
};
var VALtZMIyzODbkpPUOsxG$2 = {
	message: "证件类型"
};
var OOtkDwkZMvTavtRmc$2 = {
	message: "身份证"
};
var bRDTmhggLlBbrbdtfhM$2 = {
	message: "护照"
};
var IzXQAIEgQLMYmZwrzP$2 = {
	message: "证件号码"
};
var xjuVMsJZTRgjPgAzSV$2 = {
	message: "证件发行地"
};
var WACiElgvWMUDhQMxa$2 = {
	message: "国籍"
};
var USZqODoQgzwaggnbb$2 = {
	message: "出生地"
};
var KChGPohSmJORAMDUqSs$2 = {
	message: "出生日期"
};
var oGZZfIIocJcraogK$2 = {
	message: "职业"
};
var pAYXQPFeRbuYruZa$2 = {
	message: "就职行业"
};
var aaOdxWUHHLynEVSoWTM$2 = {
	message: "就职公司名"
};
var jSQVlHGDwxAZujRJNiSh$2 = {
	message: "交易目的（多选）"
};
var uuluQlsJBdDsslsERZX$2 = {
	message: "请阐述所选项（300字以内）（选填）"
};
var ACweJQrKoWgpyYspyEl$2 = {
	message: "所需产品/服务（多选）"
};
var JLIvWEpTgjlkpsZBM$2 = {
	message: "投资"
};
var UfkUhznLfeqzZyTdAebx$2 = {
	message: "交易（虚拟资产交易）"
};
var FxzVGfjClbeUZeEero$2 = {
	message: "其他"
};
var WjPizXTxbdPnvLWMql$2 = {
	message: "请说明"
};
var ytFXzDnzPIGUhOOClJ$2 = {
	message: "虚拟资产交易"
};
var dWHEObNDvkCjTnlvH$2 = {
	message: "多币种虚拟账户"
};
var lfjjwhqpvFBikfhkifrN$2 = {
	message: "财富来源（多选）"
};
var gGrAIKLFJuNxbjhnZz$2 = {
	message: "就业收入"
};
var trJoqkSnMVAvbRgAY$2 = {
	message: "商业收入"
};
var CyNhoDlSuMvcxydtF$2 = {
	message: "继承/赠予"
};
var dpvvLNDzKxLZIuixW$2 = {
	message: "租金"
};
var cYSzpXPrPUQxaAGTihK$2 = {
	message: "产权出售/投资"
};
var kYGDyxESdKUNNTdG$2 = {
	message: "预估净值"
};
var UqNGOztCBezyeAgI$2 = {
	message: "少于100万港币"
};
var TWuwXEwzngPlnjELUJ$2 = {
	message: "100-800万港币"
};
var AUNMAupfnBRbGlrb$2 = {
	message: "800万港币"
};
var EqpPTPZsKjTArTFVgWp$2 = {
	message: "800-1500万港币"
};
var oiSDCKooPzMznfGteAG$2 = {
	message: "超过1500万港币"
};
var DSFAJhsSefQQEdBBlUyt$2 = {
	message: "资金来源（多选）"
};
var aaKDUKbsmRiynWiqlS$2 = {
	message: "个人储蓄"
};
var eDeADqoJRnEUGotYxzY$2 = {
	message: "出售房产/资产"
};
var CDwWwMbhHZXYRMZHKnpO$2 = {
	message: "家人/朋友"
};
var fjjnxDoEsAfrEGSbNUL$2 = {
	message: "年收入"
};
var qqXTaCjhvvMrmeJpPG$2 = {
	message: "少于50万港币"
};
var RMCuKzWRRjQNKUNP$2 = {
	message: "50-100万港币"
};
var qipDilqNVyHfNJVyF$2 = {
	message: "100-200万港币"
};
var CuzRRZhhkOmuQgeVt$2 = {
	message: "200-300万港币"
};
var VoqaSnQNOfXstSBxca$2 = {
	message: "超过300万港币"
};
var ZCRfudjxgEkJLycN$2 = {
	message: "预估月均交易额"
};
var tdxlCkYgrpQOxYYJZiF$2 = {
	message: "少于1万港币"
};
var RZiGRHwDUpYgJcRLRnxa$2 = {
	message: "1万-10万港币"
};
var aXbxDDurboZtvnPno$2 = {
	message: "10-50万港币"
};
var OUDeIeQIjCliBQIHe$2 = {
	message: "50-100万港币"
};
var AbrPzuZLAZwUuIBnbx$2 = {
	message: "100万-1000万港币"
};
var JJAtBenOLOlFaFaP$2 = {
	message: "预估月均交易频率"
};
var YWCMpmGuparutCzjXpp$2 = {
	message: "按需交易"
};
var aCYhhkYhhIrzUQvFB$2 = {
	message: "少于10笔交易"
};
var sVTrHBZPprcyXLgcE$2 = {
	message: "10-20笔交易"
};
var oGHfMwDNMhRcKszx$2 = {
	message: "多于20笔交易"
};
var hYWPDZZNtYYwiYMfUfjX$2 = {
	message: "您或任何关联方"
};
var NIxMpJepTIBNynamgjj$2 = {
	message: "是政治公众人物（PEP）吗？"
};
var onaIGydLoNFhYUGyo$2 = {
	message: "是否与政治公众人物（PEP）有关？"
};
var nkENghGiqpNyJlRpBv$2 = {
	message: "PEP官方职位"
};
var eEBDsqLdNoLOJxjVc$2 = {
	message: "在职时间"
};
var SJBETCfUKQwBPbOwXhs$2 = {
	message: "PEP姓名以及与其关系说明"
};
var TbviyxwhVLMOhttn$2 = {
	message: "请确保您的证件发行地与后续的地址证明地区一致"
};
var SFeLOdYxYJLeOgLtZI$2 = {
	message: "预览"
};
var IKImbOtCOwEOtcDsMLv$2 = {
	message: "关联方是指："
};
var woYYXxIEUCPOPTbYi$2 = {
	message: "<br>就法人（合伙企业除外）而言，是指在该法人中拥有执行权的任何董事或任何自然人；</br>\n<br>就合伙法人而言，指任何合伙人或经理；</br>\n<br>就法律安排而言，是指在法律安排中拥有执行权的任何自然人</br>"
};
var XVImLdGTpJvSndfrLlee$2 = {
	message: "机构账户"
};
var ylhkcCPZqNeskQBJB$2 = {
	message: "法团账户"
};
var gLehflpqCNwIhEtbYIAz$2 = {
	message: "公司法定全名"
};
var BEfhHOirsmwpDEilDbq$2 = {
	message: "公司注册地址"
};
var WzIAmgVLQnPRHGRfGw$2 = {
	message: "主要营业地址"
};
var zcamcMLRNetHERtiy$2 = {
	message: "所在国家/地区"
};
var NStCDznwhsZPGYrJAq$2 = {
	message: "电话号码"
};
var pucEyENFLLeSzsJUK$2 = {
	message: "大于1000万港币"
};
var EqbYvDbdIrmgXbrPPAO$2 = {
	message: "<b>如果您之前对以下任何一个问题选择“是”，您可以通过向 <span>support@bixin.com</span>提交证明来申请豁免本测验。</b>"
};
var pyuZUzzDPovDumukD$2 = {
	message: "<br>a. 接受过银行、金融机构和/或专业机构提供的虚拟资产培训或课程；</br>\n<br>b. 任何虚拟资产的交易经验（过去3年内进行过5次或以上交易）； 或</br>\n<br>c. 目前或之前有与虚拟资产相关的工作经验</br>"
};
var xxgsgyEjhfwrMflwMr$2 = {
	message: "了解更多"
};
var PVcSgRlruKdhLYAvMUG$2 = {
	message: "100-400万港币"
};
var BIVIQEHEPCzGuQpNKSR$2 = {
	message: "400-800万港币"
};
var GhRAIjbecBWjePTjqSD$2 = {
	message: "FATCA声明表格"
};
var qsVtkTgbKcuLSPDXf$2 = {
	message: "查看"
};
var WINbdlmnRMSyZUqkxCP$2 = {
	message: "个人认证教程"
};
var bnpgtsIPDfFydCQlTH$2 = {
	message: "剩余充值额度"
};
var BgXkLkPusAcJBiUmSw$2 = {
	message: "剩余提现额度"
};
var OARZuIqYLXtlrvaEsC$2 = {
	message: "法团/机构认证教程"
};
var YLJxFxxsgqpWcZWy$2 = {
	message: "请扫描下方二维码或手动输入私钥"
};
var RjPDzDdrzBcLHVJiG$2 = {
	message: "剩余提现额度不足"
};
var DrmqiYKPSoxMBWXT$2 = {
	message: "FATCA和CRS自我证明表格"
};
var nSdDtaHzknwZAXJHzrGP$2 = {
	message: "添加验证器"
};
var NZjrOkmPAHtiaMLyuVDA$2 = {
	message: "或者，您可以选择面对面见证开户（仅限香港用户），我们的开户团队将尽快与您联系"
};
var XfjZomFsTRpbZJuHjI$2 = {
	message: "请联系我安排面对面见证开户"
};
var lxppTPAJDxxMIGdmiRG$2 = {
	message: "请选择一种验证方式"
};
var OljlLKYobPynbcStGlN$2 = {
	message: "您只需选择一种验证方式"
};
var YXrqAGUqprWfOCeiSGX$2 = {
	message: "审核结果将通过邮件通知"
};
var MkfqKEzRwLTbzJEOeWg$2 = {
	message: "我们的开户团队会尽快与您联系"
};
var vshrtYQXEVpbXmLZwV$2 = {
	message: "请查收邮件"
};
var wINMfXpJczhYZOnUXWp$2 = {
	message: "请输入Google Authenticator/Authy 验证码"
};
var uetkXvxfFuKnhpBFrA$2 = {
	message: "谷歌验证器"
};
var sZVlKBQCGGTVChpa$2 = {
	message: "Google Authenticator/Authy验证"
};
var AZVALNHESdbXtHmNY$2 = {
	message: "闪兑"
};
var pVQoQWJNGEfRwmpZMki$2 = {
	message: "支付"
};
var HsxgqsfmdLnIcdcXgLS$2 = {
	message: "获得"
};
var gohHRZTjodstzoCLNv$2 = {
	message: "可用"
};
var rfXBETBheWYaMqrktE$2 = {
	message: "兑换率"
};
var rxfIffMgcmDGmXfVZA$2 = {
	message: "兑换率为预估值，实际得到的数量以成交时为准"
};
var ifmHgobawgqPHdruP$2 = {
	message: "预览兑换"
};
var AkLeJkGIGPcgMPOyMJvd$2 = {
	message: "最大滑点"
};
var SLZgFNtUooxfLTcXEnm$2 = {
	message: "自定义"
};
var APOikjpbuiZXwYbMlWBl$2 = {
	message: "如实际价格在不利方向上超出最大滑点范围，兑换可能无法全部执行"
};
var pEZOQJSBxlCYyrjM$2 = {
	message: "滑点范围较大可能导致更不利的成交价格"
};
var IKLXXpDUJHlgctnhc$2 = {
	message: "当月剩余可交易额度"
};
var GSkKAUsvGPYZMAnFnH$2 = {
	message: "保存"
};
var HIptAJwjtWvHteUhwW$2 = {
	message: "选择币种"
};
var ETkemdVBXuBSBAstv$2 = {
	message: "确认兑换"
};
var fUqbBtyQPrkRchcpe$2 = {
	message: "手续费"
};
var wprsRqdyQRGnVcbsp$2 = {
	message: "该报价已过期，请刷新"
};
var zDKhBsXavFMPAEqgdH$2 = {
	message: "刷新"
};
var PpelPkXnzahxkdhVa$2 = {
	message: "兑换处理中"
};
var XvACoEmpLFSLVHywT$2 = {
	message: "您的资金暂时被锁定"
};
var hhiTSbgqtfHswnyfCs$2 = {
	message: "兑换成功"
};
var jwkMtTwNHEktKLQA$2 = {
	message: "兑换失败"
};
var aTPVtxAhNeuzjutYgu$2 = {
	message: "您的资金将退回您的资金账户"
};
var CSMPJDQZLtdBrHSlRhzp$2 = {
	message: "设置滑点"
};
var OYByrRpUomOXEqORBozE$2 = {
	message: "兑换"
};
var pQEEhEzMgmLpEznsEH$2 = {
	message: "资产名称"
};
var HNUebnMoRCmoPDEpASH$2 = {
	message: "价格"
};
var ARCAktOTCiLqQqaPTv$2 = {
	message: "总数量"
};
var LJPMiQOhqtJqlBRBCHX$2 = {
	message: "银行转账验证"
};
var lvouKixXkMbDqOnnr$2 = {
	message: "其他验证方式"
};
var FRjQUDLIESvWvPOQY$2 = {
	message: "通过向Bixin.com银行账户单笔转账不少于10,000 HKD（或等值USD）以完成开户验证"
};
var JNPXLHStukWLfpLRU$2 = {
	message: "第三方持牌人/注册人验证；或与Bixin.com开户团队面对面验证"
};
var dQRnMUSMOEdAwdfMqW$2 = {
	message: "请您以本人$s $s名下的银行账户向以下Bixin.com的银行账户转入一笔<b>不少于10,000 HKD（或等值USD）</b>的充值以完成验证，否则可能会导致延迟到账，甚至退款。如果金额不足，也将导致验证失败并退款。"
};
var cHodlBcOiNHOlxFn$2 = {
	message: "了解更多"
};
var tglvvZIzjMuxIoXEYs$2 = {
	message: "目前支持银行转账验证的"
};
var yDGXBsHUIoIkgqfepe$2 = {
	message: "目前接受的充值货币是：HKD或USD"
};
var lsdjJQPYPEOcAzVOth$2 = {
	message: "请避免向平台充值不支持的资产，否则将会退款，由此产生的退款费用需要您自行承担。"
};
var PlIgEPTbgrrwkSuHc$2 = {
	message: "银行名称"
};
var NqhjvGQWWHnmAzDH$2 = {
	message: "收款人名称"
};
var QNEAoNoQfTpYIxJvjdM$2 = {
	message: "账户号码"
};
var MhWCMBfnPEmyPhdBJC$2 = {
	message: "银行编号"
};
var rcbvwVBVHsJazGKrQv$2 = {
	message: "SWIFT代码"
};
var HsYTxsCouoyySItw$2 = {
	message: "银行地址"
};
var CNXhqxsuJtAEOpHCSI$2 = {
	message: "上传转账凭证"
};
var iQYmhTkvoynVhdKfkY$2 = {
	message: "请在完成银行转账后，上传交易凭证"
};
var lLKoAhJqRLmDyyTCvO$2 = {
	message: "PDF或JPG格式，不超过5MB"
};
var bNcNiQWtnacHBQFyTY$2 = {
	message: "超出最大交易数量"
};
var JIozcUyGaPUboZLlBjVN$2 = {
	message: "未达最小交易数量"
};
var tNbQTPYLVCKjsvpja$2 = {
	message: "月交易额度不足"
};
var UrkVGOIalMNhKwpIEzK$2 = {
	message: "法币充值"
};
var cCtaFICzFmzJltYPL$2 = {
	message: "选择扣款账号"
};
var SVpHROUKzBJsjSVHMK$2 = {
	message: "添加银行账号"
};
var UMTZPjOpYZuhdhDbBVO$2 = {
	message: "第一步：请您从已选择的扣款账号向以下Bixin.com的银行账户充值$s"
};
var iBQIPIJCNFHBCeRIvm$2 = {
	message: "单笔最小充值限额："
};
var nedDtIXJkIrvdDqe$2 = {
	message: "请提供您银行转账的交易凭证。审核通过后，您的充值将完成入账。"
};
var xWhLpCcRjLgSplng$2 = {
	message: "第二步：上传转账凭证"
};
var DZjgiswpELVABBqUWCSa$2 = {
	message: "银行转账"
};
var XrngZedCHgJUKulaDcT$2 = {
	message: "选择收款账号"
};
var fWgPNysKDTLrzjgrexk$2 = {
	message: "输入提现金额"
};
var QIzonbZxYqJjQrPHfJM$2 = {
	message: "最小提现额"
};
var iHptEcwFnEbHVLaQkXyb$2 = {
	message: "手续费"
};
var uUpDUGTUrKdXVQXkgSP$2 = {
	message: "提现手续费不包括银行收费，费率以具体银行为准"
};
var HzbSujYkGuYtObRcrdbh$2 = {
	message: "手续费不包含在提现金额中，将从您的账户余额中扣除"
};
var NOYdleknddFOfQxlNOI$2 = {
	message: "提现金额"
};
var nqPKzhAfSmqRRIHii$2 = {
	message: "法币提现"
};
var eOPHosimYamraEKUukBz$2 = {
	message: "确认提现"
};
var LoBOFhdSzMFjdqZgDE$2 = {
	message: "收款账号"
};
var mHVIpiFPJQPNPFYAeeu$2 = {
	message: "请确认以上信息准确无误"
};
var TNXdbUElFLwiyRVKuJ$2 = {
	message: "审核成功后将为您安排银行转账，请注意查收邮件通知"
};
var wLQWZKMRgmTJTSudW$2 = {
	message: "管理账号"
};
var GkvuBozDTWJAXbpwyP$2 = {
	message: "虚拟资产"
};
var IMxXGyWWPXtfrrwxV$2 = {
	message: "法币"
};
var tibiqQyzvztLFMGQ$2 = {
	message: "法币账号管理"
};
var fXTeVLzGkVECTSGgtm$2 = {
	message: "新增账号"
};
var XYVTanLxxisBNzaOFx$2 = {
	message: "账号"
};
var bdAMbKWoEuDxlGOg$2 = {
	message: "暂无账号"
};
var ALJjPGCRLTrnWlbmqO$2 = {
	message: "请确保是您本人名下账户"
};
var znOXnaDhTySukBeCrT$2 = {
	message: "请确认您是否已使用以上银行账号完成KYC银行转账验证？"
};
var ESHCFsWVeQAWSnEKV$2 = {
	message: "后续您需使用该账户向Bixin.com的银行账户存入不少于10,000 HKD（或等值USD）以完成验证"
};
var lLAJPCrarwsWDdbLaw$2 = {
	message: "搜索币种"
};
var biXQrrlOVDoExCZZKC$2 = {
	message: "设置成功"
};
var spot_trading$2 = {
	message: "现货交易"
};
var MTiCVGmtBjEPWzsw$2 = {
	message: "香港永久性居民身份证"
};
var zLnEBdSfUXdqbRqAohY$2 = {
	message: "您是否拥有其他国家/地区的有效身份证件？"
};
var oVvhpgfhTeyLLnTSv$2 = {
	message: "请提供您的外国居民身份证明文件"
};
var OEfurFwwcJaTsVxNdol$2 = {
	message: "支持的身份证明文件包括：外国居民身份证，工作/学生/受养人签证等长期签证"
};
var TeRrrjzubYVYnBhsdpD$2 = {
	message: "外国居民身份证"
};
var xwQqYnxnxmeJPqRlQ$2 = {
	message: "工作/学生等长期签证"
};
var hoTQEpJFfRRLZGLWiDK$2 = {
	message: "证件类型"
};
var wZuMVSBUSlQidCQpjoS$2 = {
	message: "上传证件"
};
var oSDxsXgENbIeNMLv$2 = {
	message: "正面"
};
var aoAIqdHabiquSjWWz$2 = {
	message: "反面（如有）"
};
var YltriUZdkgLJuXZi$2 = {
	message: "18 - 20岁"
};
var sZudUtmwNMYVhQhyj$2 = {
	message: "21 - 54岁"
};
var slqgnwkLOtCyZiTBWb$2 = {
	message: "55 - 69岁"
};
var PwxbwKVPjpeCuRYx$2 = {
	message: "70岁或以上"
};
var domCttddTWzCfimSWOq$2 = {
	message: "当前持仓"
};
var dqLNRujTTFLifcFaybP$2 = {
	message: "持仓限额"
};
var wIfwelYvkemWaZGE$2 = {
	message: "持仓限额是指您账户下（包括主账户和子账户）可用于交易的最大限额"
};
var vDIneAtEexNLfRMcVPa$2 = {
	message: "划转请求失败！您的交易账户总额不可超过最大持仓限额。"
};
var YYzgmIpjtorJXoyQJUk$2 = {
	message: "当前剩余持仓额度为："
};
var rZkFVZvvCQRyHCfLiNVX$2 = {
	message: "您必须减少下单数量或减仓交易账户中的虚拟资产"
};
var VXwjemLYMJiNKvXlZ$2 = {
	message: "国家/地区"
};
var GZOFzxVOsYtRtlONwcv$2 = {
	message: "输入全称"
};
var YiNdDLTlBGFQiuNECi$2 = {
	message: "输入全名"
};
var aFykbSRCZkUrYNzoKtk$2 = {
	message: "输入银行账号"
};
var TgilgrTuMXgbAQuPf$2 = {
	message: "输入银行编号"
};
var MQaUVFeBMhHfKxmBUV$2 = {
	message: "输入银行SWIFT代码"
};
var HgKGDukwWWdCeZlibVY$2 = {
	message: "输入银行地址"
};
var rhXOjsQATKgJNizniW$2 = {
	message: "由于银行结算时间的限制，充值资金最终到账的时间以资金在Bixin.com开户银行实际到账的时间为准。"
};
var pKuaKUWJHuajbExMUs$2 = {
	message: "Bixin.com不收取充值手续费，但您的银行可能收取手续费用，手续费将从您的充值金额中扣除，以实际入账金额为准。"
};
var nkcDnQvbZpDfYMepAc$2 = {
	message: "如果您的汇款是香港本地汇款，一般情况下半个工作日内就能到账。如果是符合规定的跨境汇款，一般需要2-3个工作日才能到账。如果遇到银行假期或公共节假日，到账时间将会相应延后。"
};
var UHAKvmcFPrannQlFz$2 = {
	message: "您确认要删除该账号吗？"
};
var MmdyZCvMXusVhfjsV$2 = {
	message: "分行编号"
};
var MGsQCMXzOIuqcXjBDDTF$2 = {
	message: "重要更新"
};
var xYFrGCCcvvWooWsibQFD$2 = {
	message: "根据AMLO第3G附表的规定，NewBX Limited (CE编号: BUY737)自2024年6月1日起被视为获得许可提供虚拟资产服务（营运虚拟资产交易所），但需遵守SFC要求的特定条件和条款。"
};
var omBdaJrTBmDrBzNYx$2 = {
	message: "NewBX Limited尚未获得香港证券及期货事务监察委员会的许可，并且可能最终不会被授予许可，因为委员会可能拒绝其许可申请或其申请可能被撤回。它仅被视为根据《反洗钱及打击恐怖主义融资条例》获得许可。"
};
var omTkmNnwlfkOvozU$2 = {
	message: "有关视为许可安排及公司许可状态的最新信息，您可以参考SFC网站："
};
var YxGqBoJIoXruDOmbNu$2 = {
	message: "我明白"
};
var NOhPBjPDsgVbfqTgjIH$2 = {
	message: "十年安全运营，百万用戶信赖！"
};
var gcFEhAlcWmjNfIqry$2 = {
	message: "BIXIN.COM成立于2014年，前身为HaoBTC，是全球首批虚拟资产托管商之一。多年来，BIXIN.COM已发展成为一个综合性的虚拟资产交易平台，为用户提供“易用又安全”的服务。其运营实体NewBX Limited是一家香港有限责任公司，是币信集团的全资子公司。"
};
var npetoxnFYOYxRjXRN$2 = {
	message: "检测到您正在使用VPN，请先关闭"
};
var TzvXfzahEvyWlLOZQE$2 = {
	message: "抱歉！您所在的国家/地区暂不提供支持"
};
var LuuhHZgOxbTJDvnm$2 = {
	message: "您的账户目前为休眠状态"
};
var sqteSBzbeJvwJeJSWZk$2 = {
	message: "请联系客服<b>support@bixin.com</b>重新激活您的账户"
};
var uhoCqEIxFLCGpwTslFY$2 = {
	message: "请选择并确认"
};
var OzYooSlNbfNTxRxNhe$2 = {
	message: "我确认我的资料均无变更"
};
var JQpSpVQqatEXOdgFvjh$2 = {
	message: "我需要更新资料"
};
var onOjgIPTpDDXLIwlSWE$2 = {
	message: "更新资料"
};
var gDgIYTmDidzeeXyOV$2 = {
	message: "修改"
};
var cOOoOlxMURFANNpFpYx$2 = {
	message: "如需更新证件信息，请同时上传经核证的证件副本"
};
var nAVsbekWuHffflMnfHHy$2 = {
	message: "如需更新常居地址，请同时上传经核证的住址证明"
};
var WelPCqxRFgXNzpkZJdsh$2 = {
	message: "您已完成确认，请勿重复提交"
};
var npqmwWmfuEsNrfQJt$2 = {
	message: "请您确认所有信息准确无误后提交"
};
var wcfFqisAqLRlhbKdJk$2 = {
	message: "财富来源证明"
};
var wcJAFtgivjbkVSdTC$2 = {
	message: "请提供与您所选财富来源对应的证明材料（最近12个月内）"
};
var pSUGpUOowrIgSHLfEIs$2 = {
	message: "重新上传"
};
var cWYINWiSUUdFuDAImP$2 = {
	message: "提交成功！"
};
var tUrSbGVjlpoCdTkb$2 = {
	message: "我们将开始对您的账户进行定期审阅，以确保我们可以持续为您提供服务。通常情况下，这个过程不会影响您的正常使用。但如果我们在审阅过程中发现任何问题，我们将立即通过电邮通知您。"
};
var YvXCqALOsnrEQAHU$2 = {
	message: "感谢您的理解和配合。如有疑问，请联络我们的客服："
};
var JJfMolWuWCFgrDrUiz$2 = {
	message: "感谢您的确认！"
};
var plHTmWdGncJPnVBJuI$2 = {
	message: "另外，您还需提供财富来源的证明材料"
};
var HbkwQxpXzqUXEvkxVmz$2 = {
	message: "选择需要更新的信息类型"
};
var KOycuFuoXkNBrUCLtCVL$2 = {
	message: "添加文件"
};
var yYxnWdRQrNPhFUhmKp$2 = {
	message: "添加信息类型"
};
var oWOQzlGOqirSVhUhQX$2 = {
	message: "上传经核证副本"
};
var xbTIXxCJIOnbLImHUPI$2 = {
	message: "周年申报表 (NAR1)"
};
var VSmzJHKoDZuNenetubvZ$2 = {
	message: "公司注册（CI）"
};
var YJlyfJbAZRZhGensD$2 = {
	message: "公司更改名称证明（如适用）"
};
var SuSDXCILmprzPXIonL$2 = {
	message: "商业登记证（BR）"
};
var FnrHWNqUvXlpfQLAfT$2 = {
	message: "公司章程（AA）"
};
var uPrPwsvUYglduYxnfgb$2 = {
	message: "6个月内的董事在职证明（COI)（仅限离岸公司）"
};
var BvERvFYtRmpkINLVdX$2 = {
	message: "股份转让书（如适用）"
};
var MSaPBxOSKeCTtUMPq$2 = {
	message: "股权架构"
};
var olGkjZMWDZBQwjnVK$2 = {
	message: "董事/授权签字人/实益拥有人身份证件"
};
var PmdVNRJcWUxjWfFSA$2 = {
	message: "董事/授权签字人/实益拥有人地址证明"
};
var gCLhGVwztVSCPNZUgqQN$2 = {
	message: "业务性质"
};
var FDynUJSlxYFxtAhrQN$2 = {
	message: "银行机构"
};
var UBCBvFlsnzzgcIOHTmN$2 = {
	message: "持牌放贷机构"
};
var MERzsdKkxudpOnlaF$2 = {
	message: "持牌货币兑换商/汇款服务商"
};
var XtpeIeGyrDDKSkgyCiL$2 = {
	message: "基金管理/信托/受托人服务"
};
var LxcfZSEIROwQeVCok$2 = {
	message: "持牌支付服务提供商"
};
var fxjdlTQeJFVyjFXmhlnI$2 = {
	message: "请勾选适合选项并简短陈述所选项"
};
var aVbJYJuVEhKXAqlbWgUE$2 = {
	message: "请阐述所选项（300字以内）"
};
var yicaYCvBFspqWpPqS$2 = {
	message: "投资收益"
};
var YLfvFQfagZeMpkzlO$2 = {
	message: "销售收入"
};
var fsjyqgrUVSYOXDUxw$2 = {
	message: "资产出售"
};
var WQsiZpVbrxKoaVkQ$2 = {
	message: "客户/投资人资金"
};
var KpLdefqDhhhdklLzxOgC$2 = {
	message: "公司自由资金/资产"
};
var WbJXVvgJiwcWWgRAYq$2 = {
	message: "公司财富来源证明"
};
var EcnKFNIFTwRUshkf$2 = {
	message: "请提供贵公司所申报的财富来源对应的证明材料（最近12个月内）"
};
var xGdbGnjcDCabqvFJX$2 = {
	message: "商业收入"
};
var olJXBlENebamalqAmC$2 = {
	message: "投资人注资"
};
var lnaNMhKSbkHzoYmMHp$2 = {
	message: "股东注资"
};
var MFJyykUbSXUkUqHxlJ$2 = {
	message: "商业借款"
};
var UsVahXMYImjwSrxR$2 = {
	message: "产权出售/投资"
};
var XjUPUpsmbzqDVlOyOzD$2 = {
	message: "实益拥有人财富来源证明"
};
var bYjpHFpkXBumbkZHbM$2 = {
	message: "请提供贵公司所有实益拥有人（UBO）的财富来源证明材料（最近12个月内）"
};
var nZkngKdQlMblSkIsJt$2 = {
	message: "实益拥有人姓名"
};
var vfiTAWyuaCrULibnur$2 = {
	message: "实益拥有人"
};
var hubWrmcrofRaRoYLCAS$2 = {
	message: "另外，您还需提供贵公司财富来源的证明材料"
};
var dIOuyFmCcSAXzBifCgd$2 = {
	message: "我们将开始对贵公司的账户进行定期审阅，以确保我们可以持续为贵公司提供服务。通常情况下，这个过程不会影响您公司账户的正常使用。但如果我们在审阅过程中发现任何问题，我们将立即通过电邮通知公司的联络人。"
};
var AoqexRnXPjWiaXQQ$2 = {
	message: "请先保存"
};
var wtPiDpoJwweHEwGphG$2 = {
	message: "子账户"
};
var YFShWZLtmVzhKApQSudo$2 = {
	message: "子账户管理"
};
var EyxlrwvHrdhvRaHtLxx$2 = {
	message: "您最多可创建$s个子账户"
};
var YbTVKYSCHSNbVSRpbwRM$2 = {
	message: "登录邮箱"
};
var rWOqJloUMhKXCZHLpnc$2 = {
	message: "创建日期"
};
var nmuzQLDdidsSBtDTLaU$2 = {
	message: "暂无子账户"
};
var cKeVqkUVuUrblpSkN$2 = {
	message: "暂无API"
};
var KgtuAymJbpqjZHQACDKA$2 = {
	message: "账户划转"
};
var WriODPyMHmFqbNRIkh$2 = {
	message: "支持主账户与子账户下资金账户之间的划转"
};
var kdGDbDfHqPdMmOODj$2 = {
	message: "新增子账户"
};
var fRcWTONIbiPEHREbRTKI$2 = {
	message: "账户验证"
};
var MIqinsTMANLFyEzWlLXm$2 = {
	message: "子账户邮箱："
};
var xmSClcrPuftAggqMjWp$2 = {
	message: "绑定手机号："
};
var uPEmuahfZCJKifAf$2 = {
	message: "正常"
};
var NazoeCHUJpEyQWZDKcVt$2 = {
	message: "已停用"
};
var ZtmHIANowsUTyUyouyg$2 = {
	message: "停用"
};
var DyXvKDfsUBPKtQScEVw$2 = {
	message: "启用"
};
var SGvHMSujomhCIGweYcH$2 = {
	message: "您确认要删除此子账户吗？此操作不可逆"
};
var xFLmujpTZsyQKTENeNr$2 = {
	message: "请确认此子账户中不含任何资产，否则将删除失败。所有关联的委托订单将被取消，API Key将被删除。您将空出一个子账户配额以创建新的子账户，但无法使用已删除的子账户邮箱再创建新的子账户。"
};
var xPXNyAgtdawfwFRxXhb$2 = {
	message: "请先清空子账户中的资产"
};
var VoQarJJpktEfEZnK$2 = {
	message: "您确认要启用此子账户吗？"
};
var wfUNVCtRXprhwYwce$2 = {
	message: "获取验证码"
};
var nirNFLwkcuvUxudti$2 = {
	message: "API管理"
};
var GqlajLqwcNJLpTqq$2 = {
	message: "每个子账户最多可创建5个API Key"
};
var NKaDUgPomETDmcmKHy$2 = {
	message: "请妥善保管您的API Key和Secret Key，以免泄露后造成资产损失"
};
var OsCIqseGbbbWXxBLk$2 = {
	message: "输入邮箱/标签名/API Key"
};
var DghVzIJcKyuvkcKwY$2 = {
	message: "标签名"
};
var XYnywMktJDrWPwZBA$2 = {
	message: "您确认要删除此API Key吗？"
};
var bgnQSQsWYPIcUDEytcq$2 = {
	message: "新增API"
};
var erGplJlLIBiVheXvc$2 = {
	message: "选择子账户"
};
var epeFMTUcZAYdtLOETgZ$2 = {
	message: "API标签名"
};
var oIIfiHdqGwpXZbtDYKG$2 = {
	message: "自定义标签名"
};
var mlUEUuDRftKStSMvF$2 = {
	message: "请先在子账户中存入资产"
};
var nNgFtrjyhesGreVhV$2 = {
	message: "API信息"
};
var ewrHdSoDPutFlPrqTEr$2 = {
	message: "仅在创建时显示，请妥善保管"
};
var ZZlJgALCrsSaNhaoV$2 = {
	message: "API权限"
};
var OgusvSSbzkNopiGbCIo$2 = {
	message: "IP访问限制"
};
var nmPUwVVQoncVHqMln$2 = {
	message: "输入受信任的IP地址，多个地址用；隔开"
};
var mWaNsXTgUIcnWSphpgB$2 = {
	message: "12个月内由托管商签发的账户报表/证明"
};
var GxjDaNmTVZaIEmLIO$2 = {
	message: "12个月内由审计师/注册会计师颁发的证明"
};
var xdBmFzKPmVQfqVSOyFY$2 = {
	message: "12个月内提交的公开备案文件"
};
var xdSXcpFurEbSenWcxPn$2 = {
	message: "请至少选择一项证明文件"
};
var KzRRnMZfXiUfprzBEe$2 = {
	message: "如需申请专业投资者认证</br>请联系开户团队<b>onboarding@bixin.com</b>"
};
var nDIaTJMAdTQRxUKJo$2 = {
	message: "错误的用户名或密码"
};
var XaQWqbeAdXIkLCiakX$2 = {
	message: "您的账户尚未开通子账户功能。如需申请，请说明理由："
};
var WHFSIZvkPFlAiUsTW$2 = {
	message: "请阐述申请开通子账户功能的原因，不超过300字"
};
var IldgeERuYKVOefpR$2 = {
	message: "子账户申请"
};
var sYnLKnDJjNhHBCpTj$2 = {
	message: "关闭"
};
var ZtsyDNmrvXDDftOHri$2 = {
	message: "验证失败，请重新验证或刷新页面重试"
};
var vAeqeVWtpVywOzVUYfuv$2 = {
	message: "您确定需要停用账号$s？"
};
var PLWcAjJpcpPoIQiCcq$2 = {
	message: "您将无法登录此账户，且所有关联的委托订单将被取消，API Key将被删除。"
};
var QHhdRUWMTaGpDwrC$2 = {
	message: "该邮箱曾被删除，无法再添加"
};
var account_transfer$2 = {
	message: "账户划转"
};
var account$2 = {
	message: "账户"
};
var UKenwEAFyRZgQyZTmPYy$2 = {
	message: "删除成功"
};
var zhJSON = {
	pHHNdTPNyDzQgIvYd: pHHNdTPNyDzQgIvYd$2,
	cWSaveaKAPErStEYy: cWSaveaKAPErStEYy$2,
	sSIcbzainkLvqqhxh: sSIcbzainkLvqqhxh$2,
	aLZzpUtzvgrrPWvcQGbT: aLZzpUtzvgrrPWvcQGbT$2,
	IizWxRwTfRDgQnVPXcb: IizWxRwTfRDgQnVPXcb$2,
	jeYCQaSvbBRtAklYZ: jeYCQaSvbBRtAklYZ$2,
	kfASiYACukCdCVcFmcsq: kfASiYACukCdCVcFmcsq$2,
	YpcGXAgMexsVEmQnseE: YpcGXAgMexsVEmQnseE$2,
	OivHVusJobtDPuGMSbDN: OivHVusJobtDPuGMSbDN$2,
	HNryhyKcRNPaLZpBHK: HNryhyKcRNPaLZpBHK$2,
	IDPsMPUXhtCczMWcA: IDPsMPUXhtCczMWcA$2,
	MnGzdARgdxwWnBQGqasa: MnGzdARgdxwWnBQGqasa$2,
	dSypETsKWXyxFowLHe: dSypETsKWXyxFowLHe$2,
	CRjZdhorIpDDNDAPls: CRjZdhorIpDDNDAPls$2,
	KEEUdFUfkYDFEeiUhk: KEEUdFUfkYDFEeiUhk$2,
	BQbWzLQtSHQVHdIDAgJ: BQbWzLQtSHQVHdIDAgJ$2,
	fxHeYqwgtTcKAdCKPyVe: fxHeYqwgtTcKAdCKPyVe$2,
	OXrwZMwkWAjoSDDALzow: OXrwZMwkWAjoSDDALzow$2,
	tOaRBVUJHpnSgDBrGON: tOaRBVUJHpnSgDBrGON$2,
	WbPTckCFMKtPHgAlL: WbPTckCFMKtPHgAlL$2,
	nHxEoVJEcaAOmKgBbYO: nHxEoVJEcaAOmKgBbYO$2,
	MZjVFSmKoCrehUMcH: MZjVFSmKoCrehUMcH$2,
	puvbUtnTezlmHPfbVAqn: puvbUtnTezlmHPfbVAqn$2,
	HOpNrycyzpeOCvcWPwAM: HOpNrycyzpeOCvcWPwAM$2,
	QaixZWMxqfefkNPgkdy: QaixZWMxqfefkNPgkdy$2,
	RPMjhEtAWhHwQeAjSV: RPMjhEtAWhHwQeAjSV$2,
	mBnIkwyDNdwNDoWcq: mBnIkwyDNdwNDoWcq$2,
	ApuVYLcjyFSzxzZB: ApuVYLcjyFSzxzZB$2,
	YoNUkubiEWSyPsgRUR: YoNUkubiEWSyPsgRUR$2,
	msvgVjHCdtHxFKkrS: msvgVjHCdtHxFKkrS$2,
	SUObcbdMwQrjwarfaMi: SUObcbdMwQrjwarfaMi$2,
	ElMEzQxYcCuZMmCmB: ElMEzQxYcCuZMmCmB$2,
	idqLvJqjeiEmQbpa: idqLvJqjeiEmQbpa$2,
	FhkGAkzeRaGMUGCREr: FhkGAkzeRaGMUGCREr$2,
	lXmoRtYVpvHfxffpUp: lXmoRtYVpvHfxffpUp$2,
	fIZJfHadJjLYozRPMC: fIZJfHadJjLYozRPMC$2,
	fVuoUoQRKfJuwltrQWcF: fVuoUoQRKfJuwltrQWcF$2,
	tMHuCmLcCyWTKXTkJpl: tMHuCmLcCyWTKXTkJpl$2,
	yXhUtplPqxAjDtkzW: yXhUtplPqxAjDtkzW$2,
	EGBtpzynCWcQsWcMz: EGBtpzynCWcQsWcMz$2,
	nFxxFVzdRTilHiouzuY: nFxxFVzdRTilHiouzuY$2,
	gYpQegnebgwwccEuM: gYpQegnebgwwccEuM$2,
	HQSjnUOWYQPuvvTpu: HQSjnUOWYQPuvvTpu$2,
	PufPEQRHcFlNqsAG: PufPEQRHcFlNqsAG$2,
	lvvtaxnLzNOtFCZllw: lvvtaxnLzNOtFCZllw$2,
	NoqAHzFdypmIlmXmyM: NoqAHzFdypmIlmXmyM$2,
	dLTuZclgDrLDUToEe: dLTuZclgDrLDUToEe$2,
	YChcfaxDaLscdSPiRQz: YChcfaxDaLscdSPiRQz$2,
	qtCIhbuRgppyZzltf: qtCIhbuRgppyZzltf$2,
	wvzbJUEmNoCiDQLTaWzH: wvzbJUEmNoCiDQLTaWzH$2,
	POdaGgvMxQRsisLbVcll: POdaGgvMxQRsisLbVcll$2,
	qRoYPOkmAoqOZnZawkD: qRoYPOkmAoqOZnZawkD$2,
	SgWXitfFwQHiWicT: SgWXitfFwQHiWicT$2,
	txfROteTwdaWdTnlkif: txfROteTwdaWdTnlkif$2,
	qEmYfNcGOwxFPeXxWz: qEmYfNcGOwxFPeXxWz$2,
	sjqwCBQBKOIAKZymEnSd: sjqwCBQBKOIAKZymEnSd$2,
	wAFriagWUVTteXOh: wAFriagWUVTteXOh$2,
	ffqVyVPsxEFhGDWwjo: ffqVyVPsxEFhGDWwjo$2,
	ZFmapCdeoYAGjnNG: ZFmapCdeoYAGjnNG$2,
	JTHQBsfkCFvanpmGhYL: JTHQBsfkCFvanpmGhYL$2,
	tLufHBCFhvZchanHd: tLufHBCFhvZchanHd$2,
	VUMActZjvXkEaSCs: VUMActZjvXkEaSCs$2,
	dqGnSTBmWfxxuxSAR: dqGnSTBmWfxxuxSAR$2,
	NrifpOBOTpbiyPCqT: NrifpOBOTpbiyPCqT$2,
	ogjLTTEZpYaUhUJAk: ogjLTTEZpYaUhUJAk$2,
	TGFdcFVaVnCAXfpC: TGFdcFVaVnCAXfpC$2,
	cFKHegtmXlwojKtJw: cFKHegtmXlwojKtJw$2,
	pNHFlymBnWuShBmbewj: pNHFlymBnWuShBmbewj$2,
	AsLSeryFUtTwDklOIhVE: AsLSeryFUtTwDklOIhVE$2,
	lNGEpmcaWzCMRfZFypa: lNGEpmcaWzCMRfZFypa$2,
	CKVRBnYMLalEUVhYrqI: CKVRBnYMLalEUVhYrqI$2,
	JAKswaiCfseLlQNZ: JAKswaiCfseLlQNZ$2,
	bZduiedsIokAAxBsM: bZduiedsIokAAxBsM$2,
	rtVWmSuAATyCaNgkRNx: rtVWmSuAATyCaNgkRNx$2,
	TVTktEvtpSXRbnxIB: TVTktEvtpSXRbnxIB$2,
	leXQdnNvhrYWetVTXjE: leXQdnNvhrYWetVTXjE$2,
	MzbyaTzwTlbRpWdHmwt: MzbyaTzwTlbRpWdHmwt$2,
	phfuULxmHCuLNyotJ: phfuULxmHCuLNyotJ$2,
	qdvGrtpVJQsGGgiLvje: qdvGrtpVJQsGGgiLvje$2,
	PIxkcsUxBzUPVVFfu: PIxkcsUxBzUPVVFfu$2,
	OBIAENcRtoPgMWcJNZ: OBIAENcRtoPgMWcJNZ$2,
	iDYPzXzvGbnKWCRr: iDYPzXzvGbnKWCRr$2,
	FmpkJYVtUXpBCGEVp: FmpkJYVtUXpBCGEVp$2,
	mzWsFtJNWfexuuUgYctv: mzWsFtJNWfexuuUgYctv$2,
	wjeaGDSVTuLLjJGehN: wjeaGDSVTuLLjJGehN$2,
	KbSjSRobgQmXjHChGKJ: KbSjSRobgQmXjHChGKJ$2,
	TAFoyaQLwVzluFioqh: TAFoyaQLwVzluFioqh$2,
	eChfcikkuQFNcZULZuP: eChfcikkuQFNcZULZuP$2,
	VnLNiYiOJxZraQxL: VnLNiYiOJxZraQxL$2,
	bqNjZcEbCrAzOJJpJDn: bqNjZcEbCrAzOJJpJDn$2,
	gTYMvovCwafJTrjdlKg: gTYMvovCwafJTrjdlKg$2,
	PczYwMSUlifZlPdkNj: PczYwMSUlifZlPdkNj$2,
	DDrTONBZdHTEWHNFNgtV: DDrTONBZdHTEWHNFNgtV$2,
	OkpDnVcVIcDyntNTMI: OkpDnVcVIcDyntNTMI$2,
	EfVkywGLHyLgyrRjzg: EfVkywGLHyLgyrRjzg$2,
	NOIPqSfkgPcsNJnyAFA: NOIPqSfkgPcsNJnyAFA$2,
	WauyOiSpVDMamrXbLP: WauyOiSpVDMamrXbLP$2,
	eXVsxwaBOXkkntIEGtC: eXVsxwaBOXkkntIEGtC$2,
	EOmmDCycYoHFOZOV: EOmmDCycYoHFOZOV$2,
	ysjFKMhSQlIqXgPlz: ysjFKMhSQlIqXgPlz$2,
	TNkXPjSKdzQcBLZPsWj: TNkXPjSKdzQcBLZPsWj$2,
	FMUUecQmwAheUKwpq: FMUUecQmwAheUKwpq$2,
	KSxzKkrfZaaHIOptelk: KSxzKkrfZaaHIOptelk$2,
	IurrXFgATIlGAlejcf: IurrXFgATIlGAlejcf$2,
	mUgsNHlLzyKVnxhVjRT: mUgsNHlLzyKVnxhVjRT$2,
	LcqaZGQKcdkxNrnIcK: LcqaZGQKcdkxNrnIcK$2,
	zQsiOHqCsFIqBzNsf: zQsiOHqCsFIqBzNsf$2,
	erLerUcELvDAcoUWi: erLerUcELvDAcoUWi$2,
	TGYvVRioXBfDBtmCBpH: TGYvVRioXBfDBtmCBpH$2,
	cQKfBbUkEhBhPtPCx: cQKfBbUkEhBhPtPCx$2,
	SHjOXbqLUjZRUKsWMzD: SHjOXbqLUjZRUKsWMzD$2,
	mUuMBlRDyzHtFgLsivV: mUuMBlRDyzHtFgLsivV$2,
	ISJVpXHVtpoxunGygBGu: ISJVpXHVtpoxunGygBGu$2,
	VGmDUnWBzMKfFbMKXyl: VGmDUnWBzMKfFbMKXyl$2,
	ZAhuzRDlLUTXhKrhhx: ZAhuzRDlLUTXhKrhhx$2,
	BggwtUciWOTxbdTdDg: BggwtUciWOTxbdTdDg$2,
	QFbYEdxUgXzRwcPFQDis: QFbYEdxUgXzRwcPFQDis$2,
	UNForxvjDLCZdGrmWkX: UNForxvjDLCZdGrmWkX$2,
	OCamqUckeIZshGlCbF: OCamqUckeIZshGlCbF$2,
	YMfvOKmAFnfMwTXPfI: YMfvOKmAFnfMwTXPfI$2,
	nvfgxTKtdXdTEhFZf: nvfgxTKtdXdTEhFZf$2,
	HrHtlLjcEICrEnWiRA: HrHtlLjcEICrEnWiRA$2,
	HIFNIcNDmIhRZEsgzSq: HIFNIcNDmIhRZEsgzSq$2,
	KSyKpOAjkLSpCGns: KSyKpOAjkLSpCGns$2,
	eUvzxeVvXrffrpEOrFrP: eUvzxeVvXrffrpEOrFrP$2,
	NqgOQEXQaHsramCnbX: NqgOQEXQaHsramCnbX$2,
	YqzlhmIgzcgLnWmZhMsa: YqzlhmIgzcgLnWmZhMsa$2,
	FrzWGSiDSDzTfNgZH: FrzWGSiDSDzTfNgZH$2,
	WYhIabGPkCnbVBIPcwW: WYhIabGPkCnbVBIPcwW$2,
	LFipKWcCwIamrrato: LFipKWcCwIamrrato$2,
	RFoMDsIwGyJlPkuuxrON: RFoMDsIwGyJlPkuuxrON$2,
	bpvYuERgedcoMzzLNl: bpvYuERgedcoMzzLNl$2,
	NsvJYqLAVHAaWNUXAvz: NsvJYqLAVHAaWNUXAvz$2,
	UbeafDPBCDfpRnQyWUjq: UbeafDPBCDfpRnQyWUjq$2,
	LbGVMqLVHqyddGmXzULS: LbGVMqLVHqyddGmXzULS$2,
	qdnqxPdrpfdxhejrkCj: qdnqxPdrpfdxhejrkCj$2,
	XYHinpRQuEPFjXMzLP: XYHinpRQuEPFjXMzLP$2,
	LQNXJVNXqgqLimcQn: LQNXJVNXqgqLimcQn$2,
	nzLBdKgvNCXQTgYI: nzLBdKgvNCXQTgYI$2,
	iYpfkywMVpuafYnqXxGI: iYpfkywMVpuafYnqXxGI$2,
	DVjsSAdKoyNHoIqhumQ: DVjsSAdKoyNHoIqhumQ$2,
	cxKcumOzANqjtQqREyas: cxKcumOzANqjtQqREyas$2,
	BQkFfUTgzkweftGIpOLt: BQkFfUTgzkweftGIpOLt$2,
	FNNzRxnZqrKRYwIte: FNNzRxnZqrKRYwIte$2,
	SultIciVtbYeZaII: SultIciVtbYeZaII$2,
	dGRvusBQRnbHUIYQRit: dGRvusBQRnbHUIYQRit$2,
	bJwUxepDjVzlNzKuI: bJwUxepDjVzlNzKuI$2,
	HlrghIZaaySLZjESwU: HlrghIZaaySLZjESwU$2,
	TCuuXTtXBYeAldQkZp: TCuuXTtXBYeAldQkZp$2,
	HYTGqldMNoESWJswz: HYTGqldMNoESWJswz$2,
	dkdmEAWTXMORUhlQaX: dkdmEAWTXMORUhlQaX$2,
	XwYKiJGJKAZZZpNp: XwYKiJGJKAZZZpNp$2,
	swejTyFcYnjuUgsfQW: swejTyFcYnjuUgsfQW$2,
	mWoxaQwwzwCFvWjRmK: mWoxaQwwzwCFvWjRmK$2,
	tFaBUAWNRhJqtjIha: tFaBUAWNRhJqtjIha$2,
	FEySNpPzdMqiOsZXI: FEySNpPzdMqiOsZXI$2,
	AIwKneHGNfSJmdLnG: AIwKneHGNfSJmdLnG$2,
	wMGJlEJaupHayuzRwi: wMGJlEJaupHayuzRwi$2,
	iRiLJudagJVXZozmnz: iRiLJudagJVXZozmnz$2,
	laRzOEpYMTvnZYRBZMnj: laRzOEpYMTvnZYRBZMnj$2,
	MDhXYatnZcwvrjVeRh: MDhXYatnZcwvrjVeRh$2,
	hDPPfPClruPeWrSoayR: hDPPfPClruPeWrSoayR$2,
	NTsLbMXwQdPYbmOwP: NTsLbMXwQdPYbmOwP$2,
	POqloYgxpcTCqdnchGE: POqloYgxpcTCqdnchGE$2,
	KxeaINzIsNNJmsIncnV: KxeaINzIsNNJmsIncnV$2,
	sfsygIDbANBoFslbcsw: sfsygIDbANBoFslbcsw$2,
	YgpFeXbXojsYnphM: YgpFeXbXojsYnphM$2,
	MutPBZAXykjaIurt: MutPBZAXykjaIurt$2,
	GvnMmZJtuApdXwWhsFd: GvnMmZJtuApdXwWhsFd$2,
	IcahwJmNfgdvVpPz: IcahwJmNfgdvVpPz$2,
	bxtlucAfnIxfwBYAY: bxtlucAfnIxfwBYAY$2,
	KKbVbDLheqewlSvBE: KKbVbDLheqewlSvBE$2,
	RLztZboedHACRMkjdD: RLztZboedHACRMkjdD$2,
	QEaaELvQUvbfoIpje: QEaaELvQUvbfoIpje$2,
	czSsfuZGitGjFRwLTF: czSsfuZGitGjFRwLTF$2,
	xrYEaiWUOcaNRQMIf: xrYEaiWUOcaNRQMIf$2,
	QDuPlYKAxjAjIgyoAqM: QDuPlYKAxjAjIgyoAqM$2,
	ZkDBgJuvDUVQPOxBY: ZkDBgJuvDUVQPOxBY$2,
	rJAhIVPUqedRmsfmj: rJAhIVPUqedRmsfmj$2,
	GpGpOkSHUzYBQNFc: GpGpOkSHUzYBQNFc$2,
	aMdrNUxkhioFGrNGFIO: aMdrNUxkhioFGrNGFIO$2,
	siLEsPwfoiqGBiXjB: siLEsPwfoiqGBiXjB$2,
	DYgqvlfmNbyLNOrWwc: DYgqvlfmNbyLNOrWwc$2,
	rifKyRmlGZOwlJkDyZG: rifKyRmlGZOwlJkDyZG$2,
	aNVsLyHapaJbRxWnHsv: aNVsLyHapaJbRxWnHsv$2,
	cQiCyvfOMMDJEIXyc: cQiCyvfOMMDJEIXyc$2,
	SywvArMjCuuGzTEtlJ: SywvArMjCuuGzTEtlJ$2,
	vRyVKhBOPCmWYPPacY: vRyVKhBOPCmWYPPacY$2,
	GMOQAxsTvfWIEBANuS: GMOQAxsTvfWIEBANuS$2,
	xqLddTkVnCrEvxgKGso: xqLddTkVnCrEvxgKGso$2,
	sHqYaogVbbeWItJGb: sHqYaogVbbeWItJGb$2,
	xgIKqcGuTlutCTLLG: xgIKqcGuTlutCTLLG$2,
	zsLweYcWjOwUgfyub: zsLweYcWjOwUgfyub$2,
	xUNmcszdZBWMTcxnI: xUNmcszdZBWMTcxnI$2,
	moirunBAysHLMEDtBxUt: moirunBAysHLMEDtBxUt$2,
	YrkgVnAQcYRhGGRex: YrkgVnAQcYRhGGRex$2,
	iuOLeRpygvfPFDnf: iuOLeRpygvfPFDnf$2,
	iuswsIRQwNAIuOzoFX: iuswsIRQwNAIuOzoFX$2,
	sBFILAqpJhAnTLlpQ: sBFILAqpJhAnTLlpQ$2,
	eSLIwfCNWkIwJpqCHSVC: eSLIwfCNWkIwJpqCHSVC$2,
	RtWpXpLfhjeWPtKhcENN: RtWpXpLfhjeWPtKhcENN$2,
	KveBVvOTiGXRKmAUQZz: KveBVvOTiGXRKmAUQZz$2,
	XwmOjTtjNklQiLDgnjIB: XwmOjTtjNklQiLDgnjIB$2,
	GLIndpTHvNVRVWQuT: GLIndpTHvNVRVWQuT$2,
	WzcUSFqDMdwkVtGoj: WzcUSFqDMdwkVtGoj$2,
	kuTgfRDYzVZvEHrFtQ: kuTgfRDYzVZvEHrFtQ$2,
	gXbirwakdsaUKBglwK: gXbirwakdsaUKBglwK$2,
	cTlSqXgGENkCAQQJCHx: cTlSqXgGENkCAQQJCHx$2,
	JsmDOHlXAmjSPqaxg: JsmDOHlXAmjSPqaxg$2,
	yCCsuXAjuRzOLNxo: yCCsuXAjuRzOLNxo$2,
	iizCYlpFHwQBzRyqLM: iizCYlpFHwQBzRyqLM$2,
	FbztGftxEQrszJntb: FbztGftxEQrszJntb$2,
	rteqizIYZXJwMWMenVz: rteqizIYZXJwMWMenVz$2,
	sydmFvhfSgzJVhtAud: sydmFvhfSgzJVhtAud$2,
	aYdhyaHCqMJLweGFD: aYdhyaHCqMJLweGFD$2,
	SMEPVJNtMGWMrEceo: SMEPVJNtMGWMrEceo$2,
	jgXHbpNLgJMKuuZER: jgXHbpNLgJMKuuZER$2,
	JWDRcPebwmpIhvJhVrJe: JWDRcPebwmpIhvJhVrJe$2,
	UtQJNokaxJhxqqTQDiO: UtQJNokaxJhxqqTQDiO$2,
	TFAtjCZbFqacobpGxct: TFAtjCZbFqacobpGxct$2,
	EokACCilfAZfuGcXD: EokACCilfAZfuGcXD$2,
	UXURgENTpgxogbFAD: UXURgENTpgxogbFAD$2,
	ElbSFPkaecjnmBToovei: ElbSFPkaecjnmBToovei$2,
	LuigfaXzmPRCftdFOV: LuigfaXzmPRCftdFOV$2,
	BNXHKONNlrkDGKwkXt: BNXHKONNlrkDGKwkXt$2,
	ltXrglJnxfNqZDSStFq: ltXrglJnxfNqZDSStFq$2,
	FClYxqPqiIjfTGZZthn: FClYxqPqiIjfTGZZthn$2,
	cNmmUqRZfZDUxgWTQeXm: cNmmUqRZfZDUxgWTQeXm$2,
	lKLpdmEuElAKKvltT: lKLpdmEuElAKKvltT$2,
	coPPHMNHpJdMYeKPskDY: coPPHMNHpJdMYeKPskDY$2,
	NovuNXyQGDRrjfyMs: NovuNXyQGDRrjfyMs$2,
	bOSFxWykzVFerKLOiV: bOSFxWykzVFerKLOiV$2,
	HfjMmDJQuBZXqFJUw: HfjMmDJQuBZXqFJUw$2,
	SVTrmHtEOHifBpgPNCY: SVTrmHtEOHifBpgPNCY$2,
	LmRHxJOIEHRnUwFSxEm: LmRHxJOIEHRnUwFSxEm$2,
	gbkxEEkMTXuhYuUCZTJ: gbkxEEkMTXuhYuUCZTJ$2,
	rQgPydQgDVYqtWJXCky: rQgPydQgDVYqtWJXCky$2,
	nFSJqWAXBnxTngDNyoj: nFSJqWAXBnxTngDNyoj$2,
	MThZOMtyoBvwpuodWEa: MThZOMtyoBvwpuodWEa$2,
	hiEgXdIbTRKrnaYJnNY: hiEgXdIbTRKrnaYJnNY$2,
	PqkPSNBQJWOqaAsafW: PqkPSNBQJWOqaAsafW$2,
	vHRZRztWvqyjjHCxW: vHRZRztWvqyjjHCxW$2,
	QZchoinPLbiohHfdnLU: QZchoinPLbiohHfdnLU$2,
	gnOvqPVwTsPuWvBTXzI: gnOvqPVwTsPuWvBTXzI$2,
	bDmdcJmdRsIZfYYBDeZ: bDmdcJmdRsIZfYYBDeZ$2,
	YEPMktdEzwhrMMYKefX: YEPMktdEzwhrMMYKefX$2,
	wGSnhUtsHuueniKdYTwM: wGSnhUtsHuueniKdYTwM$2,
	krMQcSEJDOnglqhrHgu: krMQcSEJDOnglqhrHgu$2,
	erZFCFRNsVfSKVMRLN: erZFCFRNsVfSKVMRLN$2,
	dmeNSGPySLKtEpPGwG: dmeNSGPySLKtEpPGwG$2,
	czWbrtWmnCEbUCzVWzQQ: czWbrtWmnCEbUCzVWzQQ$2,
	YATiezBAjBifZRNRVk: YATiezBAjBifZRNRVk$2,
	sTMySyQXFMSuchwUXiJ: sTMySyQXFMSuchwUXiJ$2,
	FxLhtNEexnBoJElMC: FxLhtNEexnBoJElMC$2,
	hYBHkTzZmueqvwJb: hYBHkTzZmueqvwJb$2,
	GBvqxVjZVWwZtAPZgH: GBvqxVjZVWwZtAPZgH$2,
	KVLFziUaVDlFbnJzh: KVLFziUaVDlFbnJzh$2,
	OQGpXlfSrBKFcwjAv: OQGpXlfSrBKFcwjAv$2,
	AsfYVtpYWMjfUopLa: AsfYVtpYWMjfUopLa$2,
	wZZutIhpaOoppafvh: wZZutIhpaOoppafvh$2,
	OUdBKfTzsTrdfcZmbCAI: OUdBKfTzsTrdfcZmbCAI$2,
	IwzxXaGfVvDNSxQpmeO: IwzxXaGfVvDNSxQpmeO$2,
	XzCcbOKjdfmcCnQLEwNj: XzCcbOKjdfmcCnQLEwNj$2,
	IkToKVrxLaVfCKfNGvl: IkToKVrxLaVfCKfNGvl$2,
	mRtlyGWfQVnoeqMeTs: mRtlyGWfQVnoeqMeTs$2,
	ldgxhAKPgZpGiyMyJw: ldgxhAKPgZpGiyMyJw$2,
	mxKAuwcjmevMUSvDQE: mxKAuwcjmevMUSvDQE$2,
	pSTKNwtZdcuFuoyTsPhb: pSTKNwtZdcuFuoyTsPhb$2,
	EkbLQeqmPtcNzItJWQO: EkbLQeqmPtcNzItJWQO$2,
	KzFzOytWXScqDRKFwg: KzFzOytWXScqDRKFwg$2,
	MvJmrHwTdesvsHWH: MvJmrHwTdesvsHWH$2,
	bksAzarViFUYGzwAOk: bksAzarViFUYGzwAOk$2,
	EOLVYvzyNXSKoGmX: EOLVYvzyNXSKoGmX$2,
	EvOtSTBQrIYspwjQ: EvOtSTBQrIYspwjQ$2,
	eQHAVxHydpVhNAygOp: eQHAVxHydpVhNAygOp$2,
	LWInyMcYkagvzvaBfUHZ: LWInyMcYkagvzvaBfUHZ$2,
	OKOogywrWeAjtQWF: OKOogywrWeAjtQWF$2,
	MOtoFwFvpTtTEDVUD: MOtoFwFvpTtTEDVUD$2,
	ZdMOAZGAMXotVGVlKJ: ZdMOAZGAMXotVGVlKJ$2,
	rEpbPaWEEsiOSTjOiSGL: rEpbPaWEEsiOSTjOiSGL$2,
	SWVaRdViGfCBJhJNg: SWVaRdViGfCBJhJNg$2,
	lrCgiXeJcIwkuDsyc: lrCgiXeJcIwkuDsyc$2,
	vyxYMhwwOspfcdpj: vyxYMhwwOspfcdpj$2,
	MqMVsYdMMtqujWPKHW: MqMVsYdMMtqujWPKHW$2,
	siEUrpaJmBIICzsaBnr: siEUrpaJmBIICzsaBnr$2,
	XGLKbSKPnzgwwZwEHu: XGLKbSKPnzgwwZwEHu$2,
	DPFrIOWnjfRpVQHkhKJ: DPFrIOWnjfRpVQHkhKJ$2,
	dTLgwTGGXjpsnLhrpr: dTLgwTGGXjpsnLhrpr$2,
	gZgeimlXmokhLdRziw: gZgeimlXmokhLdRziw$2,
	xqhbTjIzOYuCUiHEUmd: xqhbTjIzOYuCUiHEUmd$2,
	bbQJHoMWXkEHQuVRSsO: bbQJHoMWXkEHQuVRSsO$2,
	HHdEPKdocehppzeI: HHdEPKdocehppzeI$2,
	tICtqmzJVNeVfZQM: tICtqmzJVNeVfZQM$2,
	HOQBmfsmIsFBlsaJaSa: HOQBmfsmIsFBlsaJaSa$2,
	XsOliEIHDkjKcghOik: XsOliEIHDkjKcghOik$2,
	ADXLpfHxGLEEMBBLjSL: ADXLpfHxGLEEMBBLjSL$2,
	kHAIwKLXztAgQxLOxj: kHAIwKLXztAgQxLOxj$2,
	pqNxLtehgpuJIUBdg: pqNxLtehgpuJIUBdg$2,
	nodIQIicrpcVpCqYey: nodIQIicrpcVpCqYey$2,
	gMjyScxabRhqehsX: gMjyScxabRhqehsX$2,
	AQrCocFqoKoYieUnT: AQrCocFqoKoYieUnT$2,
	COydGeEPULYaNAmN: COydGeEPULYaNAmN$2,
	pFhbWEovZnvIiVEEJnme: pFhbWEovZnvIiVEEJnme$2,
	omUetmzxCLiTloCSalU: omUetmzxCLiTloCSalU$2,
	pqzdTKxlixAoAQwGy: pqzdTKxlixAoAQwGy$2,
	VihBsZgCPMgMJnwUeMLt: VihBsZgCPMgMJnwUeMLt$2,
	ohIqnNpSPiMOrWPSWk: ohIqnNpSPiMOrWPSWk$2,
	TGIiRSnHGjASSfzjMA: TGIiRSnHGjASSfzjMA$2,
	jjFQYQyxRWGgKdjbaeB: jjFQYQyxRWGgKdjbaeB$2,
	VsuTZcfrgRHVvsOOY: VsuTZcfrgRHVvsOOY$2,
	PLhQWivTKyTYZvsNwMxj: PLhQWivTKyTYZvsNwMxj$2,
	ZLJlKTdDgntyZXzg: ZLJlKTdDgntyZXzg$2,
	pPqFjpMzSnmyNWXdT: pPqFjpMzSnmyNWXdT$2,
	aJpdCHYrgIukuVpHluT: aJpdCHYrgIukuVpHluT$2,
	olWnlFpnBjRnPCLuu: olWnlFpnBjRnPCLuu$2,
	ApYUyYTgQDVozNVGdoWy: ApYUyYTgQDVozNVGdoWy$2,
	MEuzpQOAySrMUyXj: MEuzpQOAySrMUyXj$2,
	NkjUESwzghXjElHM: NkjUESwzghXjElHM$2,
	GnugFlecXZohsDMgfjv: GnugFlecXZohsDMgfjv$2,
	nwsbWCYbSYugmHDgHTAB: nwsbWCYbSYugmHDgHTAB$2,
	gphdXFLzIrPxMQrAp: gphdXFLzIrPxMQrAp$2,
	toUaeInrwbWVqvGGGX: toUaeInrwbWVqvGGGX$2,
	gVAFPuXrrstpWxRF: gVAFPuXrrstpWxRF$2,
	AowuwjwDLrAJJKuVzCA: AowuwjwDLrAJJKuVzCA$2,
	TfmLyYqIoASEGHkuRa: TfmLyYqIoASEGHkuRa$2,
	tjuWuhQfpwDJLMscdbI: tjuWuhQfpwDJLMscdbI$2,
	KewXLZFbuyWsCSbvXi: KewXLZFbuyWsCSbvXi$2,
	vQphyNqvokPAiFdfRR: vQphyNqvokPAiFdfRR$2,
	ZbQsLkbfHUtbznnzU: ZbQsLkbfHUtbznnzU$2,
	TsnjCIOPEKKCCfrIF: TsnjCIOPEKKCCfrIF$2,
	qyKlEsEkyTXybgIHcI: qyKlEsEkyTXybgIHcI$2,
	VZexjbUhosOUoUTI: VZexjbUhosOUoUTI$2,
	jDRHFidXonxhhPKaTl: jDRHFidXonxhhPKaTl$2,
	CInUOzoFKTOMvMbix: CInUOzoFKTOMvMbix$2,
	fTbsMnhpZYjiOkAdex: fTbsMnhpZYjiOkAdex$2,
	yOZzgRmKudbwNjuurBHz: yOZzgRmKudbwNjuurBHz$2,
	lelamaRhejmRBJOD: lelamaRhejmRBJOD$2,
	pZxEeOQMfyGXKTBxtyJ: pZxEeOQMfyGXKTBxtyJ$2,
	ZGyanZavgObBeqhP: ZGyanZavgObBeqhP$2,
	oeMZNyLdkPQdxrobojO: oeMZNyLdkPQdxrobojO$2,
	MYuuWNTVQwjCeRRGl: MYuuWNTVQwjCeRRGl$2,
	yrlrMPLgOtiEzbmPW: yrlrMPLgOtiEzbmPW$2,
	EzMbHhWUJOaBMLDRJxZ: EzMbHhWUJOaBMLDRJxZ$2,
	hQRkbssUXUGGLhtxc: hQRkbssUXUGGLhtxc$2,
	eDwDkAgbfaPsnwOb: eDwDkAgbfaPsnwOb$2,
	AVWJwkijUTbNMShmp: AVWJwkijUTbNMShmp$2,
	wEEzjRnoOftKrGIPbix: wEEzjRnoOftKrGIPbix$2,
	NqoduOnqIqJtrjajas: NqoduOnqIqJtrjajas$2,
	vLUFWGhkoIBWnOMA: vLUFWGhkoIBWnOMA$2,
	tjsCbqUvgNvcdRqdDp: tjsCbqUvgNvcdRqdDp$2,
	zBceLwpDLhGkPRkvbU: zBceLwpDLhGkPRkvbU$2,
	udmfKDblDABqFbQPK: udmfKDblDABqFbQPK$2,
	AysRHzzIQTbjLUdgdaq: AysRHzzIQTbjLUdgdaq$2,
	KZPDAndezwXohlXxO: KZPDAndezwXohlXxO$2,
	hdPRTcCCnKbkxbRwgv: hdPRTcCCnKbkxbRwgv$2,
	pfVyzGgyXmkqtJpGH: pfVyzGgyXmkqtJpGH$2,
	KRzStRHbmbrDbAUMnU: KRzStRHbmbrDbAUMnU$2,
	lfLIpxDvOAXOplowzN: lfLIpxDvOAXOplowzN$2,
	BiqzWayxveHNZGxaBa: BiqzWayxveHNZGxaBa$2,
	CvvaFnujrEUnFHnWNb: CvvaFnujrEUnFHnWNb$2,
	CNmFZyGboWXdpYPQDvxV: CNmFZyGboWXdpYPQDvxV$2,
	OmOTUgBCsVHUoKutAD: OmOTUgBCsVHUoKutAD$2,
	DCXoQKoDcwNYuYivD: DCXoQKoDcwNYuYivD$2,
	ApeuvISiLLWNGQPrFrP: ApeuvISiLLWNGQPrFrP$2,
	sCfZtZRTGxweYVxtEuoY: sCfZtZRTGxweYVxtEuoY$2,
	VpbDUCnJRDAsPzfIkn: VpbDUCnJRDAsPzfIkn$2,
	WfvaFuidVgEGCwnBEkl: WfvaFuidVgEGCwnBEkl$2,
	UheALJaSjOHgmVnoCrI: UheALJaSjOHgmVnoCrI$2,
	fNFAnFLpEoAIoPfbh: fNFAnFLpEoAIoPfbh$2,
	uUrUZzojXlsqxsuOJZTc: uUrUZzojXlsqxsuOJZTc$2,
	CqNbVYlZNfwGfGTGRtE: CqNbVYlZNfwGfGTGRtE$2,
	QgEerZTcSTdjtiTnKRT: QgEerZTcSTdjtiTnKRT$2,
	GnbMsiqoZbfmcDerQ: GnbMsiqoZbfmcDerQ$2,
	nEgrtiBYldBKXkpKCocL: nEgrtiBYldBKXkpKCocL$2,
	AJSlWSWYVQZSygnFKRsI: AJSlWSWYVQZSygnFKRsI$2,
	KzgGszjJLuRsOKsdkH: KzgGszjJLuRsOKsdkH$2,
	YmIZCYMTuGNvbocpiJOP: YmIZCYMTuGNvbocpiJOP$2,
	YixzEmijtHztNgwIE: YixzEmijtHztNgwIE$2,
	geVHcZlrpiEaagZcypgy: geVHcZlrpiEaagZcypgy$2,
	SAruOCDnkHugkPOIFSc: SAruOCDnkHugkPOIFSc$2,
	yteHSDpgaHMYFeMBfpWk: yteHSDpgaHMYFeMBfpWk$2,
	slVffWcKrAhjpgaMEuY: slVffWcKrAhjpgaMEuY$2,
	ghYLDApWJBxFOzhqAlN: ghYLDApWJBxFOzhqAlN$2,
	GCxKMtkKAZPoOHsZIDh: GCxKMtkKAZPoOHsZIDh$2,
	uRLAPBsurxBqxfvgaSH: uRLAPBsurxBqxfvgaSH$2,
	FaQaEHvLdVELQbCZrFN: FaQaEHvLdVELQbCZrFN$2,
	RZgUzTVRaXNflgjshVf: RZgUzTVRaXNflgjshVf$2,
	nXPQNJCVxPkQKidfjnn: nXPQNJCVxPkQKidfjnn$2,
	swSisSeZXWyUyMvIu: swSisSeZXWyUyMvIu$2,
	HryFxrLzCqTGOVNrpI: HryFxrLzCqTGOVNrpI$2,
	QqwNZKCLuiPIswItY: QqwNZKCLuiPIswItY$2,
	gqfClfSZIJlpPGmuBjum: gqfClfSZIJlpPGmuBjum$2,
	HMclPwyZgRMKnvBRCr: HMclPwyZgRMKnvBRCr$2,
	iZKMHnInbVLuJJcbpbR: iZKMHnInbVLuJJcbpbR$2,
	VYJdtiuPscmItOfIyux: VYJdtiuPscmItOfIyux$2,
	sbzqRZRFyPyYqnsMtNy: sbzqRZRFyPyYqnsMtNy$2,
	SwDoMzvfeChtJIrEA: SwDoMzvfeChtJIrEA$2,
	pPViUnFnexhWKoFMx: pPViUnFnexhWKoFMx$2,
	NltNaOnxuMeUAbBeZ: NltNaOnxuMeUAbBeZ$2,
	HmXYHUAhkQnrZSfKu: HmXYHUAhkQnrZSfKu$2,
	KgKURwhHRUNpPmFtXTAv: KgKURwhHRUNpPmFtXTAv$2,
	thvmUblDYmiyVPacUB: thvmUblDYmiyVPacUB$2,
	ViAVfshtzuMNFpCqJl: ViAVfshtzuMNFpCqJl$2,
	sSrzMRNSGNzrJsidBnYz: sSrzMRNSGNzrJsidBnYz$2,
	wVSQKNQtitzmkbjDOac: wVSQKNQtitzmkbjDOac$2,
	rvLRPuoiEpNqnbxwWj: rvLRPuoiEpNqnbxwWj$2,
	CRMoLKUrfyLkDWFEuSu: CRMoLKUrfyLkDWFEuSu$2,
	GJOdwcCnvAbhzEkImJ: GJOdwcCnvAbhzEkImJ$2,
	pnGXcYRvktMyOUBwX: pnGXcYRvktMyOUBwX$2,
	fQOFawXqhywMOGSe: fQOFawXqhywMOGSe$2,
	KIIMnxhTdJBhZfaEMP: KIIMnxhTdJBhZfaEMP$2,
	hAacNWPacMHaAAaOw: hAacNWPacMHaAAaOw$2,
	aCtajuQWKCQNkeKgtwLb: aCtajuQWKCQNkeKgtwLb$2,
	XjTUjttgmruHnxFXgVf: XjTUjttgmruHnxFXgVf$2,
	ovsIpOdHmKskDqaansBG: ovsIpOdHmKskDqaansBG$2,
	RawXxpklaPpnKkAjXLL: RawXxpklaPpnKkAjXLL$2,
	dpnyHVmjzJjiqtQIfpD: dpnyHVmjzJjiqtQIfpD$2,
	CtiOEevtmgSCxLlIqb: CtiOEevtmgSCxLlIqb$2,
	HmoCuzIHcMwWJJxszus: HmoCuzIHcMwWJJxszus$2,
	xoPXukoFZulOsawPoPe: xoPXukoFZulOsawPoPe$2,
	FlbUChtSXKPaYQGW: FlbUChtSXKPaYQGW$2,
	XUWTeclWoXtMrQkJzuuq: XUWTeclWoXtMrQkJzuuq$2,
	YCHRDIIKsDzJFQJw: YCHRDIIKsDzJFQJw$2,
	hfBBkSOAXqfEsLVFs: hfBBkSOAXqfEsLVFs$2,
	aETDJvQumPoQnxdEPkQR: aETDJvQumPoQnxdEPkQR$2,
	zZXyblLWbONMNIjPmBN: zZXyblLWbONMNIjPmBN$2,
	gyneoIYPeiHgfaCY: gyneoIYPeiHgfaCY$2,
	ihVcXhmbhwIbsPsTbF: ihVcXhmbhwIbsPsTbF$2,
	ctaxFEnYnZIrAtOaYc: ctaxFEnYnZIrAtOaYc$2,
	tMlPwcyXKotAImFCGfQ: tMlPwcyXKotAImFCGfQ$2,
	SRUOTyGYueLSOwlA: SRUOTyGYueLSOwlA$2,
	rpFnFNTJlMZaopFU: rpFnFNTJlMZaopFU$2,
	sMMYOeSUIvHuRdqiC: sMMYOeSUIvHuRdqiC$2,
	fYiJCYMSTpHPjREdFLyB: fYiJCYMSTpHPjREdFLyB$2,
	XzXwpEBzHGPNkUqaw: XzXwpEBzHGPNkUqaw$2,
	YyrFTDoECNUvGnXVt: YyrFTDoECNUvGnXVt$2,
	leIEPguvvNFtRsXGFI: leIEPguvvNFtRsXGFI$2,
	yEMtEIJyJomPsTPTv: yEMtEIJyJomPsTPTv$2,
	EHBFEqMJtpPqVznA: EHBFEqMJtpPqVznA$2,
	IHceeEHwOOHjpdHosyOe: IHceeEHwOOHjpdHosyOe$2,
	kINzgREzBDTsegQCvHQ: kINzgREzBDTsegQCvHQ$2,
	ObVBBALqXaIzgsSPVQO: ObVBBALqXaIzgsSPVQO$2,
	ckNnmPAbtNOsWqlpAKy: ckNnmPAbtNOsWqlpAKy$2,
	nmOEDJmAsIcTkCgZMv: nmOEDJmAsIcTkCgZMv$2,
	jMXTehFeNbljMLGb: jMXTehFeNbljMLGb$2,
	ZbUUOchcpSOpwpIk: ZbUUOchcpSOpwpIk$2,
	lzbnQluepXRurDUf: lzbnQluepXRurDUf$2,
	xDfYpxodvMVDQJKav: xDfYpxodvMVDQJKav$2,
	XBrHgyrvVacGhRNJco: XBrHgyrvVacGhRNJco$2,
	cXhPoUARLvRqvesHQqeu: cXhPoUARLvRqvesHQqeu$2,
	tBDAaKFwVBeiyQnnTDIA: tBDAaKFwVBeiyQnnTDIA$2,
	PuqWAcBQEKXlfTuxDuD: PuqWAcBQEKXlfTuxDuD$2,
	yzrKsfyEambKetSgWv: yzrKsfyEambKetSgWv$2,
	NSkMpVyoVWGymUTOzL: NSkMpVyoVWGymUTOzL$2,
	JkoaUyCjjTHSNUEy: JkoaUyCjjTHSNUEy$2,
	LtnRgezlrxMzWvZBxRJ: LtnRgezlrxMzWvZBxRJ$2,
	jXvqhJJMhyxRdxCxv: jXvqhJJMhyxRdxCxv$2,
	YZKOONeeIQMFqysxrZ: YZKOONeeIQMFqysxrZ$2,
	nmicLlJCgyNNjjzKJUt: nmicLlJCgyNNjjzKJUt$2,
	BCZEHAhJNfTPwNSqVZl: BCZEHAhJNfTPwNSqVZl$2,
	zIFzaxTFaAhTdPpeh: zIFzaxTFaAhTdPpeh$2,
	tdxbonOdGqBYgBaOjc: tdxbonOdGqBYgBaOjc$2,
	XondKWeJxfchfIoGLe: XondKWeJxfchfIoGLe$2,
	ndyNHmtKJFFsefAzdv: ndyNHmtKJFFsefAzdv$2,
	FeBXkTWnPLzGZEnXEpg: FeBXkTWnPLzGZEnXEpg$2,
	QZCxVURndUpletXFScR: QZCxVURndUpletXFScR$2,
	UXOpXybkQBmLEHTAgw: UXOpXybkQBmLEHTAgw$2,
	BslmwdHcTinuPaihULw: BslmwdHcTinuPaihULw$2,
	jvnfqZRQbFEGTCMGbvT: jvnfqZRQbFEGTCMGbvT$2,
	NsZKEKPRgLQfWeSixA: NsZKEKPRgLQfWeSixA$2,
	icMsBwEbBUQztvmOv: icMsBwEbBUQztvmOv$2,
	dXXdlICxETXaAzDyY: dXXdlICxETXaAzDyY$2,
	zhFTdPuxrgMfcNWoA: zhFTdPuxrgMfcNWoA$2,
	pjPGNrHukGWKUheCaX: pjPGNrHukGWKUheCaX$2,
	uglsZRLSLmmcqItl: uglsZRLSLmmcqItl$2,
	nPqFzGTyChvJyTQw: nPqFzGTyChvJyTQw$2,
	mEPBGXtDbaIrisefS: mEPBGXtDbaIrisefS$2,
	dBZfEFBQmkatfptbV: dBZfEFBQmkatfptbV$2,
	jYUScsXfUCTPNPqSAR: jYUScsXfUCTPNPqSAR$2,
	OJjDmIeMWmMfkDihQu: OJjDmIeMWmMfkDihQu$2,
	JoPUjgxywPfIQlnDrzx: JoPUjgxywPfIQlnDrzx$2,
	ZVRKVLGoMmmrOxLzg: ZVRKVLGoMmmrOxLzg$2,
	HYklWTwhtonjbiQRYCz: HYklWTwhtonjbiQRYCz$2,
	RsjGGXbMJbrislSlWM: RsjGGXbMJbrislSlWM$2,
	wEarLFdfZMShsSfacNU: wEarLFdfZMShsSfacNU$2,
	eEcajuQQvABwGKndqss: eEcajuQQvABwGKndqss$2,
	EfIjGkMogFrJyNKuWar: EfIjGkMogFrJyNKuWar$2,
	JaPjOXJRPJqsTDLdU: JaPjOXJRPJqsTDLdU$2,
	cuKtQbYgXOwLPEbN: cuKtQbYgXOwLPEbN$2,
	BVmyvtMVCbAJXhwSpT: BVmyvtMVCbAJXhwSpT$2,
	NRUPVKxKVtYaCDVPq: NRUPVKxKVtYaCDVPq$2,
	szgmmxxDYVvTLNzPkk: szgmmxxDYVvTLNzPkk$2,
	mJjedBCPidtXUCYHus: mJjedBCPidtXUCYHus$2,
	IIbmROzHEYCycsCyk: IIbmROzHEYCycsCyk$2,
	knoGdfgXpoVeAMqHCXu: knoGdfgXpoVeAMqHCXu$2,
	SBLHeXGlsYVIdiBNRe: SBLHeXGlsYVIdiBNRe$2,
	AocjyYzlYgRsGzlavU: AocjyYzlYgRsGzlavU$2,
	wQEsyNYfqlFrkqUvaDx: wQEsyNYfqlFrkqUvaDx$2,
	rbefbFgPVyawmaktVYF: rbefbFgPVyawmaktVYF$2,
	MjEyxNUcFsFMIjsOIDpg: MjEyxNUcFsFMIjsOIDpg$2,
	ygnbLzvTAMIylzNxj: ygnbLzvTAMIylzNxj$2,
	peIDsRhrNLVzQmAQWg: peIDsRhrNLVzQmAQWg$2,
	BbqJaDHRCDmiNwNVcGB: BbqJaDHRCDmiNwNVcGB$2,
	LESgEuOUJYjZQYLUlO: LESgEuOUJYjZQYLUlO$2,
	hsgIRJDqXwkPnsmgktga: hsgIRJDqXwkPnsmgktga$2,
	mDlqsQlmoApWZXHKLq: mDlqsQlmoApWZXHKLq$2,
	DjgcgdUJtoNmqshNSb: DjgcgdUJtoNmqshNSb$2,
	FxlLNwkBHAbChJrnM: FxlLNwkBHAbChJrnM$2,
	NuZslGbiHniUKgycjhmv: NuZslGbiHniUKgycjhmv$2,
	AdLFmhSQGMGYrTgXdUH: AdLFmhSQGMGYrTgXdUH$2,
	rQiWsAGGRmEQCtfaIK: rQiWsAGGRmEQCtfaIK$2,
	HjfxCIPqXHVRBXeofOe: HjfxCIPqXHVRBXeofOe$2,
	CwyRzEeuIMzGRVzVdSVg: CwyRzEeuIMzGRVzVdSVg$2,
	MgdMcyuZEloUdpqcv: MgdMcyuZEloUdpqcv$2,
	yKqxJEvOxokRNAPXYDZC: yKqxJEvOxokRNAPXYDZC$2,
	FIvibwVWwddLxzofT: FIvibwVWwddLxzofT$2,
	HQLJuhRwbVdfCwEp: HQLJuhRwbVdfCwEp$2,
	irXsKkZagNKDlvCyhKYK: irXsKkZagNKDlvCyhKYK$2,
	RQJGnpiCuJKbplbuWeaj: RQJGnpiCuJKbplbuWeaj$2,
	ULhbQlNBpFJzLTlp: ULhbQlNBpFJzLTlp$2,
	DmecbpJQgGJiVjTqP: DmecbpJQgGJiVjTqP$2,
	qltXLGplQJNtHWdY: qltXLGplQJNtHWdY$2,
	vamuznzHAJqilfEEP: vamuznzHAJqilfEEP$2,
	oGNuorHWcxXehehzCno: oGNuorHWcxXehehzCno$2,
	pFjSwsuOrRtiguvbEc: pFjSwsuOrRtiguvbEc$2,
	VZMtxSlhbTKcmTYeEsW: VZMtxSlhbTKcmTYeEsW$2,
	ivAXIbjvUUQpQqpmXz: ivAXIbjvUUQpQqpmXz$2,
	thJZdZfDKDEFyETsPyzj: thJZdZfDKDEFyETsPyzj$2,
	mrdEVkqkBIuEBVzzL: mrdEVkqkBIuEBVzzL$2,
	JWctZqDXJyyraLbOe: JWctZqDXJyyraLbOe$2,
	rXWcwotndeKQsLjAdyrw: rXWcwotndeKQsLjAdyrw$2,
	ZuxEmUvBYSsOHORKrFrd: ZuxEmUvBYSsOHORKrFrd$2,
	TfIbvRVtJxzInjuIwq: TfIbvRVtJxzInjuIwq$2,
	YBvzRbRVqKkwTDkNDfoc: YBvzRbRVqKkwTDkNDfoc$2,
	pJTXUuIjycHTetIC: pJTXUuIjycHTetIC$2,
	razdiXXHIkQKbPQTZn: razdiXXHIkQKbPQTZn$2,
	WCGnQDmVyXVqLZPQyqYs: WCGnQDmVyXVqLZPQyqYs$2,
	NgUCFdNkwlZfzWkAiv: NgUCFdNkwlZfzWkAiv$2,
	sdgZycbHzMUKHwVH: sdgZycbHzMUKHwVH$2,
	xQtzLCbkmmYpqCXOwRT: xQtzLCbkmmYpqCXOwRT$2,
	rKSrOqgimgcTrDutYUA: rKSrOqgimgcTrDutYUA$2,
	nFlxQWOJCGHgwwHQhP: nFlxQWOJCGHgwwHQhP$2,
	sMvNZNODlnAIiuzFMR: sMvNZNODlnAIiuzFMR$2,
	RrEKjSeFQrtvLrZIO: RrEKjSeFQrtvLrZIO$2,
	QnjpooahLXRwxGqJIVt: QnjpooahLXRwxGqJIVt$2,
	qZljkUmjmSBKpnUsYfp: qZljkUmjmSBKpnUsYfp$2,
	kjqqAmIhgKSjlBVQx: kjqqAmIhgKSjlBVQx$2,
	WfJRbDGlqfLFvNVzyWu: WfJRbDGlqfLFvNVzyWu$2,
	wgbBNytjmVvMvqRkRL: wgbBNytjmVvMvqRkRL$2,
	pXHPsbEpWSnCyJGH: pXHPsbEpWSnCyJGH$2,
	CRbVirgSccJqKzSUSEau: CRbVirgSccJqKzSUSEau$2,
	FgrxZUNDleeDGneKmwd: FgrxZUNDleeDGneKmwd$2,
	uJpZAZRdzpyAaUkEqwSx: uJpZAZRdzpyAaUkEqwSx$2,
	elXgEtyDNXczWYbDHV: elXgEtyDNXczWYbDHV$2,
	LiwpXDoMAXANnTRZ: LiwpXDoMAXANnTRZ$2,
	wfRBtzUHBPZjVDxUc: wfRBtzUHBPZjVDxUc$2,
	xrfefvhsEfCoJokIdeW: xrfefvhsEfCoJokIdeW$2,
	gapTtWntRtJcQzRtBz: gapTtWntRtJcQzRtBz$2,
	NhBzijnKrdihICUwgi: NhBzijnKrdihICUwgi$2,
	PdxWoNDxKAJmNcpe: PdxWoNDxKAJmNcpe$2,
	AHMRWIOaHFIWiIPqUx: AHMRWIOaHFIWiIPqUx$2,
	LDNvolWeNGwNyvpTMnL: LDNvolWeNGwNyvpTMnL$2,
	uYLqhJrdDgRVWcNvDpr: uYLqhJrdDgRVWcNvDpr$2,
	ZnbyJyzHTxzgLRDFBmEm: ZnbyJyzHTxzgLRDFBmEm$2,
	FTVpPZybylBmTnwhMhtx: FTVpPZybylBmTnwhMhtx$2,
	THMxZAxLcuuIfPErpGb: THMxZAxLcuuIfPErpGb$2,
	bTWntlsiiBougPgd: bTWntlsiiBougPgd$2,
	zIgntQSydRspYJCaQ: zIgntQSydRspYJCaQ$2,
	vPVjNqmPYGCrexspl: vPVjNqmPYGCrexspl$2,
	oMgGPGaGAlElFewgOv: oMgGPGaGAlElFewgOv$2,
	iqCHKgJKHatuZHiXEFm: iqCHKgJKHatuZHiXEFm$2,
	dHIzNCfEthjGsjpMsfJN: dHIzNCfEthjGsjpMsfJN$2,
	VALtZMIyzODbkpPUOsxG: VALtZMIyzODbkpPUOsxG$2,
	OOtkDwkZMvTavtRmc: OOtkDwkZMvTavtRmc$2,
	bRDTmhggLlBbrbdtfhM: bRDTmhggLlBbrbdtfhM$2,
	IzXQAIEgQLMYmZwrzP: IzXQAIEgQLMYmZwrzP$2,
	xjuVMsJZTRgjPgAzSV: xjuVMsJZTRgjPgAzSV$2,
	WACiElgvWMUDhQMxa: WACiElgvWMUDhQMxa$2,
	USZqODoQgzwaggnbb: USZqODoQgzwaggnbb$2,
	KChGPohSmJORAMDUqSs: KChGPohSmJORAMDUqSs$2,
	oGZZfIIocJcraogK: oGZZfIIocJcraogK$2,
	pAYXQPFeRbuYruZa: pAYXQPFeRbuYruZa$2,
	aaOdxWUHHLynEVSoWTM: aaOdxWUHHLynEVSoWTM$2,
	jSQVlHGDwxAZujRJNiSh: jSQVlHGDwxAZujRJNiSh$2,
	uuluQlsJBdDsslsERZX: uuluQlsJBdDsslsERZX$2,
	ACweJQrKoWgpyYspyEl: ACweJQrKoWgpyYspyEl$2,
	JLIvWEpTgjlkpsZBM: JLIvWEpTgjlkpsZBM$2,
	UfkUhznLfeqzZyTdAebx: UfkUhznLfeqzZyTdAebx$2,
	FxzVGfjClbeUZeEero: FxzVGfjClbeUZeEero$2,
	WjPizXTxbdPnvLWMql: WjPizXTxbdPnvLWMql$2,
	ytFXzDnzPIGUhOOClJ: ytFXzDnzPIGUhOOClJ$2,
	dWHEObNDvkCjTnlvH: dWHEObNDvkCjTnlvH$2,
	lfjjwhqpvFBikfhkifrN: lfjjwhqpvFBikfhkifrN$2,
	gGrAIKLFJuNxbjhnZz: gGrAIKLFJuNxbjhnZz$2,
	trJoqkSnMVAvbRgAY: trJoqkSnMVAvbRgAY$2,
	CyNhoDlSuMvcxydtF: CyNhoDlSuMvcxydtF$2,
	dpvvLNDzKxLZIuixW: dpvvLNDzKxLZIuixW$2,
	cYSzpXPrPUQxaAGTihK: cYSzpXPrPUQxaAGTihK$2,
	kYGDyxESdKUNNTdG: kYGDyxESdKUNNTdG$2,
	UqNGOztCBezyeAgI: UqNGOztCBezyeAgI$2,
	TWuwXEwzngPlnjELUJ: TWuwXEwzngPlnjELUJ$2,
	AUNMAupfnBRbGlrb: AUNMAupfnBRbGlrb$2,
	EqpPTPZsKjTArTFVgWp: EqpPTPZsKjTArTFVgWp$2,
	oiSDCKooPzMznfGteAG: oiSDCKooPzMznfGteAG$2,
	DSFAJhsSefQQEdBBlUyt: DSFAJhsSefQQEdBBlUyt$2,
	aaKDUKbsmRiynWiqlS: aaKDUKbsmRiynWiqlS$2,
	eDeADqoJRnEUGotYxzY: eDeADqoJRnEUGotYxzY$2,
	CDwWwMbhHZXYRMZHKnpO: CDwWwMbhHZXYRMZHKnpO$2,
	fjjnxDoEsAfrEGSbNUL: fjjnxDoEsAfrEGSbNUL$2,
	qqXTaCjhvvMrmeJpPG: qqXTaCjhvvMrmeJpPG$2,
	RMCuKzWRRjQNKUNP: RMCuKzWRRjQNKUNP$2,
	qipDilqNVyHfNJVyF: qipDilqNVyHfNJVyF$2,
	CuzRRZhhkOmuQgeVt: CuzRRZhhkOmuQgeVt$2,
	VoqaSnQNOfXstSBxca: VoqaSnQNOfXstSBxca$2,
	ZCRfudjxgEkJLycN: ZCRfudjxgEkJLycN$2,
	tdxlCkYgrpQOxYYJZiF: tdxlCkYgrpQOxYYJZiF$2,
	RZiGRHwDUpYgJcRLRnxa: RZiGRHwDUpYgJcRLRnxa$2,
	aXbxDDurboZtvnPno: aXbxDDurboZtvnPno$2,
	OUDeIeQIjCliBQIHe: OUDeIeQIjCliBQIHe$2,
	AbrPzuZLAZwUuIBnbx: AbrPzuZLAZwUuIBnbx$2,
	JJAtBenOLOlFaFaP: JJAtBenOLOlFaFaP$2,
	YWCMpmGuparutCzjXpp: YWCMpmGuparutCzjXpp$2,
	aCYhhkYhhIrzUQvFB: aCYhhkYhhIrzUQvFB$2,
	sVTrHBZPprcyXLgcE: sVTrHBZPprcyXLgcE$2,
	oGHfMwDNMhRcKszx: oGHfMwDNMhRcKszx$2,
	hYWPDZZNtYYwiYMfUfjX: hYWPDZZNtYYwiYMfUfjX$2,
	NIxMpJepTIBNynamgjj: NIxMpJepTIBNynamgjj$2,
	onaIGydLoNFhYUGyo: onaIGydLoNFhYUGyo$2,
	nkENghGiqpNyJlRpBv: nkENghGiqpNyJlRpBv$2,
	eEBDsqLdNoLOJxjVc: eEBDsqLdNoLOJxjVc$2,
	SJBETCfUKQwBPbOwXhs: SJBETCfUKQwBPbOwXhs$2,
	TbviyxwhVLMOhttn: TbviyxwhVLMOhttn$2,
	SFeLOdYxYJLeOgLtZI: SFeLOdYxYJLeOgLtZI$2,
	IKImbOtCOwEOtcDsMLv: IKImbOtCOwEOtcDsMLv$2,
	woYYXxIEUCPOPTbYi: woYYXxIEUCPOPTbYi$2,
	XVImLdGTpJvSndfrLlee: XVImLdGTpJvSndfrLlee$2,
	ylhkcCPZqNeskQBJB: ylhkcCPZqNeskQBJB$2,
	gLehflpqCNwIhEtbYIAz: gLehflpqCNwIhEtbYIAz$2,
	BEfhHOirsmwpDEilDbq: BEfhHOirsmwpDEilDbq$2,
	WzIAmgVLQnPRHGRfGw: WzIAmgVLQnPRHGRfGw$2,
	zcamcMLRNetHERtiy: zcamcMLRNetHERtiy$2,
	NStCDznwhsZPGYrJAq: NStCDznwhsZPGYrJAq$2,
	pucEyENFLLeSzsJUK: pucEyENFLLeSzsJUK$2,
	EqbYvDbdIrmgXbrPPAO: EqbYvDbdIrmgXbrPPAO$2,
	pyuZUzzDPovDumukD: pyuZUzzDPovDumukD$2,
	xxgsgyEjhfwrMflwMr: xxgsgyEjhfwrMflwMr$2,
	PVcSgRlruKdhLYAvMUG: PVcSgRlruKdhLYAvMUG$2,
	BIVIQEHEPCzGuQpNKSR: BIVIQEHEPCzGuQpNKSR$2,
	GhRAIjbecBWjePTjqSD: GhRAIjbecBWjePTjqSD$2,
	qsVtkTgbKcuLSPDXf: qsVtkTgbKcuLSPDXf$2,
	WINbdlmnRMSyZUqkxCP: WINbdlmnRMSyZUqkxCP$2,
	bnpgtsIPDfFydCQlTH: bnpgtsIPDfFydCQlTH$2,
	BgXkLkPusAcJBiUmSw: BgXkLkPusAcJBiUmSw$2,
	OARZuIqYLXtlrvaEsC: OARZuIqYLXtlrvaEsC$2,
	YLJxFxxsgqpWcZWy: YLJxFxxsgqpWcZWy$2,
	RjPDzDdrzBcLHVJiG: RjPDzDdrzBcLHVJiG$2,
	DrmqiYKPSoxMBWXT: DrmqiYKPSoxMBWXT$2,
	nSdDtaHzknwZAXJHzrGP: nSdDtaHzknwZAXJHzrGP$2,
	NZjrOkmPAHtiaMLyuVDA: NZjrOkmPAHtiaMLyuVDA$2,
	XfjZomFsTRpbZJuHjI: XfjZomFsTRpbZJuHjI$2,
	lxppTPAJDxxMIGdmiRG: lxppTPAJDxxMIGdmiRG$2,
	OljlLKYobPynbcStGlN: OljlLKYobPynbcStGlN$2,
	YXrqAGUqprWfOCeiSGX: YXrqAGUqprWfOCeiSGX$2,
	MkfqKEzRwLTbzJEOeWg: MkfqKEzRwLTbzJEOeWg$2,
	vshrtYQXEVpbXmLZwV: vshrtYQXEVpbXmLZwV$2,
	wINMfXpJczhYZOnUXWp: wINMfXpJczhYZOnUXWp$2,
	uetkXvxfFuKnhpBFrA: uetkXvxfFuKnhpBFrA$2,
	sZVlKBQCGGTVChpa: sZVlKBQCGGTVChpa$2,
	AZVALNHESdbXtHmNY: AZVALNHESdbXtHmNY$2,
	pVQoQWJNGEfRwmpZMki: pVQoQWJNGEfRwmpZMki$2,
	HsxgqsfmdLnIcdcXgLS: HsxgqsfmdLnIcdcXgLS$2,
	gohHRZTjodstzoCLNv: gohHRZTjodstzoCLNv$2,
	rfXBETBheWYaMqrktE: rfXBETBheWYaMqrktE$2,
	rxfIffMgcmDGmXfVZA: rxfIffMgcmDGmXfVZA$2,
	ifmHgobawgqPHdruP: ifmHgobawgqPHdruP$2,
	AkLeJkGIGPcgMPOyMJvd: AkLeJkGIGPcgMPOyMJvd$2,
	SLZgFNtUooxfLTcXEnm: SLZgFNtUooxfLTcXEnm$2,
	APOikjpbuiZXwYbMlWBl: APOikjpbuiZXwYbMlWBl$2,
	pEZOQJSBxlCYyrjM: pEZOQJSBxlCYyrjM$2,
	IKLXXpDUJHlgctnhc: IKLXXpDUJHlgctnhc$2,
	GSkKAUsvGPYZMAnFnH: GSkKAUsvGPYZMAnFnH$2,
	HIptAJwjtWvHteUhwW: HIptAJwjtWvHteUhwW$2,
	ETkemdVBXuBSBAstv: ETkemdVBXuBSBAstv$2,
	fUqbBtyQPrkRchcpe: fUqbBtyQPrkRchcpe$2,
	wprsRqdyQRGnVcbsp: wprsRqdyQRGnVcbsp$2,
	zDKhBsXavFMPAEqgdH: zDKhBsXavFMPAEqgdH$2,
	PpelPkXnzahxkdhVa: PpelPkXnzahxkdhVa$2,
	XvACoEmpLFSLVHywT: XvACoEmpLFSLVHywT$2,
	hhiTSbgqtfHswnyfCs: hhiTSbgqtfHswnyfCs$2,
	jwkMtTwNHEktKLQA: jwkMtTwNHEktKLQA$2,
	aTPVtxAhNeuzjutYgu: aTPVtxAhNeuzjutYgu$2,
	CSMPJDQZLtdBrHSlRhzp: CSMPJDQZLtdBrHSlRhzp$2,
	OYByrRpUomOXEqORBozE: OYByrRpUomOXEqORBozE$2,
	pQEEhEzMgmLpEznsEH: pQEEhEzMgmLpEznsEH$2,
	HNUebnMoRCmoPDEpASH: HNUebnMoRCmoPDEpASH$2,
	ARCAktOTCiLqQqaPTv: ARCAktOTCiLqQqaPTv$2,
	LJPMiQOhqtJqlBRBCHX: LJPMiQOhqtJqlBRBCHX$2,
	lvouKixXkMbDqOnnr: lvouKixXkMbDqOnnr$2,
	FRjQUDLIESvWvPOQY: FRjQUDLIESvWvPOQY$2,
	JNPXLHStukWLfpLRU: JNPXLHStukWLfpLRU$2,
	dQRnMUSMOEdAwdfMqW: dQRnMUSMOEdAwdfMqW$2,
	cHodlBcOiNHOlxFn: cHodlBcOiNHOlxFn$2,
	tglvvZIzjMuxIoXEYs: tglvvZIzjMuxIoXEYs$2,
	yDGXBsHUIoIkgqfepe: yDGXBsHUIoIkgqfepe$2,
	lsdjJQPYPEOcAzVOth: lsdjJQPYPEOcAzVOth$2,
	PlIgEPTbgrrwkSuHc: PlIgEPTbgrrwkSuHc$2,
	NqhjvGQWWHnmAzDH: NqhjvGQWWHnmAzDH$2,
	QNEAoNoQfTpYIxJvjdM: QNEAoNoQfTpYIxJvjdM$2,
	MhWCMBfnPEmyPhdBJC: MhWCMBfnPEmyPhdBJC$2,
	rcbvwVBVHsJazGKrQv: rcbvwVBVHsJazGKrQv$2,
	HsYTxsCouoyySItw: HsYTxsCouoyySItw$2,
	CNXhqxsuJtAEOpHCSI: CNXhqxsuJtAEOpHCSI$2,
	iQYmhTkvoynVhdKfkY: iQYmhTkvoynVhdKfkY$2,
	lLKoAhJqRLmDyyTCvO: lLKoAhJqRLmDyyTCvO$2,
	bNcNiQWtnacHBQFyTY: bNcNiQWtnacHBQFyTY$2,
	JIozcUyGaPUboZLlBjVN: JIozcUyGaPUboZLlBjVN$2,
	tNbQTPYLVCKjsvpja: tNbQTPYLVCKjsvpja$2,
	UrkVGOIalMNhKwpIEzK: UrkVGOIalMNhKwpIEzK$2,
	cCtaFICzFmzJltYPL: cCtaFICzFmzJltYPL$2,
	SVpHROUKzBJsjSVHMK: SVpHROUKzBJsjSVHMK$2,
	UMTZPjOpYZuhdhDbBVO: UMTZPjOpYZuhdhDbBVO$2,
	iBQIPIJCNFHBCeRIvm: iBQIPIJCNFHBCeRIvm$2,
	nedDtIXJkIrvdDqe: nedDtIXJkIrvdDqe$2,
	xWhLpCcRjLgSplng: xWhLpCcRjLgSplng$2,
	DZjgiswpELVABBqUWCSa: DZjgiswpELVABBqUWCSa$2,
	XrngZedCHgJUKulaDcT: XrngZedCHgJUKulaDcT$2,
	fWgPNysKDTLrzjgrexk: fWgPNysKDTLrzjgrexk$2,
	QIzonbZxYqJjQrPHfJM: QIzonbZxYqJjQrPHfJM$2,
	iHptEcwFnEbHVLaQkXyb: iHptEcwFnEbHVLaQkXyb$2,
	uUpDUGTUrKdXVQXkgSP: uUpDUGTUrKdXVQXkgSP$2,
	HzbSujYkGuYtObRcrdbh: HzbSujYkGuYtObRcrdbh$2,
	NOYdleknddFOfQxlNOI: NOYdleknddFOfQxlNOI$2,
	nqPKzhAfSmqRRIHii: nqPKzhAfSmqRRIHii$2,
	eOPHosimYamraEKUukBz: eOPHosimYamraEKUukBz$2,
	LoBOFhdSzMFjdqZgDE: LoBOFhdSzMFjdqZgDE$2,
	mHVIpiFPJQPNPFYAeeu: mHVIpiFPJQPNPFYAeeu$2,
	TNXdbUElFLwiyRVKuJ: TNXdbUElFLwiyRVKuJ$2,
	wLQWZKMRgmTJTSudW: wLQWZKMRgmTJTSudW$2,
	GkvuBozDTWJAXbpwyP: GkvuBozDTWJAXbpwyP$2,
	IMxXGyWWPXtfrrwxV: IMxXGyWWPXtfrrwxV$2,
	tibiqQyzvztLFMGQ: tibiqQyzvztLFMGQ$2,
	fXTeVLzGkVECTSGgtm: fXTeVLzGkVECTSGgtm$2,
	XYVTanLxxisBNzaOFx: XYVTanLxxisBNzaOFx$2,
	bdAMbKWoEuDxlGOg: bdAMbKWoEuDxlGOg$2,
	ALJjPGCRLTrnWlbmqO: ALJjPGCRLTrnWlbmqO$2,
	znOXnaDhTySukBeCrT: znOXnaDhTySukBeCrT$2,
	ESHCFsWVeQAWSnEKV: ESHCFsWVeQAWSnEKV$2,
	lLAJPCrarwsWDdbLaw: lLAJPCrarwsWDdbLaw$2,
	biXQrrlOVDoExCZZKC: biXQrrlOVDoExCZZKC$2,
	spot_trading: spot_trading$2,
	MTiCVGmtBjEPWzsw: MTiCVGmtBjEPWzsw$2,
	zLnEBdSfUXdqbRqAohY: zLnEBdSfUXdqbRqAohY$2,
	oVvhpgfhTeyLLnTSv: oVvhpgfhTeyLLnTSv$2,
	OEfurFwwcJaTsVxNdol: OEfurFwwcJaTsVxNdol$2,
	TeRrrjzubYVYnBhsdpD: TeRrrjzubYVYnBhsdpD$2,
	xwQqYnxnxmeJPqRlQ: xwQqYnxnxmeJPqRlQ$2,
	hoTQEpJFfRRLZGLWiDK: hoTQEpJFfRRLZGLWiDK$2,
	wZuMVSBUSlQidCQpjoS: wZuMVSBUSlQidCQpjoS$2,
	oSDxsXgENbIeNMLv: oSDxsXgENbIeNMLv$2,
	aoAIqdHabiquSjWWz: aoAIqdHabiquSjWWz$2,
	YltriUZdkgLJuXZi: YltriUZdkgLJuXZi$2,
	sZudUtmwNMYVhQhyj: sZudUtmwNMYVhQhyj$2,
	slqgnwkLOtCyZiTBWb: slqgnwkLOtCyZiTBWb$2,
	PwxbwKVPjpeCuRYx: PwxbwKVPjpeCuRYx$2,
	domCttddTWzCfimSWOq: domCttddTWzCfimSWOq$2,
	dqLNRujTTFLifcFaybP: dqLNRujTTFLifcFaybP$2,
	wIfwelYvkemWaZGE: wIfwelYvkemWaZGE$2,
	vDIneAtEexNLfRMcVPa: vDIneAtEexNLfRMcVPa$2,
	YYzgmIpjtorJXoyQJUk: YYzgmIpjtorJXoyQJUk$2,
	rZkFVZvvCQRyHCfLiNVX: rZkFVZvvCQRyHCfLiNVX$2,
	VXwjemLYMJiNKvXlZ: VXwjemLYMJiNKvXlZ$2,
	GZOFzxVOsYtRtlONwcv: GZOFzxVOsYtRtlONwcv$2,
	YiNdDLTlBGFQiuNECi: YiNdDLTlBGFQiuNECi$2,
	aFykbSRCZkUrYNzoKtk: aFykbSRCZkUrYNzoKtk$2,
	TgilgrTuMXgbAQuPf: TgilgrTuMXgbAQuPf$2,
	MQaUVFeBMhHfKxmBUV: MQaUVFeBMhHfKxmBUV$2,
	HgKGDukwWWdCeZlibVY: HgKGDukwWWdCeZlibVY$2,
	rhXOjsQATKgJNizniW: rhXOjsQATKgJNizniW$2,
	pKuaKUWJHuajbExMUs: pKuaKUWJHuajbExMUs$2,
	nkcDnQvbZpDfYMepAc: nkcDnQvbZpDfYMepAc$2,
	UHAKvmcFPrannQlFz: UHAKvmcFPrannQlFz$2,
	MmdyZCvMXusVhfjsV: MmdyZCvMXusVhfjsV$2,
	MGsQCMXzOIuqcXjBDDTF: MGsQCMXzOIuqcXjBDDTF$2,
	xYFrGCCcvvWooWsibQFD: xYFrGCCcvvWooWsibQFD$2,
	omBdaJrTBmDrBzNYx: omBdaJrTBmDrBzNYx$2,
	omTkmNnwlfkOvozU: omTkmNnwlfkOvozU$2,
	YxGqBoJIoXruDOmbNu: YxGqBoJIoXruDOmbNu$2,
	NOhPBjPDsgVbfqTgjIH: NOhPBjPDsgVbfqTgjIH$2,
	gcFEhAlcWmjNfIqry: gcFEhAlcWmjNfIqry$2,
	npetoxnFYOYxRjXRN: npetoxnFYOYxRjXRN$2,
	TzvXfzahEvyWlLOZQE: TzvXfzahEvyWlLOZQE$2,
	LuuhHZgOxbTJDvnm: LuuhHZgOxbTJDvnm$2,
	sqteSBzbeJvwJeJSWZk: sqteSBzbeJvwJeJSWZk$2,
	uhoCqEIxFLCGpwTslFY: uhoCqEIxFLCGpwTslFY$2,
	OzYooSlNbfNTxRxNhe: OzYooSlNbfNTxRxNhe$2,
	JQpSpVQqatEXOdgFvjh: JQpSpVQqatEXOdgFvjh$2,
	onOjgIPTpDDXLIwlSWE: onOjgIPTpDDXLIwlSWE$2,
	gDgIYTmDidzeeXyOV: gDgIYTmDidzeeXyOV$2,
	cOOoOlxMURFANNpFpYx: cOOoOlxMURFANNpFpYx$2,
	nAVsbekWuHffflMnfHHy: nAVsbekWuHffflMnfHHy$2,
	WelPCqxRFgXNzpkZJdsh: WelPCqxRFgXNzpkZJdsh$2,
	npqmwWmfuEsNrfQJt: npqmwWmfuEsNrfQJt$2,
	wcfFqisAqLRlhbKdJk: wcfFqisAqLRlhbKdJk$2,
	wcJAFtgivjbkVSdTC: wcJAFtgivjbkVSdTC$2,
	pSUGpUOowrIgSHLfEIs: pSUGpUOowrIgSHLfEIs$2,
	cWYINWiSUUdFuDAImP: cWYINWiSUUdFuDAImP$2,
	tUrSbGVjlpoCdTkb: tUrSbGVjlpoCdTkb$2,
	YvXCqALOsnrEQAHU: YvXCqALOsnrEQAHU$2,
	JJfMolWuWCFgrDrUiz: JJfMolWuWCFgrDrUiz$2,
	plHTmWdGncJPnVBJuI: plHTmWdGncJPnVBJuI$2,
	HbkwQxpXzqUXEvkxVmz: HbkwQxpXzqUXEvkxVmz$2,
	KOycuFuoXkNBrUCLtCVL: KOycuFuoXkNBrUCLtCVL$2,
	yYxnWdRQrNPhFUhmKp: yYxnWdRQrNPhFUhmKp$2,
	oWOQzlGOqirSVhUhQX: oWOQzlGOqirSVhUhQX$2,
	xbTIXxCJIOnbLImHUPI: xbTIXxCJIOnbLImHUPI$2,
	VSmzJHKoDZuNenetubvZ: VSmzJHKoDZuNenetubvZ$2,
	YJlyfJbAZRZhGensD: YJlyfJbAZRZhGensD$2,
	SuSDXCILmprzPXIonL: SuSDXCILmprzPXIonL$2,
	FnrHWNqUvXlpfQLAfT: FnrHWNqUvXlpfQLAfT$2,
	uPrPwsvUYglduYxnfgb: uPrPwsvUYglduYxnfgb$2,
	BvERvFYtRmpkINLVdX: BvERvFYtRmpkINLVdX$2,
	MSaPBxOSKeCTtUMPq: MSaPBxOSKeCTtUMPq$2,
	olGkjZMWDZBQwjnVK: olGkjZMWDZBQwjnVK$2,
	PmdVNRJcWUxjWfFSA: PmdVNRJcWUxjWfFSA$2,
	gCLhGVwztVSCPNZUgqQN: gCLhGVwztVSCPNZUgqQN$2,
	FDynUJSlxYFxtAhrQN: FDynUJSlxYFxtAhrQN$2,
	UBCBvFlsnzzgcIOHTmN: UBCBvFlsnzzgcIOHTmN$2,
	MERzsdKkxudpOnlaF: MERzsdKkxudpOnlaF$2,
	XtpeIeGyrDDKSkgyCiL: XtpeIeGyrDDKSkgyCiL$2,
	LxcfZSEIROwQeVCok: LxcfZSEIROwQeVCok$2,
	fxjdlTQeJFVyjFXmhlnI: fxjdlTQeJFVyjFXmhlnI$2,
	aVbJYJuVEhKXAqlbWgUE: aVbJYJuVEhKXAqlbWgUE$2,
	yicaYCvBFspqWpPqS: yicaYCvBFspqWpPqS$2,
	YLfvFQfagZeMpkzlO: YLfvFQfagZeMpkzlO$2,
	fsjyqgrUVSYOXDUxw: fsjyqgrUVSYOXDUxw$2,
	WQsiZpVbrxKoaVkQ: WQsiZpVbrxKoaVkQ$2,
	KpLdefqDhhhdklLzxOgC: KpLdefqDhhhdklLzxOgC$2,
	WbJXVvgJiwcWWgRAYq: WbJXVvgJiwcWWgRAYq$2,
	EcnKFNIFTwRUshkf: EcnKFNIFTwRUshkf$2,
	xGdbGnjcDCabqvFJX: xGdbGnjcDCabqvFJX$2,
	olJXBlENebamalqAmC: olJXBlENebamalqAmC$2,
	lnaNMhKSbkHzoYmMHp: lnaNMhKSbkHzoYmMHp$2,
	MFJyykUbSXUkUqHxlJ: MFJyykUbSXUkUqHxlJ$2,
	UsVahXMYImjwSrxR: UsVahXMYImjwSrxR$2,
	XjUPUpsmbzqDVlOyOzD: XjUPUpsmbzqDVlOyOzD$2,
	bYjpHFpkXBumbkZHbM: bYjpHFpkXBumbkZHbM$2,
	nZkngKdQlMblSkIsJt: nZkngKdQlMblSkIsJt$2,
	vfiTAWyuaCrULibnur: vfiTAWyuaCrULibnur$2,
	hubWrmcrofRaRoYLCAS: hubWrmcrofRaRoYLCAS$2,
	dIOuyFmCcSAXzBifCgd: dIOuyFmCcSAXzBifCgd$2,
	AoqexRnXPjWiaXQQ: AoqexRnXPjWiaXQQ$2,
	wtPiDpoJwweHEwGphG: wtPiDpoJwweHEwGphG$2,
	YFShWZLtmVzhKApQSudo: YFShWZLtmVzhKApQSudo$2,
	EyxlrwvHrdhvRaHtLxx: EyxlrwvHrdhvRaHtLxx$2,
	YbTVKYSCHSNbVSRpbwRM: YbTVKYSCHSNbVSRpbwRM$2,
	rWOqJloUMhKXCZHLpnc: rWOqJloUMhKXCZHLpnc$2,
	nmuzQLDdidsSBtDTLaU: nmuzQLDdidsSBtDTLaU$2,
	cKeVqkUVuUrblpSkN: cKeVqkUVuUrblpSkN$2,
	KgtuAymJbpqjZHQACDKA: KgtuAymJbpqjZHQACDKA$2,
	WriODPyMHmFqbNRIkh: WriODPyMHmFqbNRIkh$2,
	kdGDbDfHqPdMmOODj: kdGDbDfHqPdMmOODj$2,
	fRcWTONIbiPEHREbRTKI: fRcWTONIbiPEHREbRTKI$2,
	MIqinsTMANLFyEzWlLXm: MIqinsTMANLFyEzWlLXm$2,
	xmSClcrPuftAggqMjWp: xmSClcrPuftAggqMjWp$2,
	uPEmuahfZCJKifAf: uPEmuahfZCJKifAf$2,
	NazoeCHUJpEyQWZDKcVt: NazoeCHUJpEyQWZDKcVt$2,
	ZtmHIANowsUTyUyouyg: ZtmHIANowsUTyUyouyg$2,
	DyXvKDfsUBPKtQScEVw: DyXvKDfsUBPKtQScEVw$2,
	SGvHMSujomhCIGweYcH: SGvHMSujomhCIGweYcH$2,
	xFLmujpTZsyQKTENeNr: xFLmujpTZsyQKTENeNr$2,
	xPXNyAgtdawfwFRxXhb: xPXNyAgtdawfwFRxXhb$2,
	VoQarJJpktEfEZnK: VoQarJJpktEfEZnK$2,
	wfUNVCtRXprhwYwce: wfUNVCtRXprhwYwce$2,
	nirNFLwkcuvUxudti: nirNFLwkcuvUxudti$2,
	GqlajLqwcNJLpTqq: GqlajLqwcNJLpTqq$2,
	NKaDUgPomETDmcmKHy: NKaDUgPomETDmcmKHy$2,
	OsCIqseGbbbWXxBLk: OsCIqseGbbbWXxBLk$2,
	DghVzIJcKyuvkcKwY: DghVzIJcKyuvkcKwY$2,
	XYnywMktJDrWPwZBA: XYnywMktJDrWPwZBA$2,
	bgnQSQsWYPIcUDEytcq: bgnQSQsWYPIcUDEytcq$2,
	erGplJlLIBiVheXvc: erGplJlLIBiVheXvc$2,
	epeFMTUcZAYdtLOETgZ: epeFMTUcZAYdtLOETgZ$2,
	oIIfiHdqGwpXZbtDYKG: oIIfiHdqGwpXZbtDYKG$2,
	mlUEUuDRftKStSMvF: mlUEUuDRftKStSMvF$2,
	nNgFtrjyhesGreVhV: nNgFtrjyhesGreVhV$2,
	ewrHdSoDPutFlPrqTEr: ewrHdSoDPutFlPrqTEr$2,
	ZZlJgALCrsSaNhaoV: ZZlJgALCrsSaNhaoV$2,
	OgusvSSbzkNopiGbCIo: OgusvSSbzkNopiGbCIo$2,
	nmPUwVVQoncVHqMln: nmPUwVVQoncVHqMln$2,
	mWaNsXTgUIcnWSphpgB: mWaNsXTgUIcnWSphpgB$2,
	GxjDaNmTVZaIEmLIO: GxjDaNmTVZaIEmLIO$2,
	xdBmFzKPmVQfqVSOyFY: xdBmFzKPmVQfqVSOyFY$2,
	xdSXcpFurEbSenWcxPn: xdSXcpFurEbSenWcxPn$2,
	KzRRnMZfXiUfprzBEe: KzRRnMZfXiUfprzBEe$2,
	nDIaTJMAdTQRxUKJo: nDIaTJMAdTQRxUKJo$2,
	XaQWqbeAdXIkLCiakX: XaQWqbeAdXIkLCiakX$2,
	WHFSIZvkPFlAiUsTW: WHFSIZvkPFlAiUsTW$2,
	IldgeERuYKVOefpR: IldgeERuYKVOefpR$2,
	sYnLKnDJjNhHBCpTj: sYnLKnDJjNhHBCpTj$2,
	ZtsyDNmrvXDDftOHri: ZtsyDNmrvXDDftOHri$2,
	vAeqeVWtpVywOzVUYfuv: vAeqeVWtpVywOzVUYfuv$2,
	PLWcAjJpcpPoIQiCcq: PLWcAjJpcpPoIQiCcq$2,
	QHhdRUWMTaGpDwrC: QHhdRUWMTaGpDwrC$2,
	account_transfer: account_transfer$2,
	account: account$2,
	UKenwEAFyRZgQyZTmPYy: UKenwEAFyRZgQyZTmPYy$2
};

var pHHNdTPNyDzQgIvYd$1 = {
	message: "Hello"
};
var cWSaveaKAPErStEYy$1 = {
	message: "Home"
};
var sSIcbzainkLvqqhxh$1 = {
	message: "Wallet"
};
var aLZzpUtzvgrrPWvcQGbT$1 = {
	message: "Spot Trading"
};
var IizWxRwTfRDgQnVPXcb$1 = {
	message: "Bill History"
};
var jeYCQaSvbBRtAklYZ$1 = {
	message: "About Us"
};
var kfASiYACukCdCVcFmcsq$1 = {
	message: "Welcome %s%"
};
var YpcGXAgMexsVEmQnseE$1 = {
	message: "To use all account features, please complete the identity verification process as soon as possible. The main steps include:"
};
var OivHVusJobtDPuGMSbDN$1 = {
	message: "Phone Number Verification"
};
var HNryhyKcRNPaLZpBHK$1 = {
	message: "Identity Proof"
};
var IDPsMPUXhtCczMWcA$1 = {
	message: "Selfie"
};
var MnGzdARgdxwWnBQGqasa$1 = {
	message: "Address Proof (if necessary)"
};
var dSypETsKWXyxFowLHe$1 = {
	message: "Start"
};
var CRjZdhorIpDDNDAPls$1 = {
	message: "Try Later"
};
var KEEUdFUfkYDFEeiUhk$1 = {
	message: "Your Phone Number"
};
var BQbWzLQtSHQVHdIDAgJ$1 = {
	message: "Send Verification Code"
};
var fxHeYqwgtTcKAdCKPyVe$1 = {
	message: "Resend"
};
var OXrwZMwkWAjoSDDALzow$1 = {
	message: "Verification Code"
};
var tOaRBVUJHpnSgDBrGON$1 = {
	message: "Next"
};
var WbPTckCFMKtPHgAlL$1 = {
	message: "Back"
};
var nHxEoVJEcaAOmKgBbYO$1 = {
	message: "The country of issuance of the selected document is"
};
var MZjVFSmKoCrehUMcH$1 = {
	message: "Modify"
};
var puvbUtnTezlmHPfbVAqn$1 = {
	message: "Passport"
};
var HOpNrycyzpeOCvcWPwAM$1 = {
	message: "ID Card"
};
var QaixZWMxqfefkNPgkdy$1 = {
	message: "Driver's License"
};
var RPMjhEtAWhHwQeAjSV$1 = {
	message: "Upload Passport"
};
var mBnIkwyDNdwNDoWcq$1 = {
	message: "Upload ID Card"
};
var ApuVYLcjyFSzxzZB$1 = {
	message: "Upload Driver's License"
};
var YoNUkubiEWSyPsgRUR$1 = {
	message: "Please ensure that the information is clear and unmodified, upload in PDF or JPG format, not exceeding 5MB"
};
var msvgVjHCdtHxFKkrS$1 = {
	message: "Last Name"
};
var SUObcbdMwQrjwarfaMi$1 = {
	message: "First Name"
};
var ElMEzQxYcCuZMmCmB$1 = {
	message: "Middle Name "
};
var idqLvJqjeiEmQbpa$1 = {
	message: "Required"
};
var FhkGAkzeRaGMUGCREr$1 = {
	message: "Optional"
};
var lXmoRtYVpvHfxffpUp$1 = {
	message: "Date of Birth"
};
var fIZJfHadJjLYozRPMC$1 = {
	message: "Nationality"
};
var fVuoUoQRKfJuwltrQWcF$1 = {
	message: "Please ensure that the basic information you entered matches the document information"
};
var tMHuCmLcCyWTKXTkJpl$1 = {
	message: "Please open the camera and start face verification"
};
var yXhUtplPqxAjDtkzW$1 = {
	message: "Having trouble? Please upload the photo of holding your ID document"
};
var EGBtpzynCWcQsWcMz$1 = {
	message: "Please hold the document and take a selfie"
};
var nFxxFVzdRTilHiouzuY$1 = {
	message: "Upload"
};
var gYpQegnebgwwccEuM$1 = {
	message: "Residence"
};
var HQSjnUOWYQPuvvTpu$1 = {
	message: "Residential Address"
};
var PufPEQRHcFlNqsAG$1 = {
	message: "Mailing Address"
};
var lvvtaxnLzNOtFCZllw$1 = {
	message: "Same as residential address"
};
var NoqAHzFdypmIlmXmyM$1 = {
	message: "Upload proof of address"
};
var dLTuZclgDrLDUToEe$1 = {
	message: "Valid proof of address includes bank statements, utility bills, etc. within the last 3 months. Please upload in PDF or JPG format, and no larger than 5MB."
};
var YChcfaxDaLscdSPiRQz$1 = {
	message: "Submit"
};
var qtCIhbuRgppyZzltf$1 = {
	message: "Bill"
};
var wvzbJUEmNoCiDQLTaWzH$1 = {
	message: "Account Management"
};
var POdaGgvMxQRsisLbVcll$1 = {
	message: "Account Security"
};
var qRoYPOkmAoqOZnZawkD$1 = {
	message: "Personal Information"
};
var SgWXitfFwQHiWicT$1 = {
	message: "Settings"
};
var txfROteTwdaWdTnlkif$1 = {
	message: "Login password"
};
var qEmYfNcGOwxFPeXxWz$1 = {
	message: "By setting a login password, you can log in directly with your account and password."
};
var sjqwCBQBKOIAKZymEnSd$1 = {
	message: "Payment password"
};
var wAFriagWUVTteXOh$1 = {
	message: "Used for secure verification during withdrawals and transactions."
};
var ffqVyVPsxEFhGDWwjo$1 = {
	message: "Phone number"
};
var ZFmapCdeoYAGjnNG$1 = {
	message: "Used to receive verification messages for logging in, withdrawing, modifying password and security settings."
};
var JTHQBsfkCFvanpmGhYL$1 = {
	message: "Google Authy"
};
var tLufHBCFhvZchanHd$1 = {
	message: "Used to enter Google verification codes when logging in, withdrawing, and modifying security settings."
};
var VUMActZjvXkEaSCs$1 = {
	message: "Verify identity"
};
var dqGnSTBmWfxxuxSAR$1 = {
	message: "Used to verify your identity when logging in, withdrawing, and modifying security settings."
};
var NrifpOBOTpbiyPCqT$1 = {
	message: "Authentication"
};
var ogjLTTEZpYaUhUJAk$1 = {
	message: "Personal Information"
};
var TGFdcFVaVnCAXfpC$1 = {
	message: "Nickname"
};
var cFKHegtmXlwojKtJw$1 = {
	message: "Save"
};
var pNHFlymBnWuShBmbewj$1 = {
	message: "Date of Birth"
};
var AsLSeryFUtTwDklOIhVE$1 = {
	message: "Gender"
};
var lNGEpmcaWzCMRfZFypa$1 = {
	message: "Pricing Method"
};
var CKVRBnYMLalEUVhYrqI$1 = {
	message: "Back to Homepage\n"
};
var JAKswaiCfseLlQNZ$1 = {
	message: "Contact Us"
};
var bZduiedsIokAAxBsM$1 = {
	message: "Log In/Sign Up"
};
var rtVWmSuAATyCaNgkRNx$1 = {
	message: "Log In"
};
var TVTktEvtpSXRbnxIB$1 = {
	message: "Email"
};
var leXQdnNvhrYWetVTXjE$1 = {
	message: "Email Address"
};
var MzbyaTzwTlbRpWdHmwt$1 = {
	message: "Don't have an account? Sign Up Now"
};
var phfuULxmHCuLNyotJ$1 = {
	message: "Verification code has been sent to your email, please check"
};
var qdvGrtpVJQsGGgiLvje$1 = {
	message: "I have read and agree to the BIXIN User Agreement and Privacy Policy"
};
var PIxkcsUxBzUPVVFfu$1 = {
	message: "Invalid email format"
};
var OBIAENcRtoPgMWcJNZ$1 = {
	message: "Incorrect verification code"
};
var iDYPzXzvGbnKWCRr$1 = {
	message: "Forgot password?"
};
var FmpkJYVtUXpBCGEVp$1 = {
	message: "Incorrect password"
};
var mzWsFtJNWfexuuUgYctv$1 = {
	message: "Sorry ! Service is currently unavailable in your selected country/region."
};
var wjeaGDSVTuLLjJGehN$1 = {
	message: "Register"
};
var KbSjSRobgQmXjHChGKJ$1 = {
	message: "Minimum 8 characters, including at least 1 number, 1 uppercase letter, and 1 lowercase letter"
};
var TAFoyaQLwVzluFioqh$1 = {
	message: "Confirm password"
};
var eChfcikkuQFNcZULZuP$1 = {
	message: "Repeat Password"
};
var VnLNiYiOJxZraQxL$1 = {
	message: "Already have an account? Log in now."
};
var bqNjZcEbCrAzOJJpJDn$1 = {
	message: "Total Asset Value (BTC Equivalent)"
};
var gTYMvovCwafJTrjdlKg$1 = {
	message: "Deposit"
};
var PczYwMSUlifZlPdkNj$1 = {
	message: "Withdraw"
};
var DDrTONBZdHTEWHNFNgtV$1 = {
	message: "Instant Exchange"
};
var OkpDnVcVIcDyntNTMI$1 = {
	message: "Token Name"
};
var EfVkywGLHyLgyrRjzg$1 = {
	message: "Token Price"
};
var NOIPqSfkgPcsNJnyAFA$1 = {
	message: "Token Quantity"
};
var WauyOiSpVDMamrXbLP$1 = {
	message: "Equivalent Currency"
};
var eXVsxwaBOXkkntIEGtC$1 = {
	message: "Scroll down to view more"
};
var EOmmDCycYoHFOZOV$1 = {
	message: "UID"
};
var ysjFKMhSQlIqXgPlz$1 = {
	message: "Verified"
};
var TNkXPjSKdzQcBLZPsWj$1 = {
	message: "Not Verified"
};
var FMUUecQmwAheUKwpq$1 = {
	message: "Available Limit"
};
var KSxzKkrfZaaHIOptelk$1 = {
	message: "Transaction Amount"
};
var IurrXFgATIlGAlejcf$1 = {
	message: "Increase Limit"
};
var mUgsNHlLzyKVnxhVjRT$1 = {
	message: "Personal Info"
};
var LcqaZGQKcdkxNrnIcK$1 = {
	message: "Help Center"
};
var zQsiOHqCsFIqBzNsf$1 = {
	message: "Settings"
};
var erLerUcELvDAcoUWi$1 = {
	message: "Log Out"
};
var TGYvVRioXBfDBtmCBpH$1 = {
	message: "Limit Application"
};
var cQKfBbUkEhBhPtPCx$1 = {
	message: "Please provide as many income/asset proof materials as possible, so that we may approve a higher position limit for you."
};
var SHjOXbqLUjZRUKsWMzD$1 = {
	message: "Select Proof Type"
};
var mUuMBlRDyzHtFgLsivV$1 = {
	message: "Select Range"
};
var ISJVpXHVtpoxunGygBGu$1 = {
	message: "Upload Proof File"
};
var VGmDUnWBzMKfFbMKXyl$1 = {
	message: "Select Type"
};
var ZAhuzRDlLUTXhKrhhx$1 = {
	message: "Please upload in PDF or JPG format, and the file size should not exceed 5MB."
};
var BggwtUciWOTxbdTdDg$1 = {
	message: "Add"
};
var QFbYEdxUgXzRwcPFQDis$1 = {
	message: "Submit"
};
var UNForxvjDLCZdGrmWkX$1 = {
	message: "Cancel"
};
var OCamqUckeIZshGlCbF$1 = {
	message: "Bill history"
};
var YMfvOKmAFnfMwTXPfI$1 = {
	message: "Personal Center"
};
var nvfgxTKtdXdTEhFZf$1 = {
	message: "Multi-Language"
};
var HrHtlLjcEICrEnWiRA$1 = {
	message: "Asset proof issued by a qualified financial institution"
};
var HIFNIcNDmIhRZEsgzSq$1 = {
	message: "Qualified financial institution"
};
var KSyKpOAjkLSpCGns$1 = {
	message: "Other"
};
var eUvzxeVvXrffrpEOrFrP$1 = {
	message: "Delete"
};
var NqgOQEXQaHsramCnbX$1 = {
	message: "Upload"
};
var YqzlhmIgzcgLnWmZhMsa$1 = {
	message: "Deposit"
};
var FrzWGSiDSDzTfNgZH$1 = {
	message: "Back"
};
var WYhIabGPkCnbVBIPcwW$1 = {
	message: "Select the asset you want to deposit"
};
var LFipKWcCwIamrrato$1 = {
	message: "Select currency"
};
var RFoMDsIwGyJlPkuuxrON$1 = {
	message: "Select deposit network"
};
var bpvYuERgedcoMzzLNl$1 = {
	message: "Select network"
};
var NsvJYqLAVHAaWNUXAvz$1 = {
	message: "Please make sure you select the same network as the withdrawal platform to deposit your cryptocurrency, otherwise your assets may be lost."
};
var UbeafDPBCDfpRnQyWUjq$1 = {
	message: "Cryptocurrency/network"
};
var LbGVMqLVHqyddGmXzULS$1 = {
	message: "Edit again"
};
var qdnqxPdrpfdxhejrkCj$1 = {
	message: "For on-chain deposits of less than 0.05 BTC, a small handling fee of 0.0001 BTC will be charged."
};
var XYHinpRQuEPFjXMzLP$1 = {
	message: "View the reason"
};
var LQNXJVNXqgqLimcQn$1 = {
	message: "This address is only used for %S% payment, transferring other cryptocurrencies will not be retrievable"
};
var nzLBdKgvNCXQTgYI$1 = {
	message: "Memo"
};
var iYpfkywMVpuafYnqXxGI$1 = {
	message: "Withdraw"
};
var DVjsSAdKoyNHoIqhumQ$1 = {
	message: "Select the asset you want to withdraw"
};
var cxKcumOzANqjtQqREyas$1 = {
	message: "Select the withdrawal method"
};
var BQkFfUTgzkweftGIpOLt$1 = {
	message: "On-chain withdrawal"
};
var FNNzRxnZqrKRYwIte$1 = {
	message: "%S% - On-chain withdrawal"
};
var SultIciVtbYeZaII$1 = {
	message: "On-chain address"
};
var dGRvusBQRnbHUIYQRit$1 = {
	message: "Network"
};
var bJwUxepDjVzlNzKuI$1 = {
	message: "Select network"
};
var HlrghIZaaySLZjESwU$1 = {
	message: "Amount"
};
var TCuuXTtXBYeAldQkZp$1 = {
	message: "Minimum withdrawal amount: %S%"
};
var HYTGqldMNoESWJswz$1 = {
	message: "Available"
};
var dkdmEAWTXMORUhlQaX$1 = {
	message: "Fee"
};
var XwYKiJGJKAZZZpNp$1 = {
	message: "Payment details"
};
var swejTyFcYnjuUgsfQW$1 = {
	message: "Payment currency"
};
var mWoxaQwwzwCFvWjRmK$1 = {
	message: "Payer"
};
var tFaBUAWNRhJqtjIha$1 = {
	message: "Order information"
};
var FEySNpPzdMqiOsZXI$1 = {
	message: "On-chain withdrawal"
};
var AIwKneHGNfSJmdLnG$1 = {
	message: "Order amount"
};
var wMGJlEJaupHayuzRwi$1 = {
	message: "Pay now"
};
var iRiLJudagJVXZozmnz$1 = {
	message: "The current amount is less than the minimum limit"
};
var laRzOEpYMTvnZYRBZMnj$1 = {
	message: "The current amount exceeds the maximum limit"
};
var MDhXYatnZcwvrjVeRh$1 = {
	message: "The address you selected does not match the currency. Please select the correct currency."
};
var hDPPfPClruPeWrSoayR$1 = {
	message: "Internal Transfer"
};
var NTsLbMXwQdPYbmOwP$1 = {
	message: "Select the currency you want to transfer"
};
var POqloYgxpcTCqdnchGE$1 = {
	message: "Bixin account"
};
var KxeaINzIsNNJmsIncnV$1 = {
	message: "Phone number / Email / UID"
};
var sfsygIDbANBoFslbcsw$1 = {
	message: "Transfer amount"
};
var YgpFeXbXojsYnphM$1 = {
	message: "Minimum withdrawal amount: %S%"
};
var MutPBZAXykjaIurt$1 = {
	message: "Confirm transfer"
};
var GvnMmZJtuApdXwWhsFd$1 = {
	message: "You haven't bound GA at the moment, so you are unable to proceed with this transfer."
};
var IcahwJmNfgdvVpPz$1 = {
	message: "Go to settings"
};
var bxtlucAfnIxfwBYAY$1 = {
	message: "The following verifications are required for this payment"
};
var KKbVbDLheqewlSvBE$1 = {
	message: "Please enter payment password"
};
var RLztZboedHACRMkjdD$1 = {
	message: "Please enter GoogleAuthenticator verification code"
};
var QEaaELvQUvbfoIpje$1 = {
	message: "If you have any problems, please contact customer service"
};
var czSsfuZGitGjFRwLTF$1 = {
	message: "Bixin security protection in progress"
};
var xrYEaiWUOcaNRQMIf$1 = {
	message: "Transaction succeeded"
};
var QDuPlYKAxjAjIgyoAqM$1 = {
	message: "Exchange now"
};
var ZkDBgJuvDUVQPOxBY$1 = {
	message: "Remaining monthly trading limit: %S%"
};
var rJAhIVPUqedRmsfmj$1 = {
	message: "Buy"
};
var GpGpOkSHUzYBQNFc$1 = {
	message: "Payer"
};
var aMdrNUxkhioFGrNGFIO$1 = {
	message: "Amount Spent"
};
var siLEsPwfoiqGBiXjB$1 = {
	message: "Fee"
};
var DYgqvlfmNbyLNOrWwc$1 = {
	message: "Auto Refresh in %S%s"
};
var rifKyRmlGZOwlJkDyZG$1 = {
	message: "From"
};
var aNVsLyHapaJbRxWnHsv$1 = {
	message: "To"
};
var cQiCyvfOMMDJEIXyc$1 = {
	message: "Bill"
};
var SywvArMjCuuGzTEtlJ$1 = {
	message: "Max"
};
var vRyVKhBOPCmWYPPacY$1 = {
	message: "External Transfer-In"
};
var GMOQAxsTvfWIEBANuS$1 = {
	message: "External Transfer-Out"
};
var xqLddTkVnCrEvxgKGso$1 = {
	message: "Internal Transfer-In"
};
var sHqYaogVbbeWItJGb$1 = {
	message: "Internal Transfer-Out"
};
var xgIKqcGuTlutCTLLG$1 = {
	message: "Spot Trading-In"
};
var zsLweYcWjOwUgfyub$1 = {
	message: "Spot Trading-Out"
};
var xUNmcszdZBWMTcxnI$1 = {
	message: "Including Fee"
};
var moirunBAysHLMEDtBxUt$1 = {
	message: "Transfer Details"
};
var YrkgVnAQcYRhGGRex$1 = {
	message: "View"
};
var iuOLeRpygvfPFDnf$1 = {
	message: "Type"
};
var iuswsIRQwNAIuOzoFX$1 = {
	message: "Created Time"
};
var sBFILAqpJhAnTLlpQ$1 = {
	message: "Transaction Hash"
};
var eSLIwfCNWkIwJpqCHSVC$1 = {
	message: "Bill Details"
};
var RtWpXpLfhjeWPtKhcENN$1 = {
	message: "Identity Verification"
};
var KveBVvOTiGXRKmAUQZz$1 = {
	message: "Deposit details"
};
var XwmOjTtjNklQiLDgnjIB$1 = {
	message: "System has denied the payment for there're risks in the funds. Please contact customer service!"
};
var GLIndpTHvNVRVWQuT$1 = {
	message: "Send to"
};
var WzcUSFqDMdwkVtGoj$1 = {
	message: "Complete"
};
var kuTgfRDYzVZvEHrFtQ$1 = {
	message: "E-mail verification"
};
var gXbirwakdsaUKBglwK$1 = {
	message: "Copy successful"
};
var cTlSqXgGENkCAQQJCHx$1 = {
	message: "6-digit number"
};
var JsmDOHlXAmjSPqaxg$1 = {
	message: "Send"
};
var yCCsuXAjuRzOLNxo$1 = {
	message: "Invalid verification code format"
};
var iizCYlpFHwQBzRyqLM$1 = {
	message: "No account?"
};
var FbztGftxEQrszJntb$1 = {
	message: "Register now"
};
var rteqizIYZXJwMWMenVz$1 = {
	message: "This email is not registered yet. Click to register"
};
var sydmFvhfSgzJVhtAud$1 = {
	message: "This email has already been registered. Please change the email"
};
var aYdhyaHCqMJLweGFD$1 = {
	message: "Please read and agree"
};
var SMEPVJNtMGWMrEceo$1 = {
	message: "Invalid password format"
};
var jgXHbpNLgJMKuuZER$1 = {
	message: "Passwords do not match. Please re-enter"
};
var JWDRcPebwmpIhvJhVrJe$1 = {
	message: "I have read and agree to"
};
var UtQJNokaxJhxqqTQDiO$1 = {
	message: "User Agreement"
};
var TFAtjCZbFqacobpGxct$1 = {
	message: "and"
};
var EokACCilfAZfuGcXD$1 = {
	message: "Privacy Policy"
};
var UXURgENTpgxogbFAD$1 = {
	message: "Already have an account?"
};
var ElbSFPkaecjnmBToovei$1 = {
	message: "Log in now"
};
var LuigfaXzmPRCftdFOV$1 = {
	message: "Please enter the verification code"
};
var BNXHKONNlrkDGKwkXt$1 = {
	message: "Set payment password"
};
var ltXrglJnxfNqZDSStFq$1 = {
	message: "Verification code"
};
var FClYxqPqiIjfTGZZthn$1 = {
	message: "Please set a 6-digit numeric payment password."
};
var cNmmUqRZfZDUxgWTQeXm$1 = {
	message: "Incorrect format, please set it again."
};
var lKLpdmEuElAKKvltT$1 = {
	message: "Confirm payment password"
};
var coPPHMNHpJdMYeKPskDY$1 = {
	message: "Please repeat the payment password"
};
var NovuNXyQGDRrjfyMs$1 = {
	message: "Registration successful"
};
var bOSFxWykzVFerKLOiV$1 = {
	message: "Add Google Authy."
};
var HfjMmDJQuBZXqFJUw$1 = {
	message: "Step 1: Save your GA private key"
};
var SVTrmHtEOHifBpgPNCY$1 = {
	message: "Please keep your private key safe. The private key is the only way to recover GA authentication. Please do not disclose your private key to anyone."
};
var LmRHxJOIEHRnUwFSxEm$1 = {
	message: "How to recover?"
};
var gbkxEEkMTXuhYuUCZTJ$1 = {
	message: "Step 2: Open the Google Authenticator/Authy App and add an account."
};
var rQgPydQgDVYqtWJXCky$1 = {
	message: "Binding successful!"
};
var nFSJqWAXBnxTngDNyoj$1 = {
	message: "Reset password"
};
var MThZOMtyoBvwpuodWEa$1 = {
	message: "Modified successfully!"
};
var hiEgXdIbTRKrnaYJnNY$1 = {
	message: "Reset login password."
};
var PqkPSNBQJWOqaAsafW$1 = {
	message: "Google Authy verification"
};
var vHRZRztWvqyjjHCxW$1 = {
	message: "Verification code has been sent to your mobile number ending in %S%. Please check."
};
var QZchoinPLbiohHfdnLU$1 = {
	message: "Financial institution name"
};
var gnOvqPVwTsPuWvBTXzI$1 = {
	message: "Document type"
};
var bDmdcJmdRsIZfYYBDeZ$1 = {
	message: "Application successful, awaiting manual approval."
};
var YEPMktdEzwhrMMYKefX$1 = {
	message: "Month"
};
var wGSnhUtsHuueniKdYTwM$1 = {
	message: "Please fill in the institution name"
};
var krMQcSEJDOnglqhrHgu$1 = {
	message: "Please fill in the document type"
};
var erZFCFRNsVfSKVMRLN$1 = {
	message: "Male"
};
var dmeNSGPySLKtEpPGwG$1 = {
	message: "Female"
};
var czWbrtWmnCEbUCzVWzQQ$1 = {
	message: "Bind"
};
var YATiezBAjBifZRNRVk$1 = {
	message: "Bound"
};
var sTMySyQXFMSuchwUXiJ$1 = {
	message: "Reset payment password"
};
var FxLhtNEexnBoJElMC$1 = {
	message: "Change mobile number"
};
var hYBHkTzZmueqvwJb$1 = {
	message: "Hong Kong"
};
var GBvqxVjZVWwZtAPZgH$1 = {
	message: "Enter mobile number"
};
var KVLFziUaVDlFbnJzh$1 = {
	message: "Please enter your mobile number"
};
var OQGpXlfSrBKFcwjAv$1 = {
	message: "Address proof"
};
var AsfYVtpYWMjfUopLa$1 = {
	message: "The country of issuance for your selected identification document is :"
};
var wZZutIhpaOoppafvh$1 = {
	message: "Please select"
};
var OUdBKfTzsTrdfcZmbCAI$1 = {
	message: "Encountering difficulties? Please select."
};
var IwzxXaGfVvDNSxQpmeO$1 = {
	message: "Selfie with identification document"
};
var XzCcbOKjdfmcCnQLEwNj$1 = {
	message: "Review rejected, please resubmit."
};
var IkToKVrxLaVfCKfNGvl$1 = {
	message: "Please fill in your last name"
};
var mRtlyGWfQVnoeqMeTs$1 = {
	message: "Please fill in your first name"
};
var ldgxhAKPgZpGiyMyJw$1 = {
	message: "Under review, please wait."
};
var mxKAuwcjmevMUSvDQE$1 = {
	message: "Review approved"
};
var pSTKNwtZdcuFuoyTsPhb$1 = {
	message: "Please select your date of birth"
};
var EkbLQeqmPtcNzItJWQO$1 = {
	message: "Please fill in your residential address."
};
var KzFzOytWXScqDRKFwg$1 = {
	message: "Under review"
};
var MvJmrHwTdesvsHWH$1 = {
	message: "Verification code has been sent to your mobile, please check."
};
var bksAzarViFUYGzwAOk$1 = {
	message: "Artificial review"
};
var EOLVYvzyNXSKoGmX$1 = {
	message: "Due to the current risk of payment , it has entered the artificial review, and ti is expected to complete the review within 30 minutes. If you have any questions, please contact customer service."
};
var EvOtSTBQrIYspwjQ$1 = {
	message: "Please fill in the mailing address"
};
var eQHAVxHydpVhNAygOp$1 = {
	message: "Verification region"
};
var LWInyMcYkagvzvaBfUHZ$1 = {
	message: "Depositing this crypto to Bixin requires both a deposit address and a deposit memo, or the attempt will fail. "
};
var OKOogywrWeAjtQWF$1 = {
	message: "Insufficient fees"
};
var MOtoFwFvpTtTEDVUD$1 = {
	message: "Insufficient balance"
};
var ZdMOAZGAMXotVGVlKJ$1 = {
	message: "Currency/Withdrawal method"
};
var rEpbPaWEEsiOSTjOiSGL$1 = {
	message: "Enter address"
};
var SWVaRdViGfCBJhJNg$1 = {
	message: "Enter pubkey"
};
var lrCgiXeJcIwkuDsyc$1 = {
	message: "Chain"
};
var vyxYMhwwOspfcdpj$1 = {
	message: "Please enter recipient email"
};
var MqMVsYdMMtqujWPKHW$1 = {
	message: "Please enter your UID"
};
var siEUrpaJmBIICzsaBnr$1 = {
	message: "Recipient"
};
var XGLKbSKPnzgwwZwEHu$1 = {
	message: "Please enter the email verification code"
};
var DPFrIOWnjfRpVQHkhKJ$1 = {
	message: "Send email"
};
var dTLgwTGGXjpsnLhrpr$1 = {
	message: "Transaction type"
};
var gZgeimlXmokhLdRziw$1 = {
	message: "Remark"
};
var xqhbTjIzOYuCUiHEUmd$1 = {
	message: "Transaction ID"
};
var bbQJHoMWXkEHQuVRSsO$1 = {
	message: "The system has detected a risk in your account activity. Please contact customer service for manual review."
};
var HHdEPKdocehppzeI$1 = {
	message: "Please enter"
};
var tICtqmzJVNeVfZQM$1 = {
	message: "Single transaction limit"
};
var HOQBmfsmIsFBlsaJaSa$1 = {
	message: "Maximum available balance for trading"
};
var XsOliEIHDkjKcghOik$1 = {
	message: "Sell"
};
var ADXLpfHxGLEEMBBLjSL$1 = {
	message: "Amount obtained"
};
var kHAIwKLXztAgQxLOxj$1 = {
	message: "Price"
};
var pqNxLtehgpuJIUBdg$1 = {
	message: "Confirm transaction"
};
var nodIQIicrpcVpCqYey$1 = {
	message: "Submission successful"
};
var gMjyScxabRhqehsX$1 = {
	message: "To continue using the service, please confirm that you have read and agree to the latest"
};
var AQrCocFqoKoYieUnT$1 = {
	message: "Confirm"
};
var COydGeEPULYaNAmN$1 = {
	message: "External transfer"
};
var pFhbWEovZnvIiVEEJnme$1 = {
	message: "Internal transfer"
};
var omUetmzxCLiTloCSalU$1 = {
	message: "No data yet"
};
var pqzdTKxlixAoAQwGy$1 = {
	message: "A simple yet secure place to trade Bitcoin, Ethereum Virtual Assets"
};
var VihBsZgCPMgMJnwUeMLt$1 = {
	message: "First Name (Required)"
};
var ohIqnNpSPiMOrWPSWk$1 = {
	message: "Last Name (Required)"
};
var TGIiRSnHGjASSfzjMA$1 = {
	message: "About Us"
};
var jjFQYQyxRWGgKdjbaeB$1 = {
	message: "NewBX Limited is a Hong Kong limited liability company and a wholly owned subsidiary of Bixin Group. The Bixin.com Platform, formerly known as HaoBTC, was established in 2014 to provide “Simple yet Secure” virtual asset services. In the past nine years, Bixin.com has served more than 1 million users, proceeded with more than 3 million transactions annually, and saved USD$1.85 million in transaction fees for its users annually. \nBixin.com has built a comprehensive risk control system to monitor abnormal data in real time and to ensure security across all business sectors. Through hot and cold wallet segregation, multiple signatures, and military-grade hardware encryption mechanisms, Bixin.com provides industrial-level protection for users' virtual assets, securely operated for over nine years with ZERO security breach."
};
var VsuTZcfrgRHVvsOOY$1 = {
	message: "About Bixin"
};
var PLhQWivTKyTYZvsNwMxj$1 = {
	message: "Get Started"
};
var ZLJlKTdDgntyZXzg$1 = {
	message: "Simple Yet Secure\nVirtual Assets Trading Platform"
};
var pPqFjpMzSnmyNWXdT$1 = {
	message: "Trade virtual assets easily"
};
var aJpdCHYrgIukuVpHluT$1 = {
	message: "Stable & Secure for a Decade"
};
var olWnlFpnBjRnPCLuu$1 = {
	message: "Bixin owns the top security team in the\nindustry. We built a robust risk control\nsystem to monitor abnormal data in\nreal-time and ensure the security of users' \naccounts and transactions. Technologies \nsuch as hot/cold wallet separation, \nmulti-signatures, and military-grade \nhardware encryption mechanisms provide\na bank-level security for your crypto \nassets."
};
var ApYUyYTgQDVozNVGdoWy$1 = {
	message: "Powerful & Simple Trading Platform for Everyone"
};
var MEuzpQOAySrMUyXj$1 = {
	message: "We provide powerful, flexible, and \neasy-to-use tools for blockchain assets, \nand are committed to enabling everyone to \nhold, use, and manage their crypto \ncurrencies with ease. Bixin products are easy\nto understand and deliver a smooth\nexperience. Users can start to trade easily after account verification."
};
var NkjUESwzghXjElHM$1 = {
	message: "Virtual Asset Trading All-in-one Platform"
};
var GnugFlecXZohsDMgfjv$1 = {
	message: "From transfer to trading, Bixin meets all\nyour needs and offers you one-stop\noperations.We are continuously improving\nto provide users more easy-to-use features."
};
var nwsbWCYbSYugmHDgHTAB$1 = {
	message: "Trading at Your Fingertips"
};
var gphdXFLzIrPxMQrAp$1 = {
	message: "Globally accessible & Hassle-free"
};
var toUaeInrwbWVqvGGGX$1 = {
	message: "Strict Risk Controls"
};
var gVAFPuXrrstpWxRF$1 = {
	message: "Multiple layers of risk management mechanisms to secure your funds"
};
var AowuwjwDLrAJJKuVzCA$1 = {
	message: "Quick & Easy"
};
var TfmLyYqIoASEGHkuRa$1 = {
	message: "Account Verification"
};
var tjuWuhQfpwDJLMscdbI$1 = {
	message: "KYC with Face Recognition"
};
var KewXLZFbuyWsCSbvXi$1 = {
	message: "Exchange now"
};
var vQphyNqvokPAiFdfRR$1 = {
	message: "NewBX Limited is a Hong Kong limited liability company and a wholly owned subsidiary of Bixin Group. The Bixin.com Platform, formerly known as HaoBTC, was established in 2014 to provide “Simple yet Secure” virtual asset services. In the past nine years, bixin.com has served more than 1 million users, proceeded with more than 3 million transactions annually, and saved USD$1.85 million in transaction fees for its users annually. \nBixin.com has built a comprehensive risk control system to monitor abnormal data in real time and to ensure security across all business sectors. Through hot and cold wallet segregation, multiple signatures, and military-grade hardware encryption mechanisms, Bixin.com provides industrial-level protection for users' virtual assets, securely operated for over nine years with ZERO security breach."
};
var ZbQsLkbfHUtbznnzU$1 = {
	message: "User Agreement"
};
var TsnjCIOPEKKCCfrIF$1 = {
	message: "Privacy Policy"
};
var qyKlEsEkyTXybgIHcI$1 = {
	message: "Help Center"
};
var VZexjbUhosOUoUTI$1 = {
	message: "Bixin Group"
};
var jDRHFidXonxhhPKaTl$1 = {
	message: "Simple Yet Secure"
};
var CInUOzoFKTOMvMbix$1 = {
	message: "Virtual Assets Trading Platform"
};
var fTbsMnhpZYjiOkAdex$1 = {
	message: "Multiple layers of risk management mechanisms"
};
var yOZzgRmKudbwNjuurBHz$1 = {
	message: "to secure your funds"
};
var lelamaRhejmRBJOD$1 = {
	message: "Bixin.com has built a comprehensive risk control system to monitor abnormal data in real time and to ensure security across all business sectors. Through hot and cold wallet segregation, multiple signatures, and military-grade hardware encryption mechanisms, Bixin.com provides industrial-level protection for users' virtual assets, securely operated for over nine years with ZERO security breach."
};
var pZxEeOQMfyGXKTBxtyJ$1 = {
	message: "Globally"
};
var ZGyanZavgObBeqhP$1 = {
	message: "accessible"
};
var oeMZNyLdkPQdxrobojO$1 = {
	message: "Hassle-free"
};
var MYuuWNTVQwjCeRRGl$1 = {
	message: "NewBX Limited is a Hong Kong limited liability company and a wholly owned subsidiary of Bixin Group. The Bixin.com Platform, formerly known as HaoBTC, was established in 2014 to provide “Simple yet Secure” virtual asset services. In the past nine years, Bixin.com has served more than 1 million users, proceeded with more than 3 million transactions annually, and saved USD$1.85 million in transaction fees for its users annually. \n"
};
var yrlrMPLgOtiEzbmPW$1 = {
	message: "As Bixin has always advocated"
};
var EzMbHhWUJOaBMLDRJxZ$1 = {
	message: "Total Balance"
};
var hQRkbssUXUGGLhtxc$1 = {
	message: "Asset"
};
var eDwDkAgbfaPsnwOb$1 = {
	message: "Trade"
};
var AVWJwkijUTbNMShmp$1 = {
	message: "Bill"
};
var wEEzjRnoOftKrGIPbix$1 = {
	message: "Complete identity verification to access all product features"
};
var NqoduOnqIqJtrjajas$1 = {
	message: "Funding Account Asset Value (BTC Equivalent)"
};
var vLUFWGhkoIBWnOMA$1 = {
	message: "Trading Account Asset Value (BTC Equivalent)"
};
var tjsCbqUvgNvcdRqdDp$1 = {
	message: "Transfer"
};
var zBceLwpDLhGkPRkvbU$1 = {
	message: "Trade"
};
var udmfKDblDABqFbQPK$1 = {
	message: "Funding Account"
};
var AysRHzzIQTbjLUdgdaq$1 = {
	message: "Trading Account"
};
var KZPDAndezwXohlXxO$1 = {
	message: "Available"
};
var hdPRTcCCnKbkxbRwgv$1 = {
	message: "Confirm"
};
var pfVyzGgyXmkqtJpGH$1 = {
	message: "Trading Theme"
};
var KRzStRHbmbrDbAUMnU$1 = {
	message: "Light"
};
var lfLIpxDvOAXOplowzN$1 = {
	message: "Dark"
};
var BiqzWayxveHNZGxaBa$1 = {
	message: "Color Preference"
};
var CvvaFnujrEUnFHnWNb$1 = {
	message: "Green Up Red Down"
};
var CNmFZyGboWXdpYPQDvxV$1 = {
	message: "Red Up Green Down"
};
var OmOTUgBCsVHUoKutAD$1 = {
	message: "Insufficient available balance\n"
};
var DCXoQKoDcwNYuYivD$1 = {
	message: "Amount cannot be blank"
};
var ApeuvISiLLWNGQPrFrP$1 = {
	message: "Locked"
};
var sCfZtZRTGxweYVxtEuoY$1 = {
	message: "Total Token Quantity"
};
var VpbDUCnJRDAsPzfIkn$1 = {
	message: "Token amount that is locked in open orders"
};
var WfvaFuidVgEGCwnBEkl$1 = {
	message: "The selected token is not available for transfer in the account"
};
var UheALJaSjOHgmVnoCrI$1 = {
	message: "Please input amount"
};
var fNFAnFLpEoAIoPfbh$1 = {
	message: "Transfer Success"
};
var uUrUZzojXlsqxsuOJZTc$1 = {
	message: "System Error"
};
var CqNbVYlZNfwGfGTGRtE$1 = {
	message: "Payment order does not exist"
};
var QgEerZTcSTdjtiTnKRT$1 = {
	message: "Payment order has expired"
};
var GnbMsiqoZbfmcDerQ$1 = {
	message: "You cannot transfer to yourself"
};
var nEgrtiBYldBKXkpKCocL$1 = {
	message: "Sorry! Payment request is rejected"
};
var AJSlWSWYVQZSygnFKRsI$1 = {
	message: "Transfer failed"
};
var KzgGszjJLuRsOKsdkH$1 = {
	message: "Deposit failed"
};
var YmIZCYMTuGNvbocpiJOP$1 = {
	message: "Spot Trading"
};
var YixzEmijtHztNgwIE$1 = {
	message: "Price"
};
var geVHcZlrpiEaagZcypgy$1 = {
	message: "Amount"
};
var SAruOCDnkHugkPOIFSc$1 = {
	message: "Total"
};
var yteHSDpgaHMYFeMBfpWk$1 = {
	message: "Buy BTC"
};
var slVffWcKrAhjpgaMEuY$1 = {
	message: "Advanced Verify"
};
var ghYLDApWJBxFOzhqAlN$1 = {
	message: "Verify"
};
var GCxKMtkKAZPoOHsZIDh$1 = {
	message: "Professional Investor"
};
var uRLAPBsurxBqxfvgaSH$1 = {
	message: "Are you sure to verify as a Professional Investor?"
};
var FaQaEHvLdVELQbCZrFN$1 = {
	message: "According to the SFC，Individual Professional Investors refer to high-net-worth individuals holding an investment portfolio of more than 8 million HKD"
};
var RZgUzTVRaXNflgjshVf$1 = {
	message: "To use the account functions normally, please complete your identity verification as soon as possible"
};
var nXPQNJCVxPkQKidfjnn$1 = {
	message: "Individual"
};
var swSisSeZXWyUyMvIu$1 = {
	message: "Retail User"
};
var HryFxrLzCqTGOVNrpI$1 = {
	message: "Corporation/Institution"
};
var QqwNZKCLuiPIswItY$1 = {
	message: "Please fill out the pre-screening form first. Our Onboarding Specialist will contact you as soon as possible"
};
var gqfClfSZIJlpPGmuBjum$1 = {
	message: "Select"
};
var HMclPwyZgRMKnvBRCr$1 = {
	message: "Company Information"
};
var iZKMHnInbVLuJJcbpbR$1 = {
	message: "Company Name"
};
var VYJdtiuPscmItOfIyux$1 = {
	message: "Location"
};
var sbzqRZRFyPyYqnsMtNy$1 = {
	message: "Website"
};
var SwDoMzvfeChtJIrEA$1 = {
	message: "Products and Services"
};
var pPViUnFnexhWKoFMx$1 = {
	message: "Is your company a Financial Institution?"
};
var NltNaOnxuMeUAbBeZ$1 = {
	message: "Yes"
};
var HmXYHUAhkQnrZSfKu$1 = {
	message: "No"
};
var KgKURwhHRUNpPmFtXTAv$1 = {
	message: "Contact Person"
};
var thvmUblDYmiyVPacUB$1 = {
	message: "Name"
};
var ViAVfshtzuMNFpCqJl$1 = {
	message: "Position"
};
var sSrzMRNSGNzrJsidBnYz$1 = {
	message: "Submission Successful"
};
var wVSQKNQtitzmkbjDOac$1 = {
	message: "Our Onboarding Specialist will contact you as soon as possible"
};
var rvLRPuoiEpNqnbxwWj$1 = {
	message: "Individual Verification"
};
var CRMoLKUrfyLkDWFEuSu$1 = {
	message: "Basic Information"
};
var GJOdwcCnvAbhzEkImJ$1 = {
	message: "Proof of Address"
};
var pnGXcYRvktMyOUBwX$1 = {
	message: "Financial Information and Asset Proof (Mandatory for Professional Investors)"
};
var fQOFawXqhywMOGSe$1 = {
	message: "Assessments"
};
var KIIMnxhTdJBhZfaEMP$1 = {
	message: "Risk Profile Questionnaire"
};
var hAacNWPacMHaAAaOw$1 = {
	message: "Virtual Assets Knowledge Test"
};
var aCtajuQWKCQNkeKgtwLb$1 = {
	message: "Professional Investor Assessment and Declaration (Mandatory for Professional Investors)"
};
var XjTUjttgmruHnxFXgVf$1 = {
	message: "Certification"
};
var ovsIpOdHmKskDqaansBG$1 = {
	message: "Certified by licensed or registered persons"
};
var RawXxpklaPpnKkAjXLL$1 = {
	message: "Designated Bank Account Transfer (Coming Soon)"
};
var dpnyHVmjzJjiqtQIfpD$1 = {
	message: "Verify"
};
var CtiOEevtmgSCxLlIqb$1 = {
	message: "This country/region is currently not supported. Please ensure your subsequent identity verification is NOT in this country/region"
};
var HmoCuzIHcMwWJJxszus$1 = {
	message: "Former Name"
};
var xoPXukoFZulOsawPoPe$1 = {
	message: "Nationality"
};
var FlbUChtSXKPaYQGW$1 = {
	message: "Please contact <b>support@bixin.com</b> should you have any questions. </br>\nAlternatively, you can enter \"<b>manual verification</b>\" in the Customer Service bot at the bottom right to manually submit documents including identity certificate, long-term visa, entry permit, etc."
};
var XUWTeclWoXtMrQkJzuuq$1 = {
	message: "Opt for e-Statements/e-Advice"
};
var YCHRDIIKsDzJFQJw$1 = {
	message: "Strongly recommended that you opt for the environmentally friendly and real-time e-Statements/e-Advice. </br>\nIf you confirm to choose the paper statements, you will have to pay the HKD 100 annual fee. Please contact <b>support@bixin.com</b> for signup."
};
var hfBBkSOAXqfEsLVFs$1 = {
	message: "Under Review"
};
var aETDJvQumPoQnxdEPkQR$1 = {
	message: "Learn more about <b>Professional Investor Verification</b>"
};
var zZXyblLWbONMNIjPmBN$1 = {
	message: "Approved"
};
var gyneoIYPeiHgfaCY$1 = {
	message: "Failed"
};
var ihVcXhmbhwIbsPsTbF$1 = {
	message: "CRS Self-Certification Form"
};
var ctaxFEnYnZIrAtOaYc$1 = {
	message: "Download"
};
var tMlPwcyXKotAImFCGfQ$1 = {
	message: "Please fill out and sign. Upload as PDF (cannot exceed 15MB)"
};
var SRUOTyGYueLSOwlA$1 = {
	message: "Asset Proof issued by a qualified financial institution (within 12 months)"
};
var rpFnFNTJlMZaopFU$1 = {
	message: "Asset Proof certified by qualified persons (within 16 months)"
};
var sMMYOeSUIvHuRdqiC$1 = {
	message: "Qualified persons include notary public, lawyer, certified public accountant, etc."
};
var fYiJCYMSTpHPjREdFLyB$1 = {
	message: "Proof of Portfolio"
};
var XzXwpEBzHGPNkUqaw$1 = {
	message: "e.g. prime brokerage statements, holding/transaction information"
};
var YyrFTDoECNUvGnXVt$1 = {
	message: "Your risk profile type is <b>$s</b>, which means you are not suitable for virtual asset investment"
};
var leIEPguvvNFtRsXGFI$1 = {
	message: "Retry"
};
var yEMtEIJyJomPsTPTv$1 = {
	message: "Your risk profile type is <b> $s </b>, please continue to complete the \"Virtual Asset Knowledge Test\""
};
var EHBFEqMJtpPqVznA$1 = {
	message: "Test failed, please try again"
};
var IHceeEHwOOHjpdHosyOe$1 = {
	message: "Score"
};
var kINzgREzBDTsegQCvHQ$1 = {
	message: "Congratulations, your have passed the test!"
};
var ObVBBALqXaIzgsSPVQO$1 = {
	message: "Professional Investor Assessment and Declaration Form"
};
var ckNnmPAbtNOsWqlpAKy$1 = {
	message: "According to SFC, the sighting of related identity documents should be certified by any other licensed or registered person, an affiliate of a licensed or registered person, a JP (Justice of the Peace), or a professional person such as a branch manager of a bank, certified public accountant, lawyer, notary public or chartered secretary."
};
var nmOEDJmAsIcTkCgZMv$1 = {
	message: "Please upload a copy of the certificate after completing the certification"
};
var jMXTehFeNbljMLGb$1 = {
	message: "Alternatively, you can contact <b>onboarding@bixin.com</b> to arrange a face-to-face account opening certification (Hong Kong users only)"
};
var ZbUUOchcpSOpwpIk$1 = {
	message: "e-Statement"
};
var lzbnQluepXRurDUf$1 = {
	message: "Monthly Statement"
};
var xDfYpxodvMVDQJKav$1 = {
	message: "Daily Statement"
};
var XBrHgyrvVacGhRNJco$1 = {
	message: "You can check the monthly statements for the last 12 months here. For more inquiries, please contact <b>support@bixin.com</b>"
};
var cXhPoUARLvRqvesHQqeu$1 = {
	message: "Select a date"
};
var tBDAaKFwVBeiyQnnTDIA$1 = {
	message: "Query"
};
var PuqWAcBQEKXlfTuxDuD$1 = {
	message: "You can check the daily statements for the last 30 days here. For more inquiries, please contact <b>support@bixin.com</b>"
};
var yzrKsfyEambKetSgWv$1 = {
	message: "Financial Information and Asset Proof"
};
var NSkMpVyoVWGymUTOzL$1 = {
	message: "Professional Investor Assessment and Declaration"
};
var JkoaUyCjjTHSNUEy$1 = {
	message: "Conservative (Low Risk Appetite)"
};
var LtnRgezlrxMzWvZBxRJ$1 = {
	message: "Moderate (Low to Medium Risk Appetite)"
};
var jXvqhJJMhyxRdxCxv$1 = {
	message: "Balanced (Medium Risk Appetite)"
};
var YZKOONeeIQMFqysxrZ$1 = {
	message: "Growth (Medium to High Risk Appetite)"
};
var nmicLlJCgyNNjjzKJUt$1 = {
	message: "Aggressive (High Risk Appetite)"
};
var BCZEHAhJNfTPwNSqVZl$1 = {
	message: "Other (optional)"
};
var zIFzaxTFaAhTdPpeh$1 = {
	message: "Please select at least ONE asset proof or portfolio proof"
};
var tdxbonOdGqBYgBaOjc$1 = {
	message: "Upload a copy of the certificate"
};
var XondKWeJxfchfIoGLe$1 = {
	message: "Limit"
};
var ndyNHmtKJFFsefAzdv$1 = {
	message: "The transfer limit is 0"
};
var FeBXkTWnPLzGZEnXEpg$1 = {
	message: "Please ensure that the information you enter is true and valid, and consistent with the identity documents"
};
var QZCxVURndUpletXFScR$1 = {
	message: "Please fill out the required field"
};
var UXOpXybkQBmLEHTAgw$1 = {
	message: "Account Type"
};
var BslmwdHcTinuPaihULw$1 = {
	message: "This Risk Profiling Questionnaire is divided into three parts:"
};
var jvnfqZRQbFEGTCMGbvT$1 = {
	message: "<b>Background</b>: Q1 - Q2"
};
var NsZKEKPRgLQfWeSixA$1 = {
	message: "<b>Risk Profile Assessment Questionnaire</b>: Q3 - Q11"
};
var icMsBwEbBUQztvmOv$1 = {
	message: "<b>Investment Knowledge and Experience</b>:"
};
var dXXdlICxETXaAzDyY$1 = {
	message: "Non-complex products: Q12 - Q16"
};
var zhFTdPuxrgMfcNWoA$1 = {
	message: "Complex Products (Virtual Assets): Q17 - Q22"
};
var pjPGNrHukGWKUheCaX$1 = {
	message: "Please consider consulting your independent investment adviser before making any investment decisions."
};
var uglsZRLSLmmcqItl$1 = {
	message: "For a joint account, this Risk Profiling Questionnaire should be completed by all account holders, whereby the joint account holders’ collective response will reflect your agreed financial objectives, circumstances and knowledge and experience with financial instructions."
};
var nPqFzGTyChvJyTQw$1 = {
	message: "Unless otherwise stated, this Risk Profiling Questionnaire will adopt the following definition:"
};
var mEPBGXtDbaIrisefS$1 = {
	message: "<b>Investment</b> refers to investment products the value of which can fluctuate, and it includes, for example, stocks, unit trusts, foreign currencies, commodities, structured investment products, warrants, options, futures, investment-linked insurance plans or virtual asset or related products."
};
var dBZfEFBQmkatfptbV$1 = {
	message: "<b>Risk Appetite</b> refers to the overall approach to the portfolio and may include products of a higher or lower risk grade than you would like to hold."
};
var jYUScsXfUCTPNPqSAR$1 = {
	message: "The value of investment may rise or fall and may become valueless. Past performance figures are not indicative of future performance. Relevant products offering document should be read for further details."
};
var OJjDmIeMWmMfkDihQu$1 = {
	message: "Personal information collected in this Questionnaire will be kept confidential. The information may be used under a duty of confidentially, for designing and/or promoting of virtual assets products or services."
};
var JoPUjgxywPfIQlnDrzx$1 = {
	message: "<b>Important Notes and Disclaimer</b>"
};
var ZVRKVLGoMmmrOxLzg$1 = {
	message: "In completing this Risk Profiling Questionnaire, you may ask questions and take independent advice. After your confirmation of the risk profile, the corresponding risk appetite will be recorded by the Company that might be used in generating investment recommendation and assessing the suitability of products to you. This disclaimer serves as an exculpatory statement absolving the Company from any and all liabilities, responsibilities, or claims that may be brought against us as a consequence of any material omissions, errors, or false statements contained within this Risk Profiling Questionnaire. We hereby advise all participants to exercise due diligence and conduct a comprehensive review of the questionnaire's content. The Company shall not be held legally responsible for any resulting repercussions."
};
var HYklWTwhtonjbiQRYCz$1 = {
	message: "No monthly statement available in this month"
};
var RsjGGXbMJbrislSlWM$1 = {
	message: "No daily statement available on your selected date"
};
var wEarLFdfZMShsSfacNU$1 = {
	message: "Whitelist Management"
};
var eEcajuQQvABwGKndqss$1 = {
	message: "Manage the whitelist for deposits and withdrawals"
};
var EfIjGkMogFrJyNKuWar$1 = {
	message: "Manage"
};
var JaPjOXJRPJqsTDLdU$1 = {
	message: "Please ensure your deposit comes from a <b>whitelisted address</b>, otherwise your deposit assets will be frozen"
};
var cuKtQbYgXOwLPEbN$1 = {
	message: "You can only withdraw to a whitelisted address, please <b>set up your whitelist</b> first"
};
var BVmyvtMVCbAJXhwSpT$1 = {
	message: "No address yet"
};
var NRUPVKxKVtYaCDVPq$1 = {
	message: "Are you sure to delete this address?"
};
var szgmmxxDYVvTLNzPkk$1 = {
	message: "Add address"
};
var mJjedBCPidtXUCYHus$1 = {
	message: "Non-custodial wallet"
};
var IIbmROzHEYCycsCyk$1 = {
	message: "Exchange"
};
var knoGdfgXpoVeAMqHCXu$1 = {
	message: "Verified"
};
var SBLHeXGlsYVIdiBNRe$1 = {
	message: "Unverified"
};
var AocjyYzlYgRsGzlavU$1 = {
	message: "Address"
};
var wQEsyNYfqlFrkqUvaDx$1 = {
	message: "Status"
};
var rbefbFgPVyawmaktVYF$1 = {
	message: "Action"
};
var MjEyxNUcFsFMIjsOIDpg$1 = {
	message: "Custom name"
};
var ygnbLzvTAMIylzNxj$1 = {
	message: "Select network"
};
var peIDsRhrNLVzQmAQWg$1 = {
	message: "Input address"
};
var BbqJaDHRCDmiNwNVcGB$1 = {
	message: "Verify address"
};
var LESgEuOUJYjZQYLUlO$1 = {
	message: "via signature"
};
var hsgIRJDqXwkPnsmgktga$1 = {
	message: "via small-value transfer"
};
var mDlqsQlmoApWZXHKLq$1 = {
	message: "Exchange name"
};
var DjgcgdUJtoNmqshNSb$1 = {
	message: "Please transfer <b>$s $s </b>to the above address to verify your ownership of the wallet"
};
var FxlLNwkBHAbChJrnM$1 = {
	message: "I understand I need to complete the small-value transfer to verify my wallet ownership"
};
var NuZslGbiHniUKgycjhmv$1 = {
	message: "Connect wallet"
};
var AdLFmhSQGMGYrTgXdUH$1 = {
	message: "Connected"
};
var rQiWsAGGRmEQCtfaIK$1 = {
	message: "Sign"
};
var HjfxCIPqXHVRBXeofOe$1 = {
	message: "Waiting for signature..."
};
var CwyRzEeuIMzGRVzVdSVg$1 = {
	message: "Verifying the signature..."
};
var MgdMcyuZEloUdpqcv$1 = {
	message: "Signature success"
};
var yKqxJEvOxokRNAPXYDZC$1 = {
	message: "Signature failed, please try again"
};
var FIvibwVWwddLxzofT$1 = {
	message: "Retry"
};
var HQLJuhRwbVdfCwEp$1 = {
	message: "Security verification"
};
var irXsKkZagNKDlvCyhKYK$1 = {
	message: "Payment password verification"
};
var RQJGnpiCuJKbplbuWeaj$1 = {
	message: "Verification success"
};
var ULhbQlNBpFJzLTlp$1 = {
	message: "Wrong password, please try again"
};
var DmecbpJQgGJiVjTqP$1 = {
	message: "Please input payment password"
};
var qltXLGplQJNtHWdY$1 = {
	message: "Transaction Advice"
};
var vamuznzHAJqilfEEP$1 = {
	message: "Risk Confirmation for Closing Transaction Advice Notifications"
};
var oGNuorHWcxXehehzCno$1 = {
	message: "Please be advised that by opting out of the transaction advice notifications, you may be exposed to more risks. For example, it is possible that when your account is hacked or unauthorized transactions are executed, you may not be able to detect and take proper actions immediately, resulting in asset losses, or you may have limited awareness of market changes impacting your investments. </br>\n\n<br>Regularly review your account and seek alternative sources to stay informed. For inquiries, contact our support team at support@bixin.com. </br>"
};
var pFjSwsuOrRtiguvbEc$1 = {
	message: "I confirm and agree not to receive notifications about the trade executions and shall bear all risks or losses arising from this change."
};
var VZMtxSlhbTKcmTYeEsW$1 = {
	message: "Assets that are pending review or from unverified sender(s). Please contact support@bixin.com should you have any enquiries."
};
var ivAXIbjvUUQpQqpmXz$1 = {
	message: "Notifications"
};
var thJZdZfDKDEFyETsPyzj$1 = {
	message: "Not installed"
};
var mrdEVkqkBIuEBVzzL$1 = {
	message: "Address name"
};
var JWctZqDXJyyraLbOe$1 = {
	message: "If you select signature verification, please log in to www.bixin.com on PC > Click on the profile icon > Account and Security > Whitelist Management > Add Address"
};
var rXWcwotndeKQsLjAdyrw$1 = {
	message: "Last name in English"
};
var ZuxEmUvBYSsOHORKrFrd$1 = {
	message: "First name in English"
};
var TfIbvRVtJxzInjuIwq$1 = {
	message: "English"
};
var YBvzRbRVqKkwTDkNDfoc$1 = {
	message: "Contact Us"
};
var pJTXUuIjycHTetIC$1 = {
	message: "The name you enter should be consistent with the name under your account"
};
var razdiXXHIkQKbPQTZn$1 = {
	message: "Bind phone number"
};
var WCGnQDmVyXVqLZPQyqYs$1 = {
	message: "The verification code has been sent to your mobile phone number ending in $s, please check"
};
var NgUCFdNkwlZfzWkAiv$1 = {
	message: "To ensure your account security, please use phone verification for login."
};
var sdgZycbHzMUKHwVH$1 = {
	message: "Please bind your phone number first:"
};
var xQtzLCbkmmYpqCXOwRT$1 = {
	message: "Please verify phone number"
};
var rKSrOqgimgcTrDutYUA$1 = {
	message: "Usage"
};
var nFlxQWOJCGHgwwHQhP$1 = {
	message: "Please ensure it matches the name on your exchange account"
};
var sMvNZNODlnAIiuzFMR$1 = {
	message: "1. Please provide a screenshot with key information including the exchange name and logo, your account name and contact information"
};
var RrEKjSeFQrtvLrZIO$1 = {
	message: "Please upload as PNG, JPG or PDF"
};
var QnjpooahLXRwxGqJIVt$1 = {
	message: "2. Please provide a screenshot showing your deposit address for the corresponding token on the exchange"
};
var qZljkUmjmSBKpnUsYfp$1 = {
	message: "I confirm that I am the owner of the above-mentioned exchange account and that the information provided is true and valid. If there is forgery, deception or other untruths, all consequences will be borne by me."
};
var kjqqAmIhgKSjlBVQx$1 = {
	message: "Company's full legal name"
};
var WfJRbDGlqfLFvNVzyWu$1 = {
	message: "Please ensure it matches the account name on your exchange"
};
var wgbBNytjmVvMvqRkRL$1 = {
	message: "Waiting for address verification"
};
var pXHPsbEpWSnCyJGH$1 = {
	message: "Deposit failed and frozen"
};
var CRbVirgSccJqKzSUSEau$1 = {
	message: "Please contact <b>support@bixin.com</b> should you have any enquiries"
};
var FgrxZUNDleeDGneKmwd$1 = {
	message: "Update time"
};
var uJpZAZRdzpyAaUkEqwSx$1 = {
	message: "If the deposit is from a non-custodial wallet, please ensure that the wallet is on the deposit <b>whitelisted address</b>; if it is from an exchange account, you need to <span>verify the address</span> after depositing. Otherwise, your deposit assets will be frozen."
};
var elXgEtyDNXczWYbDHV$1 = {
	message: "Transaction hash"
};
var LiwpXDoMAXANnTRZ$1 = {
	message: "2. Please provide a screenshot showing the transaction details of the deposit transfer you completed on the exchange"
};
var wfRBtzUHBPZjVDxUc$1 = {
	message: "The phone number has been occupied"
};
var xrfefvhsEfCoJokIdeW$1 = {
	message: "You need to select at least one usage"
};
var gapTtWntRtJcQzRtBz$1 = {
	message: "Upload proof of exchange account ownership"
};
var NhBzijnKrdihICUwgi$1 = {
	message: "Corporation/Institution Onboarding Form"
};
var PdxWoNDxKAJmNcpe$1 = {
	message: "Please fill out and sign. Upload as PDF"
};
var AHMRWIOaHFIWiIPqUx$1 = {
	message: "Congratulations, your verification has been approved!"
};
var LDNvolWeNGwNyvpTMnL$1 = {
	message: "Your verification failed"
};
var uYLqhJrdDgRVWcNvDpr$1 = {
	message: "Please contact Onboarding Specialist at<b>onboarding@bixin.com</b> should you have any enquiries."
};
var ZnbyJyzHTxzgLRDFBmEm$1 = {
	message: "Personal Particulars"
};
var FTVpPZybylBmTnwhMhtx$1 = {
	message: "Please ensure you have all the information required to open an account. You may refer to the <b>Individual Customer Onboarding Form</b>"
};
var THMxZAxLcuuIfPErpGb$1 = {
	message: "First name/Given name"
};
var bTWntlsiiBougPgd$1 = {
	message: "Last name"
};
var zIgntQSydRspYJCaQ$1 = {
	message: "Former name"
};
var vPVjNqmPYGCrexspl$1 = {
	message: "Optional"
};
var oMgGPGaGAlElFewgOv$1 = {
	message: "Gender"
};
var iqCHKgJKHatuZHiXEFm$1 = {
	message: "Male"
};
var dHIzNCfEthjGsjpMsfJN$1 = {
	message: "Female"
};
var VALtZMIyzODbkpPUOsxG$1 = {
	message: "Identity Document Type"
};
var OOtkDwkZMvTavtRmc$1 = {
	message: "Identity card"
};
var bRDTmhggLlBbrbdtfhM$1 = {
	message: "Passport"
};
var IzXQAIEgQLMYmZwrzP$1 = {
	message: "Identity no."
};
var xjuVMsJZTRgjPgAzSV$1 = {
	message: "Place of issue"
};
var WACiElgvWMUDhQMxa$1 = {
	message: "Nationality"
};
var USZqODoQgzwaggnbb$1 = {
	message: "Place of birth"
};
var KChGPohSmJORAMDUqSs$1 = {
	message: "Date of birth"
};
var oGZZfIIocJcraogK$1 = {
	message: "Occupation"
};
var pAYXQPFeRbuYruZa$1 = {
	message: "Occupation industry"
};
var aaOdxWUHHLynEVSoWTM$1 = {
	message: "Employer name"
};
var jSQVlHGDwxAZujRJNiSh$1 = {
	message: "Purpose of transaction (select all that apply)"
};
var uuluQlsJBdDsslsERZX$1 = {
	message: "Please elaborate on your selection (within 300 words) (optional)"
};
var ACweJQrKoWgpyYspyEl$1 = {
	message: "Products/Services required (select all that apply)"
};
var JLIvWEpTgjlkpsZBM$1 = {
	message: "Investments"
};
var UfkUhznLfeqzZyTdAebx$1 = {
	message: "Trading (Virtual Assets)"
};
var FxzVGfjClbeUZeEero$1 = {
	message: "Others"
};
var WjPizXTxbdPnvLWMql$1 = {
	message: "Please specify"
};
var ytFXzDnzPIGUhOOClJ$1 = {
	message: "Virtual Assets transactions"
};
var dWHEObNDvkCjTnlvH$1 = {
	message: "Virtual multi-currency account"
};
var lfjjwhqpvFBikfhkifrN$1 = {
	message: "Source of wealth (select all that apply)"
};
var gGrAIKLFJuNxbjhnZz$1 = {
	message: "Employment income"
};
var trJoqkSnMVAvbRgAY$1 = {
	message: "Business earnings"
};
var CyNhoDlSuMvcxydtF$1 = {
	message: "Inheritance/gifts"
};
var dpvvLNDzKxLZIuixW$1 = {
	message: "Rental income"
};
var cYSzpXPrPUQxaAGTihK$1 = {
	message: "Sale of property/investments"
};
var kYGDyxESdKUNNTdG$1 = {
	message: "Estimated net worth"
};
var UqNGOztCBezyeAgI$1 = {
	message: "Less than 1 million HKD"
};
var TWuwXEwzngPlnjELUJ$1 = {
	message: "1-8 million HKD"
};
var AUNMAupfnBRbGlrb$1 = {
	message: "8 million HKD"
};
var EqpPTPZsKjTArTFVgWp$1 = {
	message: "8-15 million HKD"
};
var oiSDCKooPzMznfGteAG$1 = {
	message: "Above 15 million HKD"
};
var DSFAJhsSefQQEdBBlUyt$1 = {
	message: "Source of fund (select all that apply)"
};
var aaKDUKbsmRiynWiqlS$1 = {
	message: "Personal savings"
};
var eDeADqoJRnEUGotYxzY$1 = {
	message: "Sale of property/asset"
};
var CDwWwMbhHZXYRMZHKnpO$1 = {
	message: "Family/Friends"
};
var fjjnxDoEsAfrEGSbNUL$1 = {
	message: "Annual income"
};
var qqXTaCjhvvMrmeJpPG$1 = {
	message: "Less than 0.5 million HKD"
};
var RMCuKzWRRjQNKUNP$1 = {
	message: "0.5-1 million HKD"
};
var qipDilqNVyHfNJVyF$1 = {
	message: "1-2 million HKD"
};
var CuzRRZhhkOmuQgeVt$1 = {
	message: "2-3 million HKD"
};
var VoqaSnQNOfXstSBxca$1 = {
	message: "Above 3 million HKD"
};
var ZCRfudjxgEkJLycN$1 = {
	message: "Anticipated monthly transaction volume"
};
var tdxlCkYgrpQOxYYJZiF$1 = {
	message: "Less than 10,000 HKD"
};
var RZiGRHwDUpYgJcRLRnxa$1 = {
	message: "10,000-100,000 HKD"
};
var aXbxDDurboZtvnPno$1 = {
	message: "100,000-500,000 HKD"
};
var OUDeIeQIjCliBQIHe$1 = {
	message: "0.5-1 million HKD"
};
var AbrPzuZLAZwUuIBnbx$1 = {
	message: "1-10 million HKD"
};
var JJAtBenOLOlFaFaP$1 = {
	message: "Anticipated monthly transaction frequency"
};
var YWCMpmGuparutCzjXpp$1 = {
	message: "Ad-hoc transaction requirement"
};
var aCYhhkYhhIrzUQvFB$1 = {
	message: "Less than 10 transactions"
};
var sVTrHBZPprcyXLgcE$1 = {
	message: "10-20 transactions"
};
var oGHfMwDNMhRcKszx$1 = {
	message: "More than 20 transactions"
};
var hYWPDZZNtYYwiYMfUfjX$1 = {
	message: "Are you or any of the connected parties"
};
var NIxMpJepTIBNynamgjj$1 = {
	message: "a Politically Exposed Person (PEP) ?"
};
var onaIGydLoNFhYUGyo$1 = {
	message: "related to a Politically Exposed Person (PEP) ?"
};
var nkENghGiqpNyJlRpBv$1 = {
	message: "Official position of PEP hold"
};
var eEBDsqLdNoLOJxjVc$1 = {
	message: "Time period of position hold"
};
var SJBETCfUKQwBPbOwXhs$1 = {
	message: "Name of related PEP and relationship"
};
var TbviyxwhVLMOhttn$1 = {
	message: "Please ensure the place of issue of your identity document is consistent with the subsequent proof of address region"
};
var SFeLOdYxYJLeOgLtZI$1 = {
	message: "Preview"
};
var IKImbOtCOwEOtcDsMLv$1 = {
	message: "Connected parties refers to:"
};
var woYYXxIEUCPOPTbYi$1 = {
	message: "<br>in relation to a legal person (other than a partnership), means any director or any natural person having executive authority in the legal person; </br>\n<br>in relation to a legal person that is a partnership, means any partner or manager; and</br>\n<br>in relation to a legal arrangement, means any natural person having executive authority in the legal arrangement.</br>"
};
var XVImLdGTpJvSndfrLlee$1 = {
	message: "Institution"
};
var ylhkcCPZqNeskQBJB$1 = {
	message: "Corporation"
};
var gLehflpqCNwIhEtbYIAz$1 = {
	message: "Company's full legal name"
};
var BEfhHOirsmwpDEilDbq$1 = {
	message: "Company registered address"
};
var WzIAmgVLQnPRHGRfGw$1 = {
	message: "Main business address"
};
var zcamcMLRNetHERtiy$1 = {
	message: "Country/Region"
};
var NStCDznwhsZPGYrJAq$1 = {
	message: "Phone number"
};
var pucEyENFLLeSzsJUK$1 = {
	message: "Above 10 million HKD"
};
var EqbYvDbdIrmgXbrPPAO$1 = {
	message: "<b>If you selected \"Yes\" to any of the following questions previously, you may be exempted from this test by submitting proofs to <span>support@bixin.com</span>.</b>"
};
var pyuZUzzDPovDumukD$1 = {
	message: "<br>a. Undergone training or attended courses on Virtual Assets offered by banks, financial institutions and/or professional organizations;</br>\n<br>b. Prior trading experience in any Virtual Assets (5 or more transactions within the past 3 years); or</br>\n<br>c. Current or previous working experience related to Virtual Assets</br>"
};
var xxgsgyEjhfwrMflwMr$1 = {
	message: "Learn more"
};
var PVcSgRlruKdhLYAvMUG$1 = {
	message: "1-4 million HKD"
};
var BIVIQEHEPCzGuQpNKSR$1 = {
	message: "4-8 million HKD"
};
var GhRAIjbecBWjePTjqSD$1 = {
	message: "FATCA Declaration Form"
};
var qsVtkTgbKcuLSPDXf$1 = {
	message: "View"
};
var WINbdlmnRMSyZUqkxCP$1 = {
	message: "individual verification tutorials"
};
var bnpgtsIPDfFydCQlTH$1 = {
	message: "Remaining deposit limit"
};
var BgXkLkPusAcJBiUmSw$1 = {
	message: "Remaining withdrawal limit"
};
var OARZuIqYLXtlrvaEsC$1 = {
	message: "corporation/institution verification tutorials"
};
var YLJxFxxsgqpWcZWy$1 = {
	message: "Please scan the QR code below or enter the private key manually"
};
var RjPDzDdrzBcLHVJiG$1 = {
	message: "Insufficient remaining withdrawal limit"
};
var DrmqiYKPSoxMBWXT$1 = {
	message: "FATCA and CRS Self-Certification Form"
};
var nSdDtaHzknwZAXJHzrGP$1 = {
	message: "Add Authenticator"
};
var NZjrOkmPAHtiaMLyuVDA$1 = {
	message: "Alternatively, you can select face-to-face verification (Hong Kong users only). Our onboarding team will contact you asap."
};
var XfjZomFsTRpbZJuHjI$1 = {
	message: "Please contact me to arrange a face-to-face verification"
};
var lxppTPAJDxxMIGdmiRG$1 = {
	message: "Please select a verification method"
};
var OljlLKYobPynbcStGlN$1 = {
	message: "You only need to select ONE verification method"
};
var YXrqAGUqprWfOCeiSGX$1 = {
	message: "The review results will be notified via email"
};
var MkfqKEzRwLTbzJEOeWg$1 = {
	message: "Our onboarding team will contact you asap"
};
var vshrtYQXEVpbXmLZwV$1 = {
	message: "Please check your Email"
};
var wINMfXpJczhYZOnUXWp$1 = {
	message: "Please input the verification code from Google Authenticator/Authy"
};
var uetkXvxfFuKnhpBFrA$1 = {
	message: "Google Authenticator/Authy"
};
var sZVlKBQCGGTVChpa$1 = {
	message: "Google Authenticator/Authy verification"
};
var AZVALNHESdbXtHmNY$1 = {
	message: "Convert"
};
var pVQoQWJNGEfRwmpZMki$1 = {
	message: "Pay"
};
var HsxgqsfmdLnIcdcXgLS$1 = {
	message: "Receive"
};
var gohHRZTjodstzoCLNv$1 = {
	message: "Available"
};
var rfXBETBheWYaMqrktE$1 = {
	message: "Exchange rate"
};
var rxfIffMgcmDGmXfVZA$1 = {
	message: "The exchange rate is an estimated value, and the actual amount received depends on the actual rate at the time of transaction"
};
var ifmHgobawgqPHdruP$1 = {
	message: "Preview Conversion"
};
var AkLeJkGIGPcgMPOyMJvd$1 = {
	message: "Max. slippage"
};
var SLZgFNtUooxfLTcXEnm$1 = {
	message: "Custom"
};
var APOikjpbuiZXwYbMlWBl$1 = {
	message: "If the price changes unfavourably by more than this percentage, the conversion may not be fully executed."
};
var pEZOQJSBxlCYyrjM$1 = {
	message: "A larger slippage range may result in a more unfavourable trade"
};
var IKLXXpDUJHlgctnhc$1 = {
	message: "Remaining monthly trading limit"
};
var GSkKAUsvGPYZMAnFnH$1 = {
	message: "Save"
};
var HIptAJwjtWvHteUhwW$1 = {
	message: "Select a currency"
};
var ETkemdVBXuBSBAstv$1 = {
	message: "Confirm Conversion"
};
var fUqbBtyQPrkRchcpe$1 = {
	message: "Transaction fee"
};
var wprsRqdyQRGnVcbsp$1 = {
	message: "Quote has expired, please refresh"
};
var zDKhBsXavFMPAEqgdH$1 = {
	message: "Refresh"
};
var PpelPkXnzahxkdhVa$1 = {
	message: "Conversion in progress"
};
var XvACoEmpLFSLVHywT$1 = {
	message: "Your funds are temporarily locked"
};
var hhiTSbgqtfHswnyfCs$1 = {
	message: "Conversion Successful"
};
var jwkMtTwNHEktKLQA$1 = {
	message: "Conversion Failed"
};
var aTPVtxAhNeuzjutYgu$1 = {
	message: "Your funds will be returned to your funding account"
};
var CSMPJDQZLtdBrHSlRhzp$1 = {
	message: "Set Slippage"
};
var OYByrRpUomOXEqORBozE$1 = {
	message: "Convert"
};
var pQEEhEzMgmLpEznsEH$1 = {
	message: "Asset Name"
};
var HNUebnMoRCmoPDEpASH$1 = {
	message: "Price"
};
var ARCAktOTCiLqQqaPTv$1 = {
	message: "Total Amount"
};
var LJPMiQOhqtJqlBRBCHX$1 = {
	message: "Designated Bank Account Transfer"
};
var lvouKixXkMbDqOnnr$1 = {
	message: "Other certification approaches"
};
var FRjQUDLIESvWvPOQY$1 = {
	message: "Transfer no less than 10,000 HKD (or USD equivalent) in a single transaction to Bixin.com's bank account to complete the account opening verification"
};
var JNPXLHStukWLfpLRU$1 = {
	message: "Certified by licensed/registered persons; or face-to-face certification with Bixin.com's onboarding team"
};
var dQRnMUSMOEdAwdfMqW$1 = {
	message: "Please deposit <b>no less than 10,000 HKD (or equivalent USD)</b> to the following Bixin.com bank account from a designated bank account under your legal name $s $s to complete the verification. Failure to do so may result in delayed arrival or even refund. Insufficient amount will also result in verification failure and refund."
};
var cHodlBcOiNHOlxFn$1 = {
	message: "Learn more"
};
var tglvvZIzjMuxIoXEYs$1 = {
	message: "Bank transfer verification is currently supported in these"
};
var yDGXBsHUIoIkgqfepe$1 = {
	message: "Currently supported deposit currencies: HKD or USD"
};
var lsdjJQPYPEOcAzVOth$1 = {
	message: "Please avoid depositing unsupported assets to the platform, otherwise you will be refunded, and you will be responsible for the refund fees."
};
var PlIgEPTbgrrwkSuHc$1 = {
	message: "Bank Name"
};
var NqhjvGQWWHnmAzDH$1 = {
	message: "Beneficiary Name"
};
var QNEAoNoQfTpYIxJvjdM$1 = {
	message: "Account Number"
};
var MhWCMBfnPEmyPhdBJC$1 = {
	message: "Bank Code"
};
var rcbvwVBVHsJazGKrQv$1 = {
	message: "SWIFT Code"
};
var HsYTxsCouoyySItw$1 = {
	message: "Bank Address"
};
var CNXhqxsuJtAEOpHCSI$1 = {
	message: "Upload proof of transfer"
};
var iQYmhTkvoynVhdKfkY$1 = {
	message: "Please upload the transaction receipt after completing the bank transfer"
};
var lLKoAhJqRLmDyyTCvO$1 = {
	message: "PDF or JPG format, no more than 5MB"
};
var bNcNiQWtnacHBQFyTY$1 = {
	message: "Exceeding the maximum trading amount"
};
var JIozcUyGaPUboZLlBjVN$1 = {
	message: "Below the minimum trading amount"
};
var tNbQTPYLVCKjsvpja$1 = {
	message: "Insufficient monthly trading limit"
};
var UrkVGOIalMNhKwpIEzK$1 = {
	message: "Fiat Deposit"
};
var cCtaFICzFmzJltYPL$1 = {
	message: "Select the bank account for deduction"
};
var SVpHROUKzBJsjSVHMK$1 = {
	message: "Add bank account"
};
var UMTZPjOpYZuhdhDbBVO$1 = {
	message: "Step 1: Please deposit $s from your selected bank account above to the following Bixin.com bank account"
};
var iBQIPIJCNFHBCeRIvm$1 = {
	message: "Minimum deposit limit:"
};
var nedDtIXJkIrvdDqe$1 = {
	message: "Please provide the transaction receipt of your bank transfer. Once verified, your deposit will be credited to your account."
};
var xWhLpCcRjLgSplng$1 = {
	message: "Step 2: Upload proof of transfer"
};
var DZjgiswpELVABBqUWCSa$1 = {
	message: "Bank Transfer"
};
var XrngZedCHgJUKulaDcT$1 = {
	message: "Select the receiving bank account"
};
var fWgPNysKDTLrzjgrexk$1 = {
	message: "Input withdrawal amount"
};
var QIzonbZxYqJjQrPHfJM$1 = {
	message: "Minimum withdrawal limit"
};
var iHptEcwFnEbHVLaQkXyb$1 = {
	message: "Transaction fee"
};
var uUpDUGTUrKdXVQXkgSP$1 = {
	message: "Transaction fee for withdrawal does not include bank charges, which are subject to the specific banks."
};
var HzbSujYkGuYtObRcrdbh$1 = {
	message: "Transaction fee is not included in the withdrawal amount and will be deducted from your account balance"
};
var NOYdleknddFOfQxlNOI$1 = {
	message: "Withdrawal amount"
};
var nqPKzhAfSmqRRIHii$1 = {
	message: "Fiat Withdrawal"
};
var eOPHosimYamraEKUukBz$1 = {
	message: "Confirm Withdrawal"
};
var LoBOFhdSzMFjdqZgDE$1 = {
	message: "Receiving bank account"
};
var mHVIpiFPJQPNPFYAeeu$1 = {
	message: "Please confirm that the above information is accurate"
};
var TNXdbUElFLwiyRVKuJ$1 = {
	message: "The bank transfer will be arranged upon approval, please kindly check the email notification"
};
var wLQWZKMRgmTJTSudW$1 = {
	message: "Manage accounts"
};
var GkvuBozDTWJAXbpwyP$1 = {
	message: "Virtual Assets"
};
var IMxXGyWWPXtfrrwxV$1 = {
	message: "Fiat"
};
var tibiqQyzvztLFMGQ$1 = {
	message: "Fiat Account Management"
};
var fXTeVLzGkVECTSGgtm$1 = {
	message: "Add New Account"
};
var XYVTanLxxisBNzaOFx$1 = {
	message: "Account"
};
var bdAMbKWoEuDxlGOg$1 = {
	message: "No account yet"
};
var ALJjPGCRLTrnWlbmqO$1 = {
	message: "Please ensure the account is under your legal name"
};
var znOXnaDhTySukBeCrT$1 = {
	message: "Please confirm whether you have completed the KYC bank transfer verification using the above bank account"
};
var ESHCFsWVeQAWSnEKV$1 = {
	message: "In the next step, you need to use this account to deposit no less than 10,000 HKD (or equivalent USD) to Bixin.com bank account to complete the verification"
};
var lLAJPCrarwsWDdbLaw$1 = {
	message: "Search currency"
};
var biXQrrlOVDoExCZZKC$1 = {
	message: "Setup Successful"
};
var spot_trading$1 = {
	message: "Spot Trading"
};
var MTiCVGmtBjEPWzsw$1 = {
	message: "Hong Kong Permanent Identity Card"
};
var zLnEBdSfUXdqbRqAohY$1 = {
	message: "Do you have a valid identity document from another country/region?"
};
var oVvhpgfhTeyLLnTSv$1 = {
	message: "Please provide your foreign identity document"
};
var OEfurFwwcJaTsVxNdol$1 = {
	message: "Supported identity documents: foreign identity card, work/student/dependent visa (long-term visa)"
};
var TeRrrjzubYVYnBhsdpD$1 = {
	message: "Foreign Identity Card"
};
var xwQqYnxnxmeJPqRlQ$1 = {
	message: "Long-term visa (work/student, etc.)"
};
var hoTQEpJFfRRLZGLWiDK$1 = {
	message: "Document type"
};
var wZuMVSBUSlQidCQpjoS$1 = {
	message: "Upload document(s)"
};
var oSDxsXgENbIeNMLv$1 = {
	message: "Front side of the ID document"
};
var aoAIqdHabiquSjWWz$1 = {
	message: "Back side of the ID document (if any)"
};
var YltriUZdkgLJuXZi$1 = {
	message: "18 - 20 years old"
};
var sZudUtmwNMYVhQhyj$1 = {
	message: "21 - 54 years old"
};
var slqgnwkLOtCyZiTBWb$1 = {
	message: "55 - 69 years old"
};
var PwxbwKVPjpeCuRYx$1 = {
	message: "70 years old or above"
};
var domCttddTWzCfimSWOq$1 = {
	message: "Current position"
};
var dqLNRujTTFLifcFaybP$1 = {
	message: "Position limit"
};
var wIfwelYvkemWaZGE$1 = {
	message: "Position limit refers to the maximum amount that can be used for trading under your account (including main account and sub-accounts)"
};
var vDIneAtEexNLfRMcVPa$1 = {
	message: "Transfer request failed! The total amount of your trading account cannot exceed the maximum position limit."
};
var YYzgmIpjtorJXoyQJUk$1 = {
	message: "Current remaining position limit is:"
};
var rZkFVZvvCQRyHCfLiNVX$1 = {
	message: "You must lower the order amount or reduce the virtual assets in your trading account"
};
var VXwjemLYMJiNKvXlZ$1 = {
	message: "countries/regions"
};
var GZOFzxVOsYtRtlONwcv$1 = {
	message: "Enter full name"
};
var YiNdDLTlBGFQiuNECi$1 = {
	message: "Enter full legal name"
};
var aFykbSRCZkUrYNzoKtk$1 = {
	message: "Enter bank account number"
};
var TgilgrTuMXgbAQuPf$1 = {
	message: "Enter bank code"
};
var MQaUVFeBMhHfKxmBUV$1 = {
	message: "Enter bank SWIFT code"
};
var HgKGDukwWWdCeZlibVY$1 = {
	message: "Enter bank address"
};
var rhXOjsQATKgJNizniW$1 = {
	message: "Due to bank settlement time limitations, the final arrival time of the deposit funds is subject to the actual arrival time of the funds at the bank where the Bixin.com account is opened."
};
var pKuaKUWJHuajbExMUs$1 = {
	message: "Bixin.com does not charge deposit fees, but your bank may charge fees. The fees will be deducted from your deposit amount, and the actual deposited amount shall prevail."
};
var nkcDnQvbZpDfYMepAc$1 = {
	message: "If your remittance is from a local bank in Hong Kong, it will generally arrive within half a business day. If it is a cross-border remittance that meets the regulations, it usually takes 2-3 business days to arrive. If there are bank holidays or public holidays, the arrival time will be delayed accordingly."
};
var UHAKvmcFPrannQlFz$1 = {
	message: "Are you sure to delete this account?"
};
var MmdyZCvMXusVhfjsV$1 = {
	message: "Branch Code"
};
var MGsQCMXzOIuqcXjBDDTF$1 = {
	message: "Important Updates"
};
var xYFrGCCcvvWooWsibQFD$1 = {
	message: "Effective from 1 June 2024, NewBX Limited (CE number: BUY737) is deemed to be licensed to offer a virtual asset service (operating a virtual asset exchange) as specified in Schedule 3G to the Anti-Money Laundering and Counter-Terrorist Financing Ordinance (Cap. 615) (“AMLO”), subject to certain terms and conditions imposed by the Securities and Futures Commission of Hong Kong."
};
var omBdaJrTBmDrBzNYx$1 = {
	message: "NewBX Limited has NOT been licensed by the Securities and Futures Commission and may NOT eventually be granted a licence as the Commission may refuse its licence application or its application may be withdrawn. It is only deemed to be licensed under the Anti-Money Laundering and Counter-Terrorist Financing Ordinance."
};
var omTkmNnwlfkOvozU$1 = {
	message: "For the Company’s latest licensing status, please refer to:"
};
var YxGqBoJIoXruDOmbNu$1 = {
	message: "I understand"
};
var NOhPBjPDsgVbfqTgjIH$1 = {
	message: "A decade of safe operation, trusted by millions!"
};
var gcFEhAlcWmjNfIqry$1 = {
	message: "Founded in 2014 and formerly known as HaoBTC, BIXIN.COM started as one of the world's first virtual asset custodians. Over the years, BIXIN.COM has evolved into a comprehensive virtual asset trading platform, providing users with \"Simple, yet Secure\" services. Its operator NewBX Limited is a Hong Kong limited liability company and a wholly owned subsidiary of Bixin Group."
};
var npetoxnFYOYxRjXRN$1 = {
	message: "Your using of a VPN is detected, please turn it off"
};
var TzvXfzahEvyWlLOZQE$1 = {
	message: "Sorry ! Service is currently unavailable in your country/region."
};
var LuuhHZgOxbTJDvnm$1 = {
	message: "Your account is currently dormant"
};
var sqteSBzbeJvwJeJSWZk$1 = {
	message: "Please contact <b>support@bixin.com</b> to reactivate your account"
};
var uhoCqEIxFLCGpwTslFY$1 = {
	message: "Please select and confirm"
};
var OzYooSlNbfNTxRxNhe$1 = {
	message: "I confirm that there is no change to my information"
};
var JQpSpVQqatEXOdgFvjh$1 = {
	message: "I need to update my information"
};
var onOjgIPTpDDXLIwlSWE$1 = {
	message: "Update Information"
};
var gDgIYTmDidzeeXyOV$1 = {
	message: "Modify"
};
var cOOoOlxMURFANNpFpYx$1 = {
	message: "Please upload a certified true copy of the ID document if your ID information is updated"
};
var nAVsbekWuHffflMnfHHy$1 = {
	message: "Please upload a certified true copy of proof of address if your residential address is updated"
};
var WelPCqxRFgXNzpkZJdsh$1 = {
	message: "You have completed the confirmation, please do not re-submit"
};
var npqmwWmfuEsNrfQJt$1 = {
	message: "Please confirm all information is accurate before submission"
};
var wcfFqisAqLRlhbKdJk$1 = {
	message: "Proof of Source of Wealth"
};
var wcJAFtgivjbkVSdTC$1 = {
	message: "Please provide supporting documents to prove your previously selected source of wealth  (within the last 12 months)"
};
var pSUGpUOowrIgSHLfEIs$1 = {
	message: "Re-upload"
};
var cWYINWiSUUdFuDAImP$1 = {
	message: "Submission Successful!"
};
var tUrSbGVjlpoCdTkb$1 = {
	message: "We will begin a periodic review of your account to ensure we can continue to serve you. Generally, this process will not affect your normal use. However, if we discover any issues during the review process, we will notify you immediately via email."
};
var YvXCqALOsnrEQAHU$1 = {
	message: "Thank you for your understanding and cooperation. If you have any questions, please contact our customer service:"
};
var JJfMolWuWCFgrDrUiz$1 = {
	message: "Thank you for your confirmation!"
};
var plHTmWdGncJPnVBJuI$1 = {
	message: "In addition, you need to provide supporting documents to prove your source of wealth"
};
var HbkwQxpXzqUXEvkxVmz$1 = {
	message: "Select the information type to be updated"
};
var KOycuFuoXkNBrUCLtCVL$1 = {
	message: "Add document"
};
var yYxnWdRQrNPhFUhmKp$1 = {
	message: "Add information type"
};
var oWOQzlGOqirSVhUhQX$1 = {
	message: "Upload a certified true copy"
};
var xbTIXxCJIOnbLImHUPI$1 = {
	message: "Annual Return (NAR1)"
};
var VSmzJHKoDZuNenetubvZ$1 = {
	message: "Certificate of Incorporation"
};
var YJlyfJbAZRZhGensD$1 = {
	message: "Certificate of Change of Name (if applicable)"
};
var SuSDXCILmprzPXIonL$1 = {
	message: "Business Registration Certificate"
};
var FnrHWNqUvXlpfQLAfT$1 = {
	message: "Memorandum of Association/Articles of Association"
};
var uPrPwsvUYglduYxnfgb$1 = {
	message: "Certificate of Incumbency issued by Registered Agent within 6 months (offshore company only)"
};
var BvERvFYtRmpkINLVdX$1 = {
	message: "Instrument of Transfer (if applicable)"
};
var MSaPBxOSKeCTtUMPq$1 = {
	message: "Ownership Chart"
};
var olGkjZMWDZBQwjnVK$1 = {
	message: "ID Document of Directors/Authorized Signatory/Ultimate Beneficial Owner"
};
var PmdVNRJcWUxjWfFSA$1 = {
	message: "Proof of Address of Directors/Authorized Signatory/Ultimate Beneficial Owner"
};
var gCLhGVwztVSCPNZUgqQN$1 = {
	message: "Nature of Business"
};
var FDynUJSlxYFxtAhrQN$1 = {
	message: "Banking Institution"
};
var UBCBvFlsnzzgcIOHTmN$1 = {
	message: "Licensed Money Lender"
};
var MERzsdKkxudpOnlaF$1 = {
	message: "Licensed Money Changer/Remittance Business"
};
var XtpeIeGyrDDKSkgyCiL$1 = {
	message: "Fund Management/Trust/Trustee Services"
};
var LxcfZSEIROwQeVCok$1 = {
	message: "Licensed Payment Service Provider"
};
var fxjdlTQeJFVyjFXmhlnI$1 = {
	message: "Please tick selected choice and elaborate on the selection"
};
var aVbJYJuVEhKXAqlbWgUE$1 = {
	message: "Please elaborate on your selection (within 300 words)"
};
var yicaYCvBFspqWpPqS$1 = {
	message: "Investment Returns"
};
var YLfvFQfagZeMpkzlO$1 = {
	message: "Sales Proceeds"
};
var fsjyqgrUVSYOXDUxw$1 = {
	message: "Sale of Asset"
};
var WQsiZpVbrxKoaVkQ$1 = {
	message: "Customer’s/Investor’s Funds"
};
var KpLdefqDhhhdklLzxOgC$1 = {
	message: "Company Owned Funds/Asset"
};
var WbJXVvgJiwcWWgRAYq$1 = {
	message: "Source of Wealth Proof of Company"
};
var EcnKFNIFTwRUshkf$1 = {
	message: "Please provide supporting documents to prove the source of wealth declared by your company (within the last 12 months)"
};
var xGdbGnjcDCabqvFJX$1 = {
	message: "Business Revenue"
};
var olJXBlENebamalqAmC$1 = {
	message: "Funds from Investors"
};
var lnaNMhKSbkHzoYmMHp$1 = {
	message: "Fund from Shareholders"
};
var MFJyykUbSXUkUqHxlJ$1 = {
	message: "Business Loan"
};
var UsVahXMYImjwSrxR$1 = {
	message: "Sale of Property/Investments"
};
var XjUPUpsmbzqDVlOyOzD$1 = {
	message: "Source of Wealth Proof of Ultimate Beneficial Owner"
};
var bYjpHFpkXBumbkZHbM$1 = {
	message: "Please provide supporting documents to prove the source of wealth of all Ultimate Beneficial Owners of your company (within the last 12 months)"
};
var nZkngKdQlMblSkIsJt$1 = {
	message: "Full Name of Ultimate Beneficial Owner"
};
var vfiTAWyuaCrULibnur$1 = {
	message: "Ultimate Beneficial Owner"
};
var hubWrmcrofRaRoYLCAS$1 = {
	message: "In addition, you need to provide supporting documents to prove the source of wealth of your company"
};
var dIOuyFmCcSAXzBifCgd$1 = {
	message: "We will begin a periodic review of your company account to ensure we can continue to serve your company. Generally, this process will not affect the normal use of your company account. However, if we discover any issues during the review process, we will immediately notify your company contact person via email."
};
var AoqexRnXPjWiaXQQ$1 = {
	message: "Please save first"
};
var wtPiDpoJwweHEwGphG$1 = {
	message: "Sub-accounts"
};
var YFShWZLtmVzhKApQSudo$1 = {
	message: "Sub-accounts Management"
};
var EyxlrwvHrdhvRaHtLxx$1 = {
	message: "You can create up to $s sub-accounts"
};
var YbTVKYSCHSNbVSRpbwRM$1 = {
	message: "Login Email"
};
var rWOqJloUMhKXCZHLpnc$1 = {
	message: "Created"
};
var nmuzQLDdidsSBtDTLaU$1 = {
	message: "No sub-account yet"
};
var cKeVqkUVuUrblpSkN$1 = {
	message: "No API yet"
};
var KgtuAymJbpqjZHQACDKA$1 = {
	message: "Account Transfer"
};
var WriODPyMHmFqbNRIkh$1 = {
	message: "Support transfers between funding accounts under the main account and sub-accounts"
};
var kdGDbDfHqPdMmOODj$1 = {
	message: "Add Sub-account"
};
var fRcWTONIbiPEHREbRTKI$1 = {
	message: "Account Verification"
};
var MIqinsTMANLFyEzWlLXm$1 = {
	message: "Sub-account Email:"
};
var xmSClcrPuftAggqMjWp$1 = {
	message: "Bind phone number:"
};
var uPEmuahfZCJKifAf$1 = {
	message: "Normal"
};
var NazoeCHUJpEyQWZDKcVt$1 = {
	message: "Disabled"
};
var ZtmHIANowsUTyUyouyg$1 = {
	message: "Disable"
};
var DyXvKDfsUBPKtQScEVw$1 = {
	message: "Enable"
};
var SGvHMSujomhCIGweYcH$1 = {
	message: "Are you sure to delete this sub-account? This operation is irreversible"
};
var xFLmujpTZsyQKTENeNr$1 = {
	message: "Please confirm that this sub-account does not hold any assets, otherwise the deletion will fail. All associated open orders will be canceled and the API Key will be deleted. You will free up a sub-account quota to create a new sub-account, but you will not be able to create a new sub-account using the deleted sub-account email address."
};
var xPXNyAgtdawfwFRxXhb$1 = {
	message: "Please clear the assets in the sub-account first"
};
var VoQarJJpktEfEZnK$1 = {
	message: "Are you sure to enable this sub-account?"
};
var wfUNVCtRXprhwYwce$1 = {
	message: "Get code"
};
var nirNFLwkcuvUxudti$1 = {
	message: "API Management"
};
var GqlajLqwcNJLpTqq$1 = {
	message: "Each sub-account can create up to 5 API Keys"
};
var NKaDUgPomETDmcmKHy$1 = {
	message: "Please keep your API Key and Secret Key properly to avoid asset losses due to leakage."
};
var OsCIqseGbbbWXxBLk$1 = {
	message: "Enter Email/Tag name/API Key"
};
var DghVzIJcKyuvkcKwY$1 = {
	message: "Tag Name"
};
var XYnywMktJDrWPwZBA$1 = {
	message: "Are you sure to delete this API Key?"
};
var bgnQSQsWYPIcUDEytcq$1 = {
	message: "Add API"
};
var erGplJlLIBiVheXvc$1 = {
	message: "Select Sub-account"
};
var epeFMTUcZAYdtLOETgZ$1 = {
	message: "API Tag Name"
};
var oIIfiHdqGwpXZbtDYKG$1 = {
	message: "Custom tag name"
};
var mlUEUuDRftKStSMvF$1 = {
	message: "Please transfer assets to the sub-account first"
};
var nNgFtrjyhesGreVhV$1 = {
	message: "API Information"
};
var ewrHdSoDPutFlPrqTEr$1 = {
	message: "Only displayed when created, please keep it safe"
};
var ZZlJgALCrsSaNhaoV$1 = {
	message: "API Permission"
};
var OgusvSSbzkNopiGbCIo$1 = {
	message: "IP Access List"
};
var nmPUwVVQoncVHqMln$1 = {
	message: "Enter trusted IP addresses, separate multiple addresses with ;"
};
var mWaNsXTgUIcnWSphpgB$1 = {
	message: "Statement of accounts/certificate issued by custodian within 12 months"
};
var GxjDaNmTVZaIEmLIO$1 = {
	message: "Certificate issued by auditor/CPA within 12 months"
};
var xdBmFzKPmVQfqVSOyFY$1 = {
	message: "Public filing submitted within 12 months"
};
var xdSXcpFurEbSenWcxPn$1 = {
	message: "Please select at least one type of certificate/document"
};
var KzRRnMZfXiUfprzBEe$1 = {
	message: "If you need to apply for Professional Investor verification</br>please contact<b>onboarding@bixin.com</b>"
};
var nDIaTJMAdTQRxUKJo$1 = {
	message: "Wrong username or password"
};
var XaQWqbeAdXIkLCiakX$1 = {
	message: "Your account has not enabled the sub-account function yet. If you need to apply, please specify the reason(s):"
};
var WHFSIZvkPFlAiUsTW$1 = {
	message: "Please elaborate on the reasons for applying to enable the sub-account function, no more than 300 words."
};
var IldgeERuYKVOefpR$1 = {
	message: "Sub-account Application"
};
var sYnLKnDJjNhHBCpTj$1 = {
	message: "Close"
};
var ZtsyDNmrvXDDftOHri$1 = {
	message: "Verification failed, please re-verify or refresh the page and try again"
};
var vAeqeVWtpVywOzVUYfuv$1 = {
	message: "Are you sure to disable this account $s?"
};
var PLWcAjJpcpPoIQiCcq$1 = {
	message: "You will not be able to log in to this account, all associated open orders will be canceled, and the API Key will be deleted."
};
var QHhdRUWMTaGpDwrC$1 = {
	message: "This email address has been deleted and cannot be added again"
};
var account_transfer$1 = {
	message: "Account Transfer"
};
var account$1 = {
	message: "Account"
};
var UKenwEAFyRZgQyZTmPYy$1 = {
	message: "Deleted successfully"
};
var enJSON = {
	pHHNdTPNyDzQgIvYd: pHHNdTPNyDzQgIvYd$1,
	cWSaveaKAPErStEYy: cWSaveaKAPErStEYy$1,
	sSIcbzainkLvqqhxh: sSIcbzainkLvqqhxh$1,
	aLZzpUtzvgrrPWvcQGbT: aLZzpUtzvgrrPWvcQGbT$1,
	IizWxRwTfRDgQnVPXcb: IizWxRwTfRDgQnVPXcb$1,
	jeYCQaSvbBRtAklYZ: jeYCQaSvbBRtAklYZ$1,
	kfASiYACukCdCVcFmcsq: kfASiYACukCdCVcFmcsq$1,
	YpcGXAgMexsVEmQnseE: YpcGXAgMexsVEmQnseE$1,
	OivHVusJobtDPuGMSbDN: OivHVusJobtDPuGMSbDN$1,
	HNryhyKcRNPaLZpBHK: HNryhyKcRNPaLZpBHK$1,
	IDPsMPUXhtCczMWcA: IDPsMPUXhtCczMWcA$1,
	MnGzdARgdxwWnBQGqasa: MnGzdARgdxwWnBQGqasa$1,
	dSypETsKWXyxFowLHe: dSypETsKWXyxFowLHe$1,
	CRjZdhorIpDDNDAPls: CRjZdhorIpDDNDAPls$1,
	KEEUdFUfkYDFEeiUhk: KEEUdFUfkYDFEeiUhk$1,
	BQbWzLQtSHQVHdIDAgJ: BQbWzLQtSHQVHdIDAgJ$1,
	fxHeYqwgtTcKAdCKPyVe: fxHeYqwgtTcKAdCKPyVe$1,
	OXrwZMwkWAjoSDDALzow: OXrwZMwkWAjoSDDALzow$1,
	tOaRBVUJHpnSgDBrGON: tOaRBVUJHpnSgDBrGON$1,
	WbPTckCFMKtPHgAlL: WbPTckCFMKtPHgAlL$1,
	nHxEoVJEcaAOmKgBbYO: nHxEoVJEcaAOmKgBbYO$1,
	MZjVFSmKoCrehUMcH: MZjVFSmKoCrehUMcH$1,
	puvbUtnTezlmHPfbVAqn: puvbUtnTezlmHPfbVAqn$1,
	HOpNrycyzpeOCvcWPwAM: HOpNrycyzpeOCvcWPwAM$1,
	QaixZWMxqfefkNPgkdy: QaixZWMxqfefkNPgkdy$1,
	RPMjhEtAWhHwQeAjSV: RPMjhEtAWhHwQeAjSV$1,
	mBnIkwyDNdwNDoWcq: mBnIkwyDNdwNDoWcq$1,
	ApuVYLcjyFSzxzZB: ApuVYLcjyFSzxzZB$1,
	YoNUkubiEWSyPsgRUR: YoNUkubiEWSyPsgRUR$1,
	msvgVjHCdtHxFKkrS: msvgVjHCdtHxFKkrS$1,
	SUObcbdMwQrjwarfaMi: SUObcbdMwQrjwarfaMi$1,
	ElMEzQxYcCuZMmCmB: ElMEzQxYcCuZMmCmB$1,
	idqLvJqjeiEmQbpa: idqLvJqjeiEmQbpa$1,
	FhkGAkzeRaGMUGCREr: FhkGAkzeRaGMUGCREr$1,
	lXmoRtYVpvHfxffpUp: lXmoRtYVpvHfxffpUp$1,
	fIZJfHadJjLYozRPMC: fIZJfHadJjLYozRPMC$1,
	fVuoUoQRKfJuwltrQWcF: fVuoUoQRKfJuwltrQWcF$1,
	tMHuCmLcCyWTKXTkJpl: tMHuCmLcCyWTKXTkJpl$1,
	yXhUtplPqxAjDtkzW: yXhUtplPqxAjDtkzW$1,
	EGBtpzynCWcQsWcMz: EGBtpzynCWcQsWcMz$1,
	nFxxFVzdRTilHiouzuY: nFxxFVzdRTilHiouzuY$1,
	gYpQegnebgwwccEuM: gYpQegnebgwwccEuM$1,
	HQSjnUOWYQPuvvTpu: HQSjnUOWYQPuvvTpu$1,
	PufPEQRHcFlNqsAG: PufPEQRHcFlNqsAG$1,
	lvvtaxnLzNOtFCZllw: lvvtaxnLzNOtFCZllw$1,
	NoqAHzFdypmIlmXmyM: NoqAHzFdypmIlmXmyM$1,
	dLTuZclgDrLDUToEe: dLTuZclgDrLDUToEe$1,
	YChcfaxDaLscdSPiRQz: YChcfaxDaLscdSPiRQz$1,
	qtCIhbuRgppyZzltf: qtCIhbuRgppyZzltf$1,
	wvzbJUEmNoCiDQLTaWzH: wvzbJUEmNoCiDQLTaWzH$1,
	POdaGgvMxQRsisLbVcll: POdaGgvMxQRsisLbVcll$1,
	qRoYPOkmAoqOZnZawkD: qRoYPOkmAoqOZnZawkD$1,
	SgWXitfFwQHiWicT: SgWXitfFwQHiWicT$1,
	txfROteTwdaWdTnlkif: txfROteTwdaWdTnlkif$1,
	qEmYfNcGOwxFPeXxWz: qEmYfNcGOwxFPeXxWz$1,
	sjqwCBQBKOIAKZymEnSd: sjqwCBQBKOIAKZymEnSd$1,
	wAFriagWUVTteXOh: wAFriagWUVTteXOh$1,
	ffqVyVPsxEFhGDWwjo: ffqVyVPsxEFhGDWwjo$1,
	ZFmapCdeoYAGjnNG: ZFmapCdeoYAGjnNG$1,
	JTHQBsfkCFvanpmGhYL: JTHQBsfkCFvanpmGhYL$1,
	tLufHBCFhvZchanHd: tLufHBCFhvZchanHd$1,
	VUMActZjvXkEaSCs: VUMActZjvXkEaSCs$1,
	dqGnSTBmWfxxuxSAR: dqGnSTBmWfxxuxSAR$1,
	NrifpOBOTpbiyPCqT: NrifpOBOTpbiyPCqT$1,
	ogjLTTEZpYaUhUJAk: ogjLTTEZpYaUhUJAk$1,
	TGFdcFVaVnCAXfpC: TGFdcFVaVnCAXfpC$1,
	cFKHegtmXlwojKtJw: cFKHegtmXlwojKtJw$1,
	pNHFlymBnWuShBmbewj: pNHFlymBnWuShBmbewj$1,
	AsLSeryFUtTwDklOIhVE: AsLSeryFUtTwDklOIhVE$1,
	lNGEpmcaWzCMRfZFypa: lNGEpmcaWzCMRfZFypa$1,
	CKVRBnYMLalEUVhYrqI: CKVRBnYMLalEUVhYrqI$1,
	JAKswaiCfseLlQNZ: JAKswaiCfseLlQNZ$1,
	bZduiedsIokAAxBsM: bZduiedsIokAAxBsM$1,
	rtVWmSuAATyCaNgkRNx: rtVWmSuAATyCaNgkRNx$1,
	TVTktEvtpSXRbnxIB: TVTktEvtpSXRbnxIB$1,
	leXQdnNvhrYWetVTXjE: leXQdnNvhrYWetVTXjE$1,
	MzbyaTzwTlbRpWdHmwt: MzbyaTzwTlbRpWdHmwt$1,
	phfuULxmHCuLNyotJ: phfuULxmHCuLNyotJ$1,
	qdvGrtpVJQsGGgiLvje: qdvGrtpVJQsGGgiLvje$1,
	PIxkcsUxBzUPVVFfu: PIxkcsUxBzUPVVFfu$1,
	OBIAENcRtoPgMWcJNZ: OBIAENcRtoPgMWcJNZ$1,
	iDYPzXzvGbnKWCRr: iDYPzXzvGbnKWCRr$1,
	FmpkJYVtUXpBCGEVp: FmpkJYVtUXpBCGEVp$1,
	mzWsFtJNWfexuuUgYctv: mzWsFtJNWfexuuUgYctv$1,
	wjeaGDSVTuLLjJGehN: wjeaGDSVTuLLjJGehN$1,
	KbSjSRobgQmXjHChGKJ: KbSjSRobgQmXjHChGKJ$1,
	TAFoyaQLwVzluFioqh: TAFoyaQLwVzluFioqh$1,
	eChfcikkuQFNcZULZuP: eChfcikkuQFNcZULZuP$1,
	VnLNiYiOJxZraQxL: VnLNiYiOJxZraQxL$1,
	bqNjZcEbCrAzOJJpJDn: bqNjZcEbCrAzOJJpJDn$1,
	gTYMvovCwafJTrjdlKg: gTYMvovCwafJTrjdlKg$1,
	PczYwMSUlifZlPdkNj: PczYwMSUlifZlPdkNj$1,
	DDrTONBZdHTEWHNFNgtV: DDrTONBZdHTEWHNFNgtV$1,
	OkpDnVcVIcDyntNTMI: OkpDnVcVIcDyntNTMI$1,
	EfVkywGLHyLgyrRjzg: EfVkywGLHyLgyrRjzg$1,
	NOIPqSfkgPcsNJnyAFA: NOIPqSfkgPcsNJnyAFA$1,
	WauyOiSpVDMamrXbLP: WauyOiSpVDMamrXbLP$1,
	eXVsxwaBOXkkntIEGtC: eXVsxwaBOXkkntIEGtC$1,
	EOmmDCycYoHFOZOV: EOmmDCycYoHFOZOV$1,
	ysjFKMhSQlIqXgPlz: ysjFKMhSQlIqXgPlz$1,
	TNkXPjSKdzQcBLZPsWj: TNkXPjSKdzQcBLZPsWj$1,
	FMUUecQmwAheUKwpq: FMUUecQmwAheUKwpq$1,
	KSxzKkrfZaaHIOptelk: KSxzKkrfZaaHIOptelk$1,
	IurrXFgATIlGAlejcf: IurrXFgATIlGAlejcf$1,
	mUgsNHlLzyKVnxhVjRT: mUgsNHlLzyKVnxhVjRT$1,
	LcqaZGQKcdkxNrnIcK: LcqaZGQKcdkxNrnIcK$1,
	zQsiOHqCsFIqBzNsf: zQsiOHqCsFIqBzNsf$1,
	erLerUcELvDAcoUWi: erLerUcELvDAcoUWi$1,
	TGYvVRioXBfDBtmCBpH: TGYvVRioXBfDBtmCBpH$1,
	cQKfBbUkEhBhPtPCx: cQKfBbUkEhBhPtPCx$1,
	SHjOXbqLUjZRUKsWMzD: SHjOXbqLUjZRUKsWMzD$1,
	mUuMBlRDyzHtFgLsivV: mUuMBlRDyzHtFgLsivV$1,
	ISJVpXHVtpoxunGygBGu: ISJVpXHVtpoxunGygBGu$1,
	VGmDUnWBzMKfFbMKXyl: VGmDUnWBzMKfFbMKXyl$1,
	ZAhuzRDlLUTXhKrhhx: ZAhuzRDlLUTXhKrhhx$1,
	BggwtUciWOTxbdTdDg: BggwtUciWOTxbdTdDg$1,
	QFbYEdxUgXzRwcPFQDis: QFbYEdxUgXzRwcPFQDis$1,
	UNForxvjDLCZdGrmWkX: UNForxvjDLCZdGrmWkX$1,
	OCamqUckeIZshGlCbF: OCamqUckeIZshGlCbF$1,
	YMfvOKmAFnfMwTXPfI: YMfvOKmAFnfMwTXPfI$1,
	nvfgxTKtdXdTEhFZf: nvfgxTKtdXdTEhFZf$1,
	HrHtlLjcEICrEnWiRA: HrHtlLjcEICrEnWiRA$1,
	HIFNIcNDmIhRZEsgzSq: HIFNIcNDmIhRZEsgzSq$1,
	KSyKpOAjkLSpCGns: KSyKpOAjkLSpCGns$1,
	eUvzxeVvXrffrpEOrFrP: eUvzxeVvXrffrpEOrFrP$1,
	NqgOQEXQaHsramCnbX: NqgOQEXQaHsramCnbX$1,
	YqzlhmIgzcgLnWmZhMsa: YqzlhmIgzcgLnWmZhMsa$1,
	FrzWGSiDSDzTfNgZH: FrzWGSiDSDzTfNgZH$1,
	WYhIabGPkCnbVBIPcwW: WYhIabGPkCnbVBIPcwW$1,
	LFipKWcCwIamrrato: LFipKWcCwIamrrato$1,
	RFoMDsIwGyJlPkuuxrON: RFoMDsIwGyJlPkuuxrON$1,
	bpvYuERgedcoMzzLNl: bpvYuERgedcoMzzLNl$1,
	NsvJYqLAVHAaWNUXAvz: NsvJYqLAVHAaWNUXAvz$1,
	UbeafDPBCDfpRnQyWUjq: UbeafDPBCDfpRnQyWUjq$1,
	LbGVMqLVHqyddGmXzULS: LbGVMqLVHqyddGmXzULS$1,
	qdnqxPdrpfdxhejrkCj: qdnqxPdrpfdxhejrkCj$1,
	XYHinpRQuEPFjXMzLP: XYHinpRQuEPFjXMzLP$1,
	LQNXJVNXqgqLimcQn: LQNXJVNXqgqLimcQn$1,
	nzLBdKgvNCXQTgYI: nzLBdKgvNCXQTgYI$1,
	iYpfkywMVpuafYnqXxGI: iYpfkywMVpuafYnqXxGI$1,
	DVjsSAdKoyNHoIqhumQ: DVjsSAdKoyNHoIqhumQ$1,
	cxKcumOzANqjtQqREyas: cxKcumOzANqjtQqREyas$1,
	BQkFfUTgzkweftGIpOLt: BQkFfUTgzkweftGIpOLt$1,
	FNNzRxnZqrKRYwIte: FNNzRxnZqrKRYwIte$1,
	SultIciVtbYeZaII: SultIciVtbYeZaII$1,
	dGRvusBQRnbHUIYQRit: dGRvusBQRnbHUIYQRit$1,
	bJwUxepDjVzlNzKuI: bJwUxepDjVzlNzKuI$1,
	HlrghIZaaySLZjESwU: HlrghIZaaySLZjESwU$1,
	TCuuXTtXBYeAldQkZp: TCuuXTtXBYeAldQkZp$1,
	HYTGqldMNoESWJswz: HYTGqldMNoESWJswz$1,
	dkdmEAWTXMORUhlQaX: dkdmEAWTXMORUhlQaX$1,
	XwYKiJGJKAZZZpNp: XwYKiJGJKAZZZpNp$1,
	swejTyFcYnjuUgsfQW: swejTyFcYnjuUgsfQW$1,
	mWoxaQwwzwCFvWjRmK: mWoxaQwwzwCFvWjRmK$1,
	tFaBUAWNRhJqtjIha: tFaBUAWNRhJqtjIha$1,
	FEySNpPzdMqiOsZXI: FEySNpPzdMqiOsZXI$1,
	AIwKneHGNfSJmdLnG: AIwKneHGNfSJmdLnG$1,
	wMGJlEJaupHayuzRwi: wMGJlEJaupHayuzRwi$1,
	iRiLJudagJVXZozmnz: iRiLJudagJVXZozmnz$1,
	laRzOEpYMTvnZYRBZMnj: laRzOEpYMTvnZYRBZMnj$1,
	MDhXYatnZcwvrjVeRh: MDhXYatnZcwvrjVeRh$1,
	hDPPfPClruPeWrSoayR: hDPPfPClruPeWrSoayR$1,
	NTsLbMXwQdPYbmOwP: NTsLbMXwQdPYbmOwP$1,
	POqloYgxpcTCqdnchGE: POqloYgxpcTCqdnchGE$1,
	KxeaINzIsNNJmsIncnV: KxeaINzIsNNJmsIncnV$1,
	sfsygIDbANBoFslbcsw: sfsygIDbANBoFslbcsw$1,
	YgpFeXbXojsYnphM: YgpFeXbXojsYnphM$1,
	MutPBZAXykjaIurt: MutPBZAXykjaIurt$1,
	GvnMmZJtuApdXwWhsFd: GvnMmZJtuApdXwWhsFd$1,
	IcahwJmNfgdvVpPz: IcahwJmNfgdvVpPz$1,
	bxtlucAfnIxfwBYAY: bxtlucAfnIxfwBYAY$1,
	KKbVbDLheqewlSvBE: KKbVbDLheqewlSvBE$1,
	RLztZboedHACRMkjdD: RLztZboedHACRMkjdD$1,
	QEaaELvQUvbfoIpje: QEaaELvQUvbfoIpje$1,
	czSsfuZGitGjFRwLTF: czSsfuZGitGjFRwLTF$1,
	xrYEaiWUOcaNRQMIf: xrYEaiWUOcaNRQMIf$1,
	QDuPlYKAxjAjIgyoAqM: QDuPlYKAxjAjIgyoAqM$1,
	ZkDBgJuvDUVQPOxBY: ZkDBgJuvDUVQPOxBY$1,
	rJAhIVPUqedRmsfmj: rJAhIVPUqedRmsfmj$1,
	GpGpOkSHUzYBQNFc: GpGpOkSHUzYBQNFc$1,
	aMdrNUxkhioFGrNGFIO: aMdrNUxkhioFGrNGFIO$1,
	siLEsPwfoiqGBiXjB: siLEsPwfoiqGBiXjB$1,
	DYgqvlfmNbyLNOrWwc: DYgqvlfmNbyLNOrWwc$1,
	rifKyRmlGZOwlJkDyZG: rifKyRmlGZOwlJkDyZG$1,
	aNVsLyHapaJbRxWnHsv: aNVsLyHapaJbRxWnHsv$1,
	cQiCyvfOMMDJEIXyc: cQiCyvfOMMDJEIXyc$1,
	SywvArMjCuuGzTEtlJ: SywvArMjCuuGzTEtlJ$1,
	vRyVKhBOPCmWYPPacY: vRyVKhBOPCmWYPPacY$1,
	GMOQAxsTvfWIEBANuS: GMOQAxsTvfWIEBANuS$1,
	xqLddTkVnCrEvxgKGso: xqLddTkVnCrEvxgKGso$1,
	sHqYaogVbbeWItJGb: sHqYaogVbbeWItJGb$1,
	xgIKqcGuTlutCTLLG: xgIKqcGuTlutCTLLG$1,
	zsLweYcWjOwUgfyub: zsLweYcWjOwUgfyub$1,
	xUNmcszdZBWMTcxnI: xUNmcszdZBWMTcxnI$1,
	moirunBAysHLMEDtBxUt: moirunBAysHLMEDtBxUt$1,
	YrkgVnAQcYRhGGRex: YrkgVnAQcYRhGGRex$1,
	iuOLeRpygvfPFDnf: iuOLeRpygvfPFDnf$1,
	iuswsIRQwNAIuOzoFX: iuswsIRQwNAIuOzoFX$1,
	sBFILAqpJhAnTLlpQ: sBFILAqpJhAnTLlpQ$1,
	eSLIwfCNWkIwJpqCHSVC: eSLIwfCNWkIwJpqCHSVC$1,
	RtWpXpLfhjeWPtKhcENN: RtWpXpLfhjeWPtKhcENN$1,
	KveBVvOTiGXRKmAUQZz: KveBVvOTiGXRKmAUQZz$1,
	XwmOjTtjNklQiLDgnjIB: XwmOjTtjNklQiLDgnjIB$1,
	GLIndpTHvNVRVWQuT: GLIndpTHvNVRVWQuT$1,
	WzcUSFqDMdwkVtGoj: WzcUSFqDMdwkVtGoj$1,
	kuTgfRDYzVZvEHrFtQ: kuTgfRDYzVZvEHrFtQ$1,
	gXbirwakdsaUKBglwK: gXbirwakdsaUKBglwK$1,
	cTlSqXgGENkCAQQJCHx: cTlSqXgGENkCAQQJCHx$1,
	JsmDOHlXAmjSPqaxg: JsmDOHlXAmjSPqaxg$1,
	yCCsuXAjuRzOLNxo: yCCsuXAjuRzOLNxo$1,
	iizCYlpFHwQBzRyqLM: iizCYlpFHwQBzRyqLM$1,
	FbztGftxEQrszJntb: FbztGftxEQrszJntb$1,
	rteqizIYZXJwMWMenVz: rteqizIYZXJwMWMenVz$1,
	sydmFvhfSgzJVhtAud: sydmFvhfSgzJVhtAud$1,
	aYdhyaHCqMJLweGFD: aYdhyaHCqMJLweGFD$1,
	SMEPVJNtMGWMrEceo: SMEPVJNtMGWMrEceo$1,
	jgXHbpNLgJMKuuZER: jgXHbpNLgJMKuuZER$1,
	JWDRcPebwmpIhvJhVrJe: JWDRcPebwmpIhvJhVrJe$1,
	UtQJNokaxJhxqqTQDiO: UtQJNokaxJhxqqTQDiO$1,
	TFAtjCZbFqacobpGxct: TFAtjCZbFqacobpGxct$1,
	EokACCilfAZfuGcXD: EokACCilfAZfuGcXD$1,
	UXURgENTpgxogbFAD: UXURgENTpgxogbFAD$1,
	ElbSFPkaecjnmBToovei: ElbSFPkaecjnmBToovei$1,
	LuigfaXzmPRCftdFOV: LuigfaXzmPRCftdFOV$1,
	BNXHKONNlrkDGKwkXt: BNXHKONNlrkDGKwkXt$1,
	ltXrglJnxfNqZDSStFq: ltXrglJnxfNqZDSStFq$1,
	FClYxqPqiIjfTGZZthn: FClYxqPqiIjfTGZZthn$1,
	cNmmUqRZfZDUxgWTQeXm: cNmmUqRZfZDUxgWTQeXm$1,
	lKLpdmEuElAKKvltT: lKLpdmEuElAKKvltT$1,
	coPPHMNHpJdMYeKPskDY: coPPHMNHpJdMYeKPskDY$1,
	NovuNXyQGDRrjfyMs: NovuNXyQGDRrjfyMs$1,
	bOSFxWykzVFerKLOiV: bOSFxWykzVFerKLOiV$1,
	HfjMmDJQuBZXqFJUw: HfjMmDJQuBZXqFJUw$1,
	SVTrmHtEOHifBpgPNCY: SVTrmHtEOHifBpgPNCY$1,
	LmRHxJOIEHRnUwFSxEm: LmRHxJOIEHRnUwFSxEm$1,
	gbkxEEkMTXuhYuUCZTJ: gbkxEEkMTXuhYuUCZTJ$1,
	rQgPydQgDVYqtWJXCky: rQgPydQgDVYqtWJXCky$1,
	nFSJqWAXBnxTngDNyoj: nFSJqWAXBnxTngDNyoj$1,
	MThZOMtyoBvwpuodWEa: MThZOMtyoBvwpuodWEa$1,
	hiEgXdIbTRKrnaYJnNY: hiEgXdIbTRKrnaYJnNY$1,
	PqkPSNBQJWOqaAsafW: PqkPSNBQJWOqaAsafW$1,
	vHRZRztWvqyjjHCxW: vHRZRztWvqyjjHCxW$1,
	QZchoinPLbiohHfdnLU: QZchoinPLbiohHfdnLU$1,
	gnOvqPVwTsPuWvBTXzI: gnOvqPVwTsPuWvBTXzI$1,
	bDmdcJmdRsIZfYYBDeZ: bDmdcJmdRsIZfYYBDeZ$1,
	YEPMktdEzwhrMMYKefX: YEPMktdEzwhrMMYKefX$1,
	wGSnhUtsHuueniKdYTwM: wGSnhUtsHuueniKdYTwM$1,
	krMQcSEJDOnglqhrHgu: krMQcSEJDOnglqhrHgu$1,
	erZFCFRNsVfSKVMRLN: erZFCFRNsVfSKVMRLN$1,
	dmeNSGPySLKtEpPGwG: dmeNSGPySLKtEpPGwG$1,
	czWbrtWmnCEbUCzVWzQQ: czWbrtWmnCEbUCzVWzQQ$1,
	YATiezBAjBifZRNRVk: YATiezBAjBifZRNRVk$1,
	sTMySyQXFMSuchwUXiJ: sTMySyQXFMSuchwUXiJ$1,
	FxLhtNEexnBoJElMC: FxLhtNEexnBoJElMC$1,
	hYBHkTzZmueqvwJb: hYBHkTzZmueqvwJb$1,
	GBvqxVjZVWwZtAPZgH: GBvqxVjZVWwZtAPZgH$1,
	KVLFziUaVDlFbnJzh: KVLFziUaVDlFbnJzh$1,
	OQGpXlfSrBKFcwjAv: OQGpXlfSrBKFcwjAv$1,
	AsfYVtpYWMjfUopLa: AsfYVtpYWMjfUopLa$1,
	wZZutIhpaOoppafvh: wZZutIhpaOoppafvh$1,
	OUdBKfTzsTrdfcZmbCAI: OUdBKfTzsTrdfcZmbCAI$1,
	IwzxXaGfVvDNSxQpmeO: IwzxXaGfVvDNSxQpmeO$1,
	XzCcbOKjdfmcCnQLEwNj: XzCcbOKjdfmcCnQLEwNj$1,
	IkToKVrxLaVfCKfNGvl: IkToKVrxLaVfCKfNGvl$1,
	mRtlyGWfQVnoeqMeTs: mRtlyGWfQVnoeqMeTs$1,
	ldgxhAKPgZpGiyMyJw: ldgxhAKPgZpGiyMyJw$1,
	mxKAuwcjmevMUSvDQE: mxKAuwcjmevMUSvDQE$1,
	pSTKNwtZdcuFuoyTsPhb: pSTKNwtZdcuFuoyTsPhb$1,
	EkbLQeqmPtcNzItJWQO: EkbLQeqmPtcNzItJWQO$1,
	KzFzOytWXScqDRKFwg: KzFzOytWXScqDRKFwg$1,
	MvJmrHwTdesvsHWH: MvJmrHwTdesvsHWH$1,
	bksAzarViFUYGzwAOk: bksAzarViFUYGzwAOk$1,
	EOLVYvzyNXSKoGmX: EOLVYvzyNXSKoGmX$1,
	EvOtSTBQrIYspwjQ: EvOtSTBQrIYspwjQ$1,
	eQHAVxHydpVhNAygOp: eQHAVxHydpVhNAygOp$1,
	LWInyMcYkagvzvaBfUHZ: LWInyMcYkagvzvaBfUHZ$1,
	OKOogywrWeAjtQWF: OKOogywrWeAjtQWF$1,
	MOtoFwFvpTtTEDVUD: MOtoFwFvpTtTEDVUD$1,
	ZdMOAZGAMXotVGVlKJ: ZdMOAZGAMXotVGVlKJ$1,
	rEpbPaWEEsiOSTjOiSGL: rEpbPaWEEsiOSTjOiSGL$1,
	SWVaRdViGfCBJhJNg: SWVaRdViGfCBJhJNg$1,
	lrCgiXeJcIwkuDsyc: lrCgiXeJcIwkuDsyc$1,
	vyxYMhwwOspfcdpj: vyxYMhwwOspfcdpj$1,
	MqMVsYdMMtqujWPKHW: MqMVsYdMMtqujWPKHW$1,
	siEUrpaJmBIICzsaBnr: siEUrpaJmBIICzsaBnr$1,
	XGLKbSKPnzgwwZwEHu: XGLKbSKPnzgwwZwEHu$1,
	DPFrIOWnjfRpVQHkhKJ: DPFrIOWnjfRpVQHkhKJ$1,
	dTLgwTGGXjpsnLhrpr: dTLgwTGGXjpsnLhrpr$1,
	gZgeimlXmokhLdRziw: gZgeimlXmokhLdRziw$1,
	xqhbTjIzOYuCUiHEUmd: xqhbTjIzOYuCUiHEUmd$1,
	bbQJHoMWXkEHQuVRSsO: bbQJHoMWXkEHQuVRSsO$1,
	HHdEPKdocehppzeI: HHdEPKdocehppzeI$1,
	tICtqmzJVNeVfZQM: tICtqmzJVNeVfZQM$1,
	HOQBmfsmIsFBlsaJaSa: HOQBmfsmIsFBlsaJaSa$1,
	XsOliEIHDkjKcghOik: XsOliEIHDkjKcghOik$1,
	ADXLpfHxGLEEMBBLjSL: ADXLpfHxGLEEMBBLjSL$1,
	kHAIwKLXztAgQxLOxj: kHAIwKLXztAgQxLOxj$1,
	pqNxLtehgpuJIUBdg: pqNxLtehgpuJIUBdg$1,
	nodIQIicrpcVpCqYey: nodIQIicrpcVpCqYey$1,
	gMjyScxabRhqehsX: gMjyScxabRhqehsX$1,
	AQrCocFqoKoYieUnT: AQrCocFqoKoYieUnT$1,
	COydGeEPULYaNAmN: COydGeEPULYaNAmN$1,
	pFhbWEovZnvIiVEEJnme: pFhbWEovZnvIiVEEJnme$1,
	omUetmzxCLiTloCSalU: omUetmzxCLiTloCSalU$1,
	pqzdTKxlixAoAQwGy: pqzdTKxlixAoAQwGy$1,
	VihBsZgCPMgMJnwUeMLt: VihBsZgCPMgMJnwUeMLt$1,
	ohIqnNpSPiMOrWPSWk: ohIqnNpSPiMOrWPSWk$1,
	TGIiRSnHGjASSfzjMA: TGIiRSnHGjASSfzjMA$1,
	jjFQYQyxRWGgKdjbaeB: jjFQYQyxRWGgKdjbaeB$1,
	VsuTZcfrgRHVvsOOY: VsuTZcfrgRHVvsOOY$1,
	PLhQWivTKyTYZvsNwMxj: PLhQWivTKyTYZvsNwMxj$1,
	ZLJlKTdDgntyZXzg: ZLJlKTdDgntyZXzg$1,
	pPqFjpMzSnmyNWXdT: pPqFjpMzSnmyNWXdT$1,
	aJpdCHYrgIukuVpHluT: aJpdCHYrgIukuVpHluT$1,
	olWnlFpnBjRnPCLuu: olWnlFpnBjRnPCLuu$1,
	ApYUyYTgQDVozNVGdoWy: ApYUyYTgQDVozNVGdoWy$1,
	MEuzpQOAySrMUyXj: MEuzpQOAySrMUyXj$1,
	NkjUESwzghXjElHM: NkjUESwzghXjElHM$1,
	GnugFlecXZohsDMgfjv: GnugFlecXZohsDMgfjv$1,
	nwsbWCYbSYugmHDgHTAB: nwsbWCYbSYugmHDgHTAB$1,
	gphdXFLzIrPxMQrAp: gphdXFLzIrPxMQrAp$1,
	toUaeInrwbWVqvGGGX: toUaeInrwbWVqvGGGX$1,
	gVAFPuXrrstpWxRF: gVAFPuXrrstpWxRF$1,
	AowuwjwDLrAJJKuVzCA: AowuwjwDLrAJJKuVzCA$1,
	TfmLyYqIoASEGHkuRa: TfmLyYqIoASEGHkuRa$1,
	tjuWuhQfpwDJLMscdbI: tjuWuhQfpwDJLMscdbI$1,
	KewXLZFbuyWsCSbvXi: KewXLZFbuyWsCSbvXi$1,
	vQphyNqvokPAiFdfRR: vQphyNqvokPAiFdfRR$1,
	ZbQsLkbfHUtbznnzU: ZbQsLkbfHUtbznnzU$1,
	TsnjCIOPEKKCCfrIF: TsnjCIOPEKKCCfrIF$1,
	qyKlEsEkyTXybgIHcI: qyKlEsEkyTXybgIHcI$1,
	VZexjbUhosOUoUTI: VZexjbUhosOUoUTI$1,
	jDRHFidXonxhhPKaTl: jDRHFidXonxhhPKaTl$1,
	CInUOzoFKTOMvMbix: CInUOzoFKTOMvMbix$1,
	fTbsMnhpZYjiOkAdex: fTbsMnhpZYjiOkAdex$1,
	yOZzgRmKudbwNjuurBHz: yOZzgRmKudbwNjuurBHz$1,
	lelamaRhejmRBJOD: lelamaRhejmRBJOD$1,
	pZxEeOQMfyGXKTBxtyJ: pZxEeOQMfyGXKTBxtyJ$1,
	ZGyanZavgObBeqhP: ZGyanZavgObBeqhP$1,
	oeMZNyLdkPQdxrobojO: oeMZNyLdkPQdxrobojO$1,
	MYuuWNTVQwjCeRRGl: MYuuWNTVQwjCeRRGl$1,
	yrlrMPLgOtiEzbmPW: yrlrMPLgOtiEzbmPW$1,
	EzMbHhWUJOaBMLDRJxZ: EzMbHhWUJOaBMLDRJxZ$1,
	hQRkbssUXUGGLhtxc: hQRkbssUXUGGLhtxc$1,
	eDwDkAgbfaPsnwOb: eDwDkAgbfaPsnwOb$1,
	AVWJwkijUTbNMShmp: AVWJwkijUTbNMShmp$1,
	wEEzjRnoOftKrGIPbix: wEEzjRnoOftKrGIPbix$1,
	NqoduOnqIqJtrjajas: NqoduOnqIqJtrjajas$1,
	vLUFWGhkoIBWnOMA: vLUFWGhkoIBWnOMA$1,
	tjsCbqUvgNvcdRqdDp: tjsCbqUvgNvcdRqdDp$1,
	zBceLwpDLhGkPRkvbU: zBceLwpDLhGkPRkvbU$1,
	udmfKDblDABqFbQPK: udmfKDblDABqFbQPK$1,
	AysRHzzIQTbjLUdgdaq: AysRHzzIQTbjLUdgdaq$1,
	KZPDAndezwXohlXxO: KZPDAndezwXohlXxO$1,
	hdPRTcCCnKbkxbRwgv: hdPRTcCCnKbkxbRwgv$1,
	pfVyzGgyXmkqtJpGH: pfVyzGgyXmkqtJpGH$1,
	KRzStRHbmbrDbAUMnU: KRzStRHbmbrDbAUMnU$1,
	lfLIpxDvOAXOplowzN: lfLIpxDvOAXOplowzN$1,
	BiqzWayxveHNZGxaBa: BiqzWayxveHNZGxaBa$1,
	CvvaFnujrEUnFHnWNb: CvvaFnujrEUnFHnWNb$1,
	CNmFZyGboWXdpYPQDvxV: CNmFZyGboWXdpYPQDvxV$1,
	OmOTUgBCsVHUoKutAD: OmOTUgBCsVHUoKutAD$1,
	DCXoQKoDcwNYuYivD: DCXoQKoDcwNYuYivD$1,
	ApeuvISiLLWNGQPrFrP: ApeuvISiLLWNGQPrFrP$1,
	sCfZtZRTGxweYVxtEuoY: sCfZtZRTGxweYVxtEuoY$1,
	VpbDUCnJRDAsPzfIkn: VpbDUCnJRDAsPzfIkn$1,
	WfvaFuidVgEGCwnBEkl: WfvaFuidVgEGCwnBEkl$1,
	UheALJaSjOHgmVnoCrI: UheALJaSjOHgmVnoCrI$1,
	fNFAnFLpEoAIoPfbh: fNFAnFLpEoAIoPfbh$1,
	uUrUZzojXlsqxsuOJZTc: uUrUZzojXlsqxsuOJZTc$1,
	CqNbVYlZNfwGfGTGRtE: CqNbVYlZNfwGfGTGRtE$1,
	QgEerZTcSTdjtiTnKRT: QgEerZTcSTdjtiTnKRT$1,
	GnbMsiqoZbfmcDerQ: GnbMsiqoZbfmcDerQ$1,
	nEgrtiBYldBKXkpKCocL: nEgrtiBYldBKXkpKCocL$1,
	AJSlWSWYVQZSygnFKRsI: AJSlWSWYVQZSygnFKRsI$1,
	KzgGszjJLuRsOKsdkH: KzgGszjJLuRsOKsdkH$1,
	YmIZCYMTuGNvbocpiJOP: YmIZCYMTuGNvbocpiJOP$1,
	YixzEmijtHztNgwIE: YixzEmijtHztNgwIE$1,
	geVHcZlrpiEaagZcypgy: geVHcZlrpiEaagZcypgy$1,
	SAruOCDnkHugkPOIFSc: SAruOCDnkHugkPOIFSc$1,
	yteHSDpgaHMYFeMBfpWk: yteHSDpgaHMYFeMBfpWk$1,
	slVffWcKrAhjpgaMEuY: slVffWcKrAhjpgaMEuY$1,
	ghYLDApWJBxFOzhqAlN: ghYLDApWJBxFOzhqAlN$1,
	GCxKMtkKAZPoOHsZIDh: GCxKMtkKAZPoOHsZIDh$1,
	uRLAPBsurxBqxfvgaSH: uRLAPBsurxBqxfvgaSH$1,
	FaQaEHvLdVELQbCZrFN: FaQaEHvLdVELQbCZrFN$1,
	RZgUzTVRaXNflgjshVf: RZgUzTVRaXNflgjshVf$1,
	nXPQNJCVxPkQKidfjnn: nXPQNJCVxPkQKidfjnn$1,
	swSisSeZXWyUyMvIu: swSisSeZXWyUyMvIu$1,
	HryFxrLzCqTGOVNrpI: HryFxrLzCqTGOVNrpI$1,
	QqwNZKCLuiPIswItY: QqwNZKCLuiPIswItY$1,
	gqfClfSZIJlpPGmuBjum: gqfClfSZIJlpPGmuBjum$1,
	HMclPwyZgRMKnvBRCr: HMclPwyZgRMKnvBRCr$1,
	iZKMHnInbVLuJJcbpbR: iZKMHnInbVLuJJcbpbR$1,
	VYJdtiuPscmItOfIyux: VYJdtiuPscmItOfIyux$1,
	sbzqRZRFyPyYqnsMtNy: sbzqRZRFyPyYqnsMtNy$1,
	SwDoMzvfeChtJIrEA: SwDoMzvfeChtJIrEA$1,
	pPViUnFnexhWKoFMx: pPViUnFnexhWKoFMx$1,
	NltNaOnxuMeUAbBeZ: NltNaOnxuMeUAbBeZ$1,
	HmXYHUAhkQnrZSfKu: HmXYHUAhkQnrZSfKu$1,
	KgKURwhHRUNpPmFtXTAv: KgKURwhHRUNpPmFtXTAv$1,
	thvmUblDYmiyVPacUB: thvmUblDYmiyVPacUB$1,
	ViAVfshtzuMNFpCqJl: ViAVfshtzuMNFpCqJl$1,
	sSrzMRNSGNzrJsidBnYz: sSrzMRNSGNzrJsidBnYz$1,
	wVSQKNQtitzmkbjDOac: wVSQKNQtitzmkbjDOac$1,
	rvLRPuoiEpNqnbxwWj: rvLRPuoiEpNqnbxwWj$1,
	CRMoLKUrfyLkDWFEuSu: CRMoLKUrfyLkDWFEuSu$1,
	GJOdwcCnvAbhzEkImJ: GJOdwcCnvAbhzEkImJ$1,
	pnGXcYRvktMyOUBwX: pnGXcYRvktMyOUBwX$1,
	fQOFawXqhywMOGSe: fQOFawXqhywMOGSe$1,
	KIIMnxhTdJBhZfaEMP: KIIMnxhTdJBhZfaEMP$1,
	hAacNWPacMHaAAaOw: hAacNWPacMHaAAaOw$1,
	aCtajuQWKCQNkeKgtwLb: aCtajuQWKCQNkeKgtwLb$1,
	XjTUjttgmruHnxFXgVf: XjTUjttgmruHnxFXgVf$1,
	ovsIpOdHmKskDqaansBG: ovsIpOdHmKskDqaansBG$1,
	RawXxpklaPpnKkAjXLL: RawXxpklaPpnKkAjXLL$1,
	dpnyHVmjzJjiqtQIfpD: dpnyHVmjzJjiqtQIfpD$1,
	CtiOEevtmgSCxLlIqb: CtiOEevtmgSCxLlIqb$1,
	HmoCuzIHcMwWJJxszus: HmoCuzIHcMwWJJxszus$1,
	xoPXukoFZulOsawPoPe: xoPXukoFZulOsawPoPe$1,
	FlbUChtSXKPaYQGW: FlbUChtSXKPaYQGW$1,
	XUWTeclWoXtMrQkJzuuq: XUWTeclWoXtMrQkJzuuq$1,
	YCHRDIIKsDzJFQJw: YCHRDIIKsDzJFQJw$1,
	hfBBkSOAXqfEsLVFs: hfBBkSOAXqfEsLVFs$1,
	aETDJvQumPoQnxdEPkQR: aETDJvQumPoQnxdEPkQR$1,
	zZXyblLWbONMNIjPmBN: zZXyblLWbONMNIjPmBN$1,
	gyneoIYPeiHgfaCY: gyneoIYPeiHgfaCY$1,
	ihVcXhmbhwIbsPsTbF: ihVcXhmbhwIbsPsTbF$1,
	ctaxFEnYnZIrAtOaYc: ctaxFEnYnZIrAtOaYc$1,
	tMlPwcyXKotAImFCGfQ: tMlPwcyXKotAImFCGfQ$1,
	SRUOTyGYueLSOwlA: SRUOTyGYueLSOwlA$1,
	rpFnFNTJlMZaopFU: rpFnFNTJlMZaopFU$1,
	sMMYOeSUIvHuRdqiC: sMMYOeSUIvHuRdqiC$1,
	fYiJCYMSTpHPjREdFLyB: fYiJCYMSTpHPjREdFLyB$1,
	XzXwpEBzHGPNkUqaw: XzXwpEBzHGPNkUqaw$1,
	YyrFTDoECNUvGnXVt: YyrFTDoECNUvGnXVt$1,
	leIEPguvvNFtRsXGFI: leIEPguvvNFtRsXGFI$1,
	yEMtEIJyJomPsTPTv: yEMtEIJyJomPsTPTv$1,
	EHBFEqMJtpPqVznA: EHBFEqMJtpPqVznA$1,
	IHceeEHwOOHjpdHosyOe: IHceeEHwOOHjpdHosyOe$1,
	kINzgREzBDTsegQCvHQ: kINzgREzBDTsegQCvHQ$1,
	ObVBBALqXaIzgsSPVQO: ObVBBALqXaIzgsSPVQO$1,
	ckNnmPAbtNOsWqlpAKy: ckNnmPAbtNOsWqlpAKy$1,
	nmOEDJmAsIcTkCgZMv: nmOEDJmAsIcTkCgZMv$1,
	jMXTehFeNbljMLGb: jMXTehFeNbljMLGb$1,
	ZbUUOchcpSOpwpIk: ZbUUOchcpSOpwpIk$1,
	lzbnQluepXRurDUf: lzbnQluepXRurDUf$1,
	xDfYpxodvMVDQJKav: xDfYpxodvMVDQJKav$1,
	XBrHgyrvVacGhRNJco: XBrHgyrvVacGhRNJco$1,
	cXhPoUARLvRqvesHQqeu: cXhPoUARLvRqvesHQqeu$1,
	tBDAaKFwVBeiyQnnTDIA: tBDAaKFwVBeiyQnnTDIA$1,
	PuqWAcBQEKXlfTuxDuD: PuqWAcBQEKXlfTuxDuD$1,
	yzrKsfyEambKetSgWv: yzrKsfyEambKetSgWv$1,
	NSkMpVyoVWGymUTOzL: NSkMpVyoVWGymUTOzL$1,
	JkoaUyCjjTHSNUEy: JkoaUyCjjTHSNUEy$1,
	LtnRgezlrxMzWvZBxRJ: LtnRgezlrxMzWvZBxRJ$1,
	jXvqhJJMhyxRdxCxv: jXvqhJJMhyxRdxCxv$1,
	YZKOONeeIQMFqysxrZ: YZKOONeeIQMFqysxrZ$1,
	nmicLlJCgyNNjjzKJUt: nmicLlJCgyNNjjzKJUt$1,
	BCZEHAhJNfTPwNSqVZl: BCZEHAhJNfTPwNSqVZl$1,
	zIFzaxTFaAhTdPpeh: zIFzaxTFaAhTdPpeh$1,
	tdxbonOdGqBYgBaOjc: tdxbonOdGqBYgBaOjc$1,
	XondKWeJxfchfIoGLe: XondKWeJxfchfIoGLe$1,
	ndyNHmtKJFFsefAzdv: ndyNHmtKJFFsefAzdv$1,
	FeBXkTWnPLzGZEnXEpg: FeBXkTWnPLzGZEnXEpg$1,
	QZCxVURndUpletXFScR: QZCxVURndUpletXFScR$1,
	UXOpXybkQBmLEHTAgw: UXOpXybkQBmLEHTAgw$1,
	BslmwdHcTinuPaihULw: BslmwdHcTinuPaihULw$1,
	jvnfqZRQbFEGTCMGbvT: jvnfqZRQbFEGTCMGbvT$1,
	NsZKEKPRgLQfWeSixA: NsZKEKPRgLQfWeSixA$1,
	icMsBwEbBUQztvmOv: icMsBwEbBUQztvmOv$1,
	dXXdlICxETXaAzDyY: dXXdlICxETXaAzDyY$1,
	zhFTdPuxrgMfcNWoA: zhFTdPuxrgMfcNWoA$1,
	pjPGNrHukGWKUheCaX: pjPGNrHukGWKUheCaX$1,
	uglsZRLSLmmcqItl: uglsZRLSLmmcqItl$1,
	nPqFzGTyChvJyTQw: nPqFzGTyChvJyTQw$1,
	mEPBGXtDbaIrisefS: mEPBGXtDbaIrisefS$1,
	dBZfEFBQmkatfptbV: dBZfEFBQmkatfptbV$1,
	jYUScsXfUCTPNPqSAR: jYUScsXfUCTPNPqSAR$1,
	OJjDmIeMWmMfkDihQu: OJjDmIeMWmMfkDihQu$1,
	JoPUjgxywPfIQlnDrzx: JoPUjgxywPfIQlnDrzx$1,
	ZVRKVLGoMmmrOxLzg: ZVRKVLGoMmmrOxLzg$1,
	HYklWTwhtonjbiQRYCz: HYklWTwhtonjbiQRYCz$1,
	RsjGGXbMJbrislSlWM: RsjGGXbMJbrislSlWM$1,
	wEarLFdfZMShsSfacNU: wEarLFdfZMShsSfacNU$1,
	eEcajuQQvABwGKndqss: eEcajuQQvABwGKndqss$1,
	EfIjGkMogFrJyNKuWar: EfIjGkMogFrJyNKuWar$1,
	JaPjOXJRPJqsTDLdU: JaPjOXJRPJqsTDLdU$1,
	cuKtQbYgXOwLPEbN: cuKtQbYgXOwLPEbN$1,
	BVmyvtMVCbAJXhwSpT: BVmyvtMVCbAJXhwSpT$1,
	NRUPVKxKVtYaCDVPq: NRUPVKxKVtYaCDVPq$1,
	szgmmxxDYVvTLNzPkk: szgmmxxDYVvTLNzPkk$1,
	mJjedBCPidtXUCYHus: mJjedBCPidtXUCYHus$1,
	IIbmROzHEYCycsCyk: IIbmROzHEYCycsCyk$1,
	knoGdfgXpoVeAMqHCXu: knoGdfgXpoVeAMqHCXu$1,
	SBLHeXGlsYVIdiBNRe: SBLHeXGlsYVIdiBNRe$1,
	AocjyYzlYgRsGzlavU: AocjyYzlYgRsGzlavU$1,
	wQEsyNYfqlFrkqUvaDx: wQEsyNYfqlFrkqUvaDx$1,
	rbefbFgPVyawmaktVYF: rbefbFgPVyawmaktVYF$1,
	MjEyxNUcFsFMIjsOIDpg: MjEyxNUcFsFMIjsOIDpg$1,
	ygnbLzvTAMIylzNxj: ygnbLzvTAMIylzNxj$1,
	peIDsRhrNLVzQmAQWg: peIDsRhrNLVzQmAQWg$1,
	BbqJaDHRCDmiNwNVcGB: BbqJaDHRCDmiNwNVcGB$1,
	LESgEuOUJYjZQYLUlO: LESgEuOUJYjZQYLUlO$1,
	hsgIRJDqXwkPnsmgktga: hsgIRJDqXwkPnsmgktga$1,
	mDlqsQlmoApWZXHKLq: mDlqsQlmoApWZXHKLq$1,
	DjgcgdUJtoNmqshNSb: DjgcgdUJtoNmqshNSb$1,
	FxlLNwkBHAbChJrnM: FxlLNwkBHAbChJrnM$1,
	NuZslGbiHniUKgycjhmv: NuZslGbiHniUKgycjhmv$1,
	AdLFmhSQGMGYrTgXdUH: AdLFmhSQGMGYrTgXdUH$1,
	rQiWsAGGRmEQCtfaIK: rQiWsAGGRmEQCtfaIK$1,
	HjfxCIPqXHVRBXeofOe: HjfxCIPqXHVRBXeofOe$1,
	CwyRzEeuIMzGRVzVdSVg: CwyRzEeuIMzGRVzVdSVg$1,
	MgdMcyuZEloUdpqcv: MgdMcyuZEloUdpqcv$1,
	yKqxJEvOxokRNAPXYDZC: yKqxJEvOxokRNAPXYDZC$1,
	FIvibwVWwddLxzofT: FIvibwVWwddLxzofT$1,
	HQLJuhRwbVdfCwEp: HQLJuhRwbVdfCwEp$1,
	irXsKkZagNKDlvCyhKYK: irXsKkZagNKDlvCyhKYK$1,
	RQJGnpiCuJKbplbuWeaj: RQJGnpiCuJKbplbuWeaj$1,
	ULhbQlNBpFJzLTlp: ULhbQlNBpFJzLTlp$1,
	DmecbpJQgGJiVjTqP: DmecbpJQgGJiVjTqP$1,
	qltXLGplQJNtHWdY: qltXLGplQJNtHWdY$1,
	vamuznzHAJqilfEEP: vamuznzHAJqilfEEP$1,
	oGNuorHWcxXehehzCno: oGNuorHWcxXehehzCno$1,
	pFjSwsuOrRtiguvbEc: pFjSwsuOrRtiguvbEc$1,
	VZMtxSlhbTKcmTYeEsW: VZMtxSlhbTKcmTYeEsW$1,
	ivAXIbjvUUQpQqpmXz: ivAXIbjvUUQpQqpmXz$1,
	thJZdZfDKDEFyETsPyzj: thJZdZfDKDEFyETsPyzj$1,
	mrdEVkqkBIuEBVzzL: mrdEVkqkBIuEBVzzL$1,
	JWctZqDXJyyraLbOe: JWctZqDXJyyraLbOe$1,
	rXWcwotndeKQsLjAdyrw: rXWcwotndeKQsLjAdyrw$1,
	ZuxEmUvBYSsOHORKrFrd: ZuxEmUvBYSsOHORKrFrd$1,
	TfIbvRVtJxzInjuIwq: TfIbvRVtJxzInjuIwq$1,
	YBvzRbRVqKkwTDkNDfoc: YBvzRbRVqKkwTDkNDfoc$1,
	pJTXUuIjycHTetIC: pJTXUuIjycHTetIC$1,
	razdiXXHIkQKbPQTZn: razdiXXHIkQKbPQTZn$1,
	WCGnQDmVyXVqLZPQyqYs: WCGnQDmVyXVqLZPQyqYs$1,
	NgUCFdNkwlZfzWkAiv: NgUCFdNkwlZfzWkAiv$1,
	sdgZycbHzMUKHwVH: sdgZycbHzMUKHwVH$1,
	xQtzLCbkmmYpqCXOwRT: xQtzLCbkmmYpqCXOwRT$1,
	rKSrOqgimgcTrDutYUA: rKSrOqgimgcTrDutYUA$1,
	nFlxQWOJCGHgwwHQhP: nFlxQWOJCGHgwwHQhP$1,
	sMvNZNODlnAIiuzFMR: sMvNZNODlnAIiuzFMR$1,
	RrEKjSeFQrtvLrZIO: RrEKjSeFQrtvLrZIO$1,
	QnjpooahLXRwxGqJIVt: QnjpooahLXRwxGqJIVt$1,
	qZljkUmjmSBKpnUsYfp: qZljkUmjmSBKpnUsYfp$1,
	kjqqAmIhgKSjlBVQx: kjqqAmIhgKSjlBVQx$1,
	WfJRbDGlqfLFvNVzyWu: WfJRbDGlqfLFvNVzyWu$1,
	wgbBNytjmVvMvqRkRL: wgbBNytjmVvMvqRkRL$1,
	pXHPsbEpWSnCyJGH: pXHPsbEpWSnCyJGH$1,
	CRbVirgSccJqKzSUSEau: CRbVirgSccJqKzSUSEau$1,
	FgrxZUNDleeDGneKmwd: FgrxZUNDleeDGneKmwd$1,
	uJpZAZRdzpyAaUkEqwSx: uJpZAZRdzpyAaUkEqwSx$1,
	elXgEtyDNXczWYbDHV: elXgEtyDNXczWYbDHV$1,
	LiwpXDoMAXANnTRZ: LiwpXDoMAXANnTRZ$1,
	wfRBtzUHBPZjVDxUc: wfRBtzUHBPZjVDxUc$1,
	xrfefvhsEfCoJokIdeW: xrfefvhsEfCoJokIdeW$1,
	gapTtWntRtJcQzRtBz: gapTtWntRtJcQzRtBz$1,
	NhBzijnKrdihICUwgi: NhBzijnKrdihICUwgi$1,
	PdxWoNDxKAJmNcpe: PdxWoNDxKAJmNcpe$1,
	AHMRWIOaHFIWiIPqUx: AHMRWIOaHFIWiIPqUx$1,
	LDNvolWeNGwNyvpTMnL: LDNvolWeNGwNyvpTMnL$1,
	uYLqhJrdDgRVWcNvDpr: uYLqhJrdDgRVWcNvDpr$1,
	ZnbyJyzHTxzgLRDFBmEm: ZnbyJyzHTxzgLRDFBmEm$1,
	FTVpPZybylBmTnwhMhtx: FTVpPZybylBmTnwhMhtx$1,
	THMxZAxLcuuIfPErpGb: THMxZAxLcuuIfPErpGb$1,
	bTWntlsiiBougPgd: bTWntlsiiBougPgd$1,
	zIgntQSydRspYJCaQ: zIgntQSydRspYJCaQ$1,
	vPVjNqmPYGCrexspl: vPVjNqmPYGCrexspl$1,
	oMgGPGaGAlElFewgOv: oMgGPGaGAlElFewgOv$1,
	iqCHKgJKHatuZHiXEFm: iqCHKgJKHatuZHiXEFm$1,
	dHIzNCfEthjGsjpMsfJN: dHIzNCfEthjGsjpMsfJN$1,
	VALtZMIyzODbkpPUOsxG: VALtZMIyzODbkpPUOsxG$1,
	OOtkDwkZMvTavtRmc: OOtkDwkZMvTavtRmc$1,
	bRDTmhggLlBbrbdtfhM: bRDTmhggLlBbrbdtfhM$1,
	IzXQAIEgQLMYmZwrzP: IzXQAIEgQLMYmZwrzP$1,
	xjuVMsJZTRgjPgAzSV: xjuVMsJZTRgjPgAzSV$1,
	WACiElgvWMUDhQMxa: WACiElgvWMUDhQMxa$1,
	USZqODoQgzwaggnbb: USZqODoQgzwaggnbb$1,
	KChGPohSmJORAMDUqSs: KChGPohSmJORAMDUqSs$1,
	oGZZfIIocJcraogK: oGZZfIIocJcraogK$1,
	pAYXQPFeRbuYruZa: pAYXQPFeRbuYruZa$1,
	aaOdxWUHHLynEVSoWTM: aaOdxWUHHLynEVSoWTM$1,
	jSQVlHGDwxAZujRJNiSh: jSQVlHGDwxAZujRJNiSh$1,
	uuluQlsJBdDsslsERZX: uuluQlsJBdDsslsERZX$1,
	ACweJQrKoWgpyYspyEl: ACweJQrKoWgpyYspyEl$1,
	JLIvWEpTgjlkpsZBM: JLIvWEpTgjlkpsZBM$1,
	UfkUhznLfeqzZyTdAebx: UfkUhznLfeqzZyTdAebx$1,
	FxzVGfjClbeUZeEero: FxzVGfjClbeUZeEero$1,
	WjPizXTxbdPnvLWMql: WjPizXTxbdPnvLWMql$1,
	ytFXzDnzPIGUhOOClJ: ytFXzDnzPIGUhOOClJ$1,
	dWHEObNDvkCjTnlvH: dWHEObNDvkCjTnlvH$1,
	lfjjwhqpvFBikfhkifrN: lfjjwhqpvFBikfhkifrN$1,
	gGrAIKLFJuNxbjhnZz: gGrAIKLFJuNxbjhnZz$1,
	trJoqkSnMVAvbRgAY: trJoqkSnMVAvbRgAY$1,
	CyNhoDlSuMvcxydtF: CyNhoDlSuMvcxydtF$1,
	dpvvLNDzKxLZIuixW: dpvvLNDzKxLZIuixW$1,
	cYSzpXPrPUQxaAGTihK: cYSzpXPrPUQxaAGTihK$1,
	kYGDyxESdKUNNTdG: kYGDyxESdKUNNTdG$1,
	UqNGOztCBezyeAgI: UqNGOztCBezyeAgI$1,
	TWuwXEwzngPlnjELUJ: TWuwXEwzngPlnjELUJ$1,
	AUNMAupfnBRbGlrb: AUNMAupfnBRbGlrb$1,
	EqpPTPZsKjTArTFVgWp: EqpPTPZsKjTArTFVgWp$1,
	oiSDCKooPzMznfGteAG: oiSDCKooPzMznfGteAG$1,
	DSFAJhsSefQQEdBBlUyt: DSFAJhsSefQQEdBBlUyt$1,
	aaKDUKbsmRiynWiqlS: aaKDUKbsmRiynWiqlS$1,
	eDeADqoJRnEUGotYxzY: eDeADqoJRnEUGotYxzY$1,
	CDwWwMbhHZXYRMZHKnpO: CDwWwMbhHZXYRMZHKnpO$1,
	fjjnxDoEsAfrEGSbNUL: fjjnxDoEsAfrEGSbNUL$1,
	qqXTaCjhvvMrmeJpPG: qqXTaCjhvvMrmeJpPG$1,
	RMCuKzWRRjQNKUNP: RMCuKzWRRjQNKUNP$1,
	qipDilqNVyHfNJVyF: qipDilqNVyHfNJVyF$1,
	CuzRRZhhkOmuQgeVt: CuzRRZhhkOmuQgeVt$1,
	VoqaSnQNOfXstSBxca: VoqaSnQNOfXstSBxca$1,
	ZCRfudjxgEkJLycN: ZCRfudjxgEkJLycN$1,
	tdxlCkYgrpQOxYYJZiF: tdxlCkYgrpQOxYYJZiF$1,
	RZiGRHwDUpYgJcRLRnxa: RZiGRHwDUpYgJcRLRnxa$1,
	aXbxDDurboZtvnPno: aXbxDDurboZtvnPno$1,
	OUDeIeQIjCliBQIHe: OUDeIeQIjCliBQIHe$1,
	AbrPzuZLAZwUuIBnbx: AbrPzuZLAZwUuIBnbx$1,
	JJAtBenOLOlFaFaP: JJAtBenOLOlFaFaP$1,
	YWCMpmGuparutCzjXpp: YWCMpmGuparutCzjXpp$1,
	aCYhhkYhhIrzUQvFB: aCYhhkYhhIrzUQvFB$1,
	sVTrHBZPprcyXLgcE: sVTrHBZPprcyXLgcE$1,
	oGHfMwDNMhRcKszx: oGHfMwDNMhRcKszx$1,
	hYWPDZZNtYYwiYMfUfjX: hYWPDZZNtYYwiYMfUfjX$1,
	NIxMpJepTIBNynamgjj: NIxMpJepTIBNynamgjj$1,
	onaIGydLoNFhYUGyo: onaIGydLoNFhYUGyo$1,
	nkENghGiqpNyJlRpBv: nkENghGiqpNyJlRpBv$1,
	eEBDsqLdNoLOJxjVc: eEBDsqLdNoLOJxjVc$1,
	SJBETCfUKQwBPbOwXhs: SJBETCfUKQwBPbOwXhs$1,
	TbviyxwhVLMOhttn: TbviyxwhVLMOhttn$1,
	SFeLOdYxYJLeOgLtZI: SFeLOdYxYJLeOgLtZI$1,
	IKImbOtCOwEOtcDsMLv: IKImbOtCOwEOtcDsMLv$1,
	woYYXxIEUCPOPTbYi: woYYXxIEUCPOPTbYi$1,
	XVImLdGTpJvSndfrLlee: XVImLdGTpJvSndfrLlee$1,
	ylhkcCPZqNeskQBJB: ylhkcCPZqNeskQBJB$1,
	gLehflpqCNwIhEtbYIAz: gLehflpqCNwIhEtbYIAz$1,
	BEfhHOirsmwpDEilDbq: BEfhHOirsmwpDEilDbq$1,
	WzIAmgVLQnPRHGRfGw: WzIAmgVLQnPRHGRfGw$1,
	zcamcMLRNetHERtiy: zcamcMLRNetHERtiy$1,
	NStCDznwhsZPGYrJAq: NStCDznwhsZPGYrJAq$1,
	pucEyENFLLeSzsJUK: pucEyENFLLeSzsJUK$1,
	EqbYvDbdIrmgXbrPPAO: EqbYvDbdIrmgXbrPPAO$1,
	pyuZUzzDPovDumukD: pyuZUzzDPovDumukD$1,
	xxgsgyEjhfwrMflwMr: xxgsgyEjhfwrMflwMr$1,
	PVcSgRlruKdhLYAvMUG: PVcSgRlruKdhLYAvMUG$1,
	BIVIQEHEPCzGuQpNKSR: BIVIQEHEPCzGuQpNKSR$1,
	GhRAIjbecBWjePTjqSD: GhRAIjbecBWjePTjqSD$1,
	qsVtkTgbKcuLSPDXf: qsVtkTgbKcuLSPDXf$1,
	WINbdlmnRMSyZUqkxCP: WINbdlmnRMSyZUqkxCP$1,
	bnpgtsIPDfFydCQlTH: bnpgtsIPDfFydCQlTH$1,
	BgXkLkPusAcJBiUmSw: BgXkLkPusAcJBiUmSw$1,
	OARZuIqYLXtlrvaEsC: OARZuIqYLXtlrvaEsC$1,
	YLJxFxxsgqpWcZWy: YLJxFxxsgqpWcZWy$1,
	RjPDzDdrzBcLHVJiG: RjPDzDdrzBcLHVJiG$1,
	DrmqiYKPSoxMBWXT: DrmqiYKPSoxMBWXT$1,
	nSdDtaHzknwZAXJHzrGP: nSdDtaHzknwZAXJHzrGP$1,
	NZjrOkmPAHtiaMLyuVDA: NZjrOkmPAHtiaMLyuVDA$1,
	XfjZomFsTRpbZJuHjI: XfjZomFsTRpbZJuHjI$1,
	lxppTPAJDxxMIGdmiRG: lxppTPAJDxxMIGdmiRG$1,
	OljlLKYobPynbcStGlN: OljlLKYobPynbcStGlN$1,
	YXrqAGUqprWfOCeiSGX: YXrqAGUqprWfOCeiSGX$1,
	MkfqKEzRwLTbzJEOeWg: MkfqKEzRwLTbzJEOeWg$1,
	vshrtYQXEVpbXmLZwV: vshrtYQXEVpbXmLZwV$1,
	wINMfXpJczhYZOnUXWp: wINMfXpJczhYZOnUXWp$1,
	uetkXvxfFuKnhpBFrA: uetkXvxfFuKnhpBFrA$1,
	sZVlKBQCGGTVChpa: sZVlKBQCGGTVChpa$1,
	AZVALNHESdbXtHmNY: AZVALNHESdbXtHmNY$1,
	pVQoQWJNGEfRwmpZMki: pVQoQWJNGEfRwmpZMki$1,
	HsxgqsfmdLnIcdcXgLS: HsxgqsfmdLnIcdcXgLS$1,
	gohHRZTjodstzoCLNv: gohHRZTjodstzoCLNv$1,
	rfXBETBheWYaMqrktE: rfXBETBheWYaMqrktE$1,
	rxfIffMgcmDGmXfVZA: rxfIffMgcmDGmXfVZA$1,
	ifmHgobawgqPHdruP: ifmHgobawgqPHdruP$1,
	AkLeJkGIGPcgMPOyMJvd: AkLeJkGIGPcgMPOyMJvd$1,
	SLZgFNtUooxfLTcXEnm: SLZgFNtUooxfLTcXEnm$1,
	APOikjpbuiZXwYbMlWBl: APOikjpbuiZXwYbMlWBl$1,
	pEZOQJSBxlCYyrjM: pEZOQJSBxlCYyrjM$1,
	IKLXXpDUJHlgctnhc: IKLXXpDUJHlgctnhc$1,
	GSkKAUsvGPYZMAnFnH: GSkKAUsvGPYZMAnFnH$1,
	HIptAJwjtWvHteUhwW: HIptAJwjtWvHteUhwW$1,
	ETkemdVBXuBSBAstv: ETkemdVBXuBSBAstv$1,
	fUqbBtyQPrkRchcpe: fUqbBtyQPrkRchcpe$1,
	wprsRqdyQRGnVcbsp: wprsRqdyQRGnVcbsp$1,
	zDKhBsXavFMPAEqgdH: zDKhBsXavFMPAEqgdH$1,
	PpelPkXnzahxkdhVa: PpelPkXnzahxkdhVa$1,
	XvACoEmpLFSLVHywT: XvACoEmpLFSLVHywT$1,
	hhiTSbgqtfHswnyfCs: hhiTSbgqtfHswnyfCs$1,
	jwkMtTwNHEktKLQA: jwkMtTwNHEktKLQA$1,
	aTPVtxAhNeuzjutYgu: aTPVtxAhNeuzjutYgu$1,
	CSMPJDQZLtdBrHSlRhzp: CSMPJDQZLtdBrHSlRhzp$1,
	OYByrRpUomOXEqORBozE: OYByrRpUomOXEqORBozE$1,
	pQEEhEzMgmLpEznsEH: pQEEhEzMgmLpEznsEH$1,
	HNUebnMoRCmoPDEpASH: HNUebnMoRCmoPDEpASH$1,
	ARCAktOTCiLqQqaPTv: ARCAktOTCiLqQqaPTv$1,
	LJPMiQOhqtJqlBRBCHX: LJPMiQOhqtJqlBRBCHX$1,
	lvouKixXkMbDqOnnr: lvouKixXkMbDqOnnr$1,
	FRjQUDLIESvWvPOQY: FRjQUDLIESvWvPOQY$1,
	JNPXLHStukWLfpLRU: JNPXLHStukWLfpLRU$1,
	dQRnMUSMOEdAwdfMqW: dQRnMUSMOEdAwdfMqW$1,
	cHodlBcOiNHOlxFn: cHodlBcOiNHOlxFn$1,
	tglvvZIzjMuxIoXEYs: tglvvZIzjMuxIoXEYs$1,
	yDGXBsHUIoIkgqfepe: yDGXBsHUIoIkgqfepe$1,
	lsdjJQPYPEOcAzVOth: lsdjJQPYPEOcAzVOth$1,
	PlIgEPTbgrrwkSuHc: PlIgEPTbgrrwkSuHc$1,
	NqhjvGQWWHnmAzDH: NqhjvGQWWHnmAzDH$1,
	QNEAoNoQfTpYIxJvjdM: QNEAoNoQfTpYIxJvjdM$1,
	MhWCMBfnPEmyPhdBJC: MhWCMBfnPEmyPhdBJC$1,
	rcbvwVBVHsJazGKrQv: rcbvwVBVHsJazGKrQv$1,
	HsYTxsCouoyySItw: HsYTxsCouoyySItw$1,
	CNXhqxsuJtAEOpHCSI: CNXhqxsuJtAEOpHCSI$1,
	iQYmhTkvoynVhdKfkY: iQYmhTkvoynVhdKfkY$1,
	lLKoAhJqRLmDyyTCvO: lLKoAhJqRLmDyyTCvO$1,
	bNcNiQWtnacHBQFyTY: bNcNiQWtnacHBQFyTY$1,
	JIozcUyGaPUboZLlBjVN: JIozcUyGaPUboZLlBjVN$1,
	tNbQTPYLVCKjsvpja: tNbQTPYLVCKjsvpja$1,
	UrkVGOIalMNhKwpIEzK: UrkVGOIalMNhKwpIEzK$1,
	cCtaFICzFmzJltYPL: cCtaFICzFmzJltYPL$1,
	SVpHROUKzBJsjSVHMK: SVpHROUKzBJsjSVHMK$1,
	UMTZPjOpYZuhdhDbBVO: UMTZPjOpYZuhdhDbBVO$1,
	iBQIPIJCNFHBCeRIvm: iBQIPIJCNFHBCeRIvm$1,
	nedDtIXJkIrvdDqe: nedDtIXJkIrvdDqe$1,
	xWhLpCcRjLgSplng: xWhLpCcRjLgSplng$1,
	DZjgiswpELVABBqUWCSa: DZjgiswpELVABBqUWCSa$1,
	XrngZedCHgJUKulaDcT: XrngZedCHgJUKulaDcT$1,
	fWgPNysKDTLrzjgrexk: fWgPNysKDTLrzjgrexk$1,
	QIzonbZxYqJjQrPHfJM: QIzonbZxYqJjQrPHfJM$1,
	iHptEcwFnEbHVLaQkXyb: iHptEcwFnEbHVLaQkXyb$1,
	uUpDUGTUrKdXVQXkgSP: uUpDUGTUrKdXVQXkgSP$1,
	HzbSujYkGuYtObRcrdbh: HzbSujYkGuYtObRcrdbh$1,
	NOYdleknddFOfQxlNOI: NOYdleknddFOfQxlNOI$1,
	nqPKzhAfSmqRRIHii: nqPKzhAfSmqRRIHii$1,
	eOPHosimYamraEKUukBz: eOPHosimYamraEKUukBz$1,
	LoBOFhdSzMFjdqZgDE: LoBOFhdSzMFjdqZgDE$1,
	mHVIpiFPJQPNPFYAeeu: mHVIpiFPJQPNPFYAeeu$1,
	TNXdbUElFLwiyRVKuJ: TNXdbUElFLwiyRVKuJ$1,
	wLQWZKMRgmTJTSudW: wLQWZKMRgmTJTSudW$1,
	GkvuBozDTWJAXbpwyP: GkvuBozDTWJAXbpwyP$1,
	IMxXGyWWPXtfrrwxV: IMxXGyWWPXtfrrwxV$1,
	tibiqQyzvztLFMGQ: tibiqQyzvztLFMGQ$1,
	fXTeVLzGkVECTSGgtm: fXTeVLzGkVECTSGgtm$1,
	XYVTanLxxisBNzaOFx: XYVTanLxxisBNzaOFx$1,
	bdAMbKWoEuDxlGOg: bdAMbKWoEuDxlGOg$1,
	ALJjPGCRLTrnWlbmqO: ALJjPGCRLTrnWlbmqO$1,
	znOXnaDhTySukBeCrT: znOXnaDhTySukBeCrT$1,
	ESHCFsWVeQAWSnEKV: ESHCFsWVeQAWSnEKV$1,
	lLAJPCrarwsWDdbLaw: lLAJPCrarwsWDdbLaw$1,
	biXQrrlOVDoExCZZKC: biXQrrlOVDoExCZZKC$1,
	spot_trading: spot_trading$1,
	MTiCVGmtBjEPWzsw: MTiCVGmtBjEPWzsw$1,
	zLnEBdSfUXdqbRqAohY: zLnEBdSfUXdqbRqAohY$1,
	oVvhpgfhTeyLLnTSv: oVvhpgfhTeyLLnTSv$1,
	OEfurFwwcJaTsVxNdol: OEfurFwwcJaTsVxNdol$1,
	TeRrrjzubYVYnBhsdpD: TeRrrjzubYVYnBhsdpD$1,
	xwQqYnxnxmeJPqRlQ: xwQqYnxnxmeJPqRlQ$1,
	hoTQEpJFfRRLZGLWiDK: hoTQEpJFfRRLZGLWiDK$1,
	wZuMVSBUSlQidCQpjoS: wZuMVSBUSlQidCQpjoS$1,
	oSDxsXgENbIeNMLv: oSDxsXgENbIeNMLv$1,
	aoAIqdHabiquSjWWz: aoAIqdHabiquSjWWz$1,
	YltriUZdkgLJuXZi: YltriUZdkgLJuXZi$1,
	sZudUtmwNMYVhQhyj: sZudUtmwNMYVhQhyj$1,
	slqgnwkLOtCyZiTBWb: slqgnwkLOtCyZiTBWb$1,
	PwxbwKVPjpeCuRYx: PwxbwKVPjpeCuRYx$1,
	domCttddTWzCfimSWOq: domCttddTWzCfimSWOq$1,
	dqLNRujTTFLifcFaybP: dqLNRujTTFLifcFaybP$1,
	wIfwelYvkemWaZGE: wIfwelYvkemWaZGE$1,
	vDIneAtEexNLfRMcVPa: vDIneAtEexNLfRMcVPa$1,
	YYzgmIpjtorJXoyQJUk: YYzgmIpjtorJXoyQJUk$1,
	rZkFVZvvCQRyHCfLiNVX: rZkFVZvvCQRyHCfLiNVX$1,
	VXwjemLYMJiNKvXlZ: VXwjemLYMJiNKvXlZ$1,
	GZOFzxVOsYtRtlONwcv: GZOFzxVOsYtRtlONwcv$1,
	YiNdDLTlBGFQiuNECi: YiNdDLTlBGFQiuNECi$1,
	aFykbSRCZkUrYNzoKtk: aFykbSRCZkUrYNzoKtk$1,
	TgilgrTuMXgbAQuPf: TgilgrTuMXgbAQuPf$1,
	MQaUVFeBMhHfKxmBUV: MQaUVFeBMhHfKxmBUV$1,
	HgKGDukwWWdCeZlibVY: HgKGDukwWWdCeZlibVY$1,
	rhXOjsQATKgJNizniW: rhXOjsQATKgJNizniW$1,
	pKuaKUWJHuajbExMUs: pKuaKUWJHuajbExMUs$1,
	nkcDnQvbZpDfYMepAc: nkcDnQvbZpDfYMepAc$1,
	UHAKvmcFPrannQlFz: UHAKvmcFPrannQlFz$1,
	MmdyZCvMXusVhfjsV: MmdyZCvMXusVhfjsV$1,
	MGsQCMXzOIuqcXjBDDTF: MGsQCMXzOIuqcXjBDDTF$1,
	xYFrGCCcvvWooWsibQFD: xYFrGCCcvvWooWsibQFD$1,
	omBdaJrTBmDrBzNYx: omBdaJrTBmDrBzNYx$1,
	omTkmNnwlfkOvozU: omTkmNnwlfkOvozU$1,
	YxGqBoJIoXruDOmbNu: YxGqBoJIoXruDOmbNu$1,
	NOhPBjPDsgVbfqTgjIH: NOhPBjPDsgVbfqTgjIH$1,
	gcFEhAlcWmjNfIqry: gcFEhAlcWmjNfIqry$1,
	npetoxnFYOYxRjXRN: npetoxnFYOYxRjXRN$1,
	TzvXfzahEvyWlLOZQE: TzvXfzahEvyWlLOZQE$1,
	LuuhHZgOxbTJDvnm: LuuhHZgOxbTJDvnm$1,
	sqteSBzbeJvwJeJSWZk: sqteSBzbeJvwJeJSWZk$1,
	uhoCqEIxFLCGpwTslFY: uhoCqEIxFLCGpwTslFY$1,
	OzYooSlNbfNTxRxNhe: OzYooSlNbfNTxRxNhe$1,
	JQpSpVQqatEXOdgFvjh: JQpSpVQqatEXOdgFvjh$1,
	onOjgIPTpDDXLIwlSWE: onOjgIPTpDDXLIwlSWE$1,
	gDgIYTmDidzeeXyOV: gDgIYTmDidzeeXyOV$1,
	cOOoOlxMURFANNpFpYx: cOOoOlxMURFANNpFpYx$1,
	nAVsbekWuHffflMnfHHy: nAVsbekWuHffflMnfHHy$1,
	WelPCqxRFgXNzpkZJdsh: WelPCqxRFgXNzpkZJdsh$1,
	npqmwWmfuEsNrfQJt: npqmwWmfuEsNrfQJt$1,
	wcfFqisAqLRlhbKdJk: wcfFqisAqLRlhbKdJk$1,
	wcJAFtgivjbkVSdTC: wcJAFtgivjbkVSdTC$1,
	pSUGpUOowrIgSHLfEIs: pSUGpUOowrIgSHLfEIs$1,
	cWYINWiSUUdFuDAImP: cWYINWiSUUdFuDAImP$1,
	tUrSbGVjlpoCdTkb: tUrSbGVjlpoCdTkb$1,
	YvXCqALOsnrEQAHU: YvXCqALOsnrEQAHU$1,
	JJfMolWuWCFgrDrUiz: JJfMolWuWCFgrDrUiz$1,
	plHTmWdGncJPnVBJuI: plHTmWdGncJPnVBJuI$1,
	HbkwQxpXzqUXEvkxVmz: HbkwQxpXzqUXEvkxVmz$1,
	KOycuFuoXkNBrUCLtCVL: KOycuFuoXkNBrUCLtCVL$1,
	yYxnWdRQrNPhFUhmKp: yYxnWdRQrNPhFUhmKp$1,
	oWOQzlGOqirSVhUhQX: oWOQzlGOqirSVhUhQX$1,
	xbTIXxCJIOnbLImHUPI: xbTIXxCJIOnbLImHUPI$1,
	VSmzJHKoDZuNenetubvZ: VSmzJHKoDZuNenetubvZ$1,
	YJlyfJbAZRZhGensD: YJlyfJbAZRZhGensD$1,
	SuSDXCILmprzPXIonL: SuSDXCILmprzPXIonL$1,
	FnrHWNqUvXlpfQLAfT: FnrHWNqUvXlpfQLAfT$1,
	uPrPwsvUYglduYxnfgb: uPrPwsvUYglduYxnfgb$1,
	BvERvFYtRmpkINLVdX: BvERvFYtRmpkINLVdX$1,
	MSaPBxOSKeCTtUMPq: MSaPBxOSKeCTtUMPq$1,
	olGkjZMWDZBQwjnVK: olGkjZMWDZBQwjnVK$1,
	PmdVNRJcWUxjWfFSA: PmdVNRJcWUxjWfFSA$1,
	gCLhGVwztVSCPNZUgqQN: gCLhGVwztVSCPNZUgqQN$1,
	FDynUJSlxYFxtAhrQN: FDynUJSlxYFxtAhrQN$1,
	UBCBvFlsnzzgcIOHTmN: UBCBvFlsnzzgcIOHTmN$1,
	MERzsdKkxudpOnlaF: MERzsdKkxudpOnlaF$1,
	XtpeIeGyrDDKSkgyCiL: XtpeIeGyrDDKSkgyCiL$1,
	LxcfZSEIROwQeVCok: LxcfZSEIROwQeVCok$1,
	fxjdlTQeJFVyjFXmhlnI: fxjdlTQeJFVyjFXmhlnI$1,
	aVbJYJuVEhKXAqlbWgUE: aVbJYJuVEhKXAqlbWgUE$1,
	yicaYCvBFspqWpPqS: yicaYCvBFspqWpPqS$1,
	YLfvFQfagZeMpkzlO: YLfvFQfagZeMpkzlO$1,
	fsjyqgrUVSYOXDUxw: fsjyqgrUVSYOXDUxw$1,
	WQsiZpVbrxKoaVkQ: WQsiZpVbrxKoaVkQ$1,
	KpLdefqDhhhdklLzxOgC: KpLdefqDhhhdklLzxOgC$1,
	WbJXVvgJiwcWWgRAYq: WbJXVvgJiwcWWgRAYq$1,
	EcnKFNIFTwRUshkf: EcnKFNIFTwRUshkf$1,
	xGdbGnjcDCabqvFJX: xGdbGnjcDCabqvFJX$1,
	olJXBlENebamalqAmC: olJXBlENebamalqAmC$1,
	lnaNMhKSbkHzoYmMHp: lnaNMhKSbkHzoYmMHp$1,
	MFJyykUbSXUkUqHxlJ: MFJyykUbSXUkUqHxlJ$1,
	UsVahXMYImjwSrxR: UsVahXMYImjwSrxR$1,
	XjUPUpsmbzqDVlOyOzD: XjUPUpsmbzqDVlOyOzD$1,
	bYjpHFpkXBumbkZHbM: bYjpHFpkXBumbkZHbM$1,
	nZkngKdQlMblSkIsJt: nZkngKdQlMblSkIsJt$1,
	vfiTAWyuaCrULibnur: vfiTAWyuaCrULibnur$1,
	hubWrmcrofRaRoYLCAS: hubWrmcrofRaRoYLCAS$1,
	dIOuyFmCcSAXzBifCgd: dIOuyFmCcSAXzBifCgd$1,
	AoqexRnXPjWiaXQQ: AoqexRnXPjWiaXQQ$1,
	wtPiDpoJwweHEwGphG: wtPiDpoJwweHEwGphG$1,
	YFShWZLtmVzhKApQSudo: YFShWZLtmVzhKApQSudo$1,
	EyxlrwvHrdhvRaHtLxx: EyxlrwvHrdhvRaHtLxx$1,
	YbTVKYSCHSNbVSRpbwRM: YbTVKYSCHSNbVSRpbwRM$1,
	rWOqJloUMhKXCZHLpnc: rWOqJloUMhKXCZHLpnc$1,
	nmuzQLDdidsSBtDTLaU: nmuzQLDdidsSBtDTLaU$1,
	cKeVqkUVuUrblpSkN: cKeVqkUVuUrblpSkN$1,
	KgtuAymJbpqjZHQACDKA: KgtuAymJbpqjZHQACDKA$1,
	WriODPyMHmFqbNRIkh: WriODPyMHmFqbNRIkh$1,
	kdGDbDfHqPdMmOODj: kdGDbDfHqPdMmOODj$1,
	fRcWTONIbiPEHREbRTKI: fRcWTONIbiPEHREbRTKI$1,
	MIqinsTMANLFyEzWlLXm: MIqinsTMANLFyEzWlLXm$1,
	xmSClcrPuftAggqMjWp: xmSClcrPuftAggqMjWp$1,
	uPEmuahfZCJKifAf: uPEmuahfZCJKifAf$1,
	NazoeCHUJpEyQWZDKcVt: NazoeCHUJpEyQWZDKcVt$1,
	ZtmHIANowsUTyUyouyg: ZtmHIANowsUTyUyouyg$1,
	DyXvKDfsUBPKtQScEVw: DyXvKDfsUBPKtQScEVw$1,
	SGvHMSujomhCIGweYcH: SGvHMSujomhCIGweYcH$1,
	xFLmujpTZsyQKTENeNr: xFLmujpTZsyQKTENeNr$1,
	xPXNyAgtdawfwFRxXhb: xPXNyAgtdawfwFRxXhb$1,
	VoQarJJpktEfEZnK: VoQarJJpktEfEZnK$1,
	wfUNVCtRXprhwYwce: wfUNVCtRXprhwYwce$1,
	nirNFLwkcuvUxudti: nirNFLwkcuvUxudti$1,
	GqlajLqwcNJLpTqq: GqlajLqwcNJLpTqq$1,
	NKaDUgPomETDmcmKHy: NKaDUgPomETDmcmKHy$1,
	OsCIqseGbbbWXxBLk: OsCIqseGbbbWXxBLk$1,
	DghVzIJcKyuvkcKwY: DghVzIJcKyuvkcKwY$1,
	XYnywMktJDrWPwZBA: XYnywMktJDrWPwZBA$1,
	bgnQSQsWYPIcUDEytcq: bgnQSQsWYPIcUDEytcq$1,
	erGplJlLIBiVheXvc: erGplJlLIBiVheXvc$1,
	epeFMTUcZAYdtLOETgZ: epeFMTUcZAYdtLOETgZ$1,
	oIIfiHdqGwpXZbtDYKG: oIIfiHdqGwpXZbtDYKG$1,
	mlUEUuDRftKStSMvF: mlUEUuDRftKStSMvF$1,
	nNgFtrjyhesGreVhV: nNgFtrjyhesGreVhV$1,
	ewrHdSoDPutFlPrqTEr: ewrHdSoDPutFlPrqTEr$1,
	ZZlJgALCrsSaNhaoV: ZZlJgALCrsSaNhaoV$1,
	OgusvSSbzkNopiGbCIo: OgusvSSbzkNopiGbCIo$1,
	nmPUwVVQoncVHqMln: nmPUwVVQoncVHqMln$1,
	mWaNsXTgUIcnWSphpgB: mWaNsXTgUIcnWSphpgB$1,
	GxjDaNmTVZaIEmLIO: GxjDaNmTVZaIEmLIO$1,
	xdBmFzKPmVQfqVSOyFY: xdBmFzKPmVQfqVSOyFY$1,
	xdSXcpFurEbSenWcxPn: xdSXcpFurEbSenWcxPn$1,
	KzRRnMZfXiUfprzBEe: KzRRnMZfXiUfprzBEe$1,
	nDIaTJMAdTQRxUKJo: nDIaTJMAdTQRxUKJo$1,
	XaQWqbeAdXIkLCiakX: XaQWqbeAdXIkLCiakX$1,
	WHFSIZvkPFlAiUsTW: WHFSIZvkPFlAiUsTW$1,
	IldgeERuYKVOefpR: IldgeERuYKVOefpR$1,
	sYnLKnDJjNhHBCpTj: sYnLKnDJjNhHBCpTj$1,
	ZtsyDNmrvXDDftOHri: ZtsyDNmrvXDDftOHri$1,
	vAeqeVWtpVywOzVUYfuv: vAeqeVWtpVywOzVUYfuv$1,
	PLWcAjJpcpPoIQiCcq: PLWcAjJpcpPoIQiCcq$1,
	QHhdRUWMTaGpDwrC: QHhdRUWMTaGpDwrC$1,
	account_transfer: account_transfer$1,
	account: account$1,
	UKenwEAFyRZgQyZTmPYy: UKenwEAFyRZgQyZTmPYy$1
};

var pHHNdTPNyDzQgIvYd = {
	message: "你好"
};
var cWSaveaKAPErStEYy = {
	message: "首頁"
};
var sSIcbzainkLvqqhxh = {
	message: "錢包"
};
var aLZzpUtzvgrrPWvcQGbT = {
	message: "幣幣交易"
};
var IizWxRwTfRDgQnVPXcb = {
	message: "歷史賬單"
};
var jeYCQaSvbBRtAklYZ = {
	message: "關於我們"
};
var kfASiYACukCdCVcFmcsq = {
	message: "歡迎%s%"
};
var YpcGXAgMexsVEmQnseE = {
	message: "為正常使用賬戶功能，請儘快完成身份驗證。主要步驟包括："
};
var OivHVusJobtDPuGMSbDN = {
	message: "手機號碼驗證"
};
var HNryhyKcRNPaLZpBHK = {
	message: "身份證明"
};
var IDPsMPUXhtCczMWcA = {
	message: "自拍"
};
var MnGzdARgdxwWnBQGqasa = {
	message: "住址證明（如需要）"
};
var dSypETsKWXyxFowLHe = {
	message: "開始"
};
var CRjZdhorIpDDNDAPls = {
	message: "稍後再試"
};
var KEEUdFUfkYDFEeiUhk = {
	message: "您的手機號碼"
};
var BQbWzLQtSHQVHdIDAgJ = {
	message: "發送驗證碼"
};
var fxHeYqwgtTcKAdCKPyVe = {
	message: "重新發送"
};
var OXrwZMwkWAjoSDDALzow = {
	message: "驗證碼"
};
var tOaRBVUJHpnSgDBrGON = {
	message: "下一步"
};
var WbPTckCFMKtPHgAlL = {
	message: "返回"
};
var nHxEoVJEcaAOmKgBbYO = {
	message: "您當前所選擇的證件發行國家為"
};
var MZjVFSmKoCrehUMcH = {
	message: "修改"
};
var puvbUtnTezlmHPfbVAqn = {
	message: "護照"
};
var HOpNrycyzpeOCvcWPwAM = {
	message: "身份證"
};
var QaixZWMxqfefkNPgkdy = {
	message: "駕駛證"
};
var RPMjhEtAWhHwQeAjSV = {
	message: "上傳護照"
};
var mBnIkwyDNdwNDoWcq = {
	message: "上傳身份證"
};
var ApuVYLcjyFSzxzZB = {
	message: "上傳駕駛證"
};
var YoNUkubiEWSyPsgRUR = {
	message: "請確保信息清晰、無塗改，請上傳PDF或JPG格式，不超過5MB"
};
var msvgVjHCdtHxFKkrS = {
	message: "姓"
};
var SUObcbdMwQrjwarfaMi = {
	message: "名"
};
var ElMEzQxYcCuZMmCmB = {
	message: "中間名"
};
var idqLvJqjeiEmQbpa = {
	message: "必填"
};
var FhkGAkzeRaGMUGCREr = {
	message: "選填"
};
var lXmoRtYVpvHfxffpUp = {
	message: "出生日期"
};
var fIZJfHadJjLYozRPMC = {
	message: "國籍"
};
var fVuoUoQRKfJuwltrQWcF = {
	message: "您輸入的基本信息與證件信息保持一致"
};
var tMHuCmLcCyWTKXTkJpl = {
	message: "請打開攝像頭，開始人臉驗證"
};
var yXhUtplPqxAjDtkzW = {
	message: "遇到困難？請選擇上傳手持證件自拍"
};
var EGBtpzynCWcQsWcMz = {
	message: "請手持證件並自拍"
};
var nFxxFVzdRTilHiouzuY = {
	message: "上傳"
};
var gYpQegnebgwwccEuM = {
	message: "常居地"
};
var HQSjnUOWYQPuvvTpu = {
	message: "常居地址"
};
var PufPEQRHcFlNqsAG = {
	message: "郵寄地址"
};
var lvvtaxnLzNOtFCZllw = {
	message: "與常居地址保持一致"
};
var NoqAHzFdypmIlmXmyM = {
	message: "上傳住址證明"
};
var dLTuZclgDrLDUToEe = {
	message: "有效的住址證明包括3個月內的銀行賬單、水電費賬單等，請上傳PDF或JPG格式，且文件大小不超過5MB。"
};
var YChcfaxDaLscdSPiRQz = {
	message: "提交"
};
var qtCIhbuRgppyZzltf = {
	message: "賬單"
};
var wvzbJUEmNoCiDQLTaWzH = {
	message: "帳戶管理"
};
var POdaGgvMxQRsisLbVcll = {
	message: "帳號與安全"
};
var qRoYPOkmAoqOZnZawkD = {
	message: "個人資訊"
};
var SgWXitfFwQHiWicT = {
	message: "設定"
};
var txfROteTwdaWdTnlkif = {
	message: "登入密碼"
};
var qEmYfNcGOwxFPeXxWz = {
	message: "設定登入密碼後，您可以直接使用帳號和登入密碼進行登入。"
};
var sjqwCBQBKOIAKZymEnSd = {
	message: "支付密碼"
};
var wAFriagWUVTteXOh = {
	message: "用於提現、交易時的安全驗證。"
};
var ffqVyVPsxEFhGDWwjo = {
	message: "手機號碼"
};
var ZFmapCdeoYAGjnNG = {
	message: "用於登入、提現、修改密碼、安全設定時接收驗證簡訊。"
};
var JTHQBsfkCFvanpmGhYL = {
	message: "谷歌驗證器"
};
var tLufHBCFhvZchanHd = {
	message: "用於登入、提現、修改安全設定時輸入谷歌驗證碼。"
};
var VUMActZjvXkEaSCs = {
	message: "實名認證"
};
var dqGnSTBmWfxxuxSAR = {
	message: "用於登入、提現、修改安全設定時進行身份驗證。"
};
var NrifpOBOTpbiyPCqT = {
	message: "認證"
};
var ogjLTTEZpYaUhUJAk = {
	message: "個人信息"
};
var TGFdcFVaVnCAXfpC = {
	message: "暱稱"
};
var cFKHegtmXlwojKtJw = {
	message: "儲存"
};
var pNHFlymBnWuShBmbewj = {
	message: "出生日期"
};
var AsLSeryFUtTwDklOIhVE = {
	message: "性別"
};
var lNGEpmcaWzCMRfZFypa = {
	message: "計價方式"
};
var CKVRBnYMLalEUVhYrqI = {
	message: "返回首頁"
};
var JAKswaiCfseLlQNZ = {
	message: "聯繫我們"
};
var bZduiedsIokAAxBsM = {
	message: "登錄/註冊"
};
var rtVWmSuAATyCaNgkRNx = {
	message: "登錄"
};
var TVTktEvtpSXRbnxIB = {
	message: "電子郵件"
};
var leXQdnNvhrYWetVTXjE = {
	message: "電子郵件地址"
};
var MzbyaTzwTlbRpWdHmwt = {
	message: "沒有帳號？立即註冊"
};
var phfuULxmHCuLNyotJ = {
	message: "驗證碼已發送至您的電子郵件，請查看電子郵件"
};
var qdvGrtpVJQsGGgiLvje = {
	message: "我已閱讀並同意《BIXIN用戶條款》與《隱私政策》"
};
var PIxkcsUxBzUPVVFfu = {
	message: "錯誤的電子郵件格式"
};
var OBIAENcRtoPgMWcJNZ = {
	message: "驗證碼錯誤"
};
var iDYPzXzvGbnKWCRr = {
	message: "忘記密碼？"
};
var FmpkJYVtUXpBCGEVp = {
	message: "密碼錯誤"
};
var mzWsFtJNWfexuuUgYctv = {
	message: "抱歉！您所選的國家/地區暫不提供支持"
};
var wjeaGDSVTuLLjJGehN = {
	message: "註冊"
};
var KbSjSRobgQmXjHChGKJ = {
	message: "至少8位，包含至少1位數字、1位大寫字母和一位小寫字母"
};
var TAFoyaQLwVzluFioqh = {
	message: "確認登入密碼"
};
var eChfcikkuQFNcZULZuP = {
	message: "請重複密碼"
};
var VnLNiYiOJxZraQxL = {
	message: "已有帳戶？立即登錄"
};
var bqNjZcEbCrAzOJJpJDn = {
	message: "總資產折合（BTC）"
};
var gTYMvovCwafJTrjdlKg = {
	message: "充值"
};
var PczYwMSUlifZlPdkNj = {
	message: "提現"
};
var DDrTONBZdHTEWHNFNgtV = {
	message: "一鍵交易"
};
var OkpDnVcVIcDyntNTMI = {
	message: "代幣名稱"
};
var EfVkywGLHyLgyrRjzg = {
	message: "代幣價格"
};
var NOIPqSfkgPcsNJnyAFA = {
	message: "代幣數量"
};
var WauyOiSpVDMamrXbLP = {
	message: "折合法幣"
};
var eXVsxwaBOXkkntIEGtC = {
	message: "下滑查看更多"
};
var EOmmDCycYoHFOZOV = {
	message: "币信號"
};
var ysjFKMhSQlIqXgPlz = {
	message: "已認證"
};
var TNkXPjSKdzQcBLZPsWj = {
	message: "未認證"
};
var FMUUecQmwAheUKwpq = {
	message: "可用額度"
};
var KSxzKkrfZaaHIOptelk = {
	message: "交易總額"
};
var IurrXFgATIlGAlejcf = {
	message: "增加額度"
};
var mUgsNHlLzyKVnxhVjRT = {
	message: "個人資訊"
};
var LcqaZGQKcdkxNrnIcK = {
	message: "幫助中心"
};
var zQsiOHqCsFIqBzNsf = {
	message: "設置"
};
var erLerUcELvDAcoUWi = {
	message: "退出登錄"
};
var TGYvVRioXBfDBtmCBpH = {
	message: "額度申請"
};
var cQKfBbUkEhBhPtPCx = {
	message: "請你提供盡可能多的收入/資產證明文件，以便我們為您批核更高的持倉限額。"
};
var SHjOXbqLUjZRUKsWMzD = {
	message: "選擇證明類型"
};
var mUuMBlRDyzHtFgLsivV = {
	message: "選擇範圍"
};
var ISJVpXHVtpoxunGygBGu = {
	message: "上傳證明文件"
};
var VGmDUnWBzMKfFbMKXyl = {
	message: "選擇類型"
};
var ZAhuzRDlLUTXhKrhhx = {
	message: "請上傳PDF或JPG格式的文件，並且文件大小不得超過5MB。"
};
var BggwtUciWOTxbdTdDg = {
	message: "添加"
};
var QFbYEdxUgXzRwcPFQDis = {
	message: "提交"
};
var UNForxvjDLCZdGrmWkX = {
	message: "取消"
};
var OCamqUckeIZshGlCbF = {
	message: "歷史賬單"
};
var YMfvOKmAFnfMwTXPfI = {
	message: "個人中心"
};
var nvfgxTKtdXdTEhFZf = {
	message: "多語言"
};
var HrHtlLjcEICrEnWiRA = {
	message: "由合格金融機構開具的資產證明"
};
var HIFNIcNDmIhRZEsgzSq = {
	message: "合格金融機構"
};
var KSyKpOAjkLSpCGns = {
	message: "其他"
};
var eUvzxeVvXrffrpEOrFrP = {
	message: "刪除"
};
var NqgOQEXQaHsramCnbX = {
	message: "上傳"
};
var YqzlhmIgzcgLnWmZhMsa = {
	message: "充值"
};
var FrzWGSiDSDzTfNgZH = {
	message: "返回"
};
var WYhIabGPkCnbVBIPcwW = {
	message: "選擇您需要充入的幣種"
};
var LFipKWcCwIamrrato = {
	message: "選擇幣種"
};
var RFoMDsIwGyJlPkuuxrON = {
	message: "選擇充幣網路"
};
var bpvYuERgedcoMzzLNl = {
	message: "選擇網路"
};
var NsvJYqLAVHAaWNUXAvz = {
	message: "請確保您已選擇與提幣平臺一致的網路進行充幣，否則將造成資產損失。"
};
var UbeafDPBCDfpRnQyWUjq = {
	message: "幣種/網絡"
};
var LbGVMqLVHqyddGmXzULS = {
	message: "重新編輯"
};
var qdnqxPdrpfdxhejrkCj = {
	message: "對低於0.05 BTC的鏈上充值，收取0.0001BTC的小額處理費用。"
};
var XYHinpRQuEPFjXMzLP = {
	message: "查看原因"
};
var LQNXJVNXqgqLimcQn = {
	message: "該地址僅用於%S%收款，轉入其他幣種將無法找回"
};
var nzLBdKgvNCXQTgYI = {
	message: "Memo標籤"
};
var iYpfkywMVpuafYnqXxGI = {
	message: "提現"
};
var DVjsSAdKoyNHoIqhumQ = {
	message: "選擇您需要提取的幣種"
};
var cxKcumOzANqjtQqREyas = {
	message: "選擇提現方式"
};
var BQkFfUTgzkweftGIpOLt = {
	message: "鏈上提現"
};
var FNNzRxnZqrKRYwIte = {
	message: "%S% - 鏈上提現"
};
var SultIciVtbYeZaII = {
	message: "鏈上地址"
};
var dGRvusBQRnbHUIYQRit = {
	message: "網絡"
};
var bJwUxepDjVzlNzKuI = {
	message: "選擇網絡"
};
var HlrghIZaaySLZjESwU = {
	message: "數量"
};
var TCuuXTtXBYeAldQkZp = {
	message: "最小提幣額：%S%"
};
var HYTGqldMNoESWJswz = {
	message: "可用"
};
var dkdmEAWTXMORUhlQaX = {
	message: "服務費"
};
var XwYKiJGJKAZZZpNp = {
	message: "支付詳情"
};
var swejTyFcYnjuUgsfQW = {
	message: "付款幣種"
};
var mWoxaQwwzwCFvWjRmK = {
	message: "付款方"
};
var tFaBUAWNRhJqtjIha = {
	message: "訂單信息"
};
var FEySNpPzdMqiOsZXI = {
	message: "鏈上提現"
};
var AIwKneHGNfSJmdLnG = {
	message: "訂單金額"
};
var wMGJlEJaupHayuzRwi = {
	message: "立即付款"
};
var iRiLJudagJVXZozmnz = {
	message: "當前金額低於最小限制"
};
var laRzOEpYMTvnZYRBZMnj = {
	message: "當前金額高於最大限制"
};
var MDhXYatnZcwvrjVeRh = {
	message: "您選擇的地址與幣種不匹配，請重新選擇幣種。"
};
var hDPPfPClruPeWrSoayR = {
	message: "內部轉賬"
};
var NTsLbMXwQdPYbmOwP = {
	message: "選擇您需要轉賬的幣種"
};
var POqloYgxpcTCqdnchGE = {
	message: "幣信帳戶"
};
var KxeaINzIsNNJmsIncnV = {
	message: "手機號/郵箱/UID"
};
var sfsygIDbANBoFslbcsw = {
	message: "轉賬數量"
};
var YgpFeXbXojsYnphM = {
	message: "最小提幣額：%S%"
};
var MutPBZAXykjaIurt = {
	message: "確認轉賬"
};
var GvnMmZJtuApdXwWhsFd = {
	message: "您當前暫未綁定GA無法進行此次轉賬"
};
var IcahwJmNfgdvVpPz = {
	message: "前往設置"
};
var bxtlucAfnIxfwBYAY = {
	message: "本次支付需要完成以下驗證"
};
var KKbVbDLheqewlSvBE = {
	message: "請輸入支付密碼"
};
var RLztZboedHACRMkjdD = {
	message: "請輸入 GoogleAuthenticator 驗證碼"
};
var QEaaELvQUvbfoIpje = {
	message: "如有問題，請聯繫客服"
};
var czSsfuZGitGjFRwLTF = {
	message: "幣信安全保護中"
};
var xrYEaiWUOcaNRQMIf = {
	message: "交易成功"
};
var QDuPlYKAxjAjIgyoAqM = {
	message: "立即兌換"
};
var ZkDBgJuvDUVQPOxBY = {
	message: "當月剩餘可交易額度：%S%"
};
var rJAhIVPUqedRmsfmj = {
	message: "買入"
};
var GpGpOkSHUzYBQNFc = {
	message: "付款方"
};
var aMdrNUxkhioFGrNGFIO = {
	message: "支出金額"
};
var siLEsPwfoiqGBiXjB = {
	message: "服務費"
};
var DYgqvlfmNbyLNOrWwc = {
	message: "%S%秒後自動刷新"
};
var rifKyRmlGZOwlJkDyZG = {
	message: "支出"
};
var aNVsLyHapaJbRxWnHsv = {
	message: "獲得"
};
var cQiCyvfOMMDJEIXyc = {
	message: "賬單"
};
var SywvArMjCuuGzTEtlJ = {
	message: "全部"
};
var vRyVKhBOPCmWYPPacY = {
	message: "外部轉賬-收款"
};
var GMOQAxsTvfWIEBANuS = {
	message: "外部轉賬-付款"
};
var xqLddTkVnCrEvxgKGso = {
	message: "內部轉賬-收款"
};
var sHqYaogVbbeWItJGb = {
	message: "內部轉賬-付款"
};
var xgIKqcGuTlutCTLLG = {
	message: "幣幣交易-收款"
};
var zsLweYcWjOwUgfyub = {
	message: "幣幣交易-付款"
};
var xUNmcszdZBWMTcxnI = {
	message: "含服務費"
};
var moirunBAysHLMEDtBxUt = {
	message: "轉賬詳情"
};
var YrkgVnAQcYRhGGRex = {
	message: "查看"
};
var iuOLeRpygvfPFDnf = {
	message: "類型"
};
var iuswsIRQwNAIuOzoFX = {
	message: "創建時間"
};
var sBFILAqpJhAnTLlpQ = {
	message: "交易哈希"
};
var eSLIwfCNWkIwJpqCHSVC = {
	message: "賬單詳情"
};
var RtWpXpLfhjeWPtKhcENN = {
	message: "身份認證"
};
var KveBVvOTiGXRKmAUQZz = {
	message: "充值詳情"
};
var XwmOjTtjNklQiLDgnjIB = {
	message: "系統判定該筆資金存在風險，拒絕支付！如有疑問請聯系客服！"
};
var GLIndpTHvNVRVWQuT = {
	message: "發送給"
};
var WzcUSFqDMdwkVtGoj = {
	message: "完成"
};
var kuTgfRDYzVZvEHrFtQ = {
	message: "郵箱驗證"
};
var gXbirwakdsaUKBglwK = {
	message: "複製成功"
};
var cTlSqXgGENkCAQQJCHx = {
	message: "6位數字"
};
var JsmDOHlXAmjSPqaxg = {
	message: "發送"
};
var yCCsuXAjuRzOLNxo = {
	message: "驗證碼格式錯誤"
};
var iizCYlpFHwQBzRyqLM = {
	message: "沒有賬號？"
};
var FbztGftxEQrszJntb = {
	message: "立即註冊"
};
var rteqizIYZXJwMWMenVz = {
	message: "這個郵箱還沒註冊，點擊去註冊"
};
var sydmFvhfSgzJVhtAud = {
	message: "這個郵箱已經註冊過了，請更換郵箱"
};
var aYdhyaHCqMJLweGFD = {
	message: "請閱讀並同意"
};
var SMEPVJNtMGWMrEceo = {
	message: "密碼格式不正確"
};
var jgXHbpNLgJMKuuZER = {
	message: "兩次密碼輸入不一致，請重新輸入"
};
var JWDRcPebwmpIhvJhVrJe = {
	message: "我已閱讀並同意"
};
var UtQJNokaxJhxqqTQDiO = {
	message: "《用戶協議》"
};
var TFAtjCZbFqacobpGxct = {
	message: "與"
};
var EokACCilfAZfuGcXD = {
	message: "《隱私條款》"
};
var UXURgENTpgxogbFAD = {
	message: "已有賬戶？"
};
var ElbSFPkaecjnmBToovei = {
	message: "立即登錄"
};
var LuigfaXzmPRCftdFOV = {
	message: "請輸入驗證碼"
};
var BNXHKONNlrkDGKwkXt = {
	message: "設置支付密碼"
};
var ltXrglJnxfNqZDSStFq = {
	message: "驗證碼"
};
var FClYxqPqiIjfTGZZthn = {
	message: "請設置6位數字支付密碼"
};
var cNmmUqRZfZDUxgWTQeXm = {
	message: "格式不正確，請重新設置"
};
var lKLpdmEuElAKKvltT = {
	message: "確認支付密碼"
};
var coPPHMNHpJdMYeKPskDY = {
	message: "請重複支付密碼"
};
var NovuNXyQGDRrjfyMs = {
	message: "註冊成功"
};
var bOSFxWykzVFerKLOiV = {
	message: "添加Google Authy"
};
var HfjMmDJQuBZXqFJUw = {
	message: "第一步：保存你的GA私鑰"
};
var SVTrmHtEOHifBpgPNCY = {
	message: "請妥善保管私鑰。私鑰是恢復GA認證的唯一方式，請不要向任何人洩露你的私鑰。"
};
var LmRHxJOIEHRnUwFSxEm = {
	message: "如何恢復？"
};
var gbkxEEkMTXuhYuUCZTJ = {
	message: "第二步：打開 Google Authenticator/Authy添加帳號"
};
var rQgPydQgDVYqtWJXCky = {
	message: "綁定成功！"
};
var nFSJqWAXBnxTngDNyoj = {
	message: "重設密碼"
};
var MThZOMtyoBvwpuodWEa = {
	message: "修改成功！"
};
var hiEgXdIbTRKrnaYJnNY = {
	message: "重設登錄密碼"
};
var PqkPSNBQJWOqaAsafW = {
	message: "Google Authy驗證"
};
var vHRZRztWvqyjjHCxW = {
	message: "驗證碼已發送至您尾號%S%的手機號，請查看"
};
var QZchoinPLbiohHfdnLU = {
	message: "金融機構名稱"
};
var gnOvqPVwTsPuWvBTXzI = {
	message: "文件類型"
};
var bDmdcJmdRsIZfYYBDeZ = {
	message: "申請成功，等待人工審批"
};
var YEPMktdEzwhrMMYKefX = {
	message: "月"
};
var wGSnhUtsHuueniKdYTwM = {
	message: "請填寫機構名稱"
};
var krMQcSEJDOnglqhrHgu = {
	message: "請填寫文件類型"
};
var erZFCFRNsVfSKVMRLN = {
	message: "男"
};
var dmeNSGPySLKtEpPGwG = {
	message: "女"
};
var czWbrtWmnCEbUCzVWzQQ = {
	message: "綁定"
};
var YATiezBAjBifZRNRVk = {
	message: "已綁定"
};
var sTMySyQXFMSuchwUXiJ = {
	message: "重設支付密碼"
};
var FxLhtNEexnBoJElMC = {
	message: "修改手機號"
};
var hYBHkTzZmueqvwJb = {
	message: "中國香港"
};
var GBvqxVjZVWwZtAPZgH = {
	message: "輸入手機號"
};
var KVLFziUaVDlFbnJzh = {
	message: "請輸入手機號"
};
var OQGpXlfSrBKFcwjAv = {
	message: "住址證明"
};
var AsfYVtpYWMjfUopLa = {
	message: "您當前所選的證件發行國家為："
};
var wZZutIhpaOoppafvh = {
	message: "請選擇"
};
var OUdBKfTzsTrdfcZmbCAI = {
	message: "遇到困難？請選擇"
};
var IwzxXaGfVvDNSxQpmeO = {
	message: "手持證件自拍"
};
var XzCcbOKjdfmcCnQLEwNj = {
	message: "審核被拒絕，請重新提交"
};
var IkToKVrxLaVfCKfNGvl = {
	message: "請填寫姓"
};
var mRtlyGWfQVnoeqMeTs = {
	message: "請填寫名"
};
var ldgxhAKPgZpGiyMyJw = {
	message: "審核中，請等待"
};
var mxKAuwcjmevMUSvDQE = {
	message: "審核通過"
};
var pSTKNwtZdcuFuoyTsPhb = {
	message: "請選擇出生日期"
};
var EkbLQeqmPtcNzItJWQO = {
	message: "請填寫常居地址"
};
var KzFzOytWXScqDRKFwg = {
	message: "審核中"
};
var MvJmrHwTdesvsHWH = {
	message: "驗證碼已發送至您的手機，請查看"
};
var bksAzarViFUYGzwAOk = {
	message: "人工審核中"
};
var EOLVYvzyNXSKoGmX = {
	message: "由於當前支付風險偏高，已進入人工審核，預計30分鐘內完成審核，如有疑問請聯系客服"
};
var EvOtSTBQrIYspwjQ = {
	message: "請填寫郵寄地址"
};
var eQHAVxHydpVhNAygOp = {
	message: "認證地區"
};
var LWInyMcYkagvzvaBfUHZ = {
	message: "該幣種外部充值必須同時指定【地址】和【Memo】標籤，否則無法入賬。"
};
var OKOogywrWeAjtQWF = {
	message: "手續費不足"
};
var MOtoFwFvpTtTEDVUD = {
	message: "餘額不足"
};
var ZdMOAZGAMXotVGVlKJ = {
	message: "幣種/提現方式"
};
var rEpbPaWEEsiOSTjOiSGL = {
	message: "輸入地址"
};
var SWVaRdViGfCBJhJNg = {
	message: "輸入Pubkey"
};
var lrCgiXeJcIwkuDsyc = {
	message: "鏈號"
};
var vyxYMhwwOspfcdpj = {
	message: "請輸入郵箱"
};
var MqMVsYdMMtqujWPKHW = {
	message: "請輸入uid"
};
var siEUrpaJmBIICzsaBnr = {
	message: "收款方"
};
var XGLKbSKPnzgwwZwEHu = {
	message: "請輸入郵箱驗證碼"
};
var DPFrIOWnjfRpVQHkhKJ = {
	message: "發送郵件"
};
var dTLgwTGGXjpsnLhrpr = {
	message: "交易類型"
};
var gZgeimlXmokhLdRziw = {
	message: "備註"
};
var xqhbTjIzOYuCUiHEUmd = {
	message: "交易ID"
};
var bbQJHoMWXkEHQuVRSsO = {
	message: "系統檢測到您的帳戶行為存在風險，請聯繫客服進行人工審核"
};
var HHdEPKdocehppzeI = {
	message: "請輸入"
};
var tICtqmzJVNeVfZQM = {
	message: "單筆限額"
};
var HOQBmfsmIsFBlsaJaSa = {
	message: "可用餘額最多可交易"
};
var XsOliEIHDkjKcghOik = {
	message: "賣出"
};
var ADXLpfHxGLEEMBBLjSL = {
	message: "獲得金額"
};
var kHAIwKLXztAgQxLOxj = {
	message: "價格"
};
var pqNxLtehgpuJIUBdg = {
	message: "確認交易"
};
var nodIQIicrpcVpCqYey = {
	message: "提交成功"
};
var gMjyScxabRhqehsX = {
	message: "為繼續使用服務，請確認您已閱讀並同意最新的"
};
var AQrCocFqoKoYieUnT = {
	message: "確認"
};
var COydGeEPULYaNAmN = {
	message: "站外轉賬"
};
var pFhbWEovZnvIiVEEJnme = {
	message: "站內轉賬"
};
var omUetmzxCLiTloCSalU = {
	message: "暫無數據"
};
var pqzdTKxlixAoAQwGy = {
	message: "幣信：易用又安全的比特幣、以太幣等虛擬資產交易平台"
};
var VihBsZgCPMgMJnwUeMLt = {
	message: "英文名（必填）"
};
var ohIqnNpSPiMOrWPSWk = {
	message: "英文姓（必填）"
};
var TGIiRSnHGjASSfzjMA = {
	message: "關於我們"
};
var jjFQYQyxRWGgKdjbaeB = {
	message: "NewBX Limited設立於香港，是幣信集團的全資子公司。 Bixin.com平台前身為HaoBTC，成立於2014年，旨在為用戶提供“易用且安全”的虛擬資產服務。九年來，Bixin.com服務用戶逾百萬，年交易量超過300萬筆，每年為用戶節省交易手續費185萬美元。\nBixin.com構建了完善的風控體系，實時監控異常數據，保障各業務環節的安全。平台通過冷熱錢包隔離、多重簽名、軍工級硬件加密機制，為用戶虛擬資產提供工業級保護，安全運營九年多，零安全事故。"
};
var VsuTZcfrgRHVvsOOY = {
	message: "關於幣信"
};
var PLhQWivTKyTYZvsNwMxj = {
	message: "立即體驗"
};
var ZLJlKTdDgntyZXzg = {
	message: "易用又安全的\n虛擬資產交易平台"
};
var pPqFjpMzSnmyNWXdT = {
	message: "始於2014年,一對一專屬客戶經理全程專業服務"
};
var aJpdCHYrgIukuVpHluT = {
	message: "穩定運行十年"
};
var olWnlFpnBjRnPCLuu = {
	message: "幣信擁有業內頂尖的安全團隊，搭建了完善的風險控制架構，實時監控異常數據，確保幣信賬戶安全、交易安全。冷熱錢包分離、多重簽名、軍工級硬件加密機制等技術，更是為數字資產提供銀行級保障。"
};
var ApYUyYTgQDVozNVGdoWy = {
	message: "強大易用的交易平台"
};
var MEuzpQOAySrMUyXj = {
	message: "我們為區塊鏈資產提供強大且靈活易用的工具，致力於讓每個人都能平等地持有、使用和管理自己的數字貨幣。產品邏輯易懂，操作體驗流暢。無需繁瑣的教程，用戶完成身份驗證後即可開始使用。"
};
var NkjUESwzghXjElHM = {
	message: "虛擬資產交易一站搞掂"
};
var GnugFlecXZohsDMgfjv = {
	message: "由轉賬到交易，幣信可以滿足你全方位的需求，並幫助你實現一站式操作。幣信在不斷鞏固現有功能的基礎上，也在開發更多高效、實用、有趣的功能。"
};
var nwsbWCYbSYugmHDgHTAB = {
	message: "多種方式 一站交易"
};
var gphdXFLzIrPxMQrAp = {
	message: "全球通用 全民適用 全方位服務"
};
var toUaeInrwbWVqvGGGX = {
	message: "風控嚴格"
};
var gVAFPuXrrstpWxRF = {
	message: "多種風控手段\n保證你的資金安全"
};
var AowuwjwDLrAJJKuVzCA = {
	message: "便捷易用"
};
var TfmLyYqIoASEGHkuRa = {
	message: "身份認證"
};
var tjuWuhQfpwDJLMscdbI = {
	message: "KYC認證 活體人臉識別"
};
var KewXLZFbuyWsCSbvXi = {
	message: "立即兌換"
};
var vQphyNqvokPAiFdfRR = {
	message: "NewBX Limited設立於香港，是幣信集團的全資子公司。 Bixin.com平台前身為HaoBTC，成立於2014年，旨在為用戶提供“易用且安全”的虛擬資產服務。九年來，Bixin.com服務用戶逾百萬，年交易量超過300萬筆，每年為用戶節省交易手續費185萬美元。\nBixin.com構建了完善的風控體系，實時監控異常數據，保障各業務環節的安全。平台通過冷熱錢包隔離、多重簽名、軍工級硬件加密機制，為用戶虛擬資產提供工業級保護，安全運營九年多，零安全事故。"
};
var ZbQsLkbfHUtbznnzU = {
	message: "用戶協議"
};
var TsnjCIOPEKKCCfrIF = {
	message: "隱私條款"
};
var qyKlEsEkyTXybgIHcI = {
	message: "幫助中心"
};
var VZexjbUhosOUoUTI = {
	message: "幣信集團"
};
var jDRHFidXonxhhPKaTl = {
	message: "易用又安全的"
};
var CInUOzoFKTOMvMbix = {
	message: "虛擬資產交易平台"
};
var fTbsMnhpZYjiOkAdex = {
	message: "多種風控手段"
};
var yOZzgRmKudbwNjuurBHz = {
	message: "保證你的資金安全"
};
var lelamaRhejmRBJOD = {
	message: "Bixin.com構建了完善的風控體系，實時監控異常數據，保障各業務環節的安全。平台通過冷熱錢包隔離、多重簽名、軍工級硬件加密機制，為用戶虛擬資產提供工業級保護，安全運營九年多，零安全事故。"
};
var pZxEeOQMfyGXKTBxtyJ = {
	message: "全球通用"
};
var ZGyanZavgObBeqhP = {
	message: "全民適用"
};
var oeMZNyLdkPQdxrobojO = {
	message: "全方位服務"
};
var MYuuWNTVQwjCeRRGl = {
	message: "NewBX Limited設立於香港，是幣信集團的全資子公司。 Bixin.com平台前身為HaoBTC，成立於2014年，旨在為用戶提供“易用且安全”的虛擬資產服務。九年來，Bixin.com服務用戶逾百萬，年交易量超過300萬筆，每年為用戶節省交易手續費185萬美元。"
};
var yrlrMPLgOtiEzbmPW = {
	message: "正如幣信一貫倡導的"
};
var EzMbHhWUJOaBMLDRJxZ = {
	message: "餘額"
};
var hQRkbssUXUGGLhtxc = {
	message: "資產"
};
var eDwDkAgbfaPsnwOb = {
	message: "交易"
};
var AVWJwkijUTbNMShmp = {
	message: "帳單"
};
var wEEzjRnoOftKrGIPbix = {
	message: "完成身份認證，以正常使用所有產品功能"
};
var NqoduOnqIqJtrjajas = {
	message: "資金賬戶資產折合（BTC）"
};
var vLUFWGhkoIBWnOMA = {
	message: "交易賬戶資產折合（BTC）"
};
var tjsCbqUvgNvcdRqdDp = {
	message: "劃轉"
};
var zBceLwpDLhGkPRkvbU = {
	message: "交易"
};
var udmfKDblDABqFbQPK = {
	message: "資金帳戶"
};
var AysRHzzIQTbjLUdgdaq = {
	message: "交易帳戶"
};
var KZPDAndezwXohlXxO = {
	message: "可用"
};
var hdPRTcCCnKbkxbRwgv = {
	message: "確認"
};
var pfVyzGgyXmkqtJpGH = {
	message: "交易模式主題"
};
var KRzStRHbmbrDbAUMnU = {
	message: "日間模式"
};
var lfLIpxDvOAXOplowzN = {
	message: "夜間模式"
};
var BiqzWayxveHNZGxaBa = {
	message: "漲跌顏色"
};
var CvvaFnujrEUnFHnWNb = {
	message: "綠漲紅跌"
};
var CNmFZyGboWXdpYPQDvxV = {
	message: "紅漲綠跌"
};
var OmOTUgBCsVHUoKutAD = {
	message: "可用餘額不足"
};
var DCXoQKoDcwNYuYivD = {
	message: "數量不能為空"
};
var ApeuvISiLLWNGQPrFrP = {
	message: "凍結"
};
var sCfZtZRTGxweYVxtEuoY = {
	message: "代幣總數量"
};
var VpbDUCnJRDAsPzfIkn = {
	message: "未完成訂單中的代幣數量"
};
var WfvaFuidVgEGCwnBEkl = {
	message: "所選幣種在該賬戶中沒有可供劃轉的資產"
};
var UheALJaSjOHgmVnoCrI = {
	message: "請輸入金額"
};
var fNFAnFLpEoAIoPfbh = {
	message: "劃轉成功"
};
var uUrUZzojXlsqxsuOJZTc = {
	message: "系統錯誤"
};
var CqNbVYlZNfwGfGTGRtE = {
	message: "支付單不存在"
};
var QgEerZTcSTdjtiTnKRT = {
	message: "支付單已過期"
};
var GnbMsiqoZbfmcDerQ = {
	message: "您無法向自己轉帳"
};
var nEgrtiBYldBKXkpKCocL = {
	message: "抱歉！支付請求拒絕"
};
var AJSlWSWYVQZSygnFKRsI = {
	message: "劃轉失敗"
};
var KzgGszjJLuRsOKsdkH = {
	message: "充值失敗"
};
var YmIZCYMTuGNvbocpiJOP = {
	message: "現貨交易"
};
var YixzEmijtHztNgwIE = {
	message: "價格"
};
var geVHcZlrpiEaagZcypgy = {
	message: "數量"
};
var SAruOCDnkHugkPOIFSc = {
	message: "金額"
};
var yteHSDpgaHMYFeMBfpWk = {
	message: "買入 BTC"
};
var slVffWcKrAhjpgaMEuY = {
	message: "高級認證"
};
var ghYLDApWJBxFOzhqAlN = {
	message: "開始認證"
};
var GCxKMtkKAZPoOHsZIDh = {
	message: "專業投資者"
};
var uRLAPBsurxBqxfvgaSH = {
	message: "您確認要開始專業投資者認證？"
};
var FaQaEHvLdVELQbCZrFN = {
	message: "根據香港證監會規定，個人專業投資者（Professional Investor) 是指持有港幣800萬以上的投資組合的高淨值人士"
};
var RZgUzTVRaXNflgjshVf = {
	message: "為了正常使用賬戶功能，請儘快完成身份認證"
};
var nXPQNJCVxPkQKidfjnn = {
	message: "個人"
};
var swSisSeZXWyUyMvIu = {
	message: "零售用戶"
};
var HryFxrLzCqTGOVNrpI = {
	message: "法團/機構"
};
var QqwNZKCLuiPIswItY = {
	message: "請先填寫預選表格，我們的開戶專員會儘快與您聯繫"
};
var gqfClfSZIJlpPGmuBjum = {
	message: "選擇"
};
var HMclPwyZgRMKnvBRCr = {
	message: "公司信息"
};
var iZKMHnInbVLuJJcbpbR = {
	message: "公司名稱"
};
var VYJdtiuPscmItOfIyux = {
	message: "所在地"
};
var sbzqRZRFyPyYqnsMtNy = {
	message: "網站"
};
var SwDoMzvfeChtJIrEA = {
	message: "產品與服務"
};
var pPViUnFnexhWKoFMx = {
	message: "是否金融機構？"
};
var NltNaOnxuMeUAbBeZ = {
	message: "是"
};
var HmXYHUAhkQnrZSfKu = {
	message: "否"
};
var KgKURwhHRUNpPmFtXTAv = {
	message: "聯絡人"
};
var thvmUblDYmiyVPacUB = {
	message: "姓名"
};
var ViAVfshtzuMNFpCqJl = {
	message: "職位"
};
var sSrzMRNSGNzrJsidBnYz = {
	message: "提交成功"
};
var wVSQKNQtitzmkbjDOac = {
	message: "我們的開戶專員會儘快與您聯繫"
};
var rvLRPuoiEpNqnbxwWj = {
	message: "個人認證"
};
var CRMoLKUrfyLkDWFEuSu = {
	message: "基本信息"
};
var GJOdwcCnvAbhzEkImJ = {
	message: "地址證明"
};
var pnGXcYRvktMyOUBwX = {
	message: "財務資料與資產證明（適用於專業投資者）"
};
var fQOFawXqhywMOGSe = {
	message: "測評"
};
var KIIMnxhTdJBhZfaEMP = {
	message: "投資風險取向問卷"
};
var hAacNWPacMHaAAaOw = {
	message: "虛擬資產知識測驗"
};
var aCtajuQWKCQNkeKgtwLb = {
	message: "專業投資者測評與聲明（適用於專業投資者）"
};
var XjTUjttgmruHnxFXgVf = {
	message: "驗證"
};
var ovsIpOdHmKskDqaansBG = {
	message: "持牌人/註冊人驗證"
};
var RawXxpklaPpnKkAjXLL = {
	message: "銀行轉賬驗證（即將上線）"
};
var dpnyHVmjzJjiqtQIfpD = {
	message: "認證"
};
var CtiOEevtmgSCxLlIqb = {
	message: "該國家/地區的服務暫不提供，請確認您後續身份認證的區域不在此國家/地區"
};
var HmoCuzIHcMwWJJxszus = {
	message: "曾用名"
};
var xoPXukoFZulOsawPoPe = {
	message: "國籍"
};
var FlbUChtSXKPaYQGW = {
	message: "如有疑問，請聯繫<b>support@bixin.com</b>。</br>\n或者，您可以在右下方客服機械人輸入「<b>人工認證</b>」手動提交包括身份證明、長期簽證、入境許可等材料。\n"
};
var XUWTeclWoXtMrQkJzuuq = {
	message: "選用電子結單和通知書"
};
var YCHRDIIKsDzJFQJw = {
	message: "強烈推薦您選用環保且即時的電子結單和通知書。</br>\n如您確認選用紙質版本，須支付100港元/年的額外費用，請聯繫客服處理：<b>support@bixin.com</b>"
};
var hfBBkSOAXqfEsLVFs = {
	message: "審核中"
};
var aETDJvQumPoQnxdEPkQR = {
	message: "了解更多關於<b>專業投資者認證</b>"
};
var zZXyblLWbONMNIjPmBN = {
	message: "審核通過"
};
var gyneoIYPeiHgfaCY = {
	message: "審核失敗"
};
var ihVcXhmbhwIbsPsTbF = {
	message: "CRS自我證明表格"
};
var ctaxFEnYnZIrAtOaYc = {
	message: "下載"
};
var tMlPwcyXKotAImFCGfQ = {
	message: "請填妥並簽署後以PDF上傳（不可超過15MB）"
};
var SRUOTyGYueLSOwlA = {
	message: "由合資格金融機構開具的資產證明（12個月內）"
};
var rpFnFNTJlMZaopFU = {
	message: "由合資格人士核證的資產證明（16個月內）"
};
var sMMYOeSUIvHuRdqiC = {
	message: "合資格人士包括公正機構、律師、註冊會計師等"
};
var fYiJCYMSTpHPjREdFLyB = {
	message: "投資組合證明"
};
var XzXwpEBzHGPNkUqaw = {
	message: "例如在主經紀商（Prime Brokerage）的資產證明、持倉和交易記錄等"
};
var YyrFTDoECNUvGnXVt = {
	message: "您的風險取向類型為<b>$s</b>，代表您不適合虛擬資產投資"
};
var leIEPguvvNFtRsXGFI = {
	message: "重試"
};
var yEMtEIJyJomPsTPTv = {
	message: "您的風險取向類型為<b> $s </b>，請您繼續完成「虛擬資產知識測驗」"
};
var EHBFEqMJtpPqVznA = {
	message: "您的測評未通過，請重試"
};
var IHceeEHwOOHjpdHosyOe = {
	message: "評分"
};
var kINzgREzBDTsegQCvHQ = {
	message: "恭喜，您的測評已通過！"
};
var ObVBBALqXaIzgsSPVQO = {
	message: "專業投資者測評與聲明表格"
};
var ckNnmPAbtNOsWqlpAKy = {
	message: "根據香港證監會規定，身分證明文件的見證，應由其他持牌人或註冊人、持牌人或註冊人的聯繫人士、太平紳士或專業人士例如銀行分行經理、執業會計師、律師、公證人或特許秘書加以驗證。"
};
var nmOEDJmAsIcTkCgZMv = {
	message: "請在完成驗證後上傳證明副本"
};
var jMXTehFeNbljMLGb = {
	message: "或者，您可以聯繫<b>onboarding@bixin.com</b>安排面對面見證開戶（僅限香港用戶）"
};
var ZbUUOchcpSOpwpIk = {
	message: "電子結單"
};
var lzbnQluepXRurDUf = {
	message: "月結單"
};
var xDfYpxodvMVDQJKav = {
	message: "日結單"
};
var XBrHgyrvVacGhRNJco = {
	message: "您可在此查詢最近12個月的月結單，如需更多查詢，請聯繫<b>support@bixin.com</b>"
};
var cXhPoUARLvRqvesHQqeu = {
	message: "選擇日期"
};
var tBDAaKFwVBeiyQnnTDIA = {
	message: "查詢"
};
var PuqWAcBQEKXlfTuxDuD = {
	message: "您可在此查詢最近30天的日結單，如需更多查詢，請聯繫<b>support@bixin.com</b>"
};
var yzrKsfyEambKetSgWv = {
	message: "財務資料與資產證明"
};
var NSkMpVyoVWGymUTOzL = {
	message: "專業投資者測評與聲明"
};
var JkoaUyCjjTHSNUEy = {
	message: "保守型 (低度風險)"
};
var LtnRgezlrxMzWvZBxRJ = {
	message: "中度型 (低至中度風險)"
};
var jXvqhJJMhyxRdxCxv = {
	message: "平衡型 (中度风险)"
};
var YZKOONeeIQMFqysxrZ = {
	message: "增長型 (中至高度風險)"
};
var nmicLlJCgyNNjjzKJUt = {
	message: "進取型 (高度風險)"
};
var BCZEHAhJNfTPwNSqVZl = {
	message: "其他（選填）"
};
var zIFzaxTFaAhTdPpeh = {
	message: "請至少選擇一項資產證明或投資組合證明"
};
var tdxbonOdGqBYgBaOjc = {
	message: "上傳證明副本"
};
var XondKWeJxfchfIoGLe = {
	message: "限額"
};
var ndyNHmtKJFFsefAzdv = {
	message: "限額為0"
};
var FeBXkTWnPLzGZEnXEpg = {
	message: "請確認您輸入的信息真實有效，且與證件信息保持一致"
};
var QZCxVURndUpletXFScR = {
	message: "請輸入必填項"
};
var UXOpXybkQBmLEHTAgw = {
	message: "帳戶類型"
};
var BslmwdHcTinuPaihULw = {
	message: "本風險取向問卷分為三個部分："
};
var jvnfqZRQbFEGTCMGbvT = {
	message: "<b>背景</b>: 第1 - 2題"
};
var NsZKEKPRgLQfWeSixA = {
	message: "<b>風險狀況評估問卷<b>: 第3 - 11題"
};
var icMsBwEbBUQztvmOv = {
	message: "<b>投資知識與經驗</b>："
};
var dXXdlICxETXaAzDyY = {
	message: "非複雜產品: 第12 - 16题"
};
var zhFTdPuxrgMfcNWoA = {
	message: "複雜產品（虛擬資產）: 第17 - 22題"
};
var pjPGNrHukGWKUheCaX = {
	message: "在做出任何投資決定之前，請考慮諮詢您的獨立投資顧問。"
};
var uglsZRLSLmmcqItl = {
	message: "對於聯名帳戶，本風險取向問卷應由所有帳戶持有人填寫，聯名帳戶持有人的集體回答將反映您商定的財務目標、情況以及財務指示方面的知識和經驗。"
};
var nPqFzGTyChvJyTQw = {
	message: "除非另有說明，本風險取向問卷將採用以下定義："
};
var mEPBGXtDbaIrisefS = {
	message: "<b>投資</b>是指價值可能波動的投資產品，包括股票、單位信託、外幣、商品、結構性投資產品、認股權證、渦輪、期貨、投資連結保險計畫或虛擬資產或其相關產品。"
};
var dBZfEFBQmkatfptbV = {
	message: "<b>風險偏好</b>是指選擇投資組合的整體方法，可能包括風險等級高於或低於您期望持有的產品。"
};
var jYUScsXfUCTPNPqSAR = {
	message: "投資價值可能增加或減少，甚至可能變得毫無價值。過去的業績數據並不代表未來的業績。應閱讀相關產品提供文件以了解更多詳細資訊。"
};
var OJjDmIeMWmMfkDihQu = {
	message: "本問卷中收集的個人資料將被保密。這些資訊可在保密義務下用於設計和/或推廣虛擬資產產品或服務。"
};
var JoPUjgxywPfIQlnDrzx = {
	message: "<b>重要提示和免責聲明</b>"
};
var ZVRKVLGoMmmrOxLzg = {
	message: "在完成此風險取向問卷時，您可以提出問題並聽取獨立建議。在您確認風險狀況後，本公司將記錄相應的風險偏好，並可能用於產生投資建議和評估產品對您的適合性。本免責聲明作為一項無罪聲明，免除本公司因本風險取向問卷中包含的任何重大遺漏、錯誤或虛假陳述而可能對我們提起的任何及所有債務、責任或索賠。我們在此建議所有參與者進行盡職調查，並對問卷的內容進行全面審閱。由此產生的後果，本公司不承擔任何法律責任。"
};
var HYklWTwhtonjbiQRYCz = {
	message: "本月未生成月結單"
};
var RsjGGXbMJbrislSlWM = {
	message: "您選擇的日期內未生成日結單"
};
var wEarLFdfZMShsSfacNU = {
	message: "白名單管理"
};
var eEcajuQQvABwGKndqss = {
	message: "管理充值、提現時的白名單列表"
};
var EfIjGkMogFrJyNKuWar = {
	message: "管理"
};
var JaPjOXJRPJqsTDLdU = {
	message: "請確保您的充值來自<b>白名單地址</b>，否則您的充值資產將會被凍結"
};
var cuKtQbYgXOwLPEbN = {
	message: "您只能提現到白名單地址，請先<b>設置您的白名單</b>"
};
var BVmyvtMVCbAJXhwSpT = {
	message: "暫無地址"
};
var NRUPVKxKVtYaCDVPq = {
	message: "您確認要刪除該地址嗎？"
};
var szgmmxxDYVvTLNzPkk = {
	message: "新增地址"
};
var mJjedBCPidtXUCYHus = {
	message: "非託管錢包"
};
var IIbmROzHEYCycsCyk = {
	message: "交易所"
};
var knoGdfgXpoVeAMqHCXu = {
	message: "已驗證"
};
var SBLHeXGlsYVIdiBNRe = {
	message: "驗證失敗"
};
var AocjyYzlYgRsGzlavU = {
	message: "地址"
};
var wQEsyNYfqlFrkqUvaDx = {
	message: "狀態"
};
var rbefbFgPVyawmaktVYF = {
	message: "操作"
};
var MjEyxNUcFsFMIjsOIDpg = {
	message: "自定義名稱"
};
var ygnbLzvTAMIylzNxj = {
	message: "選擇網絡"
};
var peIDsRhrNLVzQmAQWg = {
	message: "輸入地址"
};
var BbqJaDHRCDmiNwNVcGB = {
	message: "驗證地址"
};
var LESgEuOUJYjZQYLUlO = {
	message: "簽名驗證"
};
var hsgIRJDqXwkPnsmgktga = {
	message: "小額轉帳驗證"
};
var mDlqsQlmoApWZXHKLq = {
	message: "交易所名稱"
};
var DjgcgdUJtoNmqshNSb = {
	message: "請向以上地址轉入<b>$s $s </b>以驗證該錢包歸您所有"
};
var FxlLNwkBHAbChJrnM = {
	message: "我明白我需要完成小額轉帳以驗證錢包所有權"
};
var NuZslGbiHniUKgycjhmv = {
	message: "連接錢包"
};
var AdLFmhSQGMGYrTgXdUH = {
	message: "已連接"
};
var rQiWsAGGRmEQCtfaIK = {
	message: "簽名"
};
var HjfxCIPqXHVRBXeofOe = {
	message: "等待簽名中……"
};
var CwyRzEeuIMzGRVzVdSVg = {
	message: "簽名驗證中……"
};
var MgdMcyuZEloUdpqcv = {
	message: "簽名成功"
};
var yKqxJEvOxokRNAPXYDZC = {
	message: "簽名失敗，請重試"
};
var FIvibwVWwddLxzofT = {
	message: "重試"
};
var HQLJuhRwbVdfCwEp = {
	message: "安全驗證"
};
var irXsKkZagNKDlvCyhKYK = {
	message: "支付密碼驗證"
};
var RQJGnpiCuJKbplbuWeaj = {
	message: "驗證通過"
};
var ULhbQlNBpFJzLTlp = {
	message: "密碼錯誤，請重試"
};
var DmecbpJQgGJiVjTqP = {
	message: "請輸入支付密碼"
};
var qltXLGplQJNtHWdY = {
	message: "成交單據"
};
var vamuznzHAJqilfEEP = {
	message: "關閉成交單據提醒的風險確認"
};
var oGNuorHWcxXehehzCno = {
	message: "請注意：关闭成交单据的提醒，您可能會面臨更多風險，例如：您的账户将有可能在被黑客入侵或被执行未授权交易时，未能即时发现并采取必要措施而导致资产损失，或對影響您投資的市場變化的認識有限。</br>\n\n<br>请定期檢查您的帳戶並尋找其他渠道以隨時了解情況。如有疑問，請聯絡我們的支援團隊support@bixin.com。</br>"
};
var pFjSwsuOrRtiguvbEc = {
	message: "本人確認並同意不收取有關成交的通知，並自行承擔一切因此變更引發的風險或損失。"
};
var VZMtxSlhbTKcmTYeEsW = {
	message: "待審核或未能驗證來源的資產。如有疑問，請聯絡客服 support@bixin.com"
};
var ivAXIbjvUUQpQqpmXz = {
	message: "消息通知"
};
var thJZdZfDKDEFyETsPyzj = {
	message: "未安裝"
};
var mrdEVkqkBIuEBVzzL = {
	message: "地址名稱"
};
var JWctZqDXJyyraLbOe = {
	message: "如果您選擇簽名驗證，請在PC端登錄www.bixin.com > 點擊賬戶頭像 > 賬號與安全 > 白名單管理 > 新增地址"
};
var rXWcwotndeKQsLjAdyrw = {
	message: "輸入英文姓"
};
var ZuxEmUvBYSsOHORKrFrd = {
	message: "輸入英文名"
};
var TfIbvRVtJxzInjuIwq = {
	message: "英文"
};
var YBvzRbRVqKkwTDkNDfoc = {
	message: "聯絡我們"
};
var pJTXUuIjycHTetIC = {
	message: "您填寫的姓名應與您的賬戶姓名保持一致"
};
var razdiXXHIkQKbPQTZn = {
	message: "綁定手機號"
};
var WCGnQDmVyXVqLZPQyqYs = {
	message: "驗證碼已發送至您尾號$s的手機號，請查看"
};
var NgUCFdNkwlZfzWkAiv = {
	message: "為確保您的賬戶安全，請使用手機號驗證登錄。"
};
var sdgZycbHzMUKHwVH = {
	message: "請先綁定您的手機號："
};
var xQtzLCbkmmYpqCXOwRT = {
	message: "請驗證手機號碼"
};
var rKSrOqgimgcTrDutYUA = {
	message: "用途"
};
var nFlxQWOJCGHgwwHQhP = {
	message: "請確保與您交易所賬戶的姓名一致"
};
var sMvNZNODlnAIiuzFMR = {
	message: "1. 請提供截圖顯示包括交易所名稱和logo、您的賬戶名稱和聯繫方式等關鍵信息"
};
var RrEKjSeFQrtvLrZIO = {
	message: "請以PNG、JPG或PDF格式上傳"
};
var QnjpooahLXRwxGqJIVt = {
	message: "2. 請提供截圖顯示您在交易所相應幣種的充值地址"
};
var qZljkUmjmSBKpnUsYfp = {
	message: "我確認我是以上交易所賬戶的所有人，且提供的資料真實有效。如存在偽造、欺瞞等不實情況，一切後果均由本人承擔。"
};
var kjqqAmIhgKSjlBVQx = {
	message: "公司法定全名"
};
var WfJRbDGlqfLFvNVzyWu = {
	message: "請確保與您交易所的賬戶名稱一致"
};
var wgbBNytjmVvMvqRkRL = {
	message: "待驗證地址"
};
var pXHPsbEpWSnCyJGH = {
	message: "充值失敗，已凍結"
};
var CRbVirgSccJqKzSUSEau = {
	message: "如有疑問，請聯繫客服<b>support@bixin.com</b>"
};
var FgrxZUNDleeDGneKmwd = {
	message: "更新時間"
};
var uJpZAZRdzpyAaUkEqwSx = {
	message: "如果充值來自非託管錢包，請確保該錢包在充值<b>白名單地址</b>；如果充值來自交易所帳戶，您需要在充值後<span>驗證地址</span>。否則，您的充值資產將會被凍結。"
};
var elXgEtyDNXczWYbDHV = {
	message: "交易哈希"
};
var LiwpXDoMAXANnTRZ = {
	message: "2. 請提供截圖顯示您在交易所完成該筆充值轉賬的交易明細"
};
var wfRBtzUHBPZjVDxUc = {
	message: "該手機號已被佔用"
};
var xrfefvhsEfCoJokIdeW = {
	message: "您至少需要選擇一種用途"
};
var gapTtWntRtJcQzRtBz = {
	message: "上傳交易所賬戶所有權證明"
};
var NhBzijnKrdihICUwgi = {
	message: "法團/機構開戶表格"
};
var PdxWoNDxKAJmNcpe = {
	message: "請填妥並簽署後以PDF上傳"
};
var AHMRWIOaHFIWiIPqUx = {
	message: "恭喜，您的審核已通過！"
};
var LDNvolWeNGwNyvpTMnL = {
	message: "您的審核未通過"
};
var uYLqhJrdDgRVWcNvDpr = {
	message: "如有疑問，請聯繫開戶專員<b>onboarding@bixin.com</b>"
};
var ZnbyJyzHTxzgLRDFBmEm = {
	message: "個人資料"
};
var FTVpPZybylBmTnwhMhtx = {
	message: "請確認您已備妥開戶所需填寫的資料。可參考<b>個人客戶註冊表</b>"
};
var THMxZAxLcuuIfPErpGb = {
	message: "名"
};
var bTWntlsiiBougPgd = {
	message: "姓"
};
var zIgntQSydRspYJCaQ = {
	message: "曾用名"
};
var vPVjNqmPYGCrexspl = {
	message: "選填"
};
var oMgGPGaGAlElFewgOv = {
	message: "性別"
};
var iqCHKgJKHatuZHiXEFm = {
	message: "男"
};
var dHIzNCfEthjGsjpMsfJN = {
	message: "女"
};
var VALtZMIyzODbkpPUOsxG = {
	message: "證件類型"
};
var OOtkDwkZMvTavtRmc = {
	message: "身份證"
};
var bRDTmhggLlBbrbdtfhM = {
	message: "護照"
};
var IzXQAIEgQLMYmZwrzP = {
	message: "證件號碼"
};
var xjuVMsJZTRgjPgAzSV = {
	message: "證件發行地"
};
var WACiElgvWMUDhQMxa = {
	message: "國籍"
};
var USZqODoQgzwaggnbb = {
	message: "出生地"
};
var KChGPohSmJORAMDUqSs = {
	message: "出生日期"
};
var oGZZfIIocJcraogK = {
	message: "職業"
};
var pAYXQPFeRbuYruZa = {
	message: "就職行業"
};
var aaOdxWUHHLynEVSoWTM = {
	message: "就職公司名"
};
var jSQVlHGDwxAZujRJNiSh = {
	message: "交易目的（多選）"
};
var uuluQlsJBdDsslsERZX = {
	message: "請闡述所選項（300字以內）（選填）"
};
var ACweJQrKoWgpyYspyEl = {
	message: "所需產品/服務（多選）"
};
var JLIvWEpTgjlkpsZBM = {
	message: "投資"
};
var UfkUhznLfeqzZyTdAebx = {
	message: "交易（虛擬資產交易）"
};
var FxzVGfjClbeUZeEero = {
	message: "其他"
};
var WjPizXTxbdPnvLWMql = {
	message: "請說明"
};
var ytFXzDnzPIGUhOOClJ = {
	message: "虛擬資產交易"
};
var dWHEObNDvkCjTnlvH = {
	message: "多幣種虛擬賬戶"
};
var lfjjwhqpvFBikfhkifrN = {
	message: "財富來源（多選）"
};
var gGrAIKLFJuNxbjhnZz = {
	message: "就業收入"
};
var trJoqkSnMVAvbRgAY = {
	message: "商業收入"
};
var CyNhoDlSuMvcxydtF = {
	message: "繼承/贈予"
};
var dpvvLNDzKxLZIuixW = {
	message: "租金"
};
var cYSzpXPrPUQxaAGTihK = {
	message: "產權出售/投資"
};
var kYGDyxESdKUNNTdG = {
	message: "預估淨值"
};
var UqNGOztCBezyeAgI = {
	message: "少於100萬港幣"
};
var TWuwXEwzngPlnjELUJ = {
	message: "100-800萬港幣"
};
var AUNMAupfnBRbGlrb = {
	message: "800萬港幣"
};
var EqpPTPZsKjTArTFVgWp = {
	message: "800-1500萬港幣"
};
var oiSDCKooPzMznfGteAG = {
	message: "超過1500萬港幣"
};
var DSFAJhsSefQQEdBBlUyt = {
	message: "資金來源（多選）"
};
var aaKDUKbsmRiynWiqlS = {
	message: "個人儲蓄"
};
var eDeADqoJRnEUGotYxzY = {
	message: "出售房產/資產"
};
var CDwWwMbhHZXYRMZHKnpO = {
	message: "家人/朋友"
};
var fjjnxDoEsAfrEGSbNUL = {
	message: "年收入"
};
var qqXTaCjhvvMrmeJpPG = {
	message: "少於50萬港幣"
};
var RMCuKzWRRjQNKUNP = {
	message: "50-100萬港幣"
};
var qipDilqNVyHfNJVyF = {
	message: "100-200萬港幣"
};
var CuzRRZhhkOmuQgeVt = {
	message: "200-300萬港幣"
};
var VoqaSnQNOfXstSBxca = {
	message: "超過300萬港幣"
};
var ZCRfudjxgEkJLycN = {
	message: "預估月均交易額"
};
var tdxlCkYgrpQOxYYJZiF = {
	message: "少於1萬港幣"
};
var RZiGRHwDUpYgJcRLRnxa = {
	message: "1萬-10萬港幣"
};
var aXbxDDurboZtvnPno = {
	message: "10-50萬港幣"
};
var OUDeIeQIjCliBQIHe = {
	message: "50-100萬港幣"
};
var AbrPzuZLAZwUuIBnbx = {
	message: "100萬-1000萬港幣"
};
var JJAtBenOLOlFaFaP = {
	message: "預估月均交易頻率"
};
var YWCMpmGuparutCzjXpp = {
	message: "按需交易"
};
var aCYhhkYhhIrzUQvFB = {
	message: "少於10筆交易"
};
var sVTrHBZPprcyXLgcE = {
	message: "10-20筆交易"
};
var oGHfMwDNMhRcKszx = {
	message: "多於20筆交易"
};
var hYWPDZZNtYYwiYMfUfjX = {
	message: "您或任何關聯方"
};
var NIxMpJepTIBNynamgjj = {
	message: "是政治公眾人物（PEP）嗎？"
};
var onaIGydLoNFhYUGyo = {
	message: "是否與政治公眾人物（PEP）有關？"
};
var nkENghGiqpNyJlRpBv = {
	message: "PEP官方職位"
};
var eEBDsqLdNoLOJxjVc = {
	message: "在職時間"
};
var SJBETCfUKQwBPbOwXhs = {
	message: "PEP姓名以及與其關係說明"
};
var TbviyxwhVLMOhttn = {
	message: "请确保您的证件发行地与后续的地址证明地区一致"
};
var SFeLOdYxYJLeOgLtZI = {
	message: "預覽"
};
var IKImbOtCOwEOtcDsMLv = {
	message: "關聯方是指："
};
var woYYXxIEUCPOPTbYi = {
	message: "<br>就法人（合夥企業除外）而言，是指在該法人中擁有執行權的任何董事或任何自然人；</br>\n<br>就合夥法人而言，指任何合伙人或經理；</br>\n<br>就法律安排而言，是指在法律安排中擁有執行權的任何自然人</br>"
};
var XVImLdGTpJvSndfrLlee = {
	message: "機構賬戶"
};
var ylhkcCPZqNeskQBJB = {
	message: "法團帳戶"
};
var gLehflpqCNwIhEtbYIAz = {
	message: "公司法定全名"
};
var BEfhHOirsmwpDEilDbq = {
	message: "公司註冊地址"
};
var WzIAmgVLQnPRHGRfGw = {
	message: "主要營業地址"
};
var zcamcMLRNetHERtiy = {
	message: "所在國家/地區"
};
var NStCDznwhsZPGYrJAq = {
	message: "電話號碼"
};
var pucEyENFLLeSzsJUK = {
	message: "大於1000萬港幣"
};
var EqbYvDbdIrmgXbrPPAO = {
	message: "<b>如果您之前對以下任何一個問題選擇“是”，您可以透過向 <span>support@bixin.com</span>提交證明來申請豁免本測驗。</b>"
};
var pyuZUzzDPovDumukD = {
	message: "<br>a. 曾接受銀行、金融機構和/或專業機構提供的虛擬資產訓練或課程；</br>\n<br>b. 任何虛擬資產的交易經驗（過去3年內進行過5次或以上交易）； 或</br>\n<br>c. 目前或之前有與虛擬資產相關的工作經驗</br>"
};
var xxgsgyEjhfwrMflwMr = {
	message: "了解更多"
};
var PVcSgRlruKdhLYAvMUG = {
	message: "100-400萬港幣"
};
var BIVIQEHEPCzGuQpNKSR = {
	message: "400-800萬港幣"
};
var GhRAIjbecBWjePTjqSD = {
	message: "FATCA聲明表格"
};
var qsVtkTgbKcuLSPDXf = {
	message: "查看"
};
var WINbdlmnRMSyZUqkxCP = {
	message: "個人認證教程"
};
var bnpgtsIPDfFydCQlTH = {
	message: "剩餘充值額度"
};
var BgXkLkPusAcJBiUmSw = {
	message: "剩餘提現額度"
};
var OARZuIqYLXtlrvaEsC = {
	message: "法團/機構認證教程"
};
var YLJxFxxsgqpWcZWy = {
	message: "請掃描下方二維碼或手動輸入私鑰"
};
var RjPDzDdrzBcLHVJiG = {
	message: "剩餘提現額度不足"
};
var DrmqiYKPSoxMBWXT = {
	message: "FATCA和CRS自我證明表格"
};
var nSdDtaHzknwZAXJHzrGP = {
	message: "添加驗證器"
};
var NZjrOkmPAHtiaMLyuVDA = {
	message: "或者，您可以選擇面對面見證開戶（僅限香港用戶），我們的開戶團隊將儘快與您聯繫"
};
var XfjZomFsTRpbZJuHjI = {
	message: "請聯繫我安排面對面見證開戶"
};
var lxppTPAJDxxMIGdmiRG = {
	message: "請選擇一種驗證方式"
};
var OljlLKYobPynbcStGlN = {
	message: "您只需選擇一種驗證方式"
};
var YXrqAGUqprWfOCeiSGX = {
	message: "審核結果將通過郵件通知"
};
var MkfqKEzRwLTbzJEOeWg = {
	message: "我們的開戶團隊會儘快與您聯繫"
};
var vshrtYQXEVpbXmLZwV = {
	message: "請查收郵件"
};
var wINMfXpJczhYZOnUXWp = {
	message: "請輸入Google Authenticator/Authy 驗證碼"
};
var uetkXvxfFuKnhpBFrA = {
	message: "谷歌驗證器"
};
var sZVlKBQCGGTVChpa = {
	message: "Google Authenticator/Authy驗證"
};
var AZVALNHESdbXtHmNY = {
	message: "閃兑"
};
var pVQoQWJNGEfRwmpZMki = {
	message: "支付"
};
var HsxgqsfmdLnIcdcXgLS = {
	message: "獲得"
};
var gohHRZTjodstzoCLNv = {
	message: "可用"
};
var rfXBETBheWYaMqrktE = {
	message: "兌換率"
};
var rxfIffMgcmDGmXfVZA = {
	message: "兌換率為預估值，實際得到的數量以成交時為準"
};
var ifmHgobawgqPHdruP = {
	message: "預覽兌換"
};
var AkLeJkGIGPcgMPOyMJvd = {
	message: "最大滑點"
};
var SLZgFNtUooxfLTcXEnm = {
	message: "自定義"
};
var APOikjpbuiZXwYbMlWBl = {
	message: "如實際價格在不利方向上超出最大滑點範圍，兌換可能無法全部執行"
};
var pEZOQJSBxlCYyrjM = {
	message: "滑點範圍較大可能導致更不利的成交價格"
};
var IKLXXpDUJHlgctnhc = {
	message: "當月剩餘可交易額度"
};
var GSkKAUsvGPYZMAnFnH = {
	message: "保存"
};
var HIptAJwjtWvHteUhwW = {
	message: "選擇幣種"
};
var ETkemdVBXuBSBAstv = {
	message: "確認兌換"
};
var fUqbBtyQPrkRchcpe = {
	message: "手續費"
};
var wprsRqdyQRGnVcbsp = {
	message: "該報價已過期，請刷新"
};
var zDKhBsXavFMPAEqgdH = {
	message: "刷新"
};
var PpelPkXnzahxkdhVa = {
	message: "兌換處理中"
};
var XvACoEmpLFSLVHywT = {
	message: "您的資金暫時被鎖定"
};
var hhiTSbgqtfHswnyfCs = {
	message: "兌換成功"
};
var jwkMtTwNHEktKLQA = {
	message: "兌換失敗"
};
var aTPVtxAhNeuzjutYgu = {
	message: "您的資金將退回您的資金賬戶"
};
var CSMPJDQZLtdBrHSlRhzp = {
	message: "設置滑點"
};
var OYByrRpUomOXEqORBozE = {
	message: "兌換"
};
var pQEEhEzMgmLpEznsEH = {
	message: "資產名稱"
};
var HNUebnMoRCmoPDEpASH = {
	message: "價格"
};
var ARCAktOTCiLqQqaPTv = {
	message: "總數量"
};
var LJPMiQOhqtJqlBRBCHX = {
	message: "銀行轉賬驗證"
};
var lvouKixXkMbDqOnnr = {
	message: "其他驗證方式"
};
var FRjQUDLIESvWvPOQY = {
	message: "通過向Bixin.com銀行賬戶單筆轉賬不少於10,000 HKD（或等值USD）以完成開戶驗證"
};
var JNPXLHStukWLfpLRU = {
	message: "第三方持牌人/註冊人驗證；或與Bixin.com開戶團隊面對面驗證"
};
var dQRnMUSMOEdAwdfMqW = {
	message: "請您以本人$s $s名下的銀行賬戶向以下Bixin.com的銀行賬戶轉入一筆<b>不少於10,000 HKD（或等值USD）</b>的充值以完成驗證，否則可能會導致延遲到賬，甚至退款。如果金額不足，也將導致驗證失敗並退款。"
};
var cHodlBcOiNHOlxFn = {
	message: "了解更多"
};
var tglvvZIzjMuxIoXEYs = {
	message: "目前支持銀行轉賬驗證的"
};
var yDGXBsHUIoIkgqfepe = {
	message: "目前接受的充值貨幣是：HKD或USD"
};
var lsdjJQPYPEOcAzVOth = {
	message: "請避免向平台充值不支持的資產，否則將會退款，由此產生的退款費用需要您自行承擔。"
};
var PlIgEPTbgrrwkSuHc = {
	message: "銀行名稱"
};
var NqhjvGQWWHnmAzDH = {
	message: "收款人名稱"
};
var QNEAoNoQfTpYIxJvjdM = {
	message: "賬戶號碼"
};
var MhWCMBfnPEmyPhdBJC = {
	message: "銀行編號"
};
var rcbvwVBVHsJazGKrQv = {
	message: "SWIFT代碼"
};
var HsYTxsCouoyySItw = {
	message: "銀行地址"
};
var CNXhqxsuJtAEOpHCSI = {
	message: "上傳轉賬憑證"
};
var iQYmhTkvoynVhdKfkY = {
	message: "請在完成銀行轉賬後，上傳交易憑證"
};
var lLKoAhJqRLmDyyTCvO = {
	message: "PDF或JPG格式，不超過5MB"
};
var bNcNiQWtnacHBQFyTY = {
	message: "超出最大交易數量"
};
var JIozcUyGaPUboZLlBjVN = {
	message: "未達最小交易數量"
};
var tNbQTPYLVCKjsvpja = {
	message: "月交易額度不足"
};
var UrkVGOIalMNhKwpIEzK = {
	message: "法幣充值"
};
var cCtaFICzFmzJltYPL = {
	message: "選擇扣款賬號"
};
var SVpHROUKzBJsjSVHMK = {
	message: "添加銀行賬號"
};
var UMTZPjOpYZuhdhDbBVO = {
	message: "第一步：請您從已選擇的扣款賬號向以下Bixin.com的銀行賬戶充值$s"
};
var iBQIPIJCNFHBCeRIvm = {
	message: "單筆最小充值限額："
};
var nedDtIXJkIrvdDqe = {
	message: "請提供您銀行轉賬的交易憑證。審核通過後，您的充值將完成入賬。"
};
var xWhLpCcRjLgSplng = {
	message: "第二步：上傳轉賬憑證"
};
var DZjgiswpELVABBqUWCSa = {
	message: "銀行轉賬"
};
var XrngZedCHgJUKulaDcT = {
	message: "選擇收款賬號"
};
var fWgPNysKDTLrzjgrexk = {
	message: "輸入提現金額"
};
var QIzonbZxYqJjQrPHfJM = {
	message: "最小提現額"
};
var iHptEcwFnEbHVLaQkXyb = {
	message: "手續費"
};
var uUpDUGTUrKdXVQXkgSP = {
	message: "提現手續費不包括銀行收費，費率以具體銀行為準"
};
var HzbSujYkGuYtObRcrdbh = {
	message: "手續費不包含在提現金額中，將從您的賬戶餘額中扣除"
};
var NOYdleknddFOfQxlNOI = {
	message: "提現金額"
};
var nqPKzhAfSmqRRIHii = {
	message: "法幣提現"
};
var eOPHosimYamraEKUukBz = {
	message: "確認提現"
};
var LoBOFhdSzMFjdqZgDE = {
	message: "收款賬號"
};
var mHVIpiFPJQPNPFYAeeu = {
	message: "請確認以上信息準確無誤"
};
var TNXdbUElFLwiyRVKuJ = {
	message: "審核成功後將為您安排銀行轉賬，請注意查收郵件通知"
};
var wLQWZKMRgmTJTSudW = {
	message: "管理賬號"
};
var GkvuBozDTWJAXbpwyP = {
	message: "虛擬資產"
};
var IMxXGyWWPXtfrrwxV = {
	message: "法幣"
};
var tibiqQyzvztLFMGQ = {
	message: "法幣賬號管理"
};
var fXTeVLzGkVECTSGgtm = {
	message: "新增帳號"
};
var XYVTanLxxisBNzaOFx = {
	message: "帳號"
};
var bdAMbKWoEuDxlGOg = {
	message: "暫無賬號"
};
var ALJjPGCRLTrnWlbmqO = {
	message: "請確保是您本人名下賬戶"
};
var znOXnaDhTySukBeCrT = {
	message: "請確認您是否已使用以上銀行賬號完成KYC銀行轉賬驗證？"
};
var ESHCFsWVeQAWSnEKV = {
	message: "後續您需使用該賬戶向Bixin.com的銀行賬戶存入不少於10,000 HKD（或等值USD）以完成驗證"
};
var lLAJPCrarwsWDdbLaw = {
	message: "搜索幣種"
};
var biXQrrlOVDoExCZZKC = {
	message: "設置成功"
};
var spot_trading = {
	message: "現貨交易"
};
var MTiCVGmtBjEPWzsw = {
	message: "香港永久性居民身份證"
};
var zLnEBdSfUXdqbRqAohY = {
	message: "您是否擁有其他國家/地區的有效身份證件？"
};
var oVvhpgfhTeyLLnTSv = {
	message: "請提供您的外國居民身份證明文件"
};
var OEfurFwwcJaTsVxNdol = {
	message: "支持的身份證明文件包括：外國居民身份證，工作/學生/受養人簽證等長期簽證"
};
var TeRrrjzubYVYnBhsdpD = {
	message: "外國居民身份證"
};
var xwQqYnxnxmeJPqRlQ = {
	message: "工作/學生等長期簽證"
};
var hoTQEpJFfRRLZGLWiDK = {
	message: "證件類型"
};
var wZuMVSBUSlQidCQpjoS = {
	message: "上傳證件"
};
var oSDxsXgENbIeNMLv = {
	message: "正面"
};
var aoAIqdHabiquSjWWz = {
	message: "反面（如有）"
};
var YltriUZdkgLJuXZi = {
	message: "18 - 20歲"
};
var sZudUtmwNMYVhQhyj = {
	message: "21 - 54歲"
};
var slqgnwkLOtCyZiTBWb = {
	message: "55 - 69歲"
};
var PwxbwKVPjpeCuRYx = {
	message: "70歲或以上"
};
var domCttddTWzCfimSWOq = {
	message: "當前持倉"
};
var dqLNRujTTFLifcFaybP = {
	message: "持倉限額"
};
var wIfwelYvkemWaZGE = {
	message: "持倉限額是指您賬戶下（包括主賬戶和子賬戶）可用於交易的最大限額"
};
var vDIneAtEexNLfRMcVPa = {
	message: "劃轉請求失敗！您的交易賬戶總額不可超過最大持倉限額。"
};
var YYzgmIpjtorJXoyQJUk = {
	message: "當前剩餘持倉額度為："
};
var rZkFVZvvCQRyHCfLiNVX = {
	message: "您必須減少下單數量或減倉交易賬戶中的虛擬資產"
};
var VXwjemLYMJiNKvXlZ = {
	message: "國家/地區"
};
var GZOFzxVOsYtRtlONwcv = {
	message: "輸入全稱"
};
var YiNdDLTlBGFQiuNECi = {
	message: "輸入全名"
};
var aFykbSRCZkUrYNzoKtk = {
	message: "輸入銀行賬號"
};
var TgilgrTuMXgbAQuPf = {
	message: "輸入銀行編號"
};
var MQaUVFeBMhHfKxmBUV = {
	message: "輸入銀行SWIFT代碼"
};
var HgKGDukwWWdCeZlibVY = {
	message: "輸入銀行地址"
};
var rhXOjsQATKgJNizniW = {
	message: "由於銀行結算時間的限制，充值資金最終到賬的時間以資金在Bixin.com開戶銀行實際到賬的時間為準。"
};
var pKuaKUWJHuajbExMUs = {
	message: "Bixin.com不收取充值手續費，但您的銀行可能收取手續費用，手續費將從您的充值金額中扣除，以實際入賬金額為準。"
};
var nkcDnQvbZpDfYMepAc = {
	message: "如果您的匯款是香港本地匯款，一般情況下半個工作日內就能到賬。如果是符合規定的跨境匯款，一般需要2-3個工作日才能到賬。如果遇到銀行假期或公共節假日，到賬時間將會相應延後。"
};
var UHAKvmcFPrannQlFz = {
	message: "您確認要刪除該賬號嗎？"
};
var MmdyZCvMXusVhfjsV = {
	message: "分行編號"
};
var MGsQCMXzOIuqcXjBDDTF = {
	message: "重要更新"
};
var xYFrGCCcvvWooWsibQFD = {
	message: "根據AMLO第3G附表的規定，NewBX Limited (CE編號: BUY737)自2024年6月1日起被視為獲得許可提供虛擬資產服務（營運虛擬資產交易所），但需遵守SFC要求的特定條件和條款。"
};
var omBdaJrTBmDrBzNYx = {
	message: "NewBX Limited尚未獲得香港證券及期貨事務監察委員會的許可，並且可能最終不會被授予許可，因為委員會可能拒絕其許可申請或其申請可能被撤回。它僅被視為根據《反洗錢及打擊恐怖主義融資條例》獲得許可。"
};
var omTkmNnwlfkOvozU = {
	message: "有關視為許可安排及公司許可狀態的最新信息，您可以參考SFC網站："
};
var YxGqBoJIoXruDOmbNu = {
	message: "我明白"
};
var NOhPBjPDsgVbfqTgjIH = {
	message: "十年安全運營，百萬用戶信賴！"
};
var gcFEhAlcWmjNfIqry = {
	message: "BIXIN.COM成立於2014年，前身為HaoBTC，是全球首批虛擬資產託管商之一。多年來，BIXIN.COM已發展成為一個綜合性的虛擬資產交易平台，為用戶提供「易用又安全」的服務。其運營實體NewBX Limited是一家香港有限責任公司，是幣信集團的全資子公司。"
};
var npetoxnFYOYxRjXRN = {
	message: "檢測到您正在使用VPN，請先關閉"
};
var TzvXfzahEvyWlLOZQE = {
	message: "抱歉！您所在的國家/地區暫不提供支持"
};
var LuuhHZgOxbTJDvnm = {
	message: "您的賬戶目前為休眠狀態"
};
var sqteSBzbeJvwJeJSWZk = {
	message: "請聯繫客服<b>support@bixin.com</b>重新激活您的賬戶"
};
var uhoCqEIxFLCGpwTslFY = {
	message: "請選擇並確認"
};
var OzYooSlNbfNTxRxNhe = {
	message: "我確認我的資料均無變更"
};
var JQpSpVQqatEXOdgFvjh = {
	message: "我需要更新資料"
};
var onOjgIPTpDDXLIwlSWE = {
	message: "更新資料"
};
var gDgIYTmDidzeeXyOV = {
	message: "修改"
};
var cOOoOlxMURFANNpFpYx = {
	message: "如需更新證件信息，請同時上傳經核證的證件副本"
};
var nAVsbekWuHffflMnfHHy = {
	message: "如需更新常居地址，請同時上傳經核證的住址證明"
};
var WelPCqxRFgXNzpkZJdsh = {
	message: "您已完成確認，請勿重複提交"
};
var npqmwWmfuEsNrfQJt = {
	message: "請您確認所有信息準確無誤後提交"
};
var wcfFqisAqLRlhbKdJk = {
	message: "財富來源證明"
};
var wcJAFtgivjbkVSdTC = {
	message: "請提供與您所選財富來源對應的證明材料（最近12個月內）"
};
var pSUGpUOowrIgSHLfEIs = {
	message: "重新上傳"
};
var cWYINWiSUUdFuDAImP = {
	message: "提交成功！"
};
var tUrSbGVjlpoCdTkb = {
	message: "我們將開始對您的賬戶進行定期審閱，以確保我們可以持續為您提供服務。通常情況下，這個過程不會影響您的正常使用。但如果我們在審閱過程中發現任何問題，我們將立即通過電郵通知您。\n"
};
var YvXCqALOsnrEQAHU = {
	message: "感謝您的理解和配合。如有疑問，請聯絡我們的客服："
};
var JJfMolWuWCFgrDrUiz = {
	message: "感謝您的確認！"
};
var plHTmWdGncJPnVBJuI = {
	message: "另外，您還需提供財富來源的證明材料"
};
var HbkwQxpXzqUXEvkxVmz = {
	message: "選擇需要更新的信息類型"
};
var KOycuFuoXkNBrUCLtCVL = {
	message: "添加文件"
};
var yYxnWdRQrNPhFUhmKp = {
	message: "添加信息類型"
};
var oWOQzlGOqirSVhUhQX = {
	message: "上傳經核證副本"
};
var xbTIXxCJIOnbLImHUPI = {
	message: "周年申報表 (NAR1)"
};
var VSmzJHKoDZuNenetubvZ = {
	message: "公司註冊（CI）"
};
var YJlyfJbAZRZhGensD = {
	message: "公司更改名稱證明（如適用）"
};
var SuSDXCILmprzPXIonL = {
	message: "商業登記證（BR）"
};
var FnrHWNqUvXlpfQLAfT = {
	message: "公司章程（AA）"
};
var uPrPwsvUYglduYxnfgb = {
	message: "6個月內的董事在職證明（COI)（僅限離岸公司）"
};
var BvERvFYtRmpkINLVdX = {
	message: "股份轉讓書（如適用）"
};
var MSaPBxOSKeCTtUMPq = {
	message: "股權架構"
};
var olGkjZMWDZBQwjnVK = {
	message: "董事/授權簽字人/實益擁有人身份證件"
};
var PmdVNRJcWUxjWfFSA = {
	message: "董事/授權簽字人/實益擁有人地址證明"
};
var gCLhGVwztVSCPNZUgqQN = {
	message: "業務性質"
};
var FDynUJSlxYFxtAhrQN = {
	message: "銀行機構"
};
var UBCBvFlsnzzgcIOHTmN = {
	message: "持牌放貸機構"
};
var MERzsdKkxudpOnlaF = {
	message: "持牌貨幣兌換商/匯款服務商"
};
var XtpeIeGyrDDKSkgyCiL = {
	message: "基金管理/信託/受託人服務"
};
var LxcfZSEIROwQeVCok = {
	message: "持牌支付服務提供商"
};
var fxjdlTQeJFVyjFXmhlnI = {
	message: "請勾選適合選項並簡短陳述所選項"
};
var aVbJYJuVEhKXAqlbWgUE = {
	message: "請闡述所選項（300字以內）"
};
var yicaYCvBFspqWpPqS = {
	message: "投資收益"
};
var YLfvFQfagZeMpkzlO = {
	message: "銷售收入"
};
var fsjyqgrUVSYOXDUxw = {
	message: "資產出售"
};
var WQsiZpVbrxKoaVkQ = {
	message: "客戶/投資人資金"
};
var KpLdefqDhhhdklLzxOgC = {
	message: "公司自由資金/資產"
};
var WbJXVvgJiwcWWgRAYq = {
	message: "公司財富來源證明"
};
var EcnKFNIFTwRUshkf = {
	message: "請提供貴公司所申報的財富來源對應的證明材料（最近12個月內）"
};
var xGdbGnjcDCabqvFJX = {
	message: "商業收入"
};
var olJXBlENebamalqAmC = {
	message: "投資人注資"
};
var lnaNMhKSbkHzoYmMHp = {
	message: "股東注資"
};
var MFJyykUbSXUkUqHxlJ = {
	message: "商業借款"
};
var UsVahXMYImjwSrxR = {
	message: "產權出售/投資"
};
var XjUPUpsmbzqDVlOyOzD = {
	message: "實益擁有人財富來源證明"
};
var bYjpHFpkXBumbkZHbM = {
	message: "請提供貴公司所有實益擁有人（UBO）的財富來源證明材料（最近12個月內）"
};
var nZkngKdQlMblSkIsJt = {
	message: "實益擁有人姓名"
};
var vfiTAWyuaCrULibnur = {
	message: "實益擁有人"
};
var hubWrmcrofRaRoYLCAS = {
	message: "另外，您還需提供貴公司財富來源的證明材料"
};
var dIOuyFmCcSAXzBifCgd = {
	message: "我們將開始對貴公司的賬戶進行定期審閱，以確保我們可以持續為貴公司提供服務。通常情況下，這個過程不會影響您公司賬戶的正常使用。但如果我們在審閱過程中發現任何問題，我們將立即通過電郵通知公司的聯絡人。"
};
var AoqexRnXPjWiaXQQ = {
	message: "請先保存"
};
var wtPiDpoJwweHEwGphG = {
	message: "子帳戶"
};
var YFShWZLtmVzhKApQSudo = {
	message: "子賬戶管理"
};
var EyxlrwvHrdhvRaHtLxx = {
	message: "您最多可創建$s個子賬戶"
};
var YbTVKYSCHSNbVSRpbwRM = {
	message: "登錄郵箱"
};
var rWOqJloUMhKXCZHLpnc = {
	message: "創建日期"
};
var nmuzQLDdidsSBtDTLaU = {
	message: "暫無子賬戶"
};
var cKeVqkUVuUrblpSkN = {
	message: "暫無API"
};
var KgtuAymJbpqjZHQACDKA = {
	message: "賬戶劃轉"
};
var WriODPyMHmFqbNRIkh = {
	message: "支持主賬戶與子賬戶下資金賬戶之間的劃轉"
};
var kdGDbDfHqPdMmOODj = {
	message: "新增子賬戶"
};
var fRcWTONIbiPEHREbRTKI = {
	message: "賬戶驗證"
};
var MIqinsTMANLFyEzWlLXm = {
	message: "子賬戶郵箱："
};
var xmSClcrPuftAggqMjWp = {
	message: "綁定手機號："
};
var uPEmuahfZCJKifAf = {
	message: "正常"
};
var NazoeCHUJpEyQWZDKcVt = {
	message: "已停用"
};
var ZtmHIANowsUTyUyouyg = {
	message: "停用"
};
var DyXvKDfsUBPKtQScEVw = {
	message: "啟用"
};
var SGvHMSujomhCIGweYcH = {
	message: "您確認要刪除此子賬戶嗎？此操作不可逆\n"
};
var xFLmujpTZsyQKTENeNr = {
	message: "請確認此子賬戶中不含任何資產，否則將刪除失敗。所有關聯的委託訂單將被取消，API Key將被刪除。您將空出一個子賬戶配額以創建新的子賬戶，但無法使用已刪除的子賬戶郵箱再創建新的子賬戶。"
};
var xPXNyAgtdawfwFRxXhb = {
	message: "請先清空子賬戶中的資產"
};
var VoQarJJpktEfEZnK = {
	message: "您確認要啟用此子賬戶嗎？"
};
var wfUNVCtRXprhwYwce = {
	message: "獲取驗證碼"
};
var nirNFLwkcuvUxudti = {
	message: "API管理"
};
var GqlajLqwcNJLpTqq = {
	message: "每個子賬戶最多可創建5個API Key"
};
var NKaDUgPomETDmcmKHy = {
	message: "請妥善保管您的API Key和Secret Key，以免泄露後造成資產損失"
};
var OsCIqseGbbbWXxBLk = {
	message: "輸入郵箱/標籤名/API Key"
};
var DghVzIJcKyuvkcKwY = {
	message: "標籤名"
};
var XYnywMktJDrWPwZBA = {
	message: "您確認要刪除此API Key嗎？"
};
var bgnQSQsWYPIcUDEytcq = {
	message: "新增API"
};
var erGplJlLIBiVheXvc = {
	message: "選擇子賬戶"
};
var epeFMTUcZAYdtLOETgZ = {
	message: "API標籤名"
};
var oIIfiHdqGwpXZbtDYKG = {
	message: "自定義標籤名"
};
var mlUEUuDRftKStSMvF = {
	message: "請先在子賬戶中存入資產"
};
var nNgFtrjyhesGreVhV = {
	message: "API信息"
};
var ewrHdSoDPutFlPrqTEr = {
	message: "僅在創建時顯示，請妥善保管"
};
var ZZlJgALCrsSaNhaoV = {
	message: "API權限"
};
var OgusvSSbzkNopiGbCIo = {
	message: "IP訪問限制"
};
var nmPUwVVQoncVHqMln = {
	message: "輸入受信任的IP位址，多個地址用；隔開"
};
var mWaNsXTgUIcnWSphpgB = {
	message: "12個月內由託管商簽發的賬戶報表/證明"
};
var GxjDaNmTVZaIEmLIO = {
	message: "12個月內由審計師/註冊會計師頒發的證明\n"
};
var xdBmFzKPmVQfqVSOyFY = {
	message: "12個月內提交的公開備案文件"
};
var xdSXcpFurEbSenWcxPn = {
	message: "請至少選擇一項證明文件"
};
var KzRRnMZfXiUfprzBEe = {
	message: "如需申請專業投資者認證</br>請聯繫開戶團隊<b>onboarding@bixin.com</b>"
};
var nDIaTJMAdTQRxUKJo = {
	message: "錯誤的用戶名或密碼"
};
var XaQWqbeAdXIkLCiakX = {
	message: "您的賬戶尚未開通子賬戶功能。如需申請，請說明理由：\n"
};
var WHFSIZvkPFlAiUsTW = {
	message: "請闡述申請開通子賬戶功能的原因，不超過300字"
};
var IldgeERuYKVOefpR = {
	message: "子帳戶申請"
};
var sYnLKnDJjNhHBCpTj = {
	message: "關閉"
};
var ZtsyDNmrvXDDftOHri = {
	message: "驗證失敗，請重新驗證或刷新頁面重試"
};
var vAeqeVWtpVywOzVUYfuv = {
	message: "您確定需要停用賬號$s？"
};
var PLWcAjJpcpPoIQiCcq = {
	message: "您將無法登錄此賬戶，且所有關聯的委託訂單將被取消，API Key將被刪除。"
};
var QHhdRUWMTaGpDwrC = {
	message: "該郵箱曾被刪除，無法再添加"
};
var account_transfer = {
	message: "帳戶劃轉"
};
var account = {
	message: "帳戶"
};
var UKenwEAFyRZgQyZTmPYy = {
	message: "刪除成功"
};
var twJSON = {
	pHHNdTPNyDzQgIvYd: pHHNdTPNyDzQgIvYd,
	cWSaveaKAPErStEYy: cWSaveaKAPErStEYy,
	sSIcbzainkLvqqhxh: sSIcbzainkLvqqhxh,
	aLZzpUtzvgrrPWvcQGbT: aLZzpUtzvgrrPWvcQGbT,
	IizWxRwTfRDgQnVPXcb: IizWxRwTfRDgQnVPXcb,
	jeYCQaSvbBRtAklYZ: jeYCQaSvbBRtAklYZ,
	kfASiYACukCdCVcFmcsq: kfASiYACukCdCVcFmcsq,
	YpcGXAgMexsVEmQnseE: YpcGXAgMexsVEmQnseE,
	OivHVusJobtDPuGMSbDN: OivHVusJobtDPuGMSbDN,
	HNryhyKcRNPaLZpBHK: HNryhyKcRNPaLZpBHK,
	IDPsMPUXhtCczMWcA: IDPsMPUXhtCczMWcA,
	MnGzdARgdxwWnBQGqasa: MnGzdARgdxwWnBQGqasa,
	dSypETsKWXyxFowLHe: dSypETsKWXyxFowLHe,
	CRjZdhorIpDDNDAPls: CRjZdhorIpDDNDAPls,
	KEEUdFUfkYDFEeiUhk: KEEUdFUfkYDFEeiUhk,
	BQbWzLQtSHQVHdIDAgJ: BQbWzLQtSHQVHdIDAgJ,
	fxHeYqwgtTcKAdCKPyVe: fxHeYqwgtTcKAdCKPyVe,
	OXrwZMwkWAjoSDDALzow: OXrwZMwkWAjoSDDALzow,
	tOaRBVUJHpnSgDBrGON: tOaRBVUJHpnSgDBrGON,
	WbPTckCFMKtPHgAlL: WbPTckCFMKtPHgAlL,
	nHxEoVJEcaAOmKgBbYO: nHxEoVJEcaAOmKgBbYO,
	MZjVFSmKoCrehUMcH: MZjVFSmKoCrehUMcH,
	puvbUtnTezlmHPfbVAqn: puvbUtnTezlmHPfbVAqn,
	HOpNrycyzpeOCvcWPwAM: HOpNrycyzpeOCvcWPwAM,
	QaixZWMxqfefkNPgkdy: QaixZWMxqfefkNPgkdy,
	RPMjhEtAWhHwQeAjSV: RPMjhEtAWhHwQeAjSV,
	mBnIkwyDNdwNDoWcq: mBnIkwyDNdwNDoWcq,
	ApuVYLcjyFSzxzZB: ApuVYLcjyFSzxzZB,
	YoNUkubiEWSyPsgRUR: YoNUkubiEWSyPsgRUR,
	msvgVjHCdtHxFKkrS: msvgVjHCdtHxFKkrS,
	SUObcbdMwQrjwarfaMi: SUObcbdMwQrjwarfaMi,
	ElMEzQxYcCuZMmCmB: ElMEzQxYcCuZMmCmB,
	idqLvJqjeiEmQbpa: idqLvJqjeiEmQbpa,
	FhkGAkzeRaGMUGCREr: FhkGAkzeRaGMUGCREr,
	lXmoRtYVpvHfxffpUp: lXmoRtYVpvHfxffpUp,
	fIZJfHadJjLYozRPMC: fIZJfHadJjLYozRPMC,
	fVuoUoQRKfJuwltrQWcF: fVuoUoQRKfJuwltrQWcF,
	tMHuCmLcCyWTKXTkJpl: tMHuCmLcCyWTKXTkJpl,
	yXhUtplPqxAjDtkzW: yXhUtplPqxAjDtkzW,
	EGBtpzynCWcQsWcMz: EGBtpzynCWcQsWcMz,
	nFxxFVzdRTilHiouzuY: nFxxFVzdRTilHiouzuY,
	gYpQegnebgwwccEuM: gYpQegnebgwwccEuM,
	HQSjnUOWYQPuvvTpu: HQSjnUOWYQPuvvTpu,
	PufPEQRHcFlNqsAG: PufPEQRHcFlNqsAG,
	lvvtaxnLzNOtFCZllw: lvvtaxnLzNOtFCZllw,
	NoqAHzFdypmIlmXmyM: NoqAHzFdypmIlmXmyM,
	dLTuZclgDrLDUToEe: dLTuZclgDrLDUToEe,
	YChcfaxDaLscdSPiRQz: YChcfaxDaLscdSPiRQz,
	qtCIhbuRgppyZzltf: qtCIhbuRgppyZzltf,
	wvzbJUEmNoCiDQLTaWzH: wvzbJUEmNoCiDQLTaWzH,
	POdaGgvMxQRsisLbVcll: POdaGgvMxQRsisLbVcll,
	qRoYPOkmAoqOZnZawkD: qRoYPOkmAoqOZnZawkD,
	SgWXitfFwQHiWicT: SgWXitfFwQHiWicT,
	txfROteTwdaWdTnlkif: txfROteTwdaWdTnlkif,
	qEmYfNcGOwxFPeXxWz: qEmYfNcGOwxFPeXxWz,
	sjqwCBQBKOIAKZymEnSd: sjqwCBQBKOIAKZymEnSd,
	wAFriagWUVTteXOh: wAFriagWUVTteXOh,
	ffqVyVPsxEFhGDWwjo: ffqVyVPsxEFhGDWwjo,
	ZFmapCdeoYAGjnNG: ZFmapCdeoYAGjnNG,
	JTHQBsfkCFvanpmGhYL: JTHQBsfkCFvanpmGhYL,
	tLufHBCFhvZchanHd: tLufHBCFhvZchanHd,
	VUMActZjvXkEaSCs: VUMActZjvXkEaSCs,
	dqGnSTBmWfxxuxSAR: dqGnSTBmWfxxuxSAR,
	NrifpOBOTpbiyPCqT: NrifpOBOTpbiyPCqT,
	ogjLTTEZpYaUhUJAk: ogjLTTEZpYaUhUJAk,
	TGFdcFVaVnCAXfpC: TGFdcFVaVnCAXfpC,
	cFKHegtmXlwojKtJw: cFKHegtmXlwojKtJw,
	pNHFlymBnWuShBmbewj: pNHFlymBnWuShBmbewj,
	AsLSeryFUtTwDklOIhVE: AsLSeryFUtTwDklOIhVE,
	lNGEpmcaWzCMRfZFypa: lNGEpmcaWzCMRfZFypa,
	CKVRBnYMLalEUVhYrqI: CKVRBnYMLalEUVhYrqI,
	JAKswaiCfseLlQNZ: JAKswaiCfseLlQNZ,
	bZduiedsIokAAxBsM: bZduiedsIokAAxBsM,
	rtVWmSuAATyCaNgkRNx: rtVWmSuAATyCaNgkRNx,
	TVTktEvtpSXRbnxIB: TVTktEvtpSXRbnxIB,
	leXQdnNvhrYWetVTXjE: leXQdnNvhrYWetVTXjE,
	MzbyaTzwTlbRpWdHmwt: MzbyaTzwTlbRpWdHmwt,
	phfuULxmHCuLNyotJ: phfuULxmHCuLNyotJ,
	qdvGrtpVJQsGGgiLvje: qdvGrtpVJQsGGgiLvje,
	PIxkcsUxBzUPVVFfu: PIxkcsUxBzUPVVFfu,
	OBIAENcRtoPgMWcJNZ: OBIAENcRtoPgMWcJNZ,
	iDYPzXzvGbnKWCRr: iDYPzXzvGbnKWCRr,
	FmpkJYVtUXpBCGEVp: FmpkJYVtUXpBCGEVp,
	mzWsFtJNWfexuuUgYctv: mzWsFtJNWfexuuUgYctv,
	wjeaGDSVTuLLjJGehN: wjeaGDSVTuLLjJGehN,
	KbSjSRobgQmXjHChGKJ: KbSjSRobgQmXjHChGKJ,
	TAFoyaQLwVzluFioqh: TAFoyaQLwVzluFioqh,
	eChfcikkuQFNcZULZuP: eChfcikkuQFNcZULZuP,
	VnLNiYiOJxZraQxL: VnLNiYiOJxZraQxL,
	bqNjZcEbCrAzOJJpJDn: bqNjZcEbCrAzOJJpJDn,
	gTYMvovCwafJTrjdlKg: gTYMvovCwafJTrjdlKg,
	PczYwMSUlifZlPdkNj: PczYwMSUlifZlPdkNj,
	DDrTONBZdHTEWHNFNgtV: DDrTONBZdHTEWHNFNgtV,
	OkpDnVcVIcDyntNTMI: OkpDnVcVIcDyntNTMI,
	EfVkywGLHyLgyrRjzg: EfVkywGLHyLgyrRjzg,
	NOIPqSfkgPcsNJnyAFA: NOIPqSfkgPcsNJnyAFA,
	WauyOiSpVDMamrXbLP: WauyOiSpVDMamrXbLP,
	eXVsxwaBOXkkntIEGtC: eXVsxwaBOXkkntIEGtC,
	EOmmDCycYoHFOZOV: EOmmDCycYoHFOZOV,
	ysjFKMhSQlIqXgPlz: ysjFKMhSQlIqXgPlz,
	TNkXPjSKdzQcBLZPsWj: TNkXPjSKdzQcBLZPsWj,
	FMUUecQmwAheUKwpq: FMUUecQmwAheUKwpq,
	KSxzKkrfZaaHIOptelk: KSxzKkrfZaaHIOptelk,
	IurrXFgATIlGAlejcf: IurrXFgATIlGAlejcf,
	mUgsNHlLzyKVnxhVjRT: mUgsNHlLzyKVnxhVjRT,
	LcqaZGQKcdkxNrnIcK: LcqaZGQKcdkxNrnIcK,
	zQsiOHqCsFIqBzNsf: zQsiOHqCsFIqBzNsf,
	erLerUcELvDAcoUWi: erLerUcELvDAcoUWi,
	TGYvVRioXBfDBtmCBpH: TGYvVRioXBfDBtmCBpH,
	cQKfBbUkEhBhPtPCx: cQKfBbUkEhBhPtPCx,
	SHjOXbqLUjZRUKsWMzD: SHjOXbqLUjZRUKsWMzD,
	mUuMBlRDyzHtFgLsivV: mUuMBlRDyzHtFgLsivV,
	ISJVpXHVtpoxunGygBGu: ISJVpXHVtpoxunGygBGu,
	VGmDUnWBzMKfFbMKXyl: VGmDUnWBzMKfFbMKXyl,
	ZAhuzRDlLUTXhKrhhx: ZAhuzRDlLUTXhKrhhx,
	BggwtUciWOTxbdTdDg: BggwtUciWOTxbdTdDg,
	QFbYEdxUgXzRwcPFQDis: QFbYEdxUgXzRwcPFQDis,
	UNForxvjDLCZdGrmWkX: UNForxvjDLCZdGrmWkX,
	OCamqUckeIZshGlCbF: OCamqUckeIZshGlCbF,
	YMfvOKmAFnfMwTXPfI: YMfvOKmAFnfMwTXPfI,
	nvfgxTKtdXdTEhFZf: nvfgxTKtdXdTEhFZf,
	HrHtlLjcEICrEnWiRA: HrHtlLjcEICrEnWiRA,
	HIFNIcNDmIhRZEsgzSq: HIFNIcNDmIhRZEsgzSq,
	KSyKpOAjkLSpCGns: KSyKpOAjkLSpCGns,
	eUvzxeVvXrffrpEOrFrP: eUvzxeVvXrffrpEOrFrP,
	NqgOQEXQaHsramCnbX: NqgOQEXQaHsramCnbX,
	YqzlhmIgzcgLnWmZhMsa: YqzlhmIgzcgLnWmZhMsa,
	FrzWGSiDSDzTfNgZH: FrzWGSiDSDzTfNgZH,
	WYhIabGPkCnbVBIPcwW: WYhIabGPkCnbVBIPcwW,
	LFipKWcCwIamrrato: LFipKWcCwIamrrato,
	RFoMDsIwGyJlPkuuxrON: RFoMDsIwGyJlPkuuxrON,
	bpvYuERgedcoMzzLNl: bpvYuERgedcoMzzLNl,
	NsvJYqLAVHAaWNUXAvz: NsvJYqLAVHAaWNUXAvz,
	UbeafDPBCDfpRnQyWUjq: UbeafDPBCDfpRnQyWUjq,
	LbGVMqLVHqyddGmXzULS: LbGVMqLVHqyddGmXzULS,
	qdnqxPdrpfdxhejrkCj: qdnqxPdrpfdxhejrkCj,
	XYHinpRQuEPFjXMzLP: XYHinpRQuEPFjXMzLP,
	LQNXJVNXqgqLimcQn: LQNXJVNXqgqLimcQn,
	nzLBdKgvNCXQTgYI: nzLBdKgvNCXQTgYI,
	iYpfkywMVpuafYnqXxGI: iYpfkywMVpuafYnqXxGI,
	DVjsSAdKoyNHoIqhumQ: DVjsSAdKoyNHoIqhumQ,
	cxKcumOzANqjtQqREyas: cxKcumOzANqjtQqREyas,
	BQkFfUTgzkweftGIpOLt: BQkFfUTgzkweftGIpOLt,
	FNNzRxnZqrKRYwIte: FNNzRxnZqrKRYwIte,
	SultIciVtbYeZaII: SultIciVtbYeZaII,
	dGRvusBQRnbHUIYQRit: dGRvusBQRnbHUIYQRit,
	bJwUxepDjVzlNzKuI: bJwUxepDjVzlNzKuI,
	HlrghIZaaySLZjESwU: HlrghIZaaySLZjESwU,
	TCuuXTtXBYeAldQkZp: TCuuXTtXBYeAldQkZp,
	HYTGqldMNoESWJswz: HYTGqldMNoESWJswz,
	dkdmEAWTXMORUhlQaX: dkdmEAWTXMORUhlQaX,
	XwYKiJGJKAZZZpNp: XwYKiJGJKAZZZpNp,
	swejTyFcYnjuUgsfQW: swejTyFcYnjuUgsfQW,
	mWoxaQwwzwCFvWjRmK: mWoxaQwwzwCFvWjRmK,
	tFaBUAWNRhJqtjIha: tFaBUAWNRhJqtjIha,
	FEySNpPzdMqiOsZXI: FEySNpPzdMqiOsZXI,
	AIwKneHGNfSJmdLnG: AIwKneHGNfSJmdLnG,
	wMGJlEJaupHayuzRwi: wMGJlEJaupHayuzRwi,
	iRiLJudagJVXZozmnz: iRiLJudagJVXZozmnz,
	laRzOEpYMTvnZYRBZMnj: laRzOEpYMTvnZYRBZMnj,
	MDhXYatnZcwvrjVeRh: MDhXYatnZcwvrjVeRh,
	hDPPfPClruPeWrSoayR: hDPPfPClruPeWrSoayR,
	NTsLbMXwQdPYbmOwP: NTsLbMXwQdPYbmOwP,
	POqloYgxpcTCqdnchGE: POqloYgxpcTCqdnchGE,
	KxeaINzIsNNJmsIncnV: KxeaINzIsNNJmsIncnV,
	sfsygIDbANBoFslbcsw: sfsygIDbANBoFslbcsw,
	YgpFeXbXojsYnphM: YgpFeXbXojsYnphM,
	MutPBZAXykjaIurt: MutPBZAXykjaIurt,
	GvnMmZJtuApdXwWhsFd: GvnMmZJtuApdXwWhsFd,
	IcahwJmNfgdvVpPz: IcahwJmNfgdvVpPz,
	bxtlucAfnIxfwBYAY: bxtlucAfnIxfwBYAY,
	KKbVbDLheqewlSvBE: KKbVbDLheqewlSvBE,
	RLztZboedHACRMkjdD: RLztZboedHACRMkjdD,
	QEaaELvQUvbfoIpje: QEaaELvQUvbfoIpje,
	czSsfuZGitGjFRwLTF: czSsfuZGitGjFRwLTF,
	xrYEaiWUOcaNRQMIf: xrYEaiWUOcaNRQMIf,
	QDuPlYKAxjAjIgyoAqM: QDuPlYKAxjAjIgyoAqM,
	ZkDBgJuvDUVQPOxBY: ZkDBgJuvDUVQPOxBY,
	rJAhIVPUqedRmsfmj: rJAhIVPUqedRmsfmj,
	GpGpOkSHUzYBQNFc: GpGpOkSHUzYBQNFc,
	aMdrNUxkhioFGrNGFIO: aMdrNUxkhioFGrNGFIO,
	siLEsPwfoiqGBiXjB: siLEsPwfoiqGBiXjB,
	DYgqvlfmNbyLNOrWwc: DYgqvlfmNbyLNOrWwc,
	rifKyRmlGZOwlJkDyZG: rifKyRmlGZOwlJkDyZG,
	aNVsLyHapaJbRxWnHsv: aNVsLyHapaJbRxWnHsv,
	cQiCyvfOMMDJEIXyc: cQiCyvfOMMDJEIXyc,
	SywvArMjCuuGzTEtlJ: SywvArMjCuuGzTEtlJ,
	vRyVKhBOPCmWYPPacY: vRyVKhBOPCmWYPPacY,
	GMOQAxsTvfWIEBANuS: GMOQAxsTvfWIEBANuS,
	xqLddTkVnCrEvxgKGso: xqLddTkVnCrEvxgKGso,
	sHqYaogVbbeWItJGb: sHqYaogVbbeWItJGb,
	xgIKqcGuTlutCTLLG: xgIKqcGuTlutCTLLG,
	zsLweYcWjOwUgfyub: zsLweYcWjOwUgfyub,
	xUNmcszdZBWMTcxnI: xUNmcszdZBWMTcxnI,
	moirunBAysHLMEDtBxUt: moirunBAysHLMEDtBxUt,
	YrkgVnAQcYRhGGRex: YrkgVnAQcYRhGGRex,
	iuOLeRpygvfPFDnf: iuOLeRpygvfPFDnf,
	iuswsIRQwNAIuOzoFX: iuswsIRQwNAIuOzoFX,
	sBFILAqpJhAnTLlpQ: sBFILAqpJhAnTLlpQ,
	eSLIwfCNWkIwJpqCHSVC: eSLIwfCNWkIwJpqCHSVC,
	RtWpXpLfhjeWPtKhcENN: RtWpXpLfhjeWPtKhcENN,
	KveBVvOTiGXRKmAUQZz: KveBVvOTiGXRKmAUQZz,
	XwmOjTtjNklQiLDgnjIB: XwmOjTtjNklQiLDgnjIB,
	GLIndpTHvNVRVWQuT: GLIndpTHvNVRVWQuT,
	WzcUSFqDMdwkVtGoj: WzcUSFqDMdwkVtGoj,
	kuTgfRDYzVZvEHrFtQ: kuTgfRDYzVZvEHrFtQ,
	gXbirwakdsaUKBglwK: gXbirwakdsaUKBglwK,
	cTlSqXgGENkCAQQJCHx: cTlSqXgGENkCAQQJCHx,
	JsmDOHlXAmjSPqaxg: JsmDOHlXAmjSPqaxg,
	yCCsuXAjuRzOLNxo: yCCsuXAjuRzOLNxo,
	iizCYlpFHwQBzRyqLM: iizCYlpFHwQBzRyqLM,
	FbztGftxEQrszJntb: FbztGftxEQrszJntb,
	rteqizIYZXJwMWMenVz: rteqizIYZXJwMWMenVz,
	sydmFvhfSgzJVhtAud: sydmFvhfSgzJVhtAud,
	aYdhyaHCqMJLweGFD: aYdhyaHCqMJLweGFD,
	SMEPVJNtMGWMrEceo: SMEPVJNtMGWMrEceo,
	jgXHbpNLgJMKuuZER: jgXHbpNLgJMKuuZER,
	JWDRcPebwmpIhvJhVrJe: JWDRcPebwmpIhvJhVrJe,
	UtQJNokaxJhxqqTQDiO: UtQJNokaxJhxqqTQDiO,
	TFAtjCZbFqacobpGxct: TFAtjCZbFqacobpGxct,
	EokACCilfAZfuGcXD: EokACCilfAZfuGcXD,
	UXURgENTpgxogbFAD: UXURgENTpgxogbFAD,
	ElbSFPkaecjnmBToovei: ElbSFPkaecjnmBToovei,
	LuigfaXzmPRCftdFOV: LuigfaXzmPRCftdFOV,
	BNXHKONNlrkDGKwkXt: BNXHKONNlrkDGKwkXt,
	ltXrglJnxfNqZDSStFq: ltXrglJnxfNqZDSStFq,
	FClYxqPqiIjfTGZZthn: FClYxqPqiIjfTGZZthn,
	cNmmUqRZfZDUxgWTQeXm: cNmmUqRZfZDUxgWTQeXm,
	lKLpdmEuElAKKvltT: lKLpdmEuElAKKvltT,
	coPPHMNHpJdMYeKPskDY: coPPHMNHpJdMYeKPskDY,
	NovuNXyQGDRrjfyMs: NovuNXyQGDRrjfyMs,
	bOSFxWykzVFerKLOiV: bOSFxWykzVFerKLOiV,
	HfjMmDJQuBZXqFJUw: HfjMmDJQuBZXqFJUw,
	SVTrmHtEOHifBpgPNCY: SVTrmHtEOHifBpgPNCY,
	LmRHxJOIEHRnUwFSxEm: LmRHxJOIEHRnUwFSxEm,
	gbkxEEkMTXuhYuUCZTJ: gbkxEEkMTXuhYuUCZTJ,
	rQgPydQgDVYqtWJXCky: rQgPydQgDVYqtWJXCky,
	nFSJqWAXBnxTngDNyoj: nFSJqWAXBnxTngDNyoj,
	MThZOMtyoBvwpuodWEa: MThZOMtyoBvwpuodWEa,
	hiEgXdIbTRKrnaYJnNY: hiEgXdIbTRKrnaYJnNY,
	PqkPSNBQJWOqaAsafW: PqkPSNBQJWOqaAsafW,
	vHRZRztWvqyjjHCxW: vHRZRztWvqyjjHCxW,
	QZchoinPLbiohHfdnLU: QZchoinPLbiohHfdnLU,
	gnOvqPVwTsPuWvBTXzI: gnOvqPVwTsPuWvBTXzI,
	bDmdcJmdRsIZfYYBDeZ: bDmdcJmdRsIZfYYBDeZ,
	YEPMktdEzwhrMMYKefX: YEPMktdEzwhrMMYKefX,
	wGSnhUtsHuueniKdYTwM: wGSnhUtsHuueniKdYTwM,
	krMQcSEJDOnglqhrHgu: krMQcSEJDOnglqhrHgu,
	erZFCFRNsVfSKVMRLN: erZFCFRNsVfSKVMRLN,
	dmeNSGPySLKtEpPGwG: dmeNSGPySLKtEpPGwG,
	czWbrtWmnCEbUCzVWzQQ: czWbrtWmnCEbUCzVWzQQ,
	YATiezBAjBifZRNRVk: YATiezBAjBifZRNRVk,
	sTMySyQXFMSuchwUXiJ: sTMySyQXFMSuchwUXiJ,
	FxLhtNEexnBoJElMC: FxLhtNEexnBoJElMC,
	hYBHkTzZmueqvwJb: hYBHkTzZmueqvwJb,
	GBvqxVjZVWwZtAPZgH: GBvqxVjZVWwZtAPZgH,
	KVLFziUaVDlFbnJzh: KVLFziUaVDlFbnJzh,
	OQGpXlfSrBKFcwjAv: OQGpXlfSrBKFcwjAv,
	AsfYVtpYWMjfUopLa: AsfYVtpYWMjfUopLa,
	wZZutIhpaOoppafvh: wZZutIhpaOoppafvh,
	OUdBKfTzsTrdfcZmbCAI: OUdBKfTzsTrdfcZmbCAI,
	IwzxXaGfVvDNSxQpmeO: IwzxXaGfVvDNSxQpmeO,
	XzCcbOKjdfmcCnQLEwNj: XzCcbOKjdfmcCnQLEwNj,
	IkToKVrxLaVfCKfNGvl: IkToKVrxLaVfCKfNGvl,
	mRtlyGWfQVnoeqMeTs: mRtlyGWfQVnoeqMeTs,
	ldgxhAKPgZpGiyMyJw: ldgxhAKPgZpGiyMyJw,
	mxKAuwcjmevMUSvDQE: mxKAuwcjmevMUSvDQE,
	pSTKNwtZdcuFuoyTsPhb: pSTKNwtZdcuFuoyTsPhb,
	EkbLQeqmPtcNzItJWQO: EkbLQeqmPtcNzItJWQO,
	KzFzOytWXScqDRKFwg: KzFzOytWXScqDRKFwg,
	MvJmrHwTdesvsHWH: MvJmrHwTdesvsHWH,
	bksAzarViFUYGzwAOk: bksAzarViFUYGzwAOk,
	EOLVYvzyNXSKoGmX: EOLVYvzyNXSKoGmX,
	EvOtSTBQrIYspwjQ: EvOtSTBQrIYspwjQ,
	eQHAVxHydpVhNAygOp: eQHAVxHydpVhNAygOp,
	LWInyMcYkagvzvaBfUHZ: LWInyMcYkagvzvaBfUHZ,
	OKOogywrWeAjtQWF: OKOogywrWeAjtQWF,
	MOtoFwFvpTtTEDVUD: MOtoFwFvpTtTEDVUD,
	ZdMOAZGAMXotVGVlKJ: ZdMOAZGAMXotVGVlKJ,
	rEpbPaWEEsiOSTjOiSGL: rEpbPaWEEsiOSTjOiSGL,
	SWVaRdViGfCBJhJNg: SWVaRdViGfCBJhJNg,
	lrCgiXeJcIwkuDsyc: lrCgiXeJcIwkuDsyc,
	vyxYMhwwOspfcdpj: vyxYMhwwOspfcdpj,
	MqMVsYdMMtqujWPKHW: MqMVsYdMMtqujWPKHW,
	siEUrpaJmBIICzsaBnr: siEUrpaJmBIICzsaBnr,
	XGLKbSKPnzgwwZwEHu: XGLKbSKPnzgwwZwEHu,
	DPFrIOWnjfRpVQHkhKJ: DPFrIOWnjfRpVQHkhKJ,
	dTLgwTGGXjpsnLhrpr: dTLgwTGGXjpsnLhrpr,
	gZgeimlXmokhLdRziw: gZgeimlXmokhLdRziw,
	xqhbTjIzOYuCUiHEUmd: xqhbTjIzOYuCUiHEUmd,
	bbQJHoMWXkEHQuVRSsO: bbQJHoMWXkEHQuVRSsO,
	HHdEPKdocehppzeI: HHdEPKdocehppzeI,
	tICtqmzJVNeVfZQM: tICtqmzJVNeVfZQM,
	HOQBmfsmIsFBlsaJaSa: HOQBmfsmIsFBlsaJaSa,
	XsOliEIHDkjKcghOik: XsOliEIHDkjKcghOik,
	ADXLpfHxGLEEMBBLjSL: ADXLpfHxGLEEMBBLjSL,
	kHAIwKLXztAgQxLOxj: kHAIwKLXztAgQxLOxj,
	pqNxLtehgpuJIUBdg: pqNxLtehgpuJIUBdg,
	nodIQIicrpcVpCqYey: nodIQIicrpcVpCqYey,
	gMjyScxabRhqehsX: gMjyScxabRhqehsX,
	AQrCocFqoKoYieUnT: AQrCocFqoKoYieUnT,
	COydGeEPULYaNAmN: COydGeEPULYaNAmN,
	pFhbWEovZnvIiVEEJnme: pFhbWEovZnvIiVEEJnme,
	omUetmzxCLiTloCSalU: omUetmzxCLiTloCSalU,
	pqzdTKxlixAoAQwGy: pqzdTKxlixAoAQwGy,
	VihBsZgCPMgMJnwUeMLt: VihBsZgCPMgMJnwUeMLt,
	ohIqnNpSPiMOrWPSWk: ohIqnNpSPiMOrWPSWk,
	TGIiRSnHGjASSfzjMA: TGIiRSnHGjASSfzjMA,
	jjFQYQyxRWGgKdjbaeB: jjFQYQyxRWGgKdjbaeB,
	VsuTZcfrgRHVvsOOY: VsuTZcfrgRHVvsOOY,
	PLhQWivTKyTYZvsNwMxj: PLhQWivTKyTYZvsNwMxj,
	ZLJlKTdDgntyZXzg: ZLJlKTdDgntyZXzg,
	pPqFjpMzSnmyNWXdT: pPqFjpMzSnmyNWXdT,
	aJpdCHYrgIukuVpHluT: aJpdCHYrgIukuVpHluT,
	olWnlFpnBjRnPCLuu: olWnlFpnBjRnPCLuu,
	ApYUyYTgQDVozNVGdoWy: ApYUyYTgQDVozNVGdoWy,
	MEuzpQOAySrMUyXj: MEuzpQOAySrMUyXj,
	NkjUESwzghXjElHM: NkjUESwzghXjElHM,
	GnugFlecXZohsDMgfjv: GnugFlecXZohsDMgfjv,
	nwsbWCYbSYugmHDgHTAB: nwsbWCYbSYugmHDgHTAB,
	gphdXFLzIrPxMQrAp: gphdXFLzIrPxMQrAp,
	toUaeInrwbWVqvGGGX: toUaeInrwbWVqvGGGX,
	gVAFPuXrrstpWxRF: gVAFPuXrrstpWxRF,
	AowuwjwDLrAJJKuVzCA: AowuwjwDLrAJJKuVzCA,
	TfmLyYqIoASEGHkuRa: TfmLyYqIoASEGHkuRa,
	tjuWuhQfpwDJLMscdbI: tjuWuhQfpwDJLMscdbI,
	KewXLZFbuyWsCSbvXi: KewXLZFbuyWsCSbvXi,
	vQphyNqvokPAiFdfRR: vQphyNqvokPAiFdfRR,
	ZbQsLkbfHUtbznnzU: ZbQsLkbfHUtbznnzU,
	TsnjCIOPEKKCCfrIF: TsnjCIOPEKKCCfrIF,
	qyKlEsEkyTXybgIHcI: qyKlEsEkyTXybgIHcI,
	VZexjbUhosOUoUTI: VZexjbUhosOUoUTI,
	jDRHFidXonxhhPKaTl: jDRHFidXonxhhPKaTl,
	CInUOzoFKTOMvMbix: CInUOzoFKTOMvMbix,
	fTbsMnhpZYjiOkAdex: fTbsMnhpZYjiOkAdex,
	yOZzgRmKudbwNjuurBHz: yOZzgRmKudbwNjuurBHz,
	lelamaRhejmRBJOD: lelamaRhejmRBJOD,
	pZxEeOQMfyGXKTBxtyJ: pZxEeOQMfyGXKTBxtyJ,
	ZGyanZavgObBeqhP: ZGyanZavgObBeqhP,
	oeMZNyLdkPQdxrobojO: oeMZNyLdkPQdxrobojO,
	MYuuWNTVQwjCeRRGl: MYuuWNTVQwjCeRRGl,
	yrlrMPLgOtiEzbmPW: yrlrMPLgOtiEzbmPW,
	EzMbHhWUJOaBMLDRJxZ: EzMbHhWUJOaBMLDRJxZ,
	hQRkbssUXUGGLhtxc: hQRkbssUXUGGLhtxc,
	eDwDkAgbfaPsnwOb: eDwDkAgbfaPsnwOb,
	AVWJwkijUTbNMShmp: AVWJwkijUTbNMShmp,
	wEEzjRnoOftKrGIPbix: wEEzjRnoOftKrGIPbix,
	NqoduOnqIqJtrjajas: NqoduOnqIqJtrjajas,
	vLUFWGhkoIBWnOMA: vLUFWGhkoIBWnOMA,
	tjsCbqUvgNvcdRqdDp: tjsCbqUvgNvcdRqdDp,
	zBceLwpDLhGkPRkvbU: zBceLwpDLhGkPRkvbU,
	udmfKDblDABqFbQPK: udmfKDblDABqFbQPK,
	AysRHzzIQTbjLUdgdaq: AysRHzzIQTbjLUdgdaq,
	KZPDAndezwXohlXxO: KZPDAndezwXohlXxO,
	hdPRTcCCnKbkxbRwgv: hdPRTcCCnKbkxbRwgv,
	pfVyzGgyXmkqtJpGH: pfVyzGgyXmkqtJpGH,
	KRzStRHbmbrDbAUMnU: KRzStRHbmbrDbAUMnU,
	lfLIpxDvOAXOplowzN: lfLIpxDvOAXOplowzN,
	BiqzWayxveHNZGxaBa: BiqzWayxveHNZGxaBa,
	CvvaFnujrEUnFHnWNb: CvvaFnujrEUnFHnWNb,
	CNmFZyGboWXdpYPQDvxV: CNmFZyGboWXdpYPQDvxV,
	OmOTUgBCsVHUoKutAD: OmOTUgBCsVHUoKutAD,
	DCXoQKoDcwNYuYivD: DCXoQKoDcwNYuYivD,
	ApeuvISiLLWNGQPrFrP: ApeuvISiLLWNGQPrFrP,
	sCfZtZRTGxweYVxtEuoY: sCfZtZRTGxweYVxtEuoY,
	VpbDUCnJRDAsPzfIkn: VpbDUCnJRDAsPzfIkn,
	WfvaFuidVgEGCwnBEkl: WfvaFuidVgEGCwnBEkl,
	UheALJaSjOHgmVnoCrI: UheALJaSjOHgmVnoCrI,
	fNFAnFLpEoAIoPfbh: fNFAnFLpEoAIoPfbh,
	uUrUZzojXlsqxsuOJZTc: uUrUZzojXlsqxsuOJZTc,
	CqNbVYlZNfwGfGTGRtE: CqNbVYlZNfwGfGTGRtE,
	QgEerZTcSTdjtiTnKRT: QgEerZTcSTdjtiTnKRT,
	GnbMsiqoZbfmcDerQ: GnbMsiqoZbfmcDerQ,
	nEgrtiBYldBKXkpKCocL: nEgrtiBYldBKXkpKCocL,
	AJSlWSWYVQZSygnFKRsI: AJSlWSWYVQZSygnFKRsI,
	KzgGszjJLuRsOKsdkH: KzgGszjJLuRsOKsdkH,
	YmIZCYMTuGNvbocpiJOP: YmIZCYMTuGNvbocpiJOP,
	YixzEmijtHztNgwIE: YixzEmijtHztNgwIE,
	geVHcZlrpiEaagZcypgy: geVHcZlrpiEaagZcypgy,
	SAruOCDnkHugkPOIFSc: SAruOCDnkHugkPOIFSc,
	yteHSDpgaHMYFeMBfpWk: yteHSDpgaHMYFeMBfpWk,
	slVffWcKrAhjpgaMEuY: slVffWcKrAhjpgaMEuY,
	ghYLDApWJBxFOzhqAlN: ghYLDApWJBxFOzhqAlN,
	GCxKMtkKAZPoOHsZIDh: GCxKMtkKAZPoOHsZIDh,
	uRLAPBsurxBqxfvgaSH: uRLAPBsurxBqxfvgaSH,
	FaQaEHvLdVELQbCZrFN: FaQaEHvLdVELQbCZrFN,
	RZgUzTVRaXNflgjshVf: RZgUzTVRaXNflgjshVf,
	nXPQNJCVxPkQKidfjnn: nXPQNJCVxPkQKidfjnn,
	swSisSeZXWyUyMvIu: swSisSeZXWyUyMvIu,
	HryFxrLzCqTGOVNrpI: HryFxrLzCqTGOVNrpI,
	QqwNZKCLuiPIswItY: QqwNZKCLuiPIswItY,
	gqfClfSZIJlpPGmuBjum: gqfClfSZIJlpPGmuBjum,
	HMclPwyZgRMKnvBRCr: HMclPwyZgRMKnvBRCr,
	iZKMHnInbVLuJJcbpbR: iZKMHnInbVLuJJcbpbR,
	VYJdtiuPscmItOfIyux: VYJdtiuPscmItOfIyux,
	sbzqRZRFyPyYqnsMtNy: sbzqRZRFyPyYqnsMtNy,
	SwDoMzvfeChtJIrEA: SwDoMzvfeChtJIrEA,
	pPViUnFnexhWKoFMx: pPViUnFnexhWKoFMx,
	NltNaOnxuMeUAbBeZ: NltNaOnxuMeUAbBeZ,
	HmXYHUAhkQnrZSfKu: HmXYHUAhkQnrZSfKu,
	KgKURwhHRUNpPmFtXTAv: KgKURwhHRUNpPmFtXTAv,
	thvmUblDYmiyVPacUB: thvmUblDYmiyVPacUB,
	ViAVfshtzuMNFpCqJl: ViAVfshtzuMNFpCqJl,
	sSrzMRNSGNzrJsidBnYz: sSrzMRNSGNzrJsidBnYz,
	wVSQKNQtitzmkbjDOac: wVSQKNQtitzmkbjDOac,
	rvLRPuoiEpNqnbxwWj: rvLRPuoiEpNqnbxwWj,
	CRMoLKUrfyLkDWFEuSu: CRMoLKUrfyLkDWFEuSu,
	GJOdwcCnvAbhzEkImJ: GJOdwcCnvAbhzEkImJ,
	pnGXcYRvktMyOUBwX: pnGXcYRvktMyOUBwX,
	fQOFawXqhywMOGSe: fQOFawXqhywMOGSe,
	KIIMnxhTdJBhZfaEMP: KIIMnxhTdJBhZfaEMP,
	hAacNWPacMHaAAaOw: hAacNWPacMHaAAaOw,
	aCtajuQWKCQNkeKgtwLb: aCtajuQWKCQNkeKgtwLb,
	XjTUjttgmruHnxFXgVf: XjTUjttgmruHnxFXgVf,
	ovsIpOdHmKskDqaansBG: ovsIpOdHmKskDqaansBG,
	RawXxpklaPpnKkAjXLL: RawXxpklaPpnKkAjXLL,
	dpnyHVmjzJjiqtQIfpD: dpnyHVmjzJjiqtQIfpD,
	CtiOEevtmgSCxLlIqb: CtiOEevtmgSCxLlIqb,
	HmoCuzIHcMwWJJxszus: HmoCuzIHcMwWJJxszus,
	xoPXukoFZulOsawPoPe: xoPXukoFZulOsawPoPe,
	FlbUChtSXKPaYQGW: FlbUChtSXKPaYQGW,
	XUWTeclWoXtMrQkJzuuq: XUWTeclWoXtMrQkJzuuq,
	YCHRDIIKsDzJFQJw: YCHRDIIKsDzJFQJw,
	hfBBkSOAXqfEsLVFs: hfBBkSOAXqfEsLVFs,
	aETDJvQumPoQnxdEPkQR: aETDJvQumPoQnxdEPkQR,
	zZXyblLWbONMNIjPmBN: zZXyblLWbONMNIjPmBN,
	gyneoIYPeiHgfaCY: gyneoIYPeiHgfaCY,
	ihVcXhmbhwIbsPsTbF: ihVcXhmbhwIbsPsTbF,
	ctaxFEnYnZIrAtOaYc: ctaxFEnYnZIrAtOaYc,
	tMlPwcyXKotAImFCGfQ: tMlPwcyXKotAImFCGfQ,
	SRUOTyGYueLSOwlA: SRUOTyGYueLSOwlA,
	rpFnFNTJlMZaopFU: rpFnFNTJlMZaopFU,
	sMMYOeSUIvHuRdqiC: sMMYOeSUIvHuRdqiC,
	fYiJCYMSTpHPjREdFLyB: fYiJCYMSTpHPjREdFLyB,
	XzXwpEBzHGPNkUqaw: XzXwpEBzHGPNkUqaw,
	YyrFTDoECNUvGnXVt: YyrFTDoECNUvGnXVt,
	leIEPguvvNFtRsXGFI: leIEPguvvNFtRsXGFI,
	yEMtEIJyJomPsTPTv: yEMtEIJyJomPsTPTv,
	EHBFEqMJtpPqVznA: EHBFEqMJtpPqVznA,
	IHceeEHwOOHjpdHosyOe: IHceeEHwOOHjpdHosyOe,
	kINzgREzBDTsegQCvHQ: kINzgREzBDTsegQCvHQ,
	ObVBBALqXaIzgsSPVQO: ObVBBALqXaIzgsSPVQO,
	ckNnmPAbtNOsWqlpAKy: ckNnmPAbtNOsWqlpAKy,
	nmOEDJmAsIcTkCgZMv: nmOEDJmAsIcTkCgZMv,
	jMXTehFeNbljMLGb: jMXTehFeNbljMLGb,
	ZbUUOchcpSOpwpIk: ZbUUOchcpSOpwpIk,
	lzbnQluepXRurDUf: lzbnQluepXRurDUf,
	xDfYpxodvMVDQJKav: xDfYpxodvMVDQJKav,
	XBrHgyrvVacGhRNJco: XBrHgyrvVacGhRNJco,
	cXhPoUARLvRqvesHQqeu: cXhPoUARLvRqvesHQqeu,
	tBDAaKFwVBeiyQnnTDIA: tBDAaKFwVBeiyQnnTDIA,
	PuqWAcBQEKXlfTuxDuD: PuqWAcBQEKXlfTuxDuD,
	yzrKsfyEambKetSgWv: yzrKsfyEambKetSgWv,
	NSkMpVyoVWGymUTOzL: NSkMpVyoVWGymUTOzL,
	JkoaUyCjjTHSNUEy: JkoaUyCjjTHSNUEy,
	LtnRgezlrxMzWvZBxRJ: LtnRgezlrxMzWvZBxRJ,
	jXvqhJJMhyxRdxCxv: jXvqhJJMhyxRdxCxv,
	YZKOONeeIQMFqysxrZ: YZKOONeeIQMFqysxrZ,
	nmicLlJCgyNNjjzKJUt: nmicLlJCgyNNjjzKJUt,
	BCZEHAhJNfTPwNSqVZl: BCZEHAhJNfTPwNSqVZl,
	zIFzaxTFaAhTdPpeh: zIFzaxTFaAhTdPpeh,
	tdxbonOdGqBYgBaOjc: tdxbonOdGqBYgBaOjc,
	XondKWeJxfchfIoGLe: XondKWeJxfchfIoGLe,
	ndyNHmtKJFFsefAzdv: ndyNHmtKJFFsefAzdv,
	FeBXkTWnPLzGZEnXEpg: FeBXkTWnPLzGZEnXEpg,
	QZCxVURndUpletXFScR: QZCxVURndUpletXFScR,
	UXOpXybkQBmLEHTAgw: UXOpXybkQBmLEHTAgw,
	BslmwdHcTinuPaihULw: BslmwdHcTinuPaihULw,
	jvnfqZRQbFEGTCMGbvT: jvnfqZRQbFEGTCMGbvT,
	NsZKEKPRgLQfWeSixA: NsZKEKPRgLQfWeSixA,
	icMsBwEbBUQztvmOv: icMsBwEbBUQztvmOv,
	dXXdlICxETXaAzDyY: dXXdlICxETXaAzDyY,
	zhFTdPuxrgMfcNWoA: zhFTdPuxrgMfcNWoA,
	pjPGNrHukGWKUheCaX: pjPGNrHukGWKUheCaX,
	uglsZRLSLmmcqItl: uglsZRLSLmmcqItl,
	nPqFzGTyChvJyTQw: nPqFzGTyChvJyTQw,
	mEPBGXtDbaIrisefS: mEPBGXtDbaIrisefS,
	dBZfEFBQmkatfptbV: dBZfEFBQmkatfptbV,
	jYUScsXfUCTPNPqSAR: jYUScsXfUCTPNPqSAR,
	OJjDmIeMWmMfkDihQu: OJjDmIeMWmMfkDihQu,
	JoPUjgxywPfIQlnDrzx: JoPUjgxywPfIQlnDrzx,
	ZVRKVLGoMmmrOxLzg: ZVRKVLGoMmmrOxLzg,
	HYklWTwhtonjbiQRYCz: HYklWTwhtonjbiQRYCz,
	RsjGGXbMJbrislSlWM: RsjGGXbMJbrislSlWM,
	wEarLFdfZMShsSfacNU: wEarLFdfZMShsSfacNU,
	eEcajuQQvABwGKndqss: eEcajuQQvABwGKndqss,
	EfIjGkMogFrJyNKuWar: EfIjGkMogFrJyNKuWar,
	JaPjOXJRPJqsTDLdU: JaPjOXJRPJqsTDLdU,
	cuKtQbYgXOwLPEbN: cuKtQbYgXOwLPEbN,
	BVmyvtMVCbAJXhwSpT: BVmyvtMVCbAJXhwSpT,
	NRUPVKxKVtYaCDVPq: NRUPVKxKVtYaCDVPq,
	szgmmxxDYVvTLNzPkk: szgmmxxDYVvTLNzPkk,
	mJjedBCPidtXUCYHus: mJjedBCPidtXUCYHus,
	IIbmROzHEYCycsCyk: IIbmROzHEYCycsCyk,
	knoGdfgXpoVeAMqHCXu: knoGdfgXpoVeAMqHCXu,
	SBLHeXGlsYVIdiBNRe: SBLHeXGlsYVIdiBNRe,
	AocjyYzlYgRsGzlavU: AocjyYzlYgRsGzlavU,
	wQEsyNYfqlFrkqUvaDx: wQEsyNYfqlFrkqUvaDx,
	rbefbFgPVyawmaktVYF: rbefbFgPVyawmaktVYF,
	MjEyxNUcFsFMIjsOIDpg: MjEyxNUcFsFMIjsOIDpg,
	ygnbLzvTAMIylzNxj: ygnbLzvTAMIylzNxj,
	peIDsRhrNLVzQmAQWg: peIDsRhrNLVzQmAQWg,
	BbqJaDHRCDmiNwNVcGB: BbqJaDHRCDmiNwNVcGB,
	LESgEuOUJYjZQYLUlO: LESgEuOUJYjZQYLUlO,
	hsgIRJDqXwkPnsmgktga: hsgIRJDqXwkPnsmgktga,
	mDlqsQlmoApWZXHKLq: mDlqsQlmoApWZXHKLq,
	DjgcgdUJtoNmqshNSb: DjgcgdUJtoNmqshNSb,
	FxlLNwkBHAbChJrnM: FxlLNwkBHAbChJrnM,
	NuZslGbiHniUKgycjhmv: NuZslGbiHniUKgycjhmv,
	AdLFmhSQGMGYrTgXdUH: AdLFmhSQGMGYrTgXdUH,
	rQiWsAGGRmEQCtfaIK: rQiWsAGGRmEQCtfaIK,
	HjfxCIPqXHVRBXeofOe: HjfxCIPqXHVRBXeofOe,
	CwyRzEeuIMzGRVzVdSVg: CwyRzEeuIMzGRVzVdSVg,
	MgdMcyuZEloUdpqcv: MgdMcyuZEloUdpqcv,
	yKqxJEvOxokRNAPXYDZC: yKqxJEvOxokRNAPXYDZC,
	FIvibwVWwddLxzofT: FIvibwVWwddLxzofT,
	HQLJuhRwbVdfCwEp: HQLJuhRwbVdfCwEp,
	irXsKkZagNKDlvCyhKYK: irXsKkZagNKDlvCyhKYK,
	RQJGnpiCuJKbplbuWeaj: RQJGnpiCuJKbplbuWeaj,
	ULhbQlNBpFJzLTlp: ULhbQlNBpFJzLTlp,
	DmecbpJQgGJiVjTqP: DmecbpJQgGJiVjTqP,
	qltXLGplQJNtHWdY: qltXLGplQJNtHWdY,
	vamuznzHAJqilfEEP: vamuznzHAJqilfEEP,
	oGNuorHWcxXehehzCno: oGNuorHWcxXehehzCno,
	pFjSwsuOrRtiguvbEc: pFjSwsuOrRtiguvbEc,
	VZMtxSlhbTKcmTYeEsW: VZMtxSlhbTKcmTYeEsW,
	ivAXIbjvUUQpQqpmXz: ivAXIbjvUUQpQqpmXz,
	thJZdZfDKDEFyETsPyzj: thJZdZfDKDEFyETsPyzj,
	mrdEVkqkBIuEBVzzL: mrdEVkqkBIuEBVzzL,
	JWctZqDXJyyraLbOe: JWctZqDXJyyraLbOe,
	rXWcwotndeKQsLjAdyrw: rXWcwotndeKQsLjAdyrw,
	ZuxEmUvBYSsOHORKrFrd: ZuxEmUvBYSsOHORKrFrd,
	TfIbvRVtJxzInjuIwq: TfIbvRVtJxzInjuIwq,
	YBvzRbRVqKkwTDkNDfoc: YBvzRbRVqKkwTDkNDfoc,
	pJTXUuIjycHTetIC: pJTXUuIjycHTetIC,
	razdiXXHIkQKbPQTZn: razdiXXHIkQKbPQTZn,
	WCGnQDmVyXVqLZPQyqYs: WCGnQDmVyXVqLZPQyqYs,
	NgUCFdNkwlZfzWkAiv: NgUCFdNkwlZfzWkAiv,
	sdgZycbHzMUKHwVH: sdgZycbHzMUKHwVH,
	xQtzLCbkmmYpqCXOwRT: xQtzLCbkmmYpqCXOwRT,
	rKSrOqgimgcTrDutYUA: rKSrOqgimgcTrDutYUA,
	nFlxQWOJCGHgwwHQhP: nFlxQWOJCGHgwwHQhP,
	sMvNZNODlnAIiuzFMR: sMvNZNODlnAIiuzFMR,
	RrEKjSeFQrtvLrZIO: RrEKjSeFQrtvLrZIO,
	QnjpooahLXRwxGqJIVt: QnjpooahLXRwxGqJIVt,
	qZljkUmjmSBKpnUsYfp: qZljkUmjmSBKpnUsYfp,
	kjqqAmIhgKSjlBVQx: kjqqAmIhgKSjlBVQx,
	WfJRbDGlqfLFvNVzyWu: WfJRbDGlqfLFvNVzyWu,
	wgbBNytjmVvMvqRkRL: wgbBNytjmVvMvqRkRL,
	pXHPsbEpWSnCyJGH: pXHPsbEpWSnCyJGH,
	CRbVirgSccJqKzSUSEau: CRbVirgSccJqKzSUSEau,
	FgrxZUNDleeDGneKmwd: FgrxZUNDleeDGneKmwd,
	uJpZAZRdzpyAaUkEqwSx: uJpZAZRdzpyAaUkEqwSx,
	elXgEtyDNXczWYbDHV: elXgEtyDNXczWYbDHV,
	LiwpXDoMAXANnTRZ: LiwpXDoMAXANnTRZ,
	wfRBtzUHBPZjVDxUc: wfRBtzUHBPZjVDxUc,
	xrfefvhsEfCoJokIdeW: xrfefvhsEfCoJokIdeW,
	gapTtWntRtJcQzRtBz: gapTtWntRtJcQzRtBz,
	NhBzijnKrdihICUwgi: NhBzijnKrdihICUwgi,
	PdxWoNDxKAJmNcpe: PdxWoNDxKAJmNcpe,
	AHMRWIOaHFIWiIPqUx: AHMRWIOaHFIWiIPqUx,
	LDNvolWeNGwNyvpTMnL: LDNvolWeNGwNyvpTMnL,
	uYLqhJrdDgRVWcNvDpr: uYLqhJrdDgRVWcNvDpr,
	ZnbyJyzHTxzgLRDFBmEm: ZnbyJyzHTxzgLRDFBmEm,
	FTVpPZybylBmTnwhMhtx: FTVpPZybylBmTnwhMhtx,
	THMxZAxLcuuIfPErpGb: THMxZAxLcuuIfPErpGb,
	bTWntlsiiBougPgd: bTWntlsiiBougPgd,
	zIgntQSydRspYJCaQ: zIgntQSydRspYJCaQ,
	vPVjNqmPYGCrexspl: vPVjNqmPYGCrexspl,
	oMgGPGaGAlElFewgOv: oMgGPGaGAlElFewgOv,
	iqCHKgJKHatuZHiXEFm: iqCHKgJKHatuZHiXEFm,
	dHIzNCfEthjGsjpMsfJN: dHIzNCfEthjGsjpMsfJN,
	VALtZMIyzODbkpPUOsxG: VALtZMIyzODbkpPUOsxG,
	OOtkDwkZMvTavtRmc: OOtkDwkZMvTavtRmc,
	bRDTmhggLlBbrbdtfhM: bRDTmhggLlBbrbdtfhM,
	IzXQAIEgQLMYmZwrzP: IzXQAIEgQLMYmZwrzP,
	xjuVMsJZTRgjPgAzSV: xjuVMsJZTRgjPgAzSV,
	WACiElgvWMUDhQMxa: WACiElgvWMUDhQMxa,
	USZqODoQgzwaggnbb: USZqODoQgzwaggnbb,
	KChGPohSmJORAMDUqSs: KChGPohSmJORAMDUqSs,
	oGZZfIIocJcraogK: oGZZfIIocJcraogK,
	pAYXQPFeRbuYruZa: pAYXQPFeRbuYruZa,
	aaOdxWUHHLynEVSoWTM: aaOdxWUHHLynEVSoWTM,
	jSQVlHGDwxAZujRJNiSh: jSQVlHGDwxAZujRJNiSh,
	uuluQlsJBdDsslsERZX: uuluQlsJBdDsslsERZX,
	ACweJQrKoWgpyYspyEl: ACweJQrKoWgpyYspyEl,
	JLIvWEpTgjlkpsZBM: JLIvWEpTgjlkpsZBM,
	UfkUhznLfeqzZyTdAebx: UfkUhznLfeqzZyTdAebx,
	FxzVGfjClbeUZeEero: FxzVGfjClbeUZeEero,
	WjPizXTxbdPnvLWMql: WjPizXTxbdPnvLWMql,
	ytFXzDnzPIGUhOOClJ: ytFXzDnzPIGUhOOClJ,
	dWHEObNDvkCjTnlvH: dWHEObNDvkCjTnlvH,
	lfjjwhqpvFBikfhkifrN: lfjjwhqpvFBikfhkifrN,
	gGrAIKLFJuNxbjhnZz: gGrAIKLFJuNxbjhnZz,
	trJoqkSnMVAvbRgAY: trJoqkSnMVAvbRgAY,
	CyNhoDlSuMvcxydtF: CyNhoDlSuMvcxydtF,
	dpvvLNDzKxLZIuixW: dpvvLNDzKxLZIuixW,
	cYSzpXPrPUQxaAGTihK: cYSzpXPrPUQxaAGTihK,
	kYGDyxESdKUNNTdG: kYGDyxESdKUNNTdG,
	UqNGOztCBezyeAgI: UqNGOztCBezyeAgI,
	TWuwXEwzngPlnjELUJ: TWuwXEwzngPlnjELUJ,
	AUNMAupfnBRbGlrb: AUNMAupfnBRbGlrb,
	EqpPTPZsKjTArTFVgWp: EqpPTPZsKjTArTFVgWp,
	oiSDCKooPzMznfGteAG: oiSDCKooPzMznfGteAG,
	DSFAJhsSefQQEdBBlUyt: DSFAJhsSefQQEdBBlUyt,
	aaKDUKbsmRiynWiqlS: aaKDUKbsmRiynWiqlS,
	eDeADqoJRnEUGotYxzY: eDeADqoJRnEUGotYxzY,
	CDwWwMbhHZXYRMZHKnpO: CDwWwMbhHZXYRMZHKnpO,
	fjjnxDoEsAfrEGSbNUL: fjjnxDoEsAfrEGSbNUL,
	qqXTaCjhvvMrmeJpPG: qqXTaCjhvvMrmeJpPG,
	RMCuKzWRRjQNKUNP: RMCuKzWRRjQNKUNP,
	qipDilqNVyHfNJVyF: qipDilqNVyHfNJVyF,
	CuzRRZhhkOmuQgeVt: CuzRRZhhkOmuQgeVt,
	VoqaSnQNOfXstSBxca: VoqaSnQNOfXstSBxca,
	ZCRfudjxgEkJLycN: ZCRfudjxgEkJLycN,
	tdxlCkYgrpQOxYYJZiF: tdxlCkYgrpQOxYYJZiF,
	RZiGRHwDUpYgJcRLRnxa: RZiGRHwDUpYgJcRLRnxa,
	aXbxDDurboZtvnPno: aXbxDDurboZtvnPno,
	OUDeIeQIjCliBQIHe: OUDeIeQIjCliBQIHe,
	AbrPzuZLAZwUuIBnbx: AbrPzuZLAZwUuIBnbx,
	JJAtBenOLOlFaFaP: JJAtBenOLOlFaFaP,
	YWCMpmGuparutCzjXpp: YWCMpmGuparutCzjXpp,
	aCYhhkYhhIrzUQvFB: aCYhhkYhhIrzUQvFB,
	sVTrHBZPprcyXLgcE: sVTrHBZPprcyXLgcE,
	oGHfMwDNMhRcKszx: oGHfMwDNMhRcKszx,
	hYWPDZZNtYYwiYMfUfjX: hYWPDZZNtYYwiYMfUfjX,
	NIxMpJepTIBNynamgjj: NIxMpJepTIBNynamgjj,
	onaIGydLoNFhYUGyo: onaIGydLoNFhYUGyo,
	nkENghGiqpNyJlRpBv: nkENghGiqpNyJlRpBv,
	eEBDsqLdNoLOJxjVc: eEBDsqLdNoLOJxjVc,
	SJBETCfUKQwBPbOwXhs: SJBETCfUKQwBPbOwXhs,
	TbviyxwhVLMOhttn: TbviyxwhVLMOhttn,
	SFeLOdYxYJLeOgLtZI: SFeLOdYxYJLeOgLtZI,
	IKImbOtCOwEOtcDsMLv: IKImbOtCOwEOtcDsMLv,
	woYYXxIEUCPOPTbYi: woYYXxIEUCPOPTbYi,
	XVImLdGTpJvSndfrLlee: XVImLdGTpJvSndfrLlee,
	ylhkcCPZqNeskQBJB: ylhkcCPZqNeskQBJB,
	gLehflpqCNwIhEtbYIAz: gLehflpqCNwIhEtbYIAz,
	BEfhHOirsmwpDEilDbq: BEfhHOirsmwpDEilDbq,
	WzIAmgVLQnPRHGRfGw: WzIAmgVLQnPRHGRfGw,
	zcamcMLRNetHERtiy: zcamcMLRNetHERtiy,
	NStCDznwhsZPGYrJAq: NStCDznwhsZPGYrJAq,
	pucEyENFLLeSzsJUK: pucEyENFLLeSzsJUK,
	EqbYvDbdIrmgXbrPPAO: EqbYvDbdIrmgXbrPPAO,
	pyuZUzzDPovDumukD: pyuZUzzDPovDumukD,
	xxgsgyEjhfwrMflwMr: xxgsgyEjhfwrMflwMr,
	PVcSgRlruKdhLYAvMUG: PVcSgRlruKdhLYAvMUG,
	BIVIQEHEPCzGuQpNKSR: BIVIQEHEPCzGuQpNKSR,
	GhRAIjbecBWjePTjqSD: GhRAIjbecBWjePTjqSD,
	qsVtkTgbKcuLSPDXf: qsVtkTgbKcuLSPDXf,
	WINbdlmnRMSyZUqkxCP: WINbdlmnRMSyZUqkxCP,
	bnpgtsIPDfFydCQlTH: bnpgtsIPDfFydCQlTH,
	BgXkLkPusAcJBiUmSw: BgXkLkPusAcJBiUmSw,
	OARZuIqYLXtlrvaEsC: OARZuIqYLXtlrvaEsC,
	YLJxFxxsgqpWcZWy: YLJxFxxsgqpWcZWy,
	RjPDzDdrzBcLHVJiG: RjPDzDdrzBcLHVJiG,
	DrmqiYKPSoxMBWXT: DrmqiYKPSoxMBWXT,
	nSdDtaHzknwZAXJHzrGP: nSdDtaHzknwZAXJHzrGP,
	NZjrOkmPAHtiaMLyuVDA: NZjrOkmPAHtiaMLyuVDA,
	XfjZomFsTRpbZJuHjI: XfjZomFsTRpbZJuHjI,
	lxppTPAJDxxMIGdmiRG: lxppTPAJDxxMIGdmiRG,
	OljlLKYobPynbcStGlN: OljlLKYobPynbcStGlN,
	YXrqAGUqprWfOCeiSGX: YXrqAGUqprWfOCeiSGX,
	MkfqKEzRwLTbzJEOeWg: MkfqKEzRwLTbzJEOeWg,
	vshrtYQXEVpbXmLZwV: vshrtYQXEVpbXmLZwV,
	wINMfXpJczhYZOnUXWp: wINMfXpJczhYZOnUXWp,
	uetkXvxfFuKnhpBFrA: uetkXvxfFuKnhpBFrA,
	sZVlKBQCGGTVChpa: sZVlKBQCGGTVChpa,
	AZVALNHESdbXtHmNY: AZVALNHESdbXtHmNY,
	pVQoQWJNGEfRwmpZMki: pVQoQWJNGEfRwmpZMki,
	HsxgqsfmdLnIcdcXgLS: HsxgqsfmdLnIcdcXgLS,
	gohHRZTjodstzoCLNv: gohHRZTjodstzoCLNv,
	rfXBETBheWYaMqrktE: rfXBETBheWYaMqrktE,
	rxfIffMgcmDGmXfVZA: rxfIffMgcmDGmXfVZA,
	ifmHgobawgqPHdruP: ifmHgobawgqPHdruP,
	AkLeJkGIGPcgMPOyMJvd: AkLeJkGIGPcgMPOyMJvd,
	SLZgFNtUooxfLTcXEnm: SLZgFNtUooxfLTcXEnm,
	APOikjpbuiZXwYbMlWBl: APOikjpbuiZXwYbMlWBl,
	pEZOQJSBxlCYyrjM: pEZOQJSBxlCYyrjM,
	IKLXXpDUJHlgctnhc: IKLXXpDUJHlgctnhc,
	GSkKAUsvGPYZMAnFnH: GSkKAUsvGPYZMAnFnH,
	HIptAJwjtWvHteUhwW: HIptAJwjtWvHteUhwW,
	ETkemdVBXuBSBAstv: ETkemdVBXuBSBAstv,
	fUqbBtyQPrkRchcpe: fUqbBtyQPrkRchcpe,
	wprsRqdyQRGnVcbsp: wprsRqdyQRGnVcbsp,
	zDKhBsXavFMPAEqgdH: zDKhBsXavFMPAEqgdH,
	PpelPkXnzahxkdhVa: PpelPkXnzahxkdhVa,
	XvACoEmpLFSLVHywT: XvACoEmpLFSLVHywT,
	hhiTSbgqtfHswnyfCs: hhiTSbgqtfHswnyfCs,
	jwkMtTwNHEktKLQA: jwkMtTwNHEktKLQA,
	aTPVtxAhNeuzjutYgu: aTPVtxAhNeuzjutYgu,
	CSMPJDQZLtdBrHSlRhzp: CSMPJDQZLtdBrHSlRhzp,
	OYByrRpUomOXEqORBozE: OYByrRpUomOXEqORBozE,
	pQEEhEzMgmLpEznsEH: pQEEhEzMgmLpEznsEH,
	HNUebnMoRCmoPDEpASH: HNUebnMoRCmoPDEpASH,
	ARCAktOTCiLqQqaPTv: ARCAktOTCiLqQqaPTv,
	LJPMiQOhqtJqlBRBCHX: LJPMiQOhqtJqlBRBCHX,
	lvouKixXkMbDqOnnr: lvouKixXkMbDqOnnr,
	FRjQUDLIESvWvPOQY: FRjQUDLIESvWvPOQY,
	JNPXLHStukWLfpLRU: JNPXLHStukWLfpLRU,
	dQRnMUSMOEdAwdfMqW: dQRnMUSMOEdAwdfMqW,
	cHodlBcOiNHOlxFn: cHodlBcOiNHOlxFn,
	tglvvZIzjMuxIoXEYs: tglvvZIzjMuxIoXEYs,
	yDGXBsHUIoIkgqfepe: yDGXBsHUIoIkgqfepe,
	lsdjJQPYPEOcAzVOth: lsdjJQPYPEOcAzVOth,
	PlIgEPTbgrrwkSuHc: PlIgEPTbgrrwkSuHc,
	NqhjvGQWWHnmAzDH: NqhjvGQWWHnmAzDH,
	QNEAoNoQfTpYIxJvjdM: QNEAoNoQfTpYIxJvjdM,
	MhWCMBfnPEmyPhdBJC: MhWCMBfnPEmyPhdBJC,
	rcbvwVBVHsJazGKrQv: rcbvwVBVHsJazGKrQv,
	HsYTxsCouoyySItw: HsYTxsCouoyySItw,
	CNXhqxsuJtAEOpHCSI: CNXhqxsuJtAEOpHCSI,
	iQYmhTkvoynVhdKfkY: iQYmhTkvoynVhdKfkY,
	lLKoAhJqRLmDyyTCvO: lLKoAhJqRLmDyyTCvO,
	bNcNiQWtnacHBQFyTY: bNcNiQWtnacHBQFyTY,
	JIozcUyGaPUboZLlBjVN: JIozcUyGaPUboZLlBjVN,
	tNbQTPYLVCKjsvpja: tNbQTPYLVCKjsvpja,
	UrkVGOIalMNhKwpIEzK: UrkVGOIalMNhKwpIEzK,
	cCtaFICzFmzJltYPL: cCtaFICzFmzJltYPL,
	SVpHROUKzBJsjSVHMK: SVpHROUKzBJsjSVHMK,
	UMTZPjOpYZuhdhDbBVO: UMTZPjOpYZuhdhDbBVO,
	iBQIPIJCNFHBCeRIvm: iBQIPIJCNFHBCeRIvm,
	nedDtIXJkIrvdDqe: nedDtIXJkIrvdDqe,
	xWhLpCcRjLgSplng: xWhLpCcRjLgSplng,
	DZjgiswpELVABBqUWCSa: DZjgiswpELVABBqUWCSa,
	XrngZedCHgJUKulaDcT: XrngZedCHgJUKulaDcT,
	fWgPNysKDTLrzjgrexk: fWgPNysKDTLrzjgrexk,
	QIzonbZxYqJjQrPHfJM: QIzonbZxYqJjQrPHfJM,
	iHptEcwFnEbHVLaQkXyb: iHptEcwFnEbHVLaQkXyb,
	uUpDUGTUrKdXVQXkgSP: uUpDUGTUrKdXVQXkgSP,
	HzbSujYkGuYtObRcrdbh: HzbSujYkGuYtObRcrdbh,
	NOYdleknddFOfQxlNOI: NOYdleknddFOfQxlNOI,
	nqPKzhAfSmqRRIHii: nqPKzhAfSmqRRIHii,
	eOPHosimYamraEKUukBz: eOPHosimYamraEKUukBz,
	LoBOFhdSzMFjdqZgDE: LoBOFhdSzMFjdqZgDE,
	mHVIpiFPJQPNPFYAeeu: mHVIpiFPJQPNPFYAeeu,
	TNXdbUElFLwiyRVKuJ: TNXdbUElFLwiyRVKuJ,
	wLQWZKMRgmTJTSudW: wLQWZKMRgmTJTSudW,
	GkvuBozDTWJAXbpwyP: GkvuBozDTWJAXbpwyP,
	IMxXGyWWPXtfrrwxV: IMxXGyWWPXtfrrwxV,
	tibiqQyzvztLFMGQ: tibiqQyzvztLFMGQ,
	fXTeVLzGkVECTSGgtm: fXTeVLzGkVECTSGgtm,
	XYVTanLxxisBNzaOFx: XYVTanLxxisBNzaOFx,
	bdAMbKWoEuDxlGOg: bdAMbKWoEuDxlGOg,
	ALJjPGCRLTrnWlbmqO: ALJjPGCRLTrnWlbmqO,
	znOXnaDhTySukBeCrT: znOXnaDhTySukBeCrT,
	ESHCFsWVeQAWSnEKV: ESHCFsWVeQAWSnEKV,
	lLAJPCrarwsWDdbLaw: lLAJPCrarwsWDdbLaw,
	biXQrrlOVDoExCZZKC: biXQrrlOVDoExCZZKC,
	spot_trading: spot_trading,
	MTiCVGmtBjEPWzsw: MTiCVGmtBjEPWzsw,
	zLnEBdSfUXdqbRqAohY: zLnEBdSfUXdqbRqAohY,
	oVvhpgfhTeyLLnTSv: oVvhpgfhTeyLLnTSv,
	OEfurFwwcJaTsVxNdol: OEfurFwwcJaTsVxNdol,
	TeRrrjzubYVYnBhsdpD: TeRrrjzubYVYnBhsdpD,
	xwQqYnxnxmeJPqRlQ: xwQqYnxnxmeJPqRlQ,
	hoTQEpJFfRRLZGLWiDK: hoTQEpJFfRRLZGLWiDK,
	wZuMVSBUSlQidCQpjoS: wZuMVSBUSlQidCQpjoS,
	oSDxsXgENbIeNMLv: oSDxsXgENbIeNMLv,
	aoAIqdHabiquSjWWz: aoAIqdHabiquSjWWz,
	YltriUZdkgLJuXZi: YltriUZdkgLJuXZi,
	sZudUtmwNMYVhQhyj: sZudUtmwNMYVhQhyj,
	slqgnwkLOtCyZiTBWb: slqgnwkLOtCyZiTBWb,
	PwxbwKVPjpeCuRYx: PwxbwKVPjpeCuRYx,
	domCttddTWzCfimSWOq: domCttddTWzCfimSWOq,
	dqLNRujTTFLifcFaybP: dqLNRujTTFLifcFaybP,
	wIfwelYvkemWaZGE: wIfwelYvkemWaZGE,
	vDIneAtEexNLfRMcVPa: vDIneAtEexNLfRMcVPa,
	YYzgmIpjtorJXoyQJUk: YYzgmIpjtorJXoyQJUk,
	rZkFVZvvCQRyHCfLiNVX: rZkFVZvvCQRyHCfLiNVX,
	VXwjemLYMJiNKvXlZ: VXwjemLYMJiNKvXlZ,
	GZOFzxVOsYtRtlONwcv: GZOFzxVOsYtRtlONwcv,
	YiNdDLTlBGFQiuNECi: YiNdDLTlBGFQiuNECi,
	aFykbSRCZkUrYNzoKtk: aFykbSRCZkUrYNzoKtk,
	TgilgrTuMXgbAQuPf: TgilgrTuMXgbAQuPf,
	MQaUVFeBMhHfKxmBUV: MQaUVFeBMhHfKxmBUV,
	HgKGDukwWWdCeZlibVY: HgKGDukwWWdCeZlibVY,
	rhXOjsQATKgJNizniW: rhXOjsQATKgJNizniW,
	pKuaKUWJHuajbExMUs: pKuaKUWJHuajbExMUs,
	nkcDnQvbZpDfYMepAc: nkcDnQvbZpDfYMepAc,
	UHAKvmcFPrannQlFz: UHAKvmcFPrannQlFz,
	MmdyZCvMXusVhfjsV: MmdyZCvMXusVhfjsV,
	MGsQCMXzOIuqcXjBDDTF: MGsQCMXzOIuqcXjBDDTF,
	xYFrGCCcvvWooWsibQFD: xYFrGCCcvvWooWsibQFD,
	omBdaJrTBmDrBzNYx: omBdaJrTBmDrBzNYx,
	omTkmNnwlfkOvozU: omTkmNnwlfkOvozU,
	YxGqBoJIoXruDOmbNu: YxGqBoJIoXruDOmbNu,
	NOhPBjPDsgVbfqTgjIH: NOhPBjPDsgVbfqTgjIH,
	gcFEhAlcWmjNfIqry: gcFEhAlcWmjNfIqry,
	npetoxnFYOYxRjXRN: npetoxnFYOYxRjXRN,
	TzvXfzahEvyWlLOZQE: TzvXfzahEvyWlLOZQE,
	LuuhHZgOxbTJDvnm: LuuhHZgOxbTJDvnm,
	sqteSBzbeJvwJeJSWZk: sqteSBzbeJvwJeJSWZk,
	uhoCqEIxFLCGpwTslFY: uhoCqEIxFLCGpwTslFY,
	OzYooSlNbfNTxRxNhe: OzYooSlNbfNTxRxNhe,
	JQpSpVQqatEXOdgFvjh: JQpSpVQqatEXOdgFvjh,
	onOjgIPTpDDXLIwlSWE: onOjgIPTpDDXLIwlSWE,
	gDgIYTmDidzeeXyOV: gDgIYTmDidzeeXyOV,
	cOOoOlxMURFANNpFpYx: cOOoOlxMURFANNpFpYx,
	nAVsbekWuHffflMnfHHy: nAVsbekWuHffflMnfHHy,
	WelPCqxRFgXNzpkZJdsh: WelPCqxRFgXNzpkZJdsh,
	npqmwWmfuEsNrfQJt: npqmwWmfuEsNrfQJt,
	wcfFqisAqLRlhbKdJk: wcfFqisAqLRlhbKdJk,
	wcJAFtgivjbkVSdTC: wcJAFtgivjbkVSdTC,
	pSUGpUOowrIgSHLfEIs: pSUGpUOowrIgSHLfEIs,
	cWYINWiSUUdFuDAImP: cWYINWiSUUdFuDAImP,
	tUrSbGVjlpoCdTkb: tUrSbGVjlpoCdTkb,
	YvXCqALOsnrEQAHU: YvXCqALOsnrEQAHU,
	JJfMolWuWCFgrDrUiz: JJfMolWuWCFgrDrUiz,
	plHTmWdGncJPnVBJuI: plHTmWdGncJPnVBJuI,
	HbkwQxpXzqUXEvkxVmz: HbkwQxpXzqUXEvkxVmz,
	KOycuFuoXkNBrUCLtCVL: KOycuFuoXkNBrUCLtCVL,
	yYxnWdRQrNPhFUhmKp: yYxnWdRQrNPhFUhmKp,
	oWOQzlGOqirSVhUhQX: oWOQzlGOqirSVhUhQX,
	xbTIXxCJIOnbLImHUPI: xbTIXxCJIOnbLImHUPI,
	VSmzJHKoDZuNenetubvZ: VSmzJHKoDZuNenetubvZ,
	YJlyfJbAZRZhGensD: YJlyfJbAZRZhGensD,
	SuSDXCILmprzPXIonL: SuSDXCILmprzPXIonL,
	FnrHWNqUvXlpfQLAfT: FnrHWNqUvXlpfQLAfT,
	uPrPwsvUYglduYxnfgb: uPrPwsvUYglduYxnfgb,
	BvERvFYtRmpkINLVdX: BvERvFYtRmpkINLVdX,
	MSaPBxOSKeCTtUMPq: MSaPBxOSKeCTtUMPq,
	olGkjZMWDZBQwjnVK: olGkjZMWDZBQwjnVK,
	PmdVNRJcWUxjWfFSA: PmdVNRJcWUxjWfFSA,
	gCLhGVwztVSCPNZUgqQN: gCLhGVwztVSCPNZUgqQN,
	FDynUJSlxYFxtAhrQN: FDynUJSlxYFxtAhrQN,
	UBCBvFlsnzzgcIOHTmN: UBCBvFlsnzzgcIOHTmN,
	MERzsdKkxudpOnlaF: MERzsdKkxudpOnlaF,
	XtpeIeGyrDDKSkgyCiL: XtpeIeGyrDDKSkgyCiL,
	LxcfZSEIROwQeVCok: LxcfZSEIROwQeVCok,
	fxjdlTQeJFVyjFXmhlnI: fxjdlTQeJFVyjFXmhlnI,
	aVbJYJuVEhKXAqlbWgUE: aVbJYJuVEhKXAqlbWgUE,
	yicaYCvBFspqWpPqS: yicaYCvBFspqWpPqS,
	YLfvFQfagZeMpkzlO: YLfvFQfagZeMpkzlO,
	fsjyqgrUVSYOXDUxw: fsjyqgrUVSYOXDUxw,
	WQsiZpVbrxKoaVkQ: WQsiZpVbrxKoaVkQ,
	KpLdefqDhhhdklLzxOgC: KpLdefqDhhhdklLzxOgC,
	WbJXVvgJiwcWWgRAYq: WbJXVvgJiwcWWgRAYq,
	EcnKFNIFTwRUshkf: EcnKFNIFTwRUshkf,
	xGdbGnjcDCabqvFJX: xGdbGnjcDCabqvFJX,
	olJXBlENebamalqAmC: olJXBlENebamalqAmC,
	lnaNMhKSbkHzoYmMHp: lnaNMhKSbkHzoYmMHp,
	MFJyykUbSXUkUqHxlJ: MFJyykUbSXUkUqHxlJ,
	UsVahXMYImjwSrxR: UsVahXMYImjwSrxR,
	XjUPUpsmbzqDVlOyOzD: XjUPUpsmbzqDVlOyOzD,
	bYjpHFpkXBumbkZHbM: bYjpHFpkXBumbkZHbM,
	nZkngKdQlMblSkIsJt: nZkngKdQlMblSkIsJt,
	vfiTAWyuaCrULibnur: vfiTAWyuaCrULibnur,
	hubWrmcrofRaRoYLCAS: hubWrmcrofRaRoYLCAS,
	dIOuyFmCcSAXzBifCgd: dIOuyFmCcSAXzBifCgd,
	AoqexRnXPjWiaXQQ: AoqexRnXPjWiaXQQ,
	wtPiDpoJwweHEwGphG: wtPiDpoJwweHEwGphG,
	YFShWZLtmVzhKApQSudo: YFShWZLtmVzhKApQSudo,
	EyxlrwvHrdhvRaHtLxx: EyxlrwvHrdhvRaHtLxx,
	YbTVKYSCHSNbVSRpbwRM: YbTVKYSCHSNbVSRpbwRM,
	rWOqJloUMhKXCZHLpnc: rWOqJloUMhKXCZHLpnc,
	nmuzQLDdidsSBtDTLaU: nmuzQLDdidsSBtDTLaU,
	cKeVqkUVuUrblpSkN: cKeVqkUVuUrblpSkN,
	KgtuAymJbpqjZHQACDKA: KgtuAymJbpqjZHQACDKA,
	WriODPyMHmFqbNRIkh: WriODPyMHmFqbNRIkh,
	kdGDbDfHqPdMmOODj: kdGDbDfHqPdMmOODj,
	fRcWTONIbiPEHREbRTKI: fRcWTONIbiPEHREbRTKI,
	MIqinsTMANLFyEzWlLXm: MIqinsTMANLFyEzWlLXm,
	xmSClcrPuftAggqMjWp: xmSClcrPuftAggqMjWp,
	uPEmuahfZCJKifAf: uPEmuahfZCJKifAf,
	NazoeCHUJpEyQWZDKcVt: NazoeCHUJpEyQWZDKcVt,
	ZtmHIANowsUTyUyouyg: ZtmHIANowsUTyUyouyg,
	DyXvKDfsUBPKtQScEVw: DyXvKDfsUBPKtQScEVw,
	SGvHMSujomhCIGweYcH: SGvHMSujomhCIGweYcH,
	xFLmujpTZsyQKTENeNr: xFLmujpTZsyQKTENeNr,
	xPXNyAgtdawfwFRxXhb: xPXNyAgtdawfwFRxXhb,
	VoQarJJpktEfEZnK: VoQarJJpktEfEZnK,
	wfUNVCtRXprhwYwce: wfUNVCtRXprhwYwce,
	nirNFLwkcuvUxudti: nirNFLwkcuvUxudti,
	GqlajLqwcNJLpTqq: GqlajLqwcNJLpTqq,
	NKaDUgPomETDmcmKHy: NKaDUgPomETDmcmKHy,
	OsCIqseGbbbWXxBLk: OsCIqseGbbbWXxBLk,
	DghVzIJcKyuvkcKwY: DghVzIJcKyuvkcKwY,
	XYnywMktJDrWPwZBA: XYnywMktJDrWPwZBA,
	bgnQSQsWYPIcUDEytcq: bgnQSQsWYPIcUDEytcq,
	erGplJlLIBiVheXvc: erGplJlLIBiVheXvc,
	epeFMTUcZAYdtLOETgZ: epeFMTUcZAYdtLOETgZ,
	oIIfiHdqGwpXZbtDYKG: oIIfiHdqGwpXZbtDYKG,
	mlUEUuDRftKStSMvF: mlUEUuDRftKStSMvF,
	nNgFtrjyhesGreVhV: nNgFtrjyhesGreVhV,
	ewrHdSoDPutFlPrqTEr: ewrHdSoDPutFlPrqTEr,
	ZZlJgALCrsSaNhaoV: ZZlJgALCrsSaNhaoV,
	OgusvSSbzkNopiGbCIo: OgusvSSbzkNopiGbCIo,
	nmPUwVVQoncVHqMln: nmPUwVVQoncVHqMln,
	mWaNsXTgUIcnWSphpgB: mWaNsXTgUIcnWSphpgB,
	GxjDaNmTVZaIEmLIO: GxjDaNmTVZaIEmLIO,
	xdBmFzKPmVQfqVSOyFY: xdBmFzKPmVQfqVSOyFY,
	xdSXcpFurEbSenWcxPn: xdSXcpFurEbSenWcxPn,
	KzRRnMZfXiUfprzBEe: KzRRnMZfXiUfprzBEe,
	nDIaTJMAdTQRxUKJo: nDIaTJMAdTQRxUKJo,
	XaQWqbeAdXIkLCiakX: XaQWqbeAdXIkLCiakX,
	WHFSIZvkPFlAiUsTW: WHFSIZvkPFlAiUsTW,
	IldgeERuYKVOefpR: IldgeERuYKVOefpR,
	sYnLKnDJjNhHBCpTj: sYnLKnDJjNhHBCpTj,
	ZtsyDNmrvXDDftOHri: ZtsyDNmrvXDDftOHri,
	vAeqeVWtpVywOzVUYfuv: vAeqeVWtpVywOzVUYfuv,
	PLWcAjJpcpPoIQiCcq: PLWcAjJpcpPoIQiCcq,
	QHhdRUWMTaGpDwrC: QHhdRUWMTaGpDwrC,
	account_transfer: account_transfer,
	account: account,
	UKenwEAFyRZgQyZTmPYy: UKenwEAFyRZgQyZTmPYy
};

var maps = [{
  data: zhJSON,
  lang: 'zh'
}, {
  data: enJSON,
  lang: 'en'
}, {
  data: twJSON,
  lang: 'tw'
}];
var transformData = maps.reduce(function (pre, curr) {
  var _a;
  var obj = {};
  var keys = Object.keys(curr.data);
  keys.forEach(function (key) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    obj[key] = curr.data[key]['message'];
  });
  return Object.assign({}, pre, (_a = {}, _a[curr.lang] = obj, _a));
}, {});
var resources = {
  zh: {
    translation: transformData.zh
  },
  en: {
    translation: transformData.en
  },
  tw: {
    translation: transformData.tw
  }
};

var language;
if (typeof window !== 'undefined') {
  language = (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('bx_curLang')) || 'en';
}
i18n.use(initReactI18next);
if (!language) {
  i18n.use(LanguageDetector);
}
if (!i18n.isInitialized) {
  i18n.init({
    // @ts-ignore
    resources: resources,
    fallbackLng: 'en',
    lng: language,
    supportedLngs: ['en', 'zh', 'tw']
    // interpolation: {
    //   escapeValue: true,
    // },
  });
}

var axiosRequest = axios.create();
axiosRequest.interceptors.request.use(function (config) {
  var authToken = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('token');
  config.baseURL = API_WALLET_SERVER;
  var langMaps = {
    en: 'en',
    tw: 'zh-hans',
    zh: 'zh-tw'
  };
  config.headers['Accept-Language'] = langMaps[i18n.language];
  config.headers['X-ACCESS-TOKEN'] = authToken;
  config.headers['Bx-Upstream-Host'] = 'wallet-web';
  return config;
}, function (err) {});
axiosRequest.interceptors.response.use(function (response) {
  var data = response.data;
    response.config;
  if (data.ok || (data === null || data === void 0 ? void 0 : data.code) === 0) {
    return __assign(__assign({}, data), {
      ok: true
    });
    // axios config header 配置了showMsg才会提示错误
  } else if (!(data === null || data === void 0 ? void 0 : data.ok)) {
    return __assign(__assign({}, data), {
      ok: false
    });
  }
  return Promise.reject(data);
}, function (err) {});
var request = axiosRequest;

var getUserInfo = function getUserInfo() {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, request.get('/web-wallet/api/v1/account/user/info')];
    });
  });
};
var updateUserInfo = function updateUserInfo(params) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, request.post('/web-wallet/api/v1/account/user/update', params)];
    });
  });
};
var loginoutApi = function loginoutApi() {
  return request.post('/web-wallet/api/v1/login/sign_out', {});
};

var useHeaderHooks = function useHeaderHooks() {
  var _a = useTranslation(),
    t = _a.t,
    i18n = _a.i18n;
  var _b = useState({}),
    userInfo = _b[0],
    setUserInfo = _b[1];
  var _c = useState(false),
    mobileStyle = _c[0],
    setMobileStyle = _c[1];
  var memoMenus = useMemo(function () {
    return [{
      label: t('hQRkbssUXUGGLhtxc'),
      path: '/trade/wallet'
    }, {
      label: t('eDwDkAgbfaPsnwOb'),
      path: '/trade/spot/BTC/USDC'
    }, {
      label: t('VZexjbUhosOUoUTI'),
      path: 'https://bixingroup.com/'
    }];
  }, [t, i18n.language]);
  var memoBtns = useMemo(function () {
    return [{
      label: t('rtVWmSuAATyCaNgkRNx'),
      path: '/trade/login'
    }, {
      label: t('wjeaGDSVTuLLjJGehN'),
      path: '/trade/register'
    }];
  }, [t, i18n.language]);
  var memoAboutBx = useMemo(function () {
    return [{
      label: t('TGIiRSnHGjASSfzjMA'),
      path: ''
    }, {
      label: t('YBvzRbRVqKkwTDkNDfoc'),
      path: i18n.language === 'en' ? 'https://support.bixin.com/hc/en-hk/articles/16541568849811-How-to-contact-us' : 'https://support.bixin.com/hc/zh-hk/articles/16538251486099-%E5%A6%82%E4%BD%95%E8%81%94%E7%B3%BB%E6%88%91%E5%80%91'
    }, {
      label: t('VZexjbUhosOUoUTI'),
      path: 'https://bixingroup.com'
    }];
  }, [t, i18n.language]);
  var memoConvertTrade = useMemo(function () {
    return [{
      label: t('YmIZCYMTuGNvbocpiJOP'),
      path: '/trade/spot/BTC/USDC'
    }, {
      label: t('AZVALNHESdbXtHmNY'),
      path: '/trade/convert'
    }];
  }, [t, i18n.language]);
  var memoMobileMenus = useMemo(function () {
    return [{
      label: t('hQRkbssUXUGGLhtxc'),
      path: '/trade/wallet'
    }, {
      label: t('eDwDkAgbfaPsnwOb'),
      path: '/trade/spot/BTC/USDC'
    }, {
      label: t('AZVALNHESdbXtHmNY'),
      path: '/trade/convert'
    }, {
      label: t('AVWJwkijUTbNMShmp'),
      path: '/trade/history'
    }, {
      label: t('VZexjbUhosOUoUTI'),
      path: 'https://bixingroup.com'
    }];
  }, [t, i18n.language]);
  var memoContactLinks = useMemo(function () {
    return [{
      label: 'twitter',
      path: 'https://twitter.com/Bixincom',
      img: 'https://dzs0g4mm09kzy.cloudfront.net/bx-exchange-header/wwwsite/images/website/icon/tw.png'
    }, {
      label: 'facebook',
      path: 'https://www.facebook.com/Bixincom',
      img: 'https://dzs0g4mm09kzy.cloudfront.net/bx-exchange-header/wwwsite/images/website/icon/facebook.png'
    }, {
      label: 'ins',
      path: 'https://www.instagram.com/bixin_hk/',
      img: 'https://dzs0g4mm09kzy.cloudfront.net/bx-exchange-header/wwwsite/images/website/icon/ins.png'
    }, {
      label: 'telegram',
      path: 'https://t.me/bixinoffcial',
      img: 'https://dzs0g4mm09kzy.cloudfront.net/bx-exchange-header/wwwsite/images/website/icon/telegram.png'
    }, {
      label: 'youtube',
      path: 'https://www.youtube.com/@bixin5138',
      img: 'https://dzs0g4mm09kzy.cloudfront.net/bx-exchange-header/wwwsite/images/website/icon/youtube.png'
    }, {
      label: 'mail',
      path: 'https://bixingroup.com',
      img: 'https://dzs0g4mm09kzy.cloudfront.net/bx-exchange-header/wwwsite/images/website/icon/mail.png'
    }];
  }, []);
  var shwoBxGroupIn = useMemo(function () {
    return window.location.pathname === '/';
  }, [window.location]);
  var fetchUserInfo = function fetchUserInfo() {
    return __awaiter(void 0, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, getUserInfo()];
          case 1:
            res = _a.sent();
            if (res.code === 0) {
              setUserInfo(res.data);
              // setUserInfo(
              //   Object.assign({}, res?.data, {
              //     kyc_type: 'INSTITUTION_PI',
              //   })
              // );
            }
            return [2 /*return*/];
        }
      });
    });
  };
  var handleStorage = function handleStorage() {
    return __awaiter(void 0, void 0, void 0, function () {
      var token, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            token = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('token');
            if (!token) return [3 /*break*/, 2];
            return [4 /*yield*/, getUserInfo()];
          case 1:
            res = _a.sent();
            if (res.code === 0) {
              setUserInfo(res.data);
            } else {
              setUserInfo({});
            }
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };
  var handleLoginOut = function handleLoginOut() {
    return __awaiter(void 0, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, loginoutApi()];
          case 1:
            res = _a.sent();
            if (res.code === 0) {
              localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem('token');
              localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem('bx_registerStep');
              localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem('bx_loginStep');
              window.open("/trade/login", '_self');
            }
            return [2 /*return*/];
        }
      });
    });
  };
  useEffect(function () {
    fetchUserInfo();
  }, []);
  useEffect(function () {
    window.addEventListener('storage', handleStorage);
    return function () {
      window.removeEventListener('storage', handleStorage);
    };
  }, []);
  useEffect(function () {
    var isMobileHandle = function isMobileHandle() {
      var isMobile = window.innerWidth < 890;
      setMobileStyle(isMobile);
    };
    isMobileHandle();
    window.addEventListener('resize', isMobileHandle);
    return function () {
      window.removeEventListener('resize', isMobileHandle);
    };
  }, []);
  return {
    memoBtns: memoBtns,
    memoAboutBx: memoAboutBx,
    shwoBxGroupIn: shwoBxGroupIn,
    userInfo: userInfo,
    handleStorage: handleStorage,
    handleLoginOut: handleLoginOut,
    mobileStyle: mobileStyle,
    memoMobileMenus: memoMobileMenus,
    memoContactLinks: memoContactLinks,
    fetchUserInfo: fetchUserInfo,
    memoConvertTrade: memoConvertTrade,
    memoMenus: memoMenus
  };
};

var css_248z$2 = ".styles-module_lang-icon__j1Rnr {\n  position: relative;\n  display: flex;\n}\n.styles-module_lang-icon__j1Rnr .styles-module_mobile-lang__Wnld3 {\n  display: flex;\n  align-items: center;\n}\n.styles-module_lang-icon__j1Rnr svg {\n  color: #B3B4C8;\n}\n.styles-module_lang-icon__j1Rnr:hover {\n  cursor: pointer;\n}\n.styles-module_lang-icon__j1Rnr:hover svg {\n  color: white;\n}\n.styles-module_lang-icon__j1Rnr .styles-module_lang-list__xX2Wm {\n  display: flex;\n  position: absolute;\n  top: 60px;\n  background-color: #fff;\n  width: 150px;\n  height: 170px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  z-index: 100;\n  right: 10px;\n  top: 60px;\n  padding-left: 20px;\n  padding-right: 20px;\n  color: #010313;\n  box-sizing: border-box;\n  flex-direction: column;\n}\n.styles-module_lang-icon__j1Rnr .styles-module_lang-list__xX2Wm::before {\n  content: \"\";\n  height: 30px;\n  background-color: transparent;\n  width: 100%;\n  top: -20px;\n  left: 0;\n  position: absolute;\n}\n.styles-module_lang-icon__j1Rnr .styles-module_lang-list__xX2Wm .styles-module_item__TS4BD {\n  height: 40px;\n  padding-left: 10px;\n  line-height: 40px;\n  cursor: pointer;\n  background: none;\n  border-radius: 12px;\n  font-size: 13px;\n}\n.styles-module_lang-icon__j1Rnr .styles-module_lang-list__xX2Wm .styles-module_item__TS4BD:hover {\n  background: rgba(32, 26, 85, 0.05);\n}\n.styles-module_lang-icon__j1Rnr .styles-module_lang-list__xX2Wm .styles-module_item__TS4BD.styles-module_active__OgSDo {\n  background: rgba(32, 26, 85, 0.05);\n}";
var styles$1 = {"lang-icon":"styles-module_lang-icon__j1Rnr","mobile-lang":"styles-module_mobile-lang__Wnld3","lang-list":"styles-module_lang-list__xX2Wm","item":"styles-module_item__TS4BD","active":"styles-module_active__OgSDo"};
styleInject(css_248z$2);

var Icon$k = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z',
    fill: 'currentColor'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M2.25 9C2.25 8.58579 2.58579 8.25 3 8.25H21C21.4142 8.25 21.75 8.58579 21.75 9C21.75 9.41421 21.4142 9.75 21 9.75H3C2.58579 9.75 2.25 9.41421 2.25 9Z',
    fill: 'currentColor'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M2.25 15C2.25 14.5858 2.58579 14.25 3 14.25H21C21.4142 14.25 21.75 14.5858 21.75 15C21.75 15.4142 21.4142 15.75 21 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15Z',
    fill: 'currentColor'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10.6 2.66836C11.2749 1.68052 12.7253 1.68054 13.4001 2.66839C15.5999 5.88836 16.7499 8.91791 16.7499 12C16.7499 15.0821 15.5999 18.1116 13.4001 21.3316C12.7253 22.3195 11.2749 22.3195 10.6 21.3316C8.40014 18.1117 7.24999 15.0821 7.25 12C7.25001 8.91789 8.40018 5.88833 10.6 2.66836ZM12.1616 3.51453C12.0823 3.39848 11.9179 3.39848 11.8386 3.51452C9.74606 6.5774 8.75001 9.31497 8.75 12C8.74999 14.685 9.74602 17.4226 11.8386 20.4855C11.9178 20.6015 12.0823 20.6015 12.1616 20.4855C14.254 17.4226 15.2499 14.685 15.2499 12C15.2499 9.31496 14.254 6.57739 12.1616 3.51453Z',
    fill: 'currentColor'
  }));
};

var Icon$j = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M15 10.5L12 13.5L9 10.5',
    stroke: '#B3B4C8',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var cs = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

var KYC_TYPE = {
  CORPORATION: 'CORPORATION',
  // 法团
  PERSONAL: 'PERSONAL',
  // 个人 => 普通认证
  PI: 'PI',
  // 个人 => 高级认证
  UNAUTHORIZED: 'UNAUTHORIZED',
  // 未认证
  INSTITUTION: 'INSTITUTION',
  // 机构
  INSTITUTION_PI: 'INSTITUTION_PI',
  // 机构 专业
  CORPORATION_PI: 'CORPORATION_PI' // 法团 专业
};
var BX_SESSION_LANGUAGE_KEY = 'bx_curLang';
var ACCOUNT_ROLE = {
  MAIN: 'MAIN',
  SUB: 'SUB'
};

var LanguageIcon = function LanguageIcon(_a) {
  var _b, _c;
  var userLang = _a.userLang,
    changeLanguage = _a.changeLanguage;
  var i18n = useTranslation().i18n;
  var _d = useState('en'),
    activeLang = _d[0],
    setActiveLang = _d[1];
  var _e = useState(false),
    isIn = _e[0],
    setIsIn = _e[1];
  var mobileStyle = useHeaderHooks().mobileStyle;
  var memoLangs = useMemo(function () {
    return [{
      label: '中文简体',
      value: 'zh-hans',
      localValue: 'zh'
    }, {
      label: '中文繁體',
      value: 'zh-HK',
      localValue: 'tw'
    }, {
      label: 'English',
      value: 'en',
      localValue: 'en'
    }];
  }, []);
  useEffect(function () {
    var local_language = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(BX_SESSION_LANGUAGE_KEY);
    if (local_language) {
      setActiveLang(local_language);
      i18n.changeLanguage(local_language);
      if (typeof changeLanguage === 'function') {
        changeLanguage && changeLanguage(local_language);
      }
    }
  }, []);
  useEffect(function () {
    if (userLang) {
      var activeLang_1 = memoLangs.filter(function (d) {
        return d.value === userLang;
      })[0].localValue;
      setActiveLang(activeLang_1);
      i18n.changeLanguage(activeLang_1);
      if (typeof changeLanguage === 'function') {
        changeLanguage && changeLanguage(activeLang_1);
      }
    }
  }, [userLang]);
  var setLang = function setLang(localeValue, value) {
    if (typeof changeLanguage === 'function') {
      changeLanguage && changeLanguage(localeValue);
    }
    setActiveLang(localeValue);
    i18n.changeLanguage(localeValue);
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(BX_SESSION_LANGUAGE_KEY, localeValue);
    updateUserInfo({
      language: value
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles$1['lang-icon'],
    onMouseEnter: function onMouseEnter() {
      return setIsIn(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsIn(false);
    }
  }, !mobileStyle && ( /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon$k, null), /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#b3b4c8',
      fontSize: '14px',
      display: 'inline-block',
      marginLeft: '5px'
    }
  }, (_b = memoLangs.filter(function (d) {
    return d.localValue === activeLang;
  })[0]) === null || _b === void 0 ? void 0 : _b.label))), mobileStyle && ( /*#__PURE__*/React.createElement("div", {
    className: styles$1['mobile-lang']
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'rgb(255, 255, 255)',
      fontSize: '14px',
      display: 'inline-block'
    }
  }, (_c = memoLangs.filter(function (d) {
    return d.localValue === activeLang;
  })[0]) === null || _c === void 0 ? void 0 : _c.label))), isIn && ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$1['lang-list']
  }, isIn && memoLangs.map(function (d, i) {
    var _a;
    return /*#__PURE__*/React.createElement("p", {
      key: i,
      onClick: function onClick() {
        return setLang(d.localValue, d.value);
      },
      className: cs((_a = {}, _a[styles$1['item']] = true, _a[styles$1['active']] = activeLang === d.localValue, _a))
    }, d.label);
  })))), /*#__PURE__*/React.createElement(Icon$j, {
    style: {
      marginRight: mobileStyle ? '15px' : '0px'
    }
  }));
};

var Icon$i = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '27',
    height: '27',
    viewBox: '0 0 27 27',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M16 13.9312V17.3C16 18.7625 15.025 19.7312 13.5687 19.7312H9.68125C8.225 19.7312 7.25 18.7625 7.25 17.3V12.4437C7.25 10.9812 8.225 10.0125 9.68125 10.0125H12.075C12.7188 10.0125 13.3375 10.2687 13.7938 10.725L15.2875 12.2125C15.7437 12.6687 16 13.2875 16 13.9312Z',
    stroke: '#010313',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M19.75 11.1562V14.525C19.75 15.9812 18.775 16.9562 17.3188 16.9562H16V13.9312C16 13.2875 15.7437 12.6687 15.2875 12.2125L13.7938 10.725C13.3375 10.2687 12.7188 10.0125 12.075 10.0125H11V9.66245C11 8.2062 11.975 7.2312 13.4313 7.2312H15.825C16.4688 7.2312 17.0875 7.48745 17.5437 7.9437L19.0375 9.43745C19.4938 9.8937 19.75 10.5125 19.75 11.1562Z',
    stroke: '#010313',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var Icon$h = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M11.9996 2.75C10.0469 2.75 8.46387 4.33299 8.46387 6.28571C8.46387 8.23844 10.0469 9.82143 11.9996 9.82143C13.9523 9.82143 15.5353 8.23844 15.5353 6.28571C15.5353 4.33299 13.9523 2.75 11.9996 2.75ZM6.96387 6.28571C6.96387 3.50457 9.21843 1.25 11.9996 1.25C14.7807 1.25 17.0353 3.50457 17.0353 6.28571C17.0353 9.06686 14.7807 11.3214 11.9996 11.3214C9.21843 11.3214 6.96387 9.06686 6.96387 6.28571Z',
    fill: 'currentColor'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M4.30958 16.1661C5.86682 14.5023 8.39944 13.25 12.2857 13.25C16.172 13.25 18.7046 14.5023 20.2618 16.1661C21.7995 17.8088 22.3214 19.7847 22.3214 21.1429C22.3214 21.5571 21.9856 21.8929 21.5714 21.8929H3C2.58579 21.8929 2.25 21.5571 2.25 21.1429C2.25 19.7847 2.77196 17.8088 4.30958 16.1661ZM3.81378 20.3929H20.7576C20.6016 19.4301 20.14 18.2309 19.1667 17.1911C17.9382 15.8786 15.828 14.75 12.2857 14.75C8.74342 14.75 6.63318 15.8786 5.40471 17.1911C4.43143 18.2309 3.96986 19.4301 3.81378 20.3929Z',
    fill: 'currentColor'
  }));
};

var Icon$g = function Icon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: '14',
    height: '14',
    viewBox: '0 0 12 12',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, /*#__PURE__*/React.createElement("g", {
    "clip-path": 'url(#clip0_5254_6118)'
  }, /*#__PURE__*/React.createElement("path", {
    d: 'M11.016 10.11H10.44V3.55196C10.44 3.35996 10.326 3.19196 10.152 3.10796L7.278 1.60796C7.116 1.53596 6.936 1.53596 6.774 1.60796C6.594 1.67996 6.48 1.85396 6.486 2.80196V10.86H5.91V2.00396C5.91 1.03196 5.91 0.887965 5.694 0.809965C5.508 0.731965 5.304 0.731965 5.118 0.809965L1.83 2.54396C1.656 2.62796 1.542 2.80796 1.542 2.99996V10.116H0.966C0.822 10.116 0.75 10.194 0.75 10.266V11.1C0.75 11.172 0.822 11.25 0.966 11.25H11.016C11.082 11.25 11.22 11.172 11.232 11.1V10.272C11.25 10.182 11.094 10.11 11.016 10.11ZM4.266 9.05396C4.266 9.13796 4.2 9.20397 4.116 9.20397H3.306C3.222 9.20397 3.156 9.13796 3.156 9.05396V8.35196C3.156 8.26796 3.222 8.20196 3.306 8.20196H4.134C4.218 8.20196 4.284 8.26796 4.284 8.35196L4.266 9.05396ZM4.266 6.93597C4.266 7.01997 4.2 7.08597 4.116 7.08597H3.306C3.222 7.08597 3.156 7.01997 3.156 6.93597V6.22196C3.156 6.13796 3.222 6.07196 3.306 6.07196H4.134C4.218 6.07196 4.284 6.13796 4.284 6.22196L4.266 6.93597ZM4.266 4.82397C4.266 4.90797 4.2 4.97396 4.116 4.97396H3.306C3.222 4.97396 3.156 4.90797 3.156 4.82397V4.10397C3.156 4.01996 3.222 3.95396 3.306 3.95396H4.134C4.218 3.95396 4.284 4.01996 4.284 4.10397L4.266 4.82397ZM9 9.04797C9 9.13196 8.934 9.19796 8.85 9.19796H8.022C7.938 9.19796 7.872 9.13196 7.872 9.04797V8.33996C7.872 8.25596 7.938 8.18997 8.022 8.18997H8.85C8.934 8.18997 9 8.25596 9 8.33996V9.04797ZM9 6.92997C9 7.01396 8.934 7.07996 8.85 7.07996H8.022C7.938 7.07996 7.872 7.01396 7.872 6.92997V6.22196C7.872 6.13796 7.938 6.07196 8.022 6.07196H8.85C8.934 6.07196 9 6.13796 9 6.22196V6.92997ZM9 4.81796C9 4.90196 8.934 4.96797 8.85 4.96797H8.022C7.938 4.96797 7.872 4.90196 7.872 4.81796V4.10397C7.872 4.01996 7.938 3.95396 8.022 3.95396H8.85C8.934 3.95396 9 4.01996 9 4.10397V4.81796Z',
    fill: 'white'
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: 'clip0_5254_6118'
  }, /*#__PURE__*/React.createElement("rect", {
    width: '12',
    height: '12',
    fill: 'white'
  }))));
};

var Icon$f = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '14',
    height: '12',
    viewBox: '0 0 12 10',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M1.7769 3.27313H10.2821C10.3764 3.27313 10.4668 3.23567 10.5335 3.16899C10.6002 3.10232 10.6377 3.01188 10.6377 2.91759V2.90559H11.3191V2.18188L6.00867 0L0.667969 2.12188V2.91127L1.42136 2.91759C1.42136 3.01188 1.45882 3.10232 1.5255 3.16899C1.59218 3.23567 1.68261 3.27313 1.7769 3.27313ZM2.16907 3.64067V7.8718H1.94299C1.66197 7.8718 1.43399 8.09978 1.43399 8.3808V8.6372H10.6926V8.3808C10.6926 8.09978 10.4646 7.8718 10.1836 7.8718H9.96952V3.64067H8.55872V7.8718H7.83879V3.64067H6.42799V7.8718H5.70933V3.64067H4.29853V7.8718H3.57924V3.64067H2.16907ZM10.8221 8.94537H1.3039C1.02288 8.94537 0.794903 9.17335 0.794903 9.45437V10H11.3311V9.45437C11.3311 9.17335 11.1031 8.94537 10.8221 8.94537Z',
    fill: 'white'
  }));
};

var Icon$e = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x92\xBB\xE7\x9F\xB3 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: '20',
    height: '20',
    rx: '6',
    fill: 'url(#paint0_linear_3080_10443)'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector',
    d: 'M12.6655 5H7.33696C7.04369 5 6.7703 5.13773 6.6013 5.36569L4.16069 8.71624C3.91464 9.05343 3.95441 9.51172 4.25762 9.8038L9.36251 14.7453C9.71294 15.0849 10.2871 15.0849 10.6375 14.7453L15.7424 9.80617C16.0456 9.5141 16.0854 9.0558 15.8393 8.71861L13.3987 5.36806C13.2322 5.13773 12.9588 5 12.6655 5Z',
    fill: 'white'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector_2',
    d: 'M9.98634 13C9.86708 13 9.75279 12.9456 9.66832 12.8484L7 9.75823L7.63354 9.03147L9.98634 11.7554L12.3665 9L13 9.72675L10.3043 12.8484C10.2199 12.9456 10.1056 13 9.98634 13Z',
    fill: '#FFB94D'
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 'paint0_linear_3080_10443',
    x1: '10',
    y1: '-0.5',
    x2: '10',
    y2: '20',
    gradientUnits: 'userSpaceOnUse'
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": '#FFA234'
  }), /*#__PURE__*/React.createElement("stop", {
    offset: '1',
    "stop-color": '#FFA118'
  }))));
};

var Icon$d = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '89',
    height: '30',
    viewBox: '0 0 89 30',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M20 23L17.3404 21.1074H12.8262C11.2654 21.1074 10 19.9959 10 18.625V16.4824C10 15.1114 11.2654 14 12.8262 14H17.1738C18.7346 14 20 15.1114 20 16.4824V23ZM20.7305 5.73065H9.75585C9.75585 2.56563 7.1762 0 3.9939 0H0V5.73065V8.54342V20.6507C0 25.7544 4.16003 29.8919 9.29169 29.8919H20.7305C25.8622 29.8919 30.022 25.7544 30.022 20.6507V14.9716C30.022 9.86792 25.8622 5.73065 20.7305 5.73065Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M71.541 9.221V11.7678H88.997V9.22008H82.2507L81.5717 7.27979H78.0733L78.7588 9.21995L71.541 9.221Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M76.4292 26.413V23.8261H84.8226L84.8256 25.6541C84.8263 26.0731 84.3666 26.413 83.7992 26.413H76.4292ZM72.6152 28.9996H84.9889C86.7999 28.9996 88.268 27.7475 88.268 26.203V21.3032H72.6152V28.9996Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M65.3746 12.8381C64.9668 13.3144 63.9028 14.1517 63.9028 14.1517L65.3746 18.0977C65.3746 18.0977 66.8463 17.0145 67.4177 16.1388V28.9998H70.6863V11.3223C71.7521 9.68403 72.5192 7.62663 72.5192 7.62663L68.3181 7C68.2335 7.70178 67.5263 9.27737 67.2393 9.88625C66.6667 11.1006 65.684 12.4768 65.3746 12.8381Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M81.755 13.1646H87.2875V15.6491H73.5513V13.1655L78.9037 13.1646H81.755Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M81.755 17.0875H87.2875V19.7212H73.5513V17.0885L78.9037 17.0874L81.755 17.0875Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M59.1401 27.8905H59.2618H59.3538C59.3538 27.8905 60.1402 27.3276 60.4917 26.2631C60.6088 25.9084 60.7101 25.5028 60.7044 24.78C60.6988 24.0573 60.709 24.78 60.709 24.78C60.7101 24.1341 60.709 21.1949 60.709 21.1949H51.5383V20.4844H47.6036V21.1949H38V27.9948H41.9305L41.9263 23.3231H47.6036L47.6079 29.0004H51.5367L51.5325 23.3231H57.1611C57.1611 23.3231 57.1911 25.3517 56.9837 25.8069C56.6289 26.694 56.3559 26.9221 55.9192 27.2263C55.2641 27.7213 54.6791 27.8905 54.6791 27.8905C54.9046 27.891 55.4211 27.8881 55.6712 27.8896C55.7868 27.8903 55.915 27.8898 56.0519 27.8898C56.3348 27.8898 56.6541 27.8894 56.9732 27.8891C57.9197 27.8878 59.1401 27.8905 59.1401 27.8905Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("rect", {
    x: '38',
    y: '10.5483',
    width: '3.19352',
    height: '9.22573',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("rect", {
    x: '42.6128',
    y: '7.70947',
    width: '3.19352',
    height: '12.0644',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M50.4189 7.70947H47.4916L46.5158 10.5482H49.4431L50.4189 7.70947Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M55.7412 7.70947H52.8138L51.4832 11.6127H54.4106L55.7412 7.70947Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M38 7.70947H40.9274L41.9032 10.5482H38.9758L38 7.70947Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M51.4844 12.3223H55.1341L60.7101 19.7738H57.0604L51.4844 12.3223Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M60.7095 12.3223H57.0597L51.4837 19.7738H55.1335L60.7095 12.3223Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("rect", {
    x: '47.2256',
    y: '10.5483',
    width: '3.19352',
    height: '9.22573',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M45.4172 10.5483H50.4192V12.6774H38V10.5492L42.8392 10.5483H45.4172Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M57.7081 8.77393H60.7094V11.2578H53.2578V8.77488L56.1614 8.77393H57.7081Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M42.6127 14.1611V16.5858L41.1934 16.9998V14.5759L42.6127 14.1611Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M45.8062 14.1611V16.5858L47.2256 16.9998V14.5759L45.8062 14.1611Z',
    fill: '#B3B4C8'
  }));
};

var Icon$c = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '96',
    height: '30',
    viewBox: '0 0 96 30',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M20 23L17.3404 21.1074H12.8262C11.2654 21.1074 10 19.9959 10 18.625V16.4824C10 15.1114 11.2654 14 12.8262 14H17.1738C18.7346 14 20 15.1114 20 16.4824V23ZM20.7305 5.73065H9.75585C9.75585 2.56563 7.1762 0 3.9939 0H0V5.73065V8.54342V20.6507C0 25.7544 4.16003 29.8919 9.29169 29.8919H20.7305C25.8622 29.8919 30.022 25.7544 30.022 20.6507V14.9716C30.022 9.86792 25.8622 5.73065 20.7305 5.73065Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M38 26V11H46.9356C48.4231 11 49.5539 11.3571 50.328 12.0714C51.1021 12.7857 51.4892 13.8106 51.4892 15.146C51.4892 15.9224 51.345 16.5745 51.0566 17.1025C50.7834 17.6304 50.4191 18.0497 49.9637 18.3602C50.5861 18.6087 51.0794 18.9736 51.4437 19.455C51.8231 19.9208 52.0129 20.6196 52.0129 21.5512C52.0129 22.9643 51.5879 24.059 50.7378 24.8354C49.8878 25.6118 48.6811 26 47.1177 26H38ZM42.121 16.986H45.7744C46.8217 16.986 47.3454 16.5047 47.3454 15.5419C47.3454 15.0606 47.2164 14.6957 46.9583 14.4472C46.7155 14.1988 46.2829 14.0745 45.6606 14.0745H42.121V16.986ZM42.121 22.9488H45.9566C46.5333 22.9488 46.9583 22.8245 47.2316 22.5761C47.5048 22.3276 47.6414 21.9161 47.6414 21.3416C47.6414 20.8602 47.5048 20.4953 47.2316 20.2469C46.9583 19.9984 46.503 19.8742 45.8655 19.8742H42.121V22.9488Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M53.6171 26V11H57.8975V26H53.6171Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M59.0539 26L64.4727 18.4068L59.2588 11H64.3588L67.0455 14.9363L69.7549 11H74.8549L69.641 18.4068L75.0598 26H69.8915L67.0455 21.9239L64.2222 26H59.0539Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M76.2073 26V11H80.4877V26H76.2073Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M82.5441 26V11H86.187L91.7196 18.9425V11H96V26H92.3343L86.8245 18.0807V26H82.5441Z',
    fill: '#B3B4C8'
  }));
};

var Icon$b = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '86',
    height: '30',
    viewBox: '0 0 86 30',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M20 23L17.3404 21.1074H12.8262C11.2654 21.1074 10 19.9959 10 18.625V16.4824C10 15.1114 11.2654 14 12.8262 14H17.1738C18.7346 14 20 15.1114 20 16.4824V23ZM20.7305 5.73065H9.75585C9.75585 2.56563 7.1762 0 3.9939 0H0V5.73065V8.54342V20.6507C0 25.7544 4.16003 29.8919 9.29169 29.8919H20.7305C25.8622 29.8919 30.022 25.7544 30.022 20.6507V14.9716C30.022 9.86792 25.8622 5.73065 20.7305 5.73065Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M56.4985 27.634H56.3923C56.3923 27.634 54.7082 27.6306 53.8825 27.6323C53.604 27.6327 53.3255 27.6331 53.0786 27.6331C52.9592 27.6331 52.8473 27.6337 52.7464 27.6329C52.5282 27.6311 52.0775 27.6346 51.8808 27.634C51.8808 27.634 52.4191 27.2315 52.8711 26.6056C53.1981 26.1527 53.4632 25.6719 53.6839 24.9885C53.8648 24.4282 53.9508 23.627 53.9508 22.8226V21.6613L53.9429 21.5412V18.623L53.9159 17.8839H49.5774V29.0001H46.1074V17.8839H41.7731V27.7624H37.9474V14.6881H46.1037V11.436H37V8.2269C37 8.2269 52.5882 8.24646 54.5092 8.07871C56.2061 7.93052 57.9031 7.63484 58.6881 7.31201V10.6855C58.6881 10.6855 56.4375 11.1455 54.6634 11.2989C52.9085 11.4505 49.5788 11.436 49.5788 11.436V14.6881H57.7612V22.8646H57.7572C57.7747 23.3429 57.7421 23.7722 57.7154 24.0574C57.6776 24.461 57.6065 24.8869 57.5043 25.3235C57.4122 25.7157 57.3069 26.0221 57.1476 26.4467C57.0108 26.8111 56.8851 27.0623 56.7314 27.3634C56.697 27.4307 56.5788 27.634 56.5788 27.634H56.4985Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M68.4482 9.20722V11.7385H85.7979V9.2063H79.0927L78.4178 7.27783H74.9407L75.622 9.20617L68.4482 9.20722Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M73.307 26.2948V23.7236H81.6492L81.6522 25.5405C81.6529 25.9569 81.196 26.2948 80.6321 26.2948H73.307ZM69.5166 28.8653H81.8148C81.9022 28.8653 81.9887 28.8653 82.0743 28.8653C83.7311 28.8653 85.074 27.5222 85.074 25.8653L85.074 21.2158H69.5166V28.8653Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M62.3197 12.8025C61.9144 13.2759 60.8569 14.1081 60.8569 14.1081L62.3197 18.0301C62.3197 18.0301 63.7825 16.9534 64.3504 16.0831V28.8657H67.599V11.296C68.6584 9.66768 69.4208 7.62281 69.4208 7.62281L65.2452 7C65.1613 7.69751 64.4583 9.26349 64.173 9.86866C63.604 11.0756 62.6273 12.4434 62.3197 12.8025Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M78.6006 13.1265H84.0993V15.5958H70.4468V13.1274L75.7666 13.1265H78.6006Z',
    fill: '#B3B4C8'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M78.6006 17.0265H84.0993V19.6441H70.4468V17.0275L75.7666 17.0264L78.6006 17.0265Z',
    fill: '#B3B4C8'
  }));
};

var Icon$a = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '19',
    height: '23',
    viewBox: '0 0 19 23',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("g", {
    id: 'icon'
  }, /*#__PURE__*/React.createElement("path", {
    id: 'Vector 397 (Stroke)',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M6.34351 2.00851C6.22972 1.61023 5.8146 1.37961 5.41632 1.49341C3.404 2.06836 -0.0174856 4.78201 0.590373 10.8606C0.631589 11.2728 0.999121 11.5735 1.41128 11.5323C1.82344 11.491 2.12415 11.1235 2.08293 10.7113C1.54793 5.36137 4.5074 3.31312 5.82841 2.93569C6.22668 2.8219 6.4573 2.40678 6.34351 2.00851Z',
    fill: '#010313'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector 398 (Stroke)',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10.9067 6.10284C11.7433 6.61232 12.4358 7.52384 12.7505 8.81976C12.8483 9.22227 13.2538 9.46933 13.6563 9.37157C14.0588 9.27382 14.3059 8.86827 14.2081 8.46576C13.8106 6.82891 12.9015 5.5614 11.6869 4.8217C10.4703 4.0808 8.99501 3.90012 7.54084 4.35564C6.10667 4.8049 5.15691 5.81757 4.58198 7.10115C4.01666 8.36326 3.80354 9.90171 3.80354 11.4998C3.80354 12.5446 3.72442 13.174 3.44682 13.7593C3.16285 14.3581 2.63283 14.9899 1.55565 15.9366C1.24451 16.21 1.21395 16.6839 1.48738 16.995C1.76081 17.3062 2.2347 17.3367 2.54584 17.0633C3.66151 16.0828 4.38289 15.286 4.8021 14.4021C5.22768 13.5049 5.30354 12.5977 5.30354 11.4998C5.30354 10.0111 5.50572 8.70829 5.95093 7.71432C6.38652 6.74181 7.04251 6.08362 7.98923 5.78705C9.0463 5.45592 10.0721 5.59456 10.9067 6.10284Z',
    fill: '#010313'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector 399 (Stroke)',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M8.21509 15.9C7.88372 15.6515 7.41362 15.7187 7.16509 16.05C6.83354 16.4921 6.22165 17.2069 5.49103 17.8752C4.7477 18.5552 3.94859 19.1245 3.24221 19.36C2.84925 19.4909 2.63688 19.9157 2.76787 20.3086C2.89885 20.7016 3.32359 20.914 3.71655 20.783C4.72446 20.447 5.71105 19.7068 6.50345 18.982C7.30853 18.2456 7.98236 17.4604 8.36509 16.95C8.61362 16.6187 8.54646 16.1486 8.21509 15.9Z',
    fill: '#010313'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector 400 (Stroke)',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M13.8394 10.75C13.4251 10.75 13.0894 11.0858 13.0894 11.5C13.0894 14.8223 11.0727 18.8568 7.7392 20.8569C7.38401 21.07 7.26884 21.5307 7.48195 21.8859C7.69506 22.2411 8.15576 22.3562 8.51094 22.1431C12.3203 19.8575 14.5894 15.3205 14.5894 11.5C14.5894 11.0858 14.2536 10.75 13.8394 10.75Z',
    fill: '#010313'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector 401 (Stroke)',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M8.44596 1.4466C8.41644 1.85976 8.72745 2.21861 9.14061 2.24813C11.4923 2.41611 13.1927 3.20624 14.3758 4.34959C15.5642 5.49809 16.2862 7.0571 16.5785 8.85261C17.1667 12.4666 15.9873 16.9152 13.579 20.3555C13.3415 20.6949 13.424 21.1625 13.7634 21.4001C14.1027 21.6376 14.5703 21.5551 14.8079 21.2158C17.3997 17.5132 18.7205 12.6762 18.059 8.61164C17.7263 6.56789 16.886 4.68943 15.4182 3.27098C13.9452 1.84738 11.8957 0.941099 9.24749 0.751938C8.83433 0.722426 8.47547 1.03343 8.44596 1.4466Z',
    fill: '#010313'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector 402 (Stroke)',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.01123 7.91515C8.60938 8.01561 8.36506 8.42281 8.46552 8.82466C8.70107 9.76686 9.12231 11.4843 8.48153 13.4055C8.35048 13.7984 8.56277 14.2232 8.9557 14.3542C9.34863 14.4853 9.77341 14.273 9.90447 13.8801C10.6882 11.5302 10.1679 9.44941 9.92525 8.47892C9.92374 8.47286 9.92223 8.46683 9.92074 8.46085C9.82027 8.05901 9.41307 7.81469 9.01123 7.91515Z',
    fill: '#010313'
  })));
};

var Icon$9 = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '23',
    height: '23',
    viewBox: '0 0 23 23',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M0.751607 6.50122C0.751798 3.32558 3.32632 0.751376 6.50195 0.751567L16.4997 0.75217C19.6754 0.752361 22.2496 3.32688 22.2494 6.50252L22.2488 16.5003C22.2486 19.6759 19.6741 22.2502 16.4984 22.25L6.50065 22.2494C3.32502 22.2492 0.750813 19.6746 0.751004 16.499L0.751607 6.50122ZM6.50186 2.25157C4.15465 2.25143 2.25175 4.1541 2.25161 6.50131L2.251 16.4991C2.25086 18.8463 4.15354 20.7492 6.50074 20.7494L16.4985 20.75C18.8457 20.7501 20.7487 18.8474 20.7488 16.5002L20.7494 6.50243C20.7495 4.15521 18.8469 2.25231 16.4997 2.25217L6.50186 2.25157Z',
    fill: '#14142B'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10.6233 8.56068C10.4162 8.74473 10.25 9.03701 10.25 9.50022C10.25 9.91444 9.91421 10.2502 9.5 10.2502C9.08579 10.2502 8.75 9.91444 8.75 9.50022C8.75 8.63001 9.08376 7.92223 9.62672 7.43959C10.1559 6.96922 10.8402 6.75012 11.5 6.75012C12.1598 6.75012 12.8441 6.96921 13.3733 7.43956C13.9162 7.92217 14.25 8.6299 14.25 9.50007C14.25 10.1417 14.0843 10.6319 13.7961 11.032C13.5729 11.3421 13.2801 11.581 13.0713 11.7514C13.0387 11.778 13.0081 11.8029 12.9801 11.8262C12.7482 12.0196 12.5885 12.175 12.4709 12.3905C12.3559 12.6014 12.25 12.9303 12.25 13.5002C12.25 13.9144 11.9142 14.2502 11.5 14.2502C11.0858 14.2502 10.75 13.9144 10.75 13.5002C10.75 12.7367 10.8941 12.1489 11.1541 11.6722C11.4115 11.2002 11.7518 10.8973 12.0199 10.6739C12.0633 10.6377 12.1036 10.6044 12.1411 10.5734C12.3565 10.3954 12.4793 10.2938 12.5789 10.1556C12.6657 10.0349 12.75 9.8584 12.75 9.50007C12.75 9.03696 12.5838 8.74472 12.3767 8.56068C12.1559 8.36437 11.8402 8.25012 11.5 8.25012C11.1598 8.25012 10.8441 8.36437 10.6233 8.56068Z',
    fill: '#14142B'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M12.5 15.5002C12.5 16.0525 12.0523 16.5002 11.5 16.5002C10.9477 16.5002 10.5 16.0525 10.5 15.5002C10.5 14.948 10.9477 14.5002 11.5 14.5002C12.0523 14.5002 12.5 14.948 12.5 15.5002Z',
    fill: '#14142B'
  }));
};

var Icon$8 = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '19',
    height: '23',
    viewBox: '0 0 19 23',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.61194 2.39444C9.54156 2.35924 9.45872 2.35924 9.38834 2.39444L1.81691 6.18015C1.73221 6.2225 1.67871 6.30906 1.67871 6.40376V16.5963C1.67871 16.691 1.73221 16.7775 1.81691 16.8199L9.38834 20.6056C9.45872 20.6408 9.54156 20.6408 9.61194 20.6056L17.1834 16.8199C17.2681 16.7775 17.3216 16.691 17.3216 16.5963V6.40376C17.3216 6.30906 17.2681 6.2225 17.1834 6.18015L9.61194 2.39444ZM8.71752 1.05279C9.21019 0.806457 9.79009 0.806458 10.2828 1.05279L17.8542 4.83851C18.4471 5.13495 18.8216 5.74091 18.8216 6.40376V16.5963C18.8216 17.2591 18.4471 17.8651 17.8542 18.1615L10.2828 21.9472C9.79009 22.1936 9.21019 22.1936 8.71751 21.9472L1.14609 18.1615C0.553214 17.8651 0.178711 17.2591 0.178711 16.5963V6.40376C0.178711 5.74091 0.553214 5.13494 1.14609 4.83851L8.71752 1.05279Z',
    fill: '#14142B'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.49972 9.39282C8.33598 9.39282 7.39258 10.3362 7.39258 11.5C7.39258 12.6637 8.33598 13.6071 9.49972 13.6071C10.6635 13.6071 11.6069 12.6637 11.6069 11.5C11.6069 10.3362 10.6635 9.39282 9.49972 9.39282ZM5.89258 11.5C5.89258 9.5078 7.50755 7.89282 9.49972 7.89282C11.4919 7.89282 13.1069 9.5078 13.1069 11.5C13.1069 13.4921 11.4919 15.1071 9.49972 15.1071C7.50755 15.1071 5.89258 13.4921 5.89258 11.5Z',
    fill: '#14142B'
  }));
};

var Icon$7 = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '25',
    height: '25',
    viewBox: '0 0 25 25',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("g", {
    id: 'vuesax/outline/house-2'
  }, /*#__PURE__*/React.createElement("g", {
    id: 'house-2'
  }, /*#__PURE__*/React.createElement("path", {
    id: 'Vector',
    d: 'M22.5 23.25H2.5C2.09 23.25 1.75 22.91 1.75 22.5C1.75 22.09 2.09 21.75 2.5 21.75H22.5C22.91 21.75 23.25 22.09 23.25 22.5C23.25 22.91 22.91 23.25 22.5 23.25Z',
    fill: '#010313'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector_2',
    d: 'M4.20312 22.4997H2.70312L2.75313 10.4697C2.75313 9.61971 3.14313 8.82974 3.81313 8.30974L10.8131 2.85973C11.8031 2.08973 13.1931 2.08973 14.1931 2.85973L21.1931 8.29973C21.8531 8.81973 22.2531 9.62971 22.2531 10.4697V22.4997H20.7531V10.4797C20.7531 10.0997 20.5731 9.72973 20.2731 9.48973L13.2731 4.04973C12.8231 3.69973 12.1931 3.69973 11.7331 4.04973L4.73313 9.49974C4.43313 9.72974 4.25313 10.0997 4.25313 10.4797L4.20312 22.4997Z',
    fill: '#010313'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector_3',
    d: 'M17.5 23.25H7.5C7.09 23.25 6.75 22.91 6.75 22.5V13C6.75 11.76 7.76 10.75 9 10.75H16C17.24 10.75 18.25 11.76 18.25 13V22.5C18.25 22.91 17.91 23.25 17.5 23.25ZM8.25 21.75H16.75V13C16.75 12.59 16.41 12.25 16 12.25H9C8.59 12.25 8.25 12.59 8.25 13V21.75Z',
    fill: '#010313'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector_4',
    d: 'M10.5 19C10.09 19 9.75 18.66 9.75 18.25V16.75C9.75 16.34 10.09 16 10.5 16C10.91 16 11.25 16.34 11.25 16.75V18.25C11.25 18.66 10.91 19 10.5 19Z',
    fill: '#010313'
  }), /*#__PURE__*/React.createElement("path", {
    id: 'Vector_5',
    d: 'M14 8.75H11C10.59 8.75 10.25 8.41 10.25 8C10.25 7.59 10.59 7.25 11 7.25H14C14.41 7.25 14.75 7.59 14.75 8C14.75 8.41 14.41 8.75 14 8.75Z',
    fill: '#010313'
  }))));
};

var Icon$6 = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '20',
    height: '22',
    viewBox: '0 0 20 22',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.5 4.25C7.70507 4.25 6.25 5.70507 6.25 7.5C6.25 9.29493 7.70507 10.75 9.5 10.75C11.2949 10.75 12.75 9.29493 12.75 7.5C12.75 5.70507 11.2949 4.25 9.5 4.25ZM4.75 7.5C4.75 4.87665 6.87665 2.75 9.5 2.75C12.1234 2.75 14.25 4.87665 14.25 7.5C14.25 10.1234 12.1234 12.25 9.5 12.25C6.87665 12.25 4.75 10.1234 4.75 7.5Z',
    fill: '#14142B'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M14.25 3.5C14.25 3.08579 14.5858 2.75 15 2.75L19 2.75C19.4142 2.75 19.75 3.08579 19.75 3.5C19.75 3.91421 19.4142 4.25 19 4.25L15 4.25C14.5858 4.25 14.25 3.91421 14.25 3.5Z',
    fill: '#14142B'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M17 6.25C16.5858 6.25 16.25 5.91421 16.25 5.5L16.25 1.5C16.25 1.08579 16.5858 0.75 17 0.75C17.4142 0.75 17.75 1.08579 17.75 1.5L17.75 5.5C17.75 5.91421 17.4142 6.25 17 6.25Z',
    fill: '#14142B'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M2.55896 16.2306C3.92478 14.8079 6.13389 13.75 9.5 13.75C12.8661 13.75 15.0752 14.8079 16.441 16.2306C17.7886 17.6343 18.25 19.3268 18.25 20.5C18.25 20.9142 17.9142 21.25 17.5 21.25H1.5C1.08579 21.25 0.75 20.9142 0.75 20.5C0.75 19.3268 1.21137 17.6343 2.55896 16.2306ZM2.32918 19.75H16.6708C16.5189 18.9916 16.131 18.0736 15.359 17.2694C14.3248 16.1921 12.5339 15.25 9.5 15.25C6.46611 15.25 4.67522 16.1921 3.64104 17.2694C2.86897 18.0736 2.48106 18.9916 2.32918 19.75Z',
    fill: '#14142B'
  }));
};

var Icon$5 = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '18',
    height: '14',
    viewBox: '0 0 18 14',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M0 1C0 0.585786 0.335786 0.25 0.75 0.25H17.25C17.6642 0.25 18 0.585786 18 1C18 1.41421 17.6642 1.75 17.25 1.75H0.75C0.335787 1.75 0 1.41421 0 1ZM0 7C0 6.58579 0.335786 6.25 0.75 6.25H17.25C17.6642 6.25 18 6.58579 18 7C18 7.41421 17.6642 7.75 17.25 7.75H0.75C0.335787 7.75 0 7.41421 0 7ZM0.75 12.25C0.335786 12.25 0 12.5858 0 13C0 13.4142 0.335787 13.75 0.75 13.75H17.25C17.6642 13.75 18 13.4142 18 13C18 12.5858 17.6642 12.25 17.25 12.25H0.75Z',
    fill: '#EBEBF2'
  }));
};

var Icon$4 = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    viewBox: '0 0 24 24',
    focusable: 'false'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: 'currentColor',
    d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z'
  }));
};

var Icon$3 = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '44',
    height: '45',
    viewBox: '0 0 44 45',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("rect", {
    x: '0.5',
    y: '1',
    width: '43',
    height: '43',
    rx: '11.5',
    stroke: '#7B7C8F'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M15.6359 14C15.0501 13.4142 14.1003 13.4142 13.5145 14C12.9287 14.5858 12.9287 15.5355 13.5145 16.1213L19.8933 22.5001L13.5148 28.8787C12.929 29.4645 12.929 30.4142 13.5148 31C14.1005 31.5858 15.0503 31.5858 15.6361 31L22.0146 24.6214L28.3638 30.9706C28.9496 31.5564 29.8993 31.5564 30.4851 30.9706C31.0709 30.3848 31.0709 29.435 30.4851 28.8493L24.136 22.5001L30.4853 16.1508C31.0711 15.565 31.0711 14.6152 30.4853 14.0294C29.8995 13.4437 28.9498 13.4437 28.364 14.0294L22.0146 20.3788L15.6359 14Z',
    fill: '#EBEDF5'
  }));
};

var Icon$2 = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("rect", {
    width: '24',
    height: '24',
    rx: '6',
    fill: 'url(#paint0_linear_6256_18547)'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M8.37522 5H15.628C16.0272 5 16.3993 5.19282 16.6259 5.51529L19.9479 10.2061C20.2828 10.6781 20.2286 11.3197 19.8159 11.7286L12.8676 18.6435C12.3906 19.1188 11.6092 19.1188 11.1322 18.6435L4.1839 11.7253C3.7712 11.3164 3.71707 10.6748 4.05197 10.2027L7.37391 5.51196C7.60394 5.19282 7.97605 5 8.37522 5ZM11.613 15.3231C11.7115 15.4366 11.8448 15.5 11.984 15.5C12.1231 15.5 12.2564 15.4366 12.355 15.3231L15.4999 11.6812L14.7608 10.8333L11.984 14.0479L9.23905 10.8701L8.49992 11.7179L11.613 15.3231Z',
    fill: 'white'
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 'paint0_linear_6256_18547',
    x1: '1.56',
    y1: '-2.59484e-06',
    x2: '26.8101',
    y2: '2.15016',
    gradientUnits: 'userSpaceOnUse'
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": '#FFE79D'
  }), /*#__PURE__*/React.createElement("stop", {
    offset: '1',
    "stop-color": '#FFC514'
  }))));
};

var Icon$1 = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '14',
    height: '15',
    viewBox: '0 0 14 15',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M6.99935 13.3334C10.2077 13.3334 12.8327 10.7084 12.8327 7.50008C12.8327 4.29175 10.2077 1.66675 6.99935 1.66675C3.79102 1.66675 1.16602 4.29175 1.16602 7.50008C1.16602 10.7084 3.79102 13.3334 6.99935 13.3334Z',
    fill: '#333BF5'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M7 5.16675V8.08341',
    stroke: 'white',
    strokeWidth: '1.2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M6.99609 9.83325H7.00133',
    stroke: 'white',
    strokeWidth: '1.2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var Icon = function Icon(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({}, props, {
    width: '25',
    height: '25',
    viewBox: '0 0 25 25',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M9.96768 11.7899C9.86768 11.7799 9.74768 11.7799 9.63768 11.7899C7.25768 11.7099 5.36768 9.75992 5.36768 7.35992C5.36768 4.90992 7.34768 2.91992 9.80768 2.91992C12.2577 2.91992 14.2477 4.90992 14.2477 7.35992C14.2377 9.75992 12.3477 11.7099 9.96768 11.7899Z',
    stroke: '#35334A',
    strokeWidth: '1.5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M17.2176 4.91992C19.1576 4.91992 20.7176 6.48992 20.7176 8.41992C20.7176 10.3099 19.2176 11.8499 17.3476 11.9199C17.2676 11.9099 17.1776 11.9099 17.0876 11.9199',
    stroke: '#35334A',
    strokeWidth: '1.5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M4.96759 15.4799C2.54759 17.0999 2.54759 19.7399 4.96759 21.3499C7.71759 23.1899 12.2276 23.1899 14.9776 21.3499C17.3976 19.7299 17.3976 17.0899 14.9776 15.4799C12.2376 13.6499 7.72759 13.6499 4.96759 15.4799Z',
    stroke: '#35334A',
    strokeWidth: '1.5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), /*#__PURE__*/React.createElement("path", {
    d: 'M19.1476 20.9199C19.8676 20.7699 20.5476 20.4799 21.1076 20.0499C22.6676 18.8799 22.6676 16.9499 21.1076 15.7799C20.5576 15.3599 19.8876 15.0799 19.1776 14.9199',
    stroke: '#35334A',
    strokeWidth: '1.5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var css_248z$1 = ".styles-module_user-info-modal__Xjnnk {\n  position: absolute;\n  min-width: 300px;\n  background: #fff;\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 20px;\n  position: fixed;\n  z-index: 200;\n  right: 50px;\n  top: 60px;\n  color: #010313;\n  padding: 40px 20px;\n  padding-bottom: 34px;\n  box-sizing: border-box;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_account__Qq64H {\n  display: flex;\n  color: #7B7C8F;\n  font-size: 12px;\n  justify-content: space-between;\n  align-items: center;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_account__Qq64H .styles-module_copy-info__Z0DF9 {\n  margin-left: 10px;\n  background: rgba(32, 26, 85, 0.05);\n  border-radius: 6px;\n  height: 27px;\n  width: 149px;\n  line-height: 27px;\n  font-size: 12px;\n  padding-left: 10px;\n  display: flex;\n  justify-content: space-between;\n  flex: 1;\n  color: #010313;\n  font-weight: 600;\n  text-align: right;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  margin: 20px 0px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn__nyP-a {\n  height: 30px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  padding: 5px 10px;\n  color: #fff;\n  font-size: 12px;\n  border-radius: 6px;\n  border: none;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn-normal__abaVL {\n  background: #E3E4F1;\n  color: #010313;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn-active__t565C {\n  background-color: #F0FCED;\n  color: #4FBE45;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn-start-kyc__jvKqJ {\n  background: #333BF5;\n  border-radius: 20px;\n  color: #FFF;\n  margin-left: 10px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn-professional__FQbOd {\n  border-radius: 6px;\n  background: linear-gradient(95deg, #FFE79D 5.99%, #FFC514 103.65%);\n  color: #D78100;\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn-professional__FQbOd svg {\n  margin-right: 5px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn-corporation__2hgF- {\n  border-radius: 6px;\n  background: linear-gradient(95deg, #4AE2BC 5.99%, #03AD82 103.65%);\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn-corporation__2hgF- svg {\n  margin-right: 5px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn-company__da-iy {\n  border-radius: 6px;\n  background: linear-gradient(95deg, #7684FF 5.99%, #2A3BD7 103.65%);\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_tag-btn-company__da-iy svg {\n  margin-right: 5px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_company-tip-box__IVf9a {\n  position: relative;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_kyc-info__JXoU3 .styles-module_company-tip-box__IVf9a .styles-module_company-pi-tip__y5xJv {\n  width: 99px;\n  position: absolute;\n  padding: 10px;\n  box-sizing: border-box;\n  left: 10px;\n  border-radius: 12px;\n  background: #fff;\n  border: 1px solid rgba(32, 26, 85, 0.05);\n  box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.1);\n  top: 30px;\n  color: #010313;\n  text-align: center;\n  font-family: \"PingFang HK\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info__HtM65 {\n  width: 100%;\n  background: rgba(32, 26, 85, 0.05);\n  border-radius: 12px;\n  padding: 20px;\n  box-sizing: content-box;\n  box-sizing: border-box;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-available-title__XDam8 {\n  color: #7b7c8f;\n  font-size: 12px;\n  height: 20px;\n  line-height: 20px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-available-content__xFjj7 {\n  color: #222227;\n  font-weight: 600;\n  font-size: 14px;\n  margin-top: 8px;\n  height: 20px;\n  line-height: 20px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-line__sEl5X {\n  height: 1px;\n  border-bottom: 1px solid #e3e4f1;\n  margin-top: 10px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount__wTYbv {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-left-title__Ng36Z {\n  color: #7b7c8f;\n  font-size: 12px;\n  margin-top: 10px;\n  height: 20px;\n  line-height: 20px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-left-title__Ng36Z .styles-module_limit-amount-tip__H--Hf {\n  margin-left: 5px;\n  position: relative;\n  display: flex;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-left-title__Ng36Z .styles-module_limit-amount-tip__H--Hf .styles-module_amount-tip-content__VB5zT {\n  position: absolute;\n  top: 20px;\n  border-radius: 20px;\n  border: 1px solid rgba(32, 26, 85, 0.05);\n  background: #FFF;\n  box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  width: 300px;\n  right: -10px;\n  z-index: 99;\n  font-family: \"PingFang HK\";\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-left-title__Ng36Z .styles-module_limit-amount-tip__H--Hf .styles-module_amount-tip-content__VB5zT .styles-module_title__3UshN {\n  color: #010313;\n  font-size: 16px;\n  font-weight: 500;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-left-title__Ng36Z .styles-module_limit-amount-tip__H--Hf .styles-module_amount-tip-content__VB5zT .styles-module_desc__-MdpP {\n  margin-top: 10px;\n  color: #010313;\n  font-size: 14px;\n  font-weight: 400;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-content__dqDof {\n  color: #222227;\n  font-weight: 600;\n  font-size: 14px;\n  margin-top: 8px;\n  height: 20px;\n  line-height: 20px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-btn__19vyt {\n  margin-top: 10px;\n  color: #fff;\n  font-size: 12px;\n  height: 30px;\n  line-height: 20px;\n  border-radius: 20px;\n  padding: 5px 10px;\n  border: none;\n  cursor: pointer;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-btn-noraml__Q4I7F {\n  background: #b3b4c8;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-btn-noraml__Q4I7F:hover {\n  background: #b3b4c8;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-btn-active__vnH2s {\n  background: #333bf5;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-btn-active__vnH2s:hover {\n  background: #4950f4;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_balance-info-amount-btn-disabled__stgVt {\n  background-color: #B3B4C8;\n  color: #fff;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_account-info-wrap__wqMiV {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 12px;\n  margin-top: 20px;\n  border: 1px solid #EDEFFC;\n  overflow: hidden;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_account-info-wrap__wqMiV .styles-module_account-link-item__-Vegt {\n  padding: 15px 20px;\n  margin-bottom: 0px;\n  height: 54px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #010313;\n  font-size: 12px;\n  position: relative;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_account-info-wrap__wqMiV .styles-module_account-link-item__-Vegt:not(:last-child)::after {\n  position: absolute;\n  content: \"\";\n  height: 0.5px;\n  background-color: #E3E4F1;\n  width: 225px;\n  left: 20px;\n  bottom: 0;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_account-info-wrap__wqMiV .styles-module_account-link-item__-Vegt:hover {\n  color: #333BF5;\n  background-color: rgba(32, 26, 85, 0.05);\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_account-info-wrap__wqMiV .styles-module_account-link-item__-Vegt:last-child {\n  border-bottom: none;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_account-info-wrap__wqMiV .styles-module_account-link-item__-Vegt .styles-module_account-link-item-text__8yT2Z {\n  line-height: 24px;\n  white-space: nowrap;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_login-out__8rJla {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_login-out-btn__PldPz {\n  width: 108px;\n  height: 40px;\n  border-radius: 20px;\n  border: 1px solid #7b7c8f;\n  font-size: 12px;\n  color: #7b7c8f;\n  background: #fff;\n  line-height: 20px;\n}\n.styles-module_user-info-modal__Xjnnk .styles-module_login-out-btn__PldPz:hover {\n  border-color: #222227;\n  color: #222227;\n  cursor: pointer;\n}";
var styles = {"user-info-modal":"styles-module_user-info-modal__Xjnnk","account":"styles-module_account__Qq64H","copy-info":"styles-module_copy-info__Z0DF9","kyc-info":"styles-module_kyc-info__JXoU3","tag-btn":"styles-module_tag-btn__nyP-a","tag-btn-normal":"styles-module_tag-btn-normal__abaVL","tag-btn-active":"styles-module_tag-btn-active__t565C","tag-btn-start-kyc":"styles-module_tag-btn-start-kyc__jvKqJ","tag-btn-professional":"styles-module_tag-btn-professional__FQbOd","tag-btn-corporation":"styles-module_tag-btn-corporation__2hgF-","tag-btn-company":"styles-module_tag-btn-company__da-iy","company-tip-box":"styles-module_company-tip-box__IVf9a","company-pi-tip":"styles-module_company-pi-tip__y5xJv","balance-info":"styles-module_balance-info__HtM65","balance-info-available-title":"styles-module_balance-info-available-title__XDam8","balance-info-available-content":"styles-module_balance-info-available-content__xFjj7","balance-info-line":"styles-module_balance-info-line__sEl5X","balance-info-amount":"styles-module_balance-info-amount__wTYbv","balance-info-amount-left-title":"styles-module_balance-info-amount-left-title__Ng36Z","limit-amount-tip":"styles-module_limit-amount-tip__H--Hf","amount-tip-content":"styles-module_amount-tip-content__VB5zT","title":"styles-module_title__3UshN","desc":"styles-module_desc__-MdpP","balance-info-amount-content":"styles-module_balance-info-amount-content__dqDof","balance-info-amount-btn":"styles-module_balance-info-amount-btn__19vyt","balance-info-amount-btn-noraml":"styles-module_balance-info-amount-btn-noraml__Q4I7F","balance-info-amount-btn-active":"styles-module_balance-info-amount-btn-active__vnH2s","balance-info-amount-btn-disabled":"styles-module_balance-info-amount-btn-disabled__stgVt","account-info-wrap":"styles-module_account-info-wrap__wqMiV","account-link-item":"styles-module_account-link-item__-Vegt","account-link-item-text":"styles-module_account-link-item-text__8yT2Z","login-out":"styles-module_login-out__8rJla","login-out-btn":"styles-module_login-out-btn__PldPz"};
styleInject(css_248z$1);

// src/clipboard-polyfill/ClipboardItem/data-types.ts
var TEXT_PLAIN = "text/plain";
function debugLog(s) {
}
function warnOrLog() {
  (console.warn || console.log).apply(console, arguments);
}
warnOrLog.bind("[clipboard-polyfill]");

// src/clipboard-polyfill/builtins/window-globalThis.ts
var originalWindow = typeof window === "undefined" ? void 0 : window;
var originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;

// src/clipboard-polyfill/builtins/promise-constructor.ts
var _a, _b, _c;
var promiseConstructorImpl = (_c = (_a = originalWindow) == null ? void 0 : _a.Promise) != null ? _c : (_b = originalGlobalThis) == null ? void 0 : _b.Promise;
function getPromiseConstructor() {
  if (!promiseConstructorImpl) {
    throw new Error(
      "No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included"
    );
  }
  return promiseConstructorImpl;
}

// src/clipboard-polyfill/builtins/builtin-globals.ts
var originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var originalNavigatorClipboard = originalNavigator == null ? void 0 : originalNavigator.clipboard;
var _a2;
(_a2 = originalNavigatorClipboard == null ? void 0 : originalNavigatorClipboard.read) == null ? void 0 : _a2.bind(
  originalNavigatorClipboard
);
var _a3;
(_a3 = originalNavigatorClipboard == null ? void 0 : originalNavigatorClipboard.readText) == null ? void 0 : _a3.bind(
  originalNavigatorClipboard
);
var _a4;
(_a4 = originalNavigatorClipboard == null ? void 0 : originalNavigatorClipboard.write) == null ? void 0 : _a4.bind(
  originalNavigatorClipboard
);
var _a5;
var originalNavigatorClipboardWriteText = (_a5 = originalNavigatorClipboard == null ? void 0 : originalNavigatorClipboard.writeText) == null ? void 0 : _a5.bind(
  originalNavigatorClipboard
);
var _a6;
(_a6 = originalWindow) == null ? void 0 : _a6.ClipboardItem;
var promiseConstructor = getPromiseConstructor();

// src/clipboard-polyfill/strategies/internet-explorer.ts
var ieWindow = originalWindow;
function seemToBeInIE() {
  return typeof ClipboardEvent === "undefined" && typeof (ieWindow == null ? void 0 : ieWindow.clipboardData) !== "undefined" && typeof (ieWindow == null ? void 0 : ieWindow.clipboardData.setData) !== "undefined";
}
function writeTextIE(text) {
  if (!ieWindow.clipboardData) {
    return false;
  }
  var success = ieWindow.clipboardData.setData("Text", text);
  return success;
}

// src/clipboard-polyfill/strategies/dom.ts
function copyListener(tracker, data, e) {
  tracker.success = true;
  for (var type in data) {
    var value = data[type];
    var clipboardData = e.clipboardData;
    clipboardData.setData(type, value);
    if (type === TEXT_PLAIN && clipboardData.getData(type) !== value) {
      tracker.success = false;
    }
  }
  e.preventDefault();
}
function execCopy(data) {
  var tracker = { success: false };
  var listener = copyListener.bind(this, tracker, data);
  document.addEventListener("copy", listener);
  try {
    document.execCommand("copy");
  } finally {
    document.removeEventListener("copy", listener);
  }
  return tracker.success;
}
function copyUsingTempSelection(e, data) {
  selectionSet(e);
  var success = execCopy(data);
  selectionClear();
  return success;
}
function copyUsingTempElem(data) {
  var tempElem = document.createElement("div");
  tempElem.setAttribute("style", "-webkit-user-select: text !important");
  tempElem.textContent = "temporary element";
  document.body.appendChild(tempElem);
  var success = copyUsingTempSelection(tempElem, data);
  document.body.removeChild(tempElem);
  return success;
}
function copyTextUsingDOM(str) {
  var tempElem = document.createElement("div");
  tempElem.setAttribute("style", "-webkit-user-select: text !important");
  var spanParent = tempElem;
  if (tempElem.attachShadow) {
    spanParent = tempElem.attachShadow({ mode: "open" });
  }
  var span = document.createElement("span");
  span.innerText = str;
  spanParent.appendChild(span);
  document.body.appendChild(tempElem);
  selectionSet(span);
  var result = document.execCommand("copy");
  selectionClear();
  document.body.removeChild(tempElem);
  return result;
}
function selectionSet(elem) {
  var sel = document.getSelection();
  if (sel) {
    var range = document.createRange();
    range.selectNodeContents(elem);
    sel.removeAllRanges();
    sel.addRange(range);
  }
}
function selectionClear() {
  var sel = document.getSelection();
  if (sel) {
    sel.removeAllRanges();
  }
}

// src/clipboard-polyfill/implementations/write-fallback.ts
function writeFallback(stringItem) {
  var hasTextPlain = TEXT_PLAIN in stringItem;
  if (seemToBeInIE()) {
    if (!hasTextPlain) {
      throw new Error("No `text/plain` value was specified.");
    }
    if (writeTextIE(stringItem[TEXT_PLAIN])) {
      return true;
    } else {
      throw new Error("Copying failed, possibly because the user rejected it.");
    }
  }
  if (execCopy(stringItem)) {
    return true;
  }
  if (navigator.userAgent.indexOf("Edge") > -1) {
    return true;
  }
  if (copyUsingTempSelection(document.body, stringItem)) {
    return true;
  }
  if (copyUsingTempElem(stringItem)) {
    return true;
  }
  if (copyTextUsingDOM(stringItem[TEXT_PLAIN])) {
    return true;
  }
  return false;
}
promiseConstructor.resolve();
promiseConstructor.resolve(false);
function rejectThrownErrors(executor) {
  return new promiseConstructor((resolve, reject) => {
    try {
      resolve(executor());
    } catch (e) {
      reject(e);
    }
  });
}

// src/clipboard-polyfill/implementations/text.ts
function stringToStringItem(s) {
  var stringItem = {};
  stringItem[TEXT_PLAIN] = s;
  return stringItem;
}
function writeText(s) {
  return rejectThrownErrors(() => {
    if (originalNavigatorClipboardWriteText) {
      debugLog("Using `navigator.clipboard.writeText()`.");
      return originalNavigatorClipboardWriteText(s).catch(
        writeTextStringFallback
      );
    }
    return promiseConstructor.resolve(writeTextStringFallback(s));
  });
}
function writeTextStringFallback(s) {
  if (!writeFallback(stringToStringItem(s))) {
    throw new Error("writeText() failed");
  }
}

var SUB_ACCOUNT_SHOW_LIST = [KYC_TYPE.CORPORATION, KYC_TYPE.CORPORATION_PI, KYC_TYPE.INSTITUTION, KYC_TYPE.INSTITUTION_PI];
var UserInfoModal = function UserInfoModal(_a) {
  var _b, _c;
  var _d, _e, _f, _g, _h, _j;
  var userInfo = _a.userInfo,
    setShowPIModal = _a.setShowPIModal,
    setShowCompanyPIModal = _a.setShowCompanyPIModal;
  var t = useTranslation().t;
  var handleLoginOut = useHeaderHooks().handleLoginOut;
  var _k = useState(false),
    copyed = _k[0],
    setCopyed = _k[1];
  var _l = useState(false),
    showCompanyTip = _l[0],
    setShowCompanyTip = _l[1];
  var _m = useState(false),
    showAmountLimitTip = _m[0],
    setShowAmountTip = _m[1];
  var copyUid = function copyUid(text) {
    writeText(text).then(function () {
      setCopyed(true);
      setTimeout(function () {
        setCopyed(false);
      }, 3000);
    });
  };
  var toAmount = function toAmount() {
    if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.INSTITUTION_PI || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.account_role) === ACCOUNT_ROLE.SUB) {
      return;
    }
    if (userInfo.kyc_type === KYC_TYPE.UNAUTHORIZED) {
      window.open('/trade/kyc', '_self');
    } else {
      if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.trade_limit_status) !== 'PENDING') {
        window.open('/trade/amountApply', '_self');
      }
    }
  };
  // kyc status
  var renderKycStatus = function renderKycStatus() {
    // 未认证
    if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.UNAUTHORIZED) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-normal']])
      }, t('TNkXPjSKdzQcBLZPsWj')), /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-start-kyc']]),
        onClick: function onClick() {
          return window.open("/trade/kyc", '_self');
        }
      }, t('ghYLDApWJBxFOzhqAlN')));
    } else if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.PERSONAL) {
      // 已认证但未高级认证
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-active']])
      }, t('ysjFKMhSQlIqXgPlz')), /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-start-kyc']]),
        onClick: function onClick() {
          return setShowPIModal(true);
        }
      }, t('slVffWcKrAhjpgaMEuY')));
    } else if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.PI) {
      //  PI
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-active']])
      }, t('ysjFKMhSQlIqXgPlz')), /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-professional']])
      }, /*#__PURE__*/React.createElement(Icon$e, null), t('GCxKMtkKAZPoOHsZIDh')));
    } else if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.CORPORATION) {
      // 法团已认证 未PI
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-active']])
      }, t('ysjFKMhSQlIqXgPlz')), /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-corporation']]),
        style: {
          marginLeft: '5px'
        }
      }, /*#__PURE__*/React.createElement(Icon$g, null), t('ylhkcCPZqNeskQBJB')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: '5px'
        },
        className: cs([styles['tag-btn'], styles['tag-btn-start-kyc']]),
        onClick: function onClick() {
          return setShowCompanyPIModal(true);
        }
      }, t('slVffWcKrAhjpgaMEuY')));
    } else if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.INSTITUTION) {
      // 机构已认证 未PI
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-active']])
      }, t('ysjFKMhSQlIqXgPlz')), /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-company']]),
        style: {
          marginLeft: '5px'
        }
      }, /*#__PURE__*/React.createElement(Icon$f, null), t('XVImLdGTpJvSndfrLlee')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: '5px'
        },
        className: cs([styles['tag-btn'], styles['tag-btn-start-kyc']]),
        onClick: function onClick() {
          return setShowCompanyPIModal(true);
        }
      }, t('slVffWcKrAhjpgaMEuY')));
    } else if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.INSTITUTION_PI) {
      // 机构专业
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-active']])
      }, t('ysjFKMhSQlIqXgPlz')), /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-company']])
      }, /*#__PURE__*/React.createElement(Icon$f, null), t('XVImLdGTpJvSndfrLlee')), /*#__PURE__*/React.createElement("div", {
        className: styles['company-tip-box'],
        onMouseEnter: function onMouseEnter() {
          return setShowCompanyTip(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setShowCompanyTip(false);
        }
      }, /*#__PURE__*/React.createElement(Icon$2, {
        style: {
          marginLeft: '10px'
        }
      }), showCompanyTip && ( /*#__PURE__*/React.createElement("div", {
        className: styles['company-pi-tip']
      }, t('GCxKMtkKAZPoOHsZIDh')))));
    } else if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.CORPORATION_PI) {
      // 机构专业
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-active']])
      }, t('ysjFKMhSQlIqXgPlz')), /*#__PURE__*/React.createElement("div", {
        className: cs([styles['tag-btn'], styles['tag-btn-corporation']])
      }, /*#__PURE__*/React.createElement(Icon$g, null), t('ylhkcCPZqNeskQBJB')), /*#__PURE__*/React.createElement("div", {
        className: styles['company-tip-box'],
        onMouseEnter: function onMouseEnter() {
          return setShowCompanyTip(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setShowCompanyTip(false);
        }
      }, /*#__PURE__*/React.createElement(Icon$2, {
        style: {
          marginLeft: '10px'
        }
      }), showCompanyTip && ( /*#__PURE__*/React.createElement("div", {
        className: styles['company-pi-tip']
      }, t('GCxKMtkKAZPoOHsZIDh')))));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  return (
    /*#__PURE__*/
    //用户信息弹窗
    React.createElement("div", {
      className: styles['user-info-modal']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['account']
    }, /*#__PURE__*/React.createElement("span", null, t('EOmmDCycYoHFOZOV'), ":"), /*#__PURE__*/React.createElement("div", {
      className: styles['copy-info']
    }, userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid, copyed && /*#__PURE__*/React.createElement("span", null, t('gXbirwakdsaUKBglwK')), /*#__PURE__*/React.createElement(Icon$i, {
      onClick: function onClick() {
        copyUid(userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid);
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles['kyc-info']
    }, renderKycStatus()), /*#__PURE__*/React.createElement("div", {
      className: styles['balance-info']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['balance-info-available']
    }, /*#__PURE__*/React.createElement("p", {
      className: styles['balance-info-available-title']
    }, i18n.t('domCttddTWzCfimSWOq')), /*#__PURE__*/React.createElement("p", {
      className: styles['balance-info-available-content']
    }, (_d = userInfo === null || userInfo === void 0 ? void 0 : userInfo.available_trade_limit) === null || _d === void 0 ? void 0 : _d.primary_currency, ' ', ((_e = userInfo === null || userInfo === void 0 ? void 0 : userInfo.available_trade_limit) === null || _e === void 0 ? void 0 : _e.amount) && numbro((_f = userInfo === null || userInfo === void 0 ? void 0 : userInfo.available_trade_limit) === null || _f === void 0 ? void 0 : _f.amount).format({
      thousandSeparated: true,
      mantissa: 2,
      trimMantissa: true
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles['balance-info-line']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['balance-info-amount']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['balance-info-amount-left']
    }, /*#__PURE__*/React.createElement("p", {
      className: styles['balance-info-amount-left-title'],
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement("span", null, i18n.t('dqLNRujTTFLifcFaybP')), /*#__PURE__*/React.createElement("div", {
      className: styles['limit-amount-tip'],
      onMouseEnter: function onMouseEnter() {
        setShowAmountTip(true);
      },
      onMouseLeave: function onMouseLeave() {
        setShowAmountTip(false);
      }
    }, /*#__PURE__*/React.createElement(Icon$1, null), showAmountLimitTip && ( /*#__PURE__*/React.createElement("div", {
      className: styles['amount-tip-content']
    }, /*#__PURE__*/React.createElement("p", {
      className: styles['title']
    }, i18n.t('dqLNRujTTFLifcFaybP')), /*#__PURE__*/React.createElement("p", {
      className: styles['desc']
    }, i18n.t('wIfwelYvkemWaZGE')))))), /*#__PURE__*/React.createElement("p", {
      className: styles['balance-info-amount-content']
    }, (_g = userInfo === null || userInfo === void 0 ? void 0 : userInfo.trade_limit) === null || _g === void 0 ? void 0 : _g.primary_currency, ' ', ((_h = userInfo === null || userInfo === void 0 ? void 0 : userInfo.trade_limit) === null || _h === void 0 ? void 0 : _h.amount) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) !== KYC_TYPE.INSTITUTION_PI && numbro((_j = userInfo === null || userInfo === void 0 ? void 0 : userInfo.trade_limit) === null || _j === void 0 ? void 0 : _j.amount).format({
      thousandSeparated: true,
      mantissa: 2,
      trimMantissa: true
    }), (userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.INSTITUTION_PI && 'N/A')), /*#__PURE__*/React.createElement("div", {
      className: styles['balance-info-amount-right']
    }, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.trade_limit_status) === 'PENDING' ? ( /*#__PURE__*/React.createElement("button", {
      className: cs((_b = {}, _b[styles['balance-info-amount-btn']] = true, _b[styles['balance-info-amount-btn-noraml']] = true, _b))
    }, i18n.t('KzFzOytWXScqDRKFwg'))) : ( /*#__PURE__*/React.createElement("button", {
      className: cs((_c = {}, _c[styles['balance-info-amount-btn']] = true, _c[styles[(userInfo === null || userInfo === void 0 ? void 0 : userInfo.kyc_type) === KYC_TYPE.INSTITUTION_PI || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.account_role) === ACCOUNT_ROLE.SUB ? 'balance-info-amount-btn-disabled' : 'balance-info-amount-btn-active']] = true, _c)),
      onClick: toAmount
    }, i18n.t('IurrXFgATIlGAlejcf')))))), /*#__PURE__*/React.createElement("div", {
      className: styles['account-info-wrap']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['account-link-item'],
      onClick: function onClick() {
        return window.open("/trade/accountManager?current=1", '_self');
      }
    }, /*#__PURE__*/React.createElement(Icon$a, null), /*#__PURE__*/React.createElement("p", {
      className: styles['account-link-item-text']
    }, i18n.t('POdaGgvMxQRsisLbVcll'))), (userInfo.kyc_type === KYC_TYPE.PERSONAL || userInfo.kyc_type === KYC_TYPE.PI || userInfo.kyc_type === KYC_TYPE.UNAUTHORIZED) && ( /*#__PURE__*/React.createElement("div", {
      className: styles['account-link-item'],
      onClick: function onClick() {
        return window.open("/trade/accountManager?current=2", '_self');
      }
    }, /*#__PURE__*/React.createElement(Icon$6, null), /*#__PURE__*/React.createElement("p", {
      className: styles['account-link-item-text']
    }, i18n.t('qRoYPOkmAoqOZnZawkD')))), (userInfo.kyc_type === KYC_TYPE.INSTITUTION || userInfo.kyc_type === KYC_TYPE.CORPORATION || userInfo.kyc_type === KYC_TYPE.INSTITUTION_PI || userInfo.kyc_type === KYC_TYPE.CORPORATION_PI) && ( /*#__PURE__*/React.createElement("div", {
      className: styles['account-link-item'],
      onClick: function onClick() {
        return window.open('/trade/companyKyc/info', '_self');
      }
    }, /*#__PURE__*/React.createElement(Icon$7, null), /*#__PURE__*/React.createElement("p", {
      className: styles['account-link-item-text']
    }, i18n.t('HMclPwyZgRMKnvBRCr')))), SUB_ACCOUNT_SHOW_LIST.indexOf(userInfo.kyc_type) > -1 && userInfo.account_role === ACCOUNT_ROLE.MAIN && ( /*#__PURE__*/React.createElement("div", {
      className: styles['account-link-item'],
      onClick: function onClick() {
        return window.open('/trade/subAccount', '_self');
      }
    }, /*#__PURE__*/React.createElement(Icon, null), /*#__PURE__*/React.createElement("p", {
      className: styles['account-link-item-text']
    }, i18n.t('wtPiDpoJwweHEwGphG')))), /*#__PURE__*/React.createElement("div", {
      className: styles['account-link-item'],
      onClick: function onClick() {
        return window.open("/trade/accountManager?current=3", '_self');
      }
    }, /*#__PURE__*/React.createElement(Icon$8, null), /*#__PURE__*/React.createElement("p", {
      className: styles['account-link-item-text']
    }, i18n.t('SgWXitfFwQHiWicT'))), /*#__PURE__*/React.createElement("div", {
      className: styles['account-link-item'],
      onClick: function onClick() {
        if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.language) === 'en') {
          window.open('https://support.bixin.com/hc/en-hk');
        } else {
          window.open('https://support.bixin.com/hc/zh-hk');
        }
      }
    }, /*#__PURE__*/React.createElement(Icon$9, null), /*#__PURE__*/React.createElement("p", {
      className: styles['account-link-item-text']
    }, i18n.t('LcqaZGQKcdkxNrnIcK')))), /*#__PURE__*/React.createElement("div", {
      className: styles['login-out']
    }, /*#__PURE__*/React.createElement("button", {
      className: styles['login-out-btn'],
      onClick: handleLoginOut
    }, i18n.t('erLerUcELvDAcoUWi'))))
  );
};

var BxHeader = function BxHeader(_a) {
  var changeLanguage = _a.changeLanguage;
  var t = useTranslation().t;
  var _b = useHeaderHooks(),
    memoBtns = _b.memoBtns,
    memoAboutBx = _b.memoAboutBx,
    shwoBxGroupIn = _b.shwoBxGroupIn,
    userInfo = _b.userInfo,
    // handleStorage,
    mobileStyle = _b.mobileStyle,
    memoMobileMenus = _b.memoMobileMenus,
    memoContactLinks = _b.memoContactLinks,
    fetchUserInfo = _b.fetchUserInfo,
    memoMenus = _b.memoMenus;
  var _c = useState(false),
    isIn = _c[0],
    setIsIn = _c[1];
  var _d = useState(false),
    showMoileMenu = _d[0],
    setShowMobilMenu = _d[1]; // 移动端弹窗
  var _e = useState(false),
    showUserInfoModal = _e[0],
    setShowUserInfoModal = _e[1]; // 用户信息弹窗
  var _f = useState(false),
    showPIModal = _f[0],
    setShowPIModal = _f[1]; // PI 弹窗
  var _g = useState(false),
    showCompanyPIModal = _g[0],
    setShowCompanyPIModal = _g[1];
  useEffect(function () {
    if (showUserInfoModal) {
      fetchUserInfo();
    }
  }, [showUserInfoModal]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$2['header-wrap']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['left']
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return window.open('https://www.bixin.com', '_self');
    }
  }, i18n.language === 'en' ? ( /*#__PURE__*/React.createElement(Icon$c, null)) : i18n.language === 'zh' ? ( /*#__PURE__*/React.createElement(Icon$b, null)) : ( /*#__PURE__*/React.createElement(Icon$d, null))), !mobileStyle && ( /*#__PURE__*/React.createElement("div", {
    className: styles$2['menus']
  }, memoMenus.map(function (d, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$2['menu-item'],
      key: i,
      onMouseEnter: function onMouseEnter() {
        if (i === 2) {
          setIsIn(true);
        }
      },
      onMouseLeave: function onMouseLeave() {
        if (i === 2) {
          setIsIn(false);
        }
      },
      onClick: function onClick() {
        if (i === 2 && shwoBxGroupIn) {
          return;
        } else {
          if (i === 2) {
            window.open(d.path, '_blank');
          } else {
            window.open(d.path, '_self');
          }
        }
      }
    }, d.label, i === 2 && shwoBxGroupIn && /*#__PURE__*/React.createElement(Icon$j, null), shwoBxGroupIn && isIn && i === 2 && ( /*#__PURE__*/React.createElement("div", {
      className: styles$2['about-bx-wrap']
    }, memoAboutBx.map(function (d, i) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$2['item'],
        key: i,
        onClick: function onClick() {
          if (d.path) {
            window.open(d.path, '_blank');
          } else {
            window.scrollTo(0, document.body.scrollHeight);
          }
        }
      }, d.label);
    }))));
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles$2['right']
  }, !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid) && !mobileStyle && memoBtns.map(function (d, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$2['btn'],
      key: i,
      onClick: function onClick() {
        return window.open(d.path, '_self');
      }
    }, d.label);
  }), (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid) && !mobileStyle && ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$2['btn'],
    onClick: function onClick() {
      return window.open('/trade/history', '_self');
    }
  }, t('qtCIhbuRgppyZzltf')), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '50px'
    },
    className: styles$2['user-info-wrap'],
    onMouseEnter: function onMouseEnter() {
      return setShowUserInfoModal(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowUserInfoModal(false);
    }
  }, /*#__PURE__*/React.createElement(Icon$h, {
    className: styles$2['user-icon']
  }), showUserInfoModal && ( /*#__PURE__*/React.createElement(UserInfoModal, {
    userInfo: userInfo,
    setShowPIModal: setShowPIModal,
    setShowCompanyPIModal: setShowCompanyPIModal
  }))))), /*#__PURE__*/React.createElement(LanguageIcon, {
    userLang: userInfo === null || userInfo === void 0 ? void 0 : userInfo.language,
    changeLanguage: changeLanguage
  }), mobileStyle && showMoileMenu && ( /*#__PURE__*/React.createElement(Icon$3, {
    onClick: function onClick() {
      return setShowMobilMenu(false);
    }
  })), mobileStyle && !showMoileMenu && ( /*#__PURE__*/React.createElement(Icon$5, {
    onClick: function onClick() {
      return setShowMobilMenu(true);
    }
  }))), mobileStyle && showMoileMenu && ( /*#__PURE__*/React.createElement("div", {
    className: styles$2['mobile-wrap']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['menu-wrap']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['personal'],
    onClick: function onClick() {
      window.open('/trade/accountManager?current=1', '_self');
    }
  }, /*#__PURE__*/React.createElement(Icon$h, null), t('YMfvOKmAFnfMwTXPfI')), memoMobileMenus.map(function (d, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles$2['mobile-menu-item'],
      onClick: function onClick() {
        window.open(d.path, '_self');
      }
    }, /*#__PURE__*/React.createElement("span", null, d.label), /*#__PURE__*/React.createElement(Icon$4, null));
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$2['contact-wrap']
  }, memoContactLinks.map(function (d, i) {
    return /*#__PURE__*/React.createElement("img", {
      src: d.img,
      key: i,
      onClick: function onClick() {
        return window.open(d.path, '_blank');
      }
    });
  }))))), showPIModal && ( /*#__PURE__*/React.createElement("div", {
    className: styles$2['pi-tip-modal-mask']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['pi-tip-modal']
  }, /*#__PURE__*/React.createElement(Icon$e, null), /*#__PURE__*/React.createElement("p", {
    className: styles$2['title']
  }, i18n.t('uRLAPBsurxBqxfvgaSH')), /*#__PURE__*/React.createElement("p", {
    className: styles$2['content']
  }, i18n.t('FaQaEHvLdVELQbCZrFN')), /*#__PURE__*/React.createElement("div", {
    className: styles$2['footer']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['cancel-button'],
    onClick: function onClick() {
      return setShowPIModal(false);
    }
  }, i18n.t('UNForxvjDLCZdGrmWkX')), /*#__PURE__*/React.createElement("div", {
    className: styles$2['ok-button'],
    onClick: function onClick() {
      return window.open("/trade/personKyc/certificate", '_self');
    }
  }, i18n.t('AQrCocFqoKoYieUnT')))))), showCompanyPIModal && ( /*#__PURE__*/React.createElement("div", {
    className: styles$2['pi-tip-modal-mask']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['pi-tip-modal'],
    style: {
      padding: '40px 20px'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: 'center'
    },
    className: styles$2['company-tip-text'],
    dangerouslySetInnerHTML: {
      __html: i18n.t('KzRRnMZfXiUfprzBEe')
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$2['footer']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['ok-button'],
    onClick: function onClick() {
      return setShowCompanyPIModal(false);
    }
  }, i18n.t('AQrCocFqoKoYieUnT')))))));
};

var css_248z = "* {\n  padding: 0;\n  margin: 0;\n}\n";
styleInject(css_248z);

function App(_a) {
  var appChangeLanguage = _a.appChangeLanguage;
  return /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18n
  }, /*#__PURE__*/React.createElement(BxHeader, {
    changeLanguage: appChangeLanguage
  }));
}

export { App as BxHeaderComponent };
